webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(259);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(589);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(593);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(259);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(253);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = __webpack_require__(265);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(600);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasAnyHandlers = function hasAnyHandlers(handlers) {
  return (0, _keys2.default)(handlers).some(function (key) {
    return handlers[key];
  });
};

var View = function (_Component) {
  (0, _inherits3.default)(View, _Component);

  function View() {
    (0, _classCallCheck3.default)(this, View);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  View.prototype.componentDidMount = function componentDidMount() {
    var autoFocus = this.props.autoFocus;


    if (autoFocus) {
      this.element.focus();
    }
  };

  View.prototype.componentWillUnmount = function componentWillUnmount() {
    var tooltips = this.context.tooltips;


    if (tooltips && this.tooltipId != null) {
      tooltips.hide(this.tooltipId);
    }
  };

  View.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        className = _props.className,
        hidden = _props.hidden,
        onArrowDown = _props.onArrowDown,
        onArrowLeft = _props.onArrowLeft,
        onArrowRight = _props.onArrowRight,
        onArrowUp = _props.onArrowUp,
        onDelete = _props.onDelete,
        onEnter = _props.onEnter,
        onEscape = _props.onEscape,
        onKeyDown = _props.onKeyDown,
        onSpace = _props.onSpace,
        onTab = _props.onTab,
        title = _props.title,
        tooltipPositioning = _props.tooltipPositioning,
        testId = _props.testId,
        other = (0, _objectWithoutProperties3.default)(_props, ["children", "className", "hidden", "onArrowDown", "onArrowLeft", "onArrowRight", "onArrowUp", "onDelete", "onEnter", "onEscape", "onKeyDown", "onSpace", "onTab", "title", "tooltipPositioning", "testId"]);


    var keyDownHandlers = {
      "8": onDelete,
      "9": onTab,
      "13": onEnter,
      "27": onEscape,
      "32": onSpace,
      "37": onArrowLeft,
      "38": onArrowUp,
      "39": onArrowRight,
      "40": onArrowDown
    };

    var eventHandlers = {};

    if (onKeyDown || hasAnyHandlers(keyDownHandlers)) {
      eventHandlers.onKeyDown = function (e) {
        var handler = keyDownHandlers[e.keyCode];
        handler && handler(e);
        onKeyDown && onKeyDown(e);
      };
    }

    var props = (0, _extends3.default)({}, other, eventHandlers);

    var tooltips = this.context.tooltips;


    if (tooltips && title) {
      props.onMouseEnter = function (e) {
        _this2.tooltipId = tooltips.show(_this2.element, title, tooltipPositioning);
        _this2.props.onMouseOver && _this2.props.onMouseOver(e);
      };
      ["onMouseLeave", "onBlur", "onWheel", "onClick"].forEach(function (handler) {
        props[handler] = function (e) {
          tooltips.hide(_this2.tooltipId);
          _this2.props[handler] && _this2.props[handler](e);
        };
      });

      props["aria-label"] = title;
    } else if (title) {
      props.title = title;
    }

    if (testId) {
      props["data-test-id"] = testId;
    }

    if (hidden) {
      props["aria-hidden"] = true;
    }

    return _react2.default.createElement(
      "div",
      (0, _extends3.default)({}, props, {
        className: (0, _classnames2.default)(_styles2.default.view, className),
        ref: function ref(_ref) {
          _this2.element = _ref;
        }
      }),
      children
    );
  };

  return View;
}(_react.Component);

View.propTypes = {
  autoFocus: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  hidden: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onDragEnter: _propTypes2.default.func,
  onDragLeave: _propTypes2.default.func,
  onDragOver: _propTypes2.default.func,
  onDragStart: _propTypes2.default.func,
  onDrop: _propTypes2.default.func,
  onArrowDown: _propTypes2.default.func,
  onArrowLeft: _propTypes2.default.func,
  onArrowRight: _propTypes2.default.func,
  onArrowUp: _propTypes2.default.func,
  onBackspace: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onEnter: _propTypes2.default.func,
  onEscape: _propTypes2.default.func,
  onMouseOver: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onScroll: _propTypes2.default.func,
  onSpace: _propTypes2.default.func,
  onTab: _propTypes2.default.func,
  testId: _propTypes2.default.string,
  /** Hiding advanced content within tooltips may have accessibility impacts */
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  /** One of: 'top', 'right', 'bottom', 'left' or as array (prioritization) */
  tooltipPositioning: function tooltipPositioning() {}
};
View.contextTypes = {
  tooltips: _propTypes2.default.object
};
exports.default = View;

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = __webpack_require__(265);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extendStyles = function extendStyles(styles, theme, resetTheme, namespace) {
  var _ref = theme || {},
      themeStyles = _ref[namespace];

  if (themeStyles) {
    // If resetTheme is provided we don't want to override the default styling
    if (resetTheme) {
      return themeStyles;
    }

    var _extendStyles = {};

    (0, _keys2.default)(styles).forEach(function (key) {
      _extendStyles[key] = key in themeStyles ? styles[key] + " " + themeStyles[key] : styles[key];
    });

    return _extendStyles;
  } else {
    return styles;
  }
};

var ThemedComponent = function (_Component) {
  (0, _inherits3.default)(ThemedComponent, _Component);

  function ThemedComponent(props, context, _ref2) {
    var namespace = _ref2.namespace,
        styles = _ref2.styles;
    (0, _classCallCheck3.default)(this, ThemedComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));

    var rcTheme = context.rcTheme,
        resetTheme = context.resetTheme;

    _this.theme = extendStyles(styles, rcTheme, resetTheme, namespace);
    return _this;
  }

  return ThemedComponent;
}(_react.Component);

ThemedComponent.contextTypes = {
  rcTheme: _propTypes2.default.object,
  resetTheme: _propTypes2.default.bool
};
exports.default = ThemedComponent;

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ThemedComponent = __webpack_require__(22);

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ThemedComponent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _View = __webpack_require__(17);

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_View).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(189)('wks')
  , uid        = __webpack_require__(133)
  , Symbol     = __webpack_require__(68).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(253);

var _assign2 = _interopRequireDefault(_assign);

var _extends3 = __webpack_require__(12);

var _extends4 = _interopRequireDefault(_extends3);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Selectable = function Selectable(ChildComponent) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      action = _ref.action,
      _ref$preventDefault = _ref.preventDefault,
      preventDefault = _ref$preventDefault === undefined ? false : _ref$preventDefault,
      _ref$stopPropagation = _ref.stopPropagation,
      stopPropagation = _ref$stopPropagation === undefined ? false : _ref$stopPropagation,
      _ref$selectOnHover = _ref.selectOnHover,
      selectOnHover = _ref$selectOnHover === undefined ? false : _ref$selectOnHover,
      _ref$selectEvent = _ref.selectEvent,
      selectEvent = _ref$selectEvent === undefined ? "onMouseDown" : _ref$selectEvent;

  var Selectable = function (_Component) {
    (0, _inherits3.default)(Selectable, _Component);

    function Selectable() {
      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, Selectable);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChoseValue = function (e) {
        var _this$props = _this.props,
            disabled = _this$props.disabled,
            onValueChosen = _this$props.onValueChosen,
            value = _this$props.value;


        if (!disabled && onValueChosen) {
          onValueChosen(value, e);
          preventDefault && e.preventDefault();
          stopPropagation && e.stopPropagation();
        }
      }, _this.onMouseEnter = function (e) {
        var onSelect = _this.props.onSelect;


        _this.hover = true;
        if (selectOnHover) {
          setTimeout(function () {
            onSelect && onSelect(e, _this);
          }, 0);
        }
      }, _this.onMouseLeave = function (e) {
        _this.hover = false;
      }, _this.onMouseDown = function (e) {
        preventDefault && e.preventDefault();
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Selectable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var selected = this.props.selected;


      if (!selected && nextProps.selected && !this.hover) {
        setTimeout(function () {
          if (_this2.domNode.scrollIntoViewIfNeeded) {
            _this2.domNode.scrollIntoViewIfNeeded(false);
          } else if (_this2.domNode.scrollIntoView) {
            _this2.domNode.scrollIntoView(false);
          }
        }, 0);
      }
    };

    Selectable.prototype.render = function render() {
      var _extends2,
          _this3 = this;

      var props = (0, _extends4.default)({}, this.props, (_extends2 = {
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onMouseDown: this.onMouseDown
      }, _extends2[selectEvent] = this.onChoseValue, _extends2));

      return _react2.default.createElement(ChildComponent, (0, _extends4.default)({
        ref: function ref(_ref2) {
          _this3.domNode = _this3.domNode || _ref2 && (0, _reactDom.findDOMNode)(_ref2);
        }
      }, props));
    };

    return Selectable;
  }(_react.Component);

  Selectable.selectable = true;
  Selectable.propTypes = {
    disabled: _propTypes2.default.bool,
    onSelect: _propTypes2.default.func,
    onValueChosen: _propTypes2.default.func,
    selected: _propTypes2.default.bool,
    value: _propTypes2.default.any
  };
  Selectable.defaultProps = (0, _assign2.default)({}, ChildComponent.defaultProps || {}, {
    action: action,
    disabled: false
  });


  return Selectable;
};

exports.default = Selectable;

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SIGNED_IN_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_TYPE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_STEP_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_STEP_SEGMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_STEP_REVIEW; });
/* unused harmony export CREATE_STEPS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);


var _USER_TYPE_NAME;

var STAFF = "staff";
var SIGNED_IN_USERS = "signed_in_users";
var USER_TYPES = [STAFF, SIGNED_IN_USERS];
var USER_TYPE_NAME = (_USER_TYPE_NAME = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_USER_TYPE_NAME, STAFF, "knowledge-user-segments.userSegment.staffUserType"), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_USER_TYPE_NAME, SIGNED_IN_USERS, "knowledge-user-segments.userSegment.signedInUsersUserType"), _USER_TYPE_NAME);
var CREATE_STEP_SETUP = "setup";
var CREATE_STEP_SEGMENT = "segment";
var CREATE_STEP_REVIEW = "review";
var CREATE_STEPS = [CREATE_STEP_SETUP, CREATE_STEP_SEGMENT, CREATE_STEP_REVIEW];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)
__webpack_require__(199)
__webpack_require__(277)

appendStyles({
  css: ".ssc-stretched-6c67512f{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:100%;height:100%}.ssc-menu-6c67512f{position:relative;padding:0}.ssc-fixed_width-6c67512f{max-width:180px}.ssc-inner-6c67512f{padding:8px 0;box-sizing:inherit}.ssc-scrollable-6c67512f>.ssc-inner-6c67512f{overflow-x:hidden;overflow-y:auto}.ssc-position_bottom_stretch-6c67512f,.ssc-position_top_stretch-6c67512f{width:100%}@-webkit-keyframes ssc-zd-menu--up-open-6c67512f{0%{margin-top:20px}100%{margin-top:0}}@keyframes ssc-zd-menu--up-open-6c67512f{0%{margin-top:20px}100%{margin-top:0}}@-webkit-keyframes ssc-zd-menu--left-open-6c67512f{0%{margin-left:20px}100%{margin-left:0}}@keyframes ssc-zd-menu--left-open-6c67512f{0%{margin-left:20px}100%{margin-left:0}}.ssc-position_top-6c67512f.ssc-animate-6c67512f,.ssc-position_top_left-6c67512f.ssc-animate-6c67512f,.ssc-position_top_right-6c67512f.ssc-animate-6c67512f,.ssc-position_top_stretch-6c67512f.ssc-animate-6c67512f{-webkit-animation-name:ssc-zd-menu--up-open-6c67512f;animation-name:ssc-zd-menu--up-open-6c67512f}.ssc-position_left-6c67512f.ssc-animate-6c67512f,.ssc-position_left_bottom-6c67512f.ssc-animate-6c67512f,.ssc-position_left_top-6c67512f.ssc-animate-6c67512f{-webkit-animation-name:ssc-zd-menu--left-open-6c67512f;animation-name:ssc-zd-menu--left-open-6c67512f}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"stretched":"ssc-stretched-6c67512f","menu":"ssc-menu-6c67512f scc-c-menu-526a8b12","size_small":"ssc-size_small-6c67512f scc-c-menu--sm-526a8b12","fixed_width":"ssc-fixed_width-6c67512f","item":"ssc-item-6c67512f scc-c-menu__item-526a8b12","previous_item":"ssc-previous_item-6c67512f scc-c-menu__item--previous-526a8b12","next_item":"ssc-next_item-6c67512f scc-c-menu__item--next-526a8b12","header_item":"ssc-header_item-6c67512f scc-c-menu__item--header-526a8b12","header_icon":"ssc-header_icon-6c67512f scc-c-menu__item--header__icon-526a8b12","add_item":"ssc-add_item-6c67512f scc-c-menu__item--add-526a8b12","media_item":"ssc-media_item-6c67512f scc-c-menu__item--media-526a8b12","media_figure":"ssc-media_figure-6c67512f scc-c-menu__item--media__figure-526a8b12","media_body":"ssc-media_body-6c67512f scc-c-menu__item--media__body-526a8b12","meta":"ssc-meta-6c67512f scc-c-menu__item__meta-526a8b12","inner":"ssc-inner-6c67512f","scrollable":"ssc-scrollable-6c67512f","disabled":"ssc-disabled-6c67512f scc-is-disabled-526a8b12","focused":"ssc-focused-6c67512f scc-is-focused-526a8b12","checked":"ssc-checked-6c67512f scc-is-checked-526a8b12","separator":"ssc-separator-6c67512f scc-c-menu__separator-526a8b12","rtl":"ssc-rtl-6c67512f scc-is-rtl-526a8b12","position_bottom_stretch":"ssc-position_bottom_stretch-6c67512f scc-c-menu--down-526a8b12","position_top_stretch":"ssc-position_top_stretch-6c67512f scc-c-menu--up-526a8b12","position_top_right":"ssc-position_top_right-6c67512f scc-c-menu--up-526a8b12","position_top_left":"ssc-position_top_left-6c67512f scc-c-menu--up-526a8b12","position_top":"ssc-position_top-6c67512f scc-c-menu--up-526a8b12","position_bottom_right":"ssc-position_bottom_right-6c67512f scc-c-menu--down-526a8b12","position_bottom_left":"ssc-position_bottom_left-6c67512f scc-c-menu--down-526a8b12","position_bottom":"ssc-position_bottom-6c67512f scc-c-menu--down-526a8b12","position_left_top":"ssc-position_left_top-6c67512f scc-c-menu--left-526a8b12","position_left_bottom":"ssc-position_left_bottom-6c67512f scc-c-menu--left-526a8b12","position_left":"ssc-position_left-6c67512f scc-c-menu--left-526a8b12","position_right_top":"ssc-position_right_top-6c67512f scc-c-menu--right-526a8b12","position_right_bottom":"ssc-position_right_bottom-6c67512f scc-c-menu--right-526a8b12","position_right":"ssc-position_right-6c67512f scc-c-menu--right-526a8b12","animate":"ssc-animate-6c67512f scc-is-open-526a8b12","zd-menu--up-open":"ssc-zd-menu--up-open-6c67512f","zd-menu--left-open":"ssc-zd-menu--left-open-6c67512f","arrow":"ssc-arrow-6c67512f scc-c-arrow-be7b392f","arrow_bottom":"ssc-arrow_bottom-6c67512f scc-c-arrow--b-be7b392f","arrow_bottom_left":"ssc-arrow_bottom_left-6c67512f scc-c-arrow--bl-be7b392f","arrow_bottom_right":"ssc-arrow_bottom_right-6c67512f scc-c-arrow--br-be7b392f","arrow_left":"ssc-arrow_left-6c67512f scc-c-arrow--l-be7b392f","arrow_right":"ssc-arrow_right-6c67512f scc-c-arrow--r-be7b392f","arrow_top":"ssc-arrow_top-6c67512f scc-c-arrow--t-be7b392f","arrow_top_left":"ssc-arrow_top_left-6c67512f scc-c-arrow--tl-be7b392f","arrow_top_right":"ssc-arrow_top_right-6c67512f scc-c-arrow--tr-be7b392f"}


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(68)
  , core      = __webpack_require__(42)
  , ctx       = __webpack_require__(183)
  , hide      = __webpack_require__(91)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["duplicateUserSegment"] = duplicateUserSegment;
/* harmony export (immutable) */ __webpack_exports__["deleteUserSegment"] = deleteUserSegment;
/* harmony export (immutable) */ __webpack_exports__["editUserSegment"] = editUserSegment;
/* harmony export (immutable) */ __webpack_exports__["addUserSegment"] = addUserSegment;
/* harmony export (immutable) */ __webpack_exports__["fetchUserSegment"] = fetchUserSegment;
/* harmony export (immutable) */ __webpack_exports__["changeName"] = changeName;
/* harmony export (immutable) */ __webpack_exports__["changeUserType"] = changeUserType;
/* harmony export (immutable) */ __webpack_exports__["changeTag"] = changeTag;
/* harmony export (immutable) */ __webpack_exports__["addTag"] = addTag;
/* harmony export (immutable) */ __webpack_exports__["removeTag"] = removeTag;
/* harmony export (immutable) */ __webpack_exports__["changeOrganization"] = changeOrganization;
/* harmony export (immutable) */ __webpack_exports__["addOrganization"] = addOrganization;
/* harmony export (immutable) */ __webpack_exports__["removeOrganization"] = removeOrganization;
/* harmony export (immutable) */ __webpack_exports__["changeGroup"] = changeGroup;
/* harmony export (immutable) */ __webpack_exports__["addGroup"] = addGroup;
/* harmony export (immutable) */ __webpack_exports__["removeGroup"] = removeGroup;
/* harmony export (immutable) */ __webpack_exports__["saveUserSegment"] = saveUserSegment;
/* harmony export (immutable) */ __webpack_exports__["createUserSegment"] = createUserSegment;
/* harmony export (immutable) */ __webpack_exports__["fetchUsers"] = fetchUsers;
/* harmony export (immutable) */ __webpack_exports__["resetUserSegment"] = resetUserSegment;
/* harmony export (immutable) */ __webpack_exports__["resetUserSegmentAttributes"] = resetUserSegmentAttributes;
/* harmony export (immutable) */ __webpack_exports__["cancelNewUserSegment"] = cancelNewUserSegment;
/* harmony export (immutable) */ __webpack_exports__["filterUserSegments"] = filterUserSegments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_http_client__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_http_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_http_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notifications__ = __webpack_require__(675);







var USERS_PER_PAGE = 30;
var USER_SEGMENTS_URL = "/api/v2/help_center/user_segments";

function duplicateUserSegmentRequest(userSegment) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["p" /* DUPLICATE_USER_SEGMENT_REQUEST */],
    userSegment: userSegment
  };
}

function duplicateUserSegmentSuccess(originalId, userSegment) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["q" /* DUPLICATE_USER_SEGMENT_SUCCESS */],
    userSegment: userSegment,
    originalId: originalId
  };
}

function duplicateUserSegmentFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["o" /* DUPLICATE_USER_SEGMENT_FAILURE */],
    error: true,
    payload: error
  };
}

function duplicateUserSegment(originalId, userSegment) {
  return function (dispatch, getState) {
    dispatch(duplicateUserSegmentRequest(userSegment));
    var name = userSegment.name,
        tags = userSegment.tags,
        organization_ids = userSegment.organization_ids,
        group_ids = userSegment.group_ids,
        user_type = userSegment.user_type;
    return Object(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_http_client__["post"])("".concat(USER_SEGMENTS_URL, "?multibrand=true"), {
      user_segment: {
        name: name,
        tags: tags,
        organization_ids: organization_ids,
        group_ids: group_ids,
        user_type: user_type
      }
    }, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function (_ref) {
      var user_segment = _ref.user_segment;
      dispatch(duplicateUserSegmentSuccess(originalId, user_segment));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__notifications__["b" /* showSuccessNotification */])(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default()("knowledge-user-segments.notifications.duplicate.success")));
    }).catch(function (err) {
      dispatch(duplicateUserSegmentFailure(err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* showErrorNotification */])(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default()("knowledge-user-segments.notifications.duplicate.failure")));
      throw err;
    });
  };
}

function deleteUserSegmentRequest(userSegmentId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["m" /* DELETE_USER_SEGMENT_REQUEST */],
    userSegmentId: userSegmentId
  };
}

function deleteUserSegmentSuccess(userSegmentId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["n" /* DELETE_USER_SEGMENT_SUCCESS */],
    userSegmentId: userSegmentId
  };
}

function deleteUserSegmentFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["l" /* DELETE_USER_SEGMENT_FAILURE */],
    error: true,
    payload: error
  };
}

function deleteUserSegment(userSegmentId) {
  return function (dispatch, getState) {
    dispatch(deleteUserSegmentRequest(userSegmentId));
    return Object(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_http_client__["del"])("".concat(USER_SEGMENTS_URL, "/").concat(userSegmentId, "?multibrand=true"), {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(deleteUserSegmentSuccess(userSegmentId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__notifications__["b" /* showSuccessNotification */])(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default()("knowledge-user-segments.notifications.delete.success")));
    }).catch(function (err) {
      dispatch(deleteUserSegmentFailure(err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* showErrorNotification */])(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default()("knowledge-user-segments.notifications.delete.failure")));
      throw err;
    });
  };
}
function editUserSegment(userSegmentId) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])({
    pathname: "/knowledge/user_segments/".concat(userSegmentId),
    search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context__["getCurrentBrandId"])())
  });
}
function addUserSegment() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])({
    pathname: "/knowledge/user_segments/new",
    search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context__["getCurrentBrandId"])())
  });
}

function fetchUserSegmentRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["B" /* FETCH_USER_SEGMENT_REQUEST */]
  };
}

function fetchUserSegmentSuccess(userSegment) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["C" /* FETCH_USER_SEGMENT_SUCCESS */],
    userSegment: userSegment
  };
}

function fetchUserSegmentFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["u" /* FETCH_USER_SEGMENT_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchUserSegment(userSegmentId) {
  return function (dispatch) {
    dispatch(fetchUserSegmentRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_http_client__["get"])("".concat(USER_SEGMENTS_URL, "/").concat(userSegmentId, "?multibrand=true")).then(function (_ref2) {
      var userSegment = _ref2.user_segment;
      dispatch(fetchUserSegmentSuccess(userSegment));
      return userSegment;
    }).catch(function (err) {
      dispatch(fetchUserSegmentFailure(err));
      throw err;
    }).then(function (userSegment) {
      if (userSegment.user_type === __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* SIGNED_IN_USERS */]) {
        return dispatch(fetchUserSegmentOrganizations(userSegment.organization_ids));
      } else if (userSegment.user_type === __WEBPACK_IMPORTED_MODULE_4__constants__["e" /* STAFF */]) {
        return dispatch(fetchUserSegmentGroups(userSegment.group_ids));
      }
    }).then(function () {
      return dispatch(fetchUsers());
    });
  };
}

function fetchUserSegmentOrganizationsRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["z" /* FETCH_USER_SEGMENT_ORGANIZATIONS_REQUEST */]
  };
}

function fetchUserSegmentOrganizationsSuccess(requestedIds, organizations) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["A" /* FETCH_USER_SEGMENT_ORGANIZATIONS_SUCCESS */],
    requestedIds: requestedIds,
    organizations: organizations
  };
}

function fetchUserSegmentOrganizationsFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["y" /* FETCH_USER_SEGMENT_ORGANIZATIONS_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchUserSegmentOrganizations(organizationIds) {
  return function (dispatch) {
    dispatch(fetchUserSegmentOrganizationsRequest());

    if (organizationIds.length === 0) {
      dispatch(fetchUserSegmentOrganizationsSuccess([]));
      return;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_http_client__["get"])("/api/v2/organizations/show_many.json?ids=".concat(organizationIds.join(","))).then(function (_ref3) {
      var organizations = _ref3.organizations;
      return dispatch(fetchUserSegmentOrganizationsSuccess(organizationIds, organizations));
    }).catch(function (err) {
      dispatch(fetchUserSegmentOrganizationsFailure(err));
    });
  };
}

function fetchUserSegmentGroupsRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["w" /* FETCH_USER_SEGMENT_GROUPS_REQUEST */]
  };
}

function fetchUserSegmentGroupsSuccess(groups) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["x" /* FETCH_USER_SEGMENT_GROUPS_SUCCESS */],
    groups: groups
  };
}

function fetchUserSegmentGroupsFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["v" /* FETCH_USER_SEGMENT_GROUPS_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchUserSegmentGroups(groupIds) {
  return function (dispatch) {
    dispatch(fetchUserSegmentGroupsRequest());

    if (groupIds.length === 0) {
      dispatch(fetchUserSegmentGroupsSuccess([]));
    }

    var promises = groupIds.map(function (groupId) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_http_client__["get"])("/api/v2/groups/".concat(groupId, ".json"));
    });
    return Promise.all(promises).then(function (wrappedGroups) {
      var groups = wrappedGroups.map(function (group) {
        return group.group;
      });
      dispatch(fetchUserSegmentGroupsSuccess(groups));
    }).catch(function (err) {
      dispatch(fetchUserSegmentGroupsFailure(err));
      throw err;
    });
  };
}

function changeName(name) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["e" /* CHANGE_NAME */],
    name: name
  };
}
function changeUserType(userType) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["h" /* CHANGE_USER_TYPE */],
    userType: userType
  };
}
function changeTag(originalTag, newTag) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__types__["g" /* CHANGE_TAG */],
      originalTag: originalTag,
      newTag: newTag
    });
    return dispatch(fetchUsers());
  };
}
function addTag(tag) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__types__["c" /* ADD_TAG */],
      tag: tag
    });
    return dispatch(fetchUsers());
  };
}
function removeTag(tag) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__types__["F" /* REMOVE_TAG */],
      tag: tag
    });
    return dispatch(fetchUsers());
  };
}
function changeOrganization(originalOrganization, newOrganization) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__types__["f" /* CHANGE_ORGANIZATION */],
      originalOrganization: originalOrganization,
      newOrganization: newOrganization
    });
    return dispatch(fetchUsers());
  };
}
function addOrganization(organization) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__types__["b" /* ADD_ORGANIZATION */],
      organization: organization
    });
    return dispatch(fetchUsers());
  };
}
function removeOrganization(organization) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__types__["E" /* REMOVE_ORGANIZATION */],
      organization: organization
    });
    return dispatch(fetchUsers());
  };
}
function changeGroup(originalGroup, newGroup) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__types__["d" /* CHANGE_GROUP */],
      originalGroup: originalGroup,
      newGroup: newGroup
    });
    return dispatch(fetchUsers());
  };
}
function addGroup(group) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__types__["a" /* ADD_GROUP */],
      group: group
    });
    return dispatch(fetchUsers());
  };
}
function removeGroup(group) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__types__["D" /* REMOVE_GROUP */],
      group: group
    });
    return dispatch(fetchUsers());
  };
}

function saveUserSegmentRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["J" /* SAVE_USER_SEGMENT_REQUEST */]
  };
}

function saveUserSegmentSuccess() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["K" /* SAVE_USER_SEGMENT_SUCCESS */]
  };
}

function saveUserSegmentFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["I" /* SAVE_USER_SEGMENT_FAILURE */],
    error: true,
    payload: error
  };
}

function saveUserSegment(userSegmentId) {
  return function (dispatch, getState) {
    var _getState = getState(),
        _getState$userSegment = _getState.userSegment,
        name = _getState$userSegment.name,
        tags = _getState$userSegment.tags,
        groups = _getState$userSegment.groups,
        organizations = _getState$userSegment.organizations;

    if (organizations.some(function (organization) {
      return organization.deleted;
    })) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* showErrorNotification */])("User segment cannot be saved with deleted organizations"));
      return;
    }

    if (groups.some(function (group) {
      return group.deleted;
    })) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* showErrorNotification */])("User segment cannot be saved with deleted groups"));
      return;
    }

    dispatch(saveUserSegmentRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_http_client__["put"])("".concat(USER_SEGMENTS_URL, "/").concat(userSegmentId, "?multibrand=true"), {
      user_segment: {
        name: name,
        tags: tags,
        group_ids: groups.map(function (_ref4) {
          var id = _ref4.id;
          return id;
        }),
        organization_ids: organizations.map(function (_ref5) {
          var id = _ref5.id;
          return id;
        })
      }
    }, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(saveUserSegmentSuccess());
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__notifications__["b" /* showSuccessNotification */])(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default()("knowledge-user-segments.notifications.save.success")));
    }).catch(function (err) {
      dispatch(saveUserSegmentFailure(err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* showErrorNotification */])(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default()("knowledge-user-segments.notifications.save.failure")));
      throw err;
    });
  };
}

function createUserSegmentRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["j" /* CREATE_USER_SEGMENT_REQUEST */]
  };
}

function createUserSegmentSuccess() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["k" /* CREATE_USER_SEGMENT_SUCCESS */]
  };
}

function createUserSegmentFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["i" /* CREATE_USER_SEGMENT_FAILURE */],
    error: true,
    payload: error
  };
}

function createUserSegment() {
  return function (dispatch, getState) {
    dispatch(createUserSegmentRequest());

    var _getState2 = getState(),
        _getState2$userSegmen = _getState2.userSegment,
        name = _getState2$userSegmen.name,
        tags = _getState2$userSegmen.tags,
        groups = _getState2$userSegmen.groups,
        organizations = _getState2$userSegmen.organizations,
        userType = _getState2$userSegmen.userType;

    return Object(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_http_client__["post"])("".concat(USER_SEGMENTS_URL, "?multibrand=true"), {
      user_segment: {
        name: name,
        user_type: userType,
        tags: tags,
        group_ids: groups.map(function (_ref6) {
          var id = _ref6.id;
          return id;
        }),
        organization_ids: organizations.map(function (_ref7) {
          var id = _ref7.id;
          return id;
        })
      }
    }, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function (_ref8) {
      var id = _ref8.user_segment.id;
      dispatch(createUserSegmentSuccess());
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__notifications__["b" /* showSuccessNotification */])(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default()("knowledge-user-segments.notifications.create.success")));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])({
        pathname: "/knowledge/user_segments/".concat(id),
        search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context__["getCurrentBrandId"])())
      }));
    }).catch(function (err) {
      dispatch(createUserSegmentFailure(err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* showErrorNotification */])(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default()("knowledge-user-segments.notifications.create.failure")));
      throw err;
    });
  };
}

function fetchUsersRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["s" /* FETCH_USERS_REQUEST */]
  };
}

function fetchUsersSuccess(users, count, pageCount) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["t" /* FETCH_USERS_SUCCESS */],
    users: users,
    count: count,
    pageCount: pageCount
  };
}

function fetchUsersFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["r" /* FETCH_USERS_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchUsers() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return function (dispatch, getState) {
    var _getState3 = getState(),
        _getState3$userSegmen = _getState3.userSegment,
        userType = _getState3$userSegmen.userType,
        tags = _getState3$userSegmen.tags,
        groups = _getState3$userSegmen.groups,
        organizations = _getState3$userSegmen.organizations; // Non-admins are not allowed to see user list


    if (!Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context__["hasEntitlement"])("admin")) {
      return;
    }

    dispatch(fetchUsersRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_http_client__["get"])("".concat(USER_SEGMENTS_URL, "/users.json"), {
      query: {
        page: page,
        user_type: userType,
        tags: tags.join(","),
        group_ids: groups.map(function (g) {
          return g.id;
        }).join(","),
        organization_ids: organizations.map(function (o) {
          return o.id;
        }).join(","),
        per_page: USERS_PER_PAGE,
        multibrand: true
      }
    }).then(function (_ref9) {
      var users = _ref9.users,
          count = _ref9.count,
          page_count = _ref9.page_count;
      return dispatch(fetchUsersSuccess(users, count, page_count));
    }).catch(function (err) {
      dispatch(fetchUsersFailure(err));
      throw err;
    });
  };
}
function resetUserSegment() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["G" /* RESET_USER_SEGMENT */]
  };
}
function resetUserSegmentAttributes() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__types__["H" /* RESET_USER_SEGMENT_ATTRIBUTES */]
  };
}
function cancelNewUserSegment() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])({
    pathname: "/knowledge/user_segments",
    search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context__["getCurrentBrandId"])())
  });
}
function filterUserSegments(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])({
    pathname: "/knowledge/user_segments/".concat(id),
    search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_context__["getCurrentBrandId"])())
  });
}

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(92)
  , IE8_DOM_DEFINE = __webpack_require__(254)
  , toPrimitive    = __webpack_require__(184)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(78) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(94)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 79 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(257)
  , defined = __webpack_require__(186);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(69)
  , createDesc = __webpack_require__(105);
module.exports = __webpack_require__(78) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(93);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(256)
  , enumBugKeys = __webpack_require__(190);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Item = undefined;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _Selectable = __webpack_require__(51);

var _Selectable2 = _interopRequireDefault(_Selectable);

var _styles = __webpack_require__(53);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = exports.Item = function (_ThemedComponent) {
  (0, _inherits3.default)(Item, _ThemedComponent);

  function Item(props, context) {
    (0, _classCallCheck3.default)(this, Item);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Menu",
      styles: _styles2.default
    }));
  }

  Item.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        children = _props.children,
        className = _props.className,
        disabled = _props.disabled,
        onMouseDown = _props.onMouseDown,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onClick = _props.onClick,
        role = _props.role,
        selected = _props.selected,
        testId = _props.testId,
        title = _props.title,
        tooltipPositioning = _props.tooltipPositioning,
        checked = _props.checked,
        metaInformation = _props.metaInformation,
        isCheckable = _props.isCheckable,
        selectedByMouse = _props.selectedByMouse;
    var theme = this.theme;


    var accessibilityProps = {
      "aria-activedescendant": selected,
      "aria-disabled": disabled
    };

    if (isCheckable) {
      accessibilityProps["aria-checked"] = checked;
    }

    return _react2.default.createElement(
      _View2.default,
      (0, _extends3.default)({}, accessibilityProps, {
        className: (0, _classnames2.default)(theme.item, className, (_classNames = {}, _classNames[theme.disabled] = disabled, _classNames[theme.focused] = selected && !selectedByMouse, _classNames[theme.checked] = checked, _classNames)),
        disabled: disabled,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        role: role,
        testId: testId,
        title: title,
        tooltipPositioning: tooltipPositioning
      }),
      children,
      metaInformation && _react2.default.createElement(
        "div",
        { className: theme.meta },
        metaInformation
      )
    );
  };

  return Item;
}(_ThemedComponent3.default);

Item.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  onMouseDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  role: _propTypes2.default.string,
  selected: _propTypes2.default.bool,
  testId: _propTypes2.default.string,
  title: _propTypes2.default.string,
  /** <a href="#view">See View</a> */
  tooltipPositioning: function tooltipPositioning() {},
  checked: _propTypes2.default.bool,
  metaInformation: _propTypes2.default.node,
  onClick: _propTypes2.default.func,
  isCheckable: _propTypes2.default.bool
};
Item.defaultProps = {
  disabled: false,
  role: "menuitem",
  checked: false,
  isCheckable: true
};
exports.default = (0, _Selectable2.default)(Item, {
  action: function action(props, event) {
    var onClick = props.onClick,
        value = props.value;

    onClick && onClick(value, event);
  },
  preventDefault: true,
  selectEvent: "onClick"
});

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(266);

var _createClass3 = _interopRequireDefault(_createClass2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SingleSelectionModel = __webpack_require__(611);

var _SingleSelectionModel2 = _interopRequireDefault(_SingleSelectionModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactSingleSelectionModel = function () {
  function ReactSingleSelectionModel() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$rtl = _ref.rtl,
        rtl = _ref$rtl === undefined ? false : _ref$rtl,
        _ref$wrapping = _ref.wrapping,
        wrapping = _ref$wrapping === undefined ? "items" : _ref$wrapping,
        _ref$selectOnSpace = _ref.selectOnSpace,
        selectOnSpace = _ref$selectOnSpace === undefined ? true : _ref$selectOnSpace,
        _ref$vertical = _ref.vertical,
        vertical = _ref$vertical === undefined ? true : _ref$vertical;

    (0, _classCallCheck3.default)(this, ReactSingleSelectionModel);

    this.isItemSelectable = function (item) {
      return item && !(item.props && item.props.disabled) && item.type && item.type.selectable;
    };

    this.itemIsSelected = function (item) {
      return _this.hasSelection() && (item.props && item.props.value) === _this.model.selection.props.value;
    };

    this.itemHasChildren = function (item) {
      return item && item.props && item.props.children;
    };

    this.setItems = function (items) {
      var output = [];

      _react2.default.Children.forEach(items, function (item) {
        if (_this.isItemSelectable(item)) {
          output = [].concat(output, [item]);

          if (_this.itemIsSelected(item)) {
            _this.model.selection = item;
          }
        } else if (_this.itemHasChildren(item)) {
          output = [].concat(output, _this.setItems(item.props.children));
        }
      });

      return output;
    };

    this.getItems = function (items) {
      return _react2.default.Children.map(items, function (item) {
        if (_this.isItemSelectable(item)) {
          return _react2.default.cloneElement(item, {
            selectedByMouse: _this.selectedByMouse,
            onSelect: function onSelect() {
              _this.selectedByMouse = true;
              _this.model.select(item);
            },
            onValueChosen: function onValueChosen(value, event) {
              _this.selectedByMouse = true;
              if (_this.model.selection !== item) {
                _this.model.select(item);
              }
              _this.choseSelection(event);
            },
            selected: item === _this.model.selection
          });
        } else if (_this.itemHasChildren(item)) {
          return _react2.default.cloneElement(item, {
            children: _this.getItems(item.props.children)
          });
        } else {
          return item;
        }
      });
    };

    this.handleKeyDown = function (event) {
      var keyDownHandlers = _this.vertical ? {
        "13": _this.onEnter,
        "32": _this.onSpace,
        "38": _this.onArrowUp,
        "40": _this.onArrowDown
      } : {
        "13": _this.onEnter,
        "32": _this.onSpace,
        "37": _this.onArrowLeft,
        "39": _this.onArrowRight
      };

      keyDownHandlers["35"] = _this.onEnd;
      keyDownHandlers["36"] = _this.onHome;

      var handler = keyDownHandlers[event.keyCode];
      if (handler) {
        _this.selectedByMouse = false;
        handler(event);
      }
    };

    this.choseSelection = function (event) {
      if (_this.hasSelection()) {
        var selection = _this.model.selection;
        var value = selection.props.value;
        if (selection.props.action) {
          selection.props.action && selection.props.action(selection.props, event);
        }
        _this.onValueChosen && _this.onValueChosen(value, event);
        return true;
      }
    };

    this.hasSelection = function () {
      return _this.model.hasSelection();
    };

    this.onEnter = function (event) {
      if (_this.choseSelection(event)) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    this.onSpace = function (event) {
      if (_this.selectOnSpace && _this.choseSelection(event)) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    this.onArrowDown = function (event) {
      if (_this.model.selectNext()) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    this.onArrowUp = function (event) {
      if (_this.model.selectPrevious()) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    this.onArrowRight = function (event) {
      var success = _this.rtl ? _this.model.selectPrevious() : _this.model.selectNext();

      if (success) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    this.onArrowLeft = function (event) {
      var success = _this.rtl ? _this.model.selectNext() : _this.model.selectPrevious();

      if (success) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    this.onHome = function (event) {
      if (_this.model.selectFirst()) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    this.onEnd = function (event) {
      if (_this.model.selectLast()) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    this.reactivate = function (defaultSelection) {
      _this.model.reactivate(defaultSelection);
    };

    this.clear = function () {
      _this.selectedByMouse = false;
      _this.model.clear();
    };

    this.model = new _SingleSelectionModel2.default({ wrapping: wrapping });
    this.onSelectionChanged = null;
    this.onValueChosen = null;
    this.model.onSelectionChanged = function (newSelection, previousSelection) {
      if (newSelection !== previousSelection) {
        _this.onSelectionChanged && _this.onSelectionChanged();
      }
    };
    this.selectedByMouse = false;
    this.selectOnSpace = selectOnSpace;
    this.rtl = rtl;
    this.vertical = vertical;
    this._items = [];
  }

  (0, _createClass3.default)(ReactSingleSelectionModel, [{
    key: "items",
    set: function set(items) {
      this._items = items;
      this.model.items = this.setItems(this._items);
    },
    get: function get() {
      return this.getItems(this._items);
    }
  }, {
    key: "selection",
    get: function get() {
      if (this.hasSelection()) {
        return this.model.selection.props.value;
      } else {
        return null;
      }
    }
  }]);
  return ReactSingleSelectionModel;
}();

exports.default = ReactSingleSelectionModel;

/***/ }),
/* 108 */,
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(44);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _ReactSingleSelectionModel = __webpack_require__(107);

var _ReactSingleSelectionModel2 = _interopRequireDefault(_ReactSingleSelectionModel);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _RelativePositionedPopup = __webpack_require__(275);

var _RelativePositionedPopup2 = _interopRequireDefault(_RelativePositionedPopup);

var _keyCodes = __webpack_require__(666);

var _keyCodes2 = _interopRequireDefault(_keyCodes);

var _Container = __webpack_require__(667);

var _Container2 = _interopRequireDefault(_Container);

var _Item = __webpack_require__(96);

var _Item2 = _interopRequireDefault(_Item);

var _LinkItem = __webpack_require__(668);

var _LinkItem2 = _interopRequireDefault(_LinkItem);

var _Separator = __webpack_require__(669);

var _Separator2 = _interopRequireDefault(_Separator);

var _PreviousItem = __webpack_require__(670);

var _PreviousItem2 = _interopRequireDefault(_PreviousItem);

var _NextItem = __webpack_require__(671);

var _NextItem2 = _interopRequireDefault(_NextItem);

var _HeaderItem = __webpack_require__(672);

var _HeaderItem2 = _interopRequireDefault(_HeaderItem);

var _AddItem = __webpack_require__(673);

var _AddItem2 = _interopRequireDefault(_AddItem);

var _MediaItem = __webpack_require__(674);

var _MediaItem2 = _interopRequireDefault(_MediaItem);

var _styles = __webpack_require__(53);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = function (_ThemedComponent) {
  (0, _inherits3.default)(Menu, _ThemedComponent);

  function Menu(props, context) {
    (0, _classCallCheck3.default)(this, Menu);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Menu",
      styles: _styles2.default
    }));

    _this.componentWillReceiveProps = function (nextProps) {
      var children = nextProps.children;

      _this.setSelectableItems(children);
    };

    _this.onSelectionChanged = function () {
      var items = _this.selectionModel.items;
      _this.setState({ items: items });
      _this.showMenu();
    };

    _this.onValueChosen = function (value, event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          focusOnClose = _this$props.focusOnClose,
          shouldClose = _this$props.shouldClose;


      onChange && onChange(value, event);

      if (!shouldClose || shouldClose(value, event)) {
        _this.closeMenu();

        if (focusOnClose) {
          var triggerDOMNode = (0, _reactDom.findDOMNode)(_this.refs.triggerElement);
          triggerDOMNode.focus();
        }
      }
    };

    _this.showMenu = function () {
      var onOpen = _this.props.onOpen;


      if (_this.state.hidden) {
        _this.setState({ hidden: false }, function () {
          onOpen && onOpen();
        });
      }
    };

    _this.closeMenu = function (e) {
      var onClose = _this.props.onClose;


      _this.selectionModel.clear();
      _this.setState({ hidden: true }, function () {
        onClose && onClose();
      });
      e && e.stopPropagation();
    };

    _this.toggleHidden = function (e) {
      if (_this.state.hidden) {
        _this.showMenu();
      } else {
        _this.closeMenu();
      }
      e && e.stopPropagation();
    };

    _this.keyboardToggleHidden = function (e) {
      if (!_this.selectionModel.hasSelection()) {
        _this.toggleHidden();
        e.preventDefault();
        e.stopPropagation();
      }
    };

    _this.selectionModel = new _ReactSingleSelectionModel2.default();
    _this.selectionModel.onSelectionChanged = _this.onSelectionChanged;
    _this.selectionModel.onValueChosen = _this.onValueChosen;
    _this.state = {
      hidden: true,
      items: []
    };
    return _this;
  }

  Menu.prototype.setSelectableItems = function setSelectableItems(children) {
    this.selectionModel.items = children;
    this.setState({ items: this.selectionModel.items });
  };

  Menu.prototype.componentWillMount = function componentWillMount() {
    var children = this.props.children;

    this.setSelectableItems(children);
  };

  Menu.prototype.render = function render() {
    var _classNames,
        _this2 = this;

    var _props = this.props,
        arrow = _props.arrow,
        dir = _props.dir,
        centerArrow = _props.centerArrow,
        marginBottom = _props.marginBottom,
        marginLeft = _props.marginLeft,
        marginRight = _props.marginRight,
        marginTop = _props.marginTop,
        positioning = _props.positioning,
        trigger = _props.trigger,
        testId = _props.testId,
        stretched = _props.stretched,
        enableArrowKeyExpansion = _props.enableArrowKeyExpansion,
        other = (0, _objectWithoutProperties3.default)(_props, ["arrow", "dir", "centerArrow", "marginBottom", "marginLeft", "marginRight", "marginTop", "positioning", "trigger", "testId", "stretched", "enableArrowKeyExpansion"]);
    var theme = this.theme;
    var _state = this.state,
        hidden = _state.hidden,
        items = _state.items;


    var triggerElement = _react2.default.cloneElement(typeof trigger === "function" ? trigger({ open: !hidden }) : trigger, { ref: "triggerElement" });

    var anchor = _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)((_classNames = {}, _classNames[theme.stretched] = stretched, _classNames)),
        onKeyDown: function onKeyDown(event) {
          if (!hidden) {
            _this2.selectionModel.handleKeyDown(event);
          } else if (enableArrowKeyExpansion && (event.keyCode === _keyCodes2.default.UP || event.keyCode === _keyCodes2.default.DOWN)) {
            _this2.showMenu();
            event.preventDefault();
            event.stopPropagation();
          }
        },
        onBlur: function onBlur(event) {
          if (!_this2.containerMousedDown) {
            _this2.closeMenu(event);
          }
        },
        onClick: this.toggleHidden,
        onEnter: this.keyboardToggleHidden,
        onEscape: this.closeMenu,
        onSpace: this.keyboardToggleHidden
      },
      triggerElement
    );

    var arrowMargin = arrow ? 3 : 0;

    var centerPoint = centerArrow ? 19 : null;

    return _react2.default.createElement(
      _RelativePositionedPopup2.default,
      {
        anchor: anchor,
        centerPoint: centerPoint,
        dir: dir,
        hidden: hidden,
        positioning: positioning,
        marginTop: marginTop + arrowMargin,
        marginLeft: marginLeft + arrowMargin,
        marginRight: marginRight + arrowMargin,
        marginBottom: marginBottom + arrowMargin,
        stretched: stretched,
        testId: testId
      },
      function (position) {
        return _react2.default.createElement(
          _Container2.default,
          (0, _extends3.default)({}, other, {
            animate: !hidden,
            dir: dir,
            arrow: arrow,
            position: position,
            onMouseDown: function onMouseDown(event) {
              _this2.containerMousedDown = true;

              setTimeout(function () {
                _this2.containerMousedDown = false;
              }, 0);
            },
            onBlur: function onBlur() {
              return _this2.closeMenu();
            },
            onKeyDown: _this2.selectionModel.handleKeyDown,
            onEscape: _this2.closeMenu
          }),
          items
        );
      }
    );
  };

  return Menu;
}(_ThemedComponent3.default);

Menu.propTypes = {
  arrow: _propTypes2.default.bool,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  centerArrow: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.node.isRequired,
  fixedWidth: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onOpen: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  marginBottom: _propTypes2.default.number,
  marginLeft: _propTypes2.default.number,
  marginRight: _propTypes2.default.number,
  marginTop: _propTypes2.default.number,
  maxHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /** <a href="#relativepositionedpopup">See RelativePositionedPopup</a> */
  positioning: _RelativePositionedPopup2.default.propTypes.positioning,
  size: _propTypes2.default.oneOf(["small", "medium"]),
  stretched: _propTypes2.default.bool,
  testId: _propTypes2.default.string,
  trigger: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]).isRequired,
  /**
   * Allows arrow keys to expand Menu. Used by the Select component.
   */
  enableArrowKeyExpansion: _propTypes2.default.bool,
  /**
   * Focus the trigger DOM node when a menu item is selected
   */
  focusOnClose: _propTypes2.default.bool,
  /**
   * Callback that determines whether the menu should be closed
   * when a value is selected. Useful for nested menus.
   * Passed (selectedValue, selectionEvent)
   */
  shouldClose: _propTypes2.default.func,
  className: _propTypes2.default.string
};
Menu.defaultProps = {
  arrow: false,
  dir: "ltr",
  centerArrow: false,
  marginBottom: 4,
  marginLeft: 4,
  marginRight: 4,
  marginTop: 4,
  positioning: ["bottom_right", "top_right"],
  stretched: false,
  size: "medium",
  enableArrowKeyExpansion: false,
  focusOnClose: true
};
Menu.Container = _Container2.default;
Menu.Item = _Item2.default;
Menu.LinkItem = _LinkItem2.default;
Menu.Separator = _Separator2.default;
Menu.PreviousItem = _PreviousItem2.default;
Menu.NextItem = _NextItem2.default;
Menu.HeaderItem = _HeaderItem2.default;
Menu.AddItem = _AddItem2.default;
Menu.MediaItem = _MediaItem2.default;
exports.default = Menu;

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: "/*!\n * Copyright Zendesk, Inc.\n *\n * Use of this source code is governed under the Apache License, Version 2.0\n * found at http://www.apache.org/licenses/LICENSE-2.0.\n */.scc-c-chk-4506f8eb{position:relative;margin:0;border:0;padding:0}.scc-c-chk__input-4506f8eb{position:absolute;clip:rect(1px,1px,1px,1px)}.scc-c-chk__label-4506f8eb{display:inline-block;position:relative;cursor:pointer;padding-left:22px;vertical-align:middle;line-height:1.42857;white-space:normal;color:#2f3941;font-size:14px;font-weight:600;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.scc-c-chk__label-4506f8eb:before{position:absolute;top:10px;left:0;-webkit-transition:border-color .25s ease-in-out,background-color .25s ease-in-out,background-image .25s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;transition:border-color .25s ease-in-out,background-color .25s ease-in-out,background-image .25s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;transition:border-color .25s ease-in-out,box-shadow .1s ease-in-out,background-color .25s ease-in-out,background-image .25s ease-in-out,color .25s ease-in-out;transition:border-color .25s ease-in-out,box-shadow .1s ease-in-out,background-color .25s ease-in-out,background-image .25s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;margin-top:-7px;border:1px solid #d8dcde;border-radius:4px;background-color:#fff;background-repeat:no-repeat;background-position:50%;background-size:100%;width:14px;height:14px;-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;content:\"\"}.scc-c-chk__label--regular-4506f8eb{font-weight:400}.scc-c-chk__hint-4506f8eb{padding-left:22px;line-height:1.42857;color:#68737d;font-size:14px}.scc-c-chk__message-4506f8eb{display:inline-block;padding-left:22px;vertical-align:middle;line-height:1.33333;color:#49545c;font-size:12px}.scc-c-chk__message--error-4506f8eb,.scc-c-chk__message--success-4506f8eb,.scc-c-chk__message--warning-4506f8eb{background-repeat:no-repeat;background-position:0 0}.scc-c-chk__message--error-4506f8eb{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23D93F4C'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm-.75 3.75c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.5zM7 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'/%3E%3C/svg%3E\");color:#cc3340}.scc-c-chk__message--success-4506f8eb{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23228F67'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm3.09 5.363l-3.3 4.2a.75.75 0 0 1-.545.286H6.2a.748.748 0 0 1-.53-.22L3.97 7.93a.75.75 0 1 1 1.06-1.06l1.103 1.102L8.91 4.437a.75.75 0 0 1 1.18.926z'/%3E%3C/svg%3E\");color:#038153}.scc-c-chk__message--warning-4506f8eb{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23F5A133'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm-.75 3.75c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.5zM7 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'/%3E%3C/svg%3E\");color:#ad5e18}.scc-c-chk__label-4506f8eb.scc-is-hidden-4506f8eb{padding-left:14px;font-size:0}.scc-c-chk__label-4506f8eb.scc-is-hidden-4506f8eb:before{top:0}.scc-is-rtl-4506f8eb.scc-c-chk-4506f8eb{direction:rtl}.scc-is-rtl-4506f8eb.scc-c-chk__label-4506f8eb:before{right:0;left:auto}.scc-is-rtl-4506f8eb.scc-c-chk__hint-4506f8eb,.scc-is-rtl-4506f8eb.scc-c-chk__label-4506f8eb,.scc-is-rtl-4506f8eb.scc-c-chk__message-4506f8eb{direction:rtl;padding-right:22px;padding-left:0}.scc-is-rtl-4506f8eb.scc-c-chk__message--error-4506f8eb,.scc-is-rtl-4506f8eb.scc-c-chk__message--success-4506f8eb,.scc-is-rtl-4506f8eb.scc-c-chk__message--warning-4506f8eb{background-position:100% 0;padding-left:0}.scc-is-rtl-4506f8eb.scc-c-chk__label-4506f8eb.scc-is-hidden-4506f8eb{padding-right:14px}.scc-c-chk__label-4506f8eb+.scc-c-chk__message-4506f8eb{display:block;margin-top:4px}.scc-c-chk-4506f8eb .scc-c-chk__hint-4506f8eb{display:block}.scc-c-chk__input-4506f8eb:checked~.scc-c-chk__label-4506f8eb:before,.scc-c-chk__label-4506f8eb.scc-is-checked-4506f8eb:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23FFF'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M4.5 7.19L6.76 9.5l2.744-5'/%3E%3C/svg%3E\")}.scc-c-chk__input-4506f8eb:indeterminate~.scc-c-chk__label-4506f8eb:not(.scc-c-chk__label--radio-4506f8eb):not(.scc-c-chk__label--toggle-4506f8eb):before,.scc-c-chk__label-4506f8eb:not(.scc-c-chk__label--radio-4506f8eb):not(.scc-c-chk__label--toggle-4506f8eb).scc-is-indeterminate-4506f8eb:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23FFF'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M4.25 7h5.5'/%3E%3C/svg%3E\")}.scc-c-chk__input-4506f8eb:checked:enabled~.scc-c-chk__label-4506f8eb:not(.scc-is-disabled-4506f8eb):before,.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb.scc-is-checked-4506f8eb:not(.scc-is-disabled-4506f8eb):before,.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb:not(.scc-c-chk__label--radio-4506f8eb):not(.scc-c-chk__label--toggle-4506f8eb).scc-is-indeterminate-4506f8eb:not(.scc-is-disabled-4506f8eb):before,.scc-c-chk__input-4506f8eb:indeterminate:enabled~.scc-c-chk__label-4506f8eb:not(.scc-c-chk__label--radio-4506f8eb):not(.scc-c-chk__label--toggle-4506f8eb):not(.scc-is-disabled-4506f8eb):before{border-color:#1f73b7;background-color:#1f73b7}.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb.scc-is-hovered-4506f8eb:not(.scc-is-disabled-4506f8eb):before,.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb:not(.scc-is-disabled-4506f8eb):hover:before{border-color:#1f73b7}.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb.scc-is-focused-4506f8eb:not(.scc-is-disabled-4506f8eb):before{outline:0;border-color:#1f73b7;-webkit-box-shadow:0 0 0 3px rgba(31,115,183,.35);box-shadow:0 0 0 3px rgba(31,115,183,.35)}.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb.scc-is-active-4506f8eb:not(.scc-is-disabled-4506f8eb):before,.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb:not(.scc-is-disabled-4506f8eb):active:before{-webkit-transition:border-color .1s ease-in-out,background-color .1s ease-in-out,background-image .1s ease-in-out,color .1s ease-in-out;transition:border-color .1s ease-in-out,background-color .1s ease-in-out,background-image .1s ease-in-out,color .1s ease-in-out;border-color:#1f73b7;background-color:#cee2f2}.scc-c-chk__input-4506f8eb:enabled:checked~.scc-c-chk__label-4506f8eb.scc-is-active-4506f8eb:not(.scc-is-disabled-4506f8eb):before,.scc-c-chk__input-4506f8eb:enabled:checked~.scc-c-chk__label-4506f8eb:not(.scc-is-disabled-4506f8eb):active:before,.scc-c-chk__input-4506f8eb:enabled:indeterminate~.scc-c-chk__label-4506f8eb:not(.scc-c-chk__label--radio-4506f8eb):not(.scc-c-chk__label--toggle-4506f8eb).scc-is-active-4506f8eb:not(.scc-is-disabled-4506f8eb):before,.scc-c-chk__input-4506f8eb:enabled:indeterminate~.scc-c-chk__label-4506f8eb:not(.scc-c-chk__label--radio-4506f8eb):not(.scc-c-chk__label--toggle-4506f8eb):not(.scc-is-disabled-4506f8eb):active:before,.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb.scc-is-checked-4506f8eb.scc-is-active-4506f8eb:not(.scc-is-disabled-4506f8eb):before,.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb.scc-is-checked-4506f8eb:not(.scc-is-disabled-4506f8eb):active:before,.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb:not(.scc-c-chk__label--radio-4506f8eb):not(.scc-c-chk__label--toggle-4506f8eb).scc-is-indeterminate-4506f8eb.scc-is-active-4506f8eb:not(.scc-is-disabled-4506f8eb):before,.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb:not(.scc-c-chk__label--radio-4506f8eb):not(.scc-c-chk__label--toggle-4506f8eb).scc-is-indeterminate-4506f8eb:not(.scc-is-disabled-4506f8eb):active:before{border-color:#144a75;background-color:#144a75}.scc-c-chk__input-4506f8eb[disabled]~.scc-c-chk__label-4506f8eb,.scc-c-chk__label-4506f8eb.scc-is-disabled-4506f8eb{cursor:default}.scc-c-chk__input-4506f8eb[disabled]~.scc-c-chk__label-4506f8eb:before,.scc-c-chk__label-4506f8eb.scc-is-disabled-4506f8eb:before{border-color:transparent;-webkit-box-shadow:none;box-shadow:none;background-color:#e9ebed}.scc-c-chk__label--radio-4506f8eb:before{border-radius:50%}.scc-c-chk__input-4506f8eb:checked~.scc-c-chk__label-4506f8eb.scc-c-chk__label--radio-4506f8eb:before,.scc-c-chk__label-4506f8eb.scc-is-checked-4506f8eb.scc-c-chk__label--radio-4506f8eb:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' color='%23FFF'%3E%3Ccircle cx='6' cy='6' r='2' fill='currentColor'/%3E%3C/svg%3E\")}.scc-c-chk__hint--toggle-4506f8eb,.scc-c-chk__label--toggle-4506f8eb,.scc-c-chk__message--toggle-4506f8eb{padding-left:48px}.scc-c-chk__message--toggle-4506f8eb{background-position:26px}.scc-c-chk__label--toggle-4506f8eb:before{top:0;-webkit-transition:background-color .15s ease-in-out,background-position .15s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;transition:background-color .15s ease-in-out,background-position .15s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;transition:box-shadow .1s ease-in-out,background-color .15s ease-in-out,background-position .15s ease-in-out,color .25s ease-in-out;transition:box-shadow .1s ease-in-out,background-color .15s ease-in-out,background-position .15s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;margin-top:0;border:none;border-radius:100px;background-color:#87929d;background-position:10%;background-size:auto;width:40px;height:20px}.scc-c-chk__input-4506f8eb:checked~.scc-c-chk__label-4506f8eb.scc-c-chk__label--toggle-4506f8eb:before,.scc-c-chk__label--toggle-4506f8eb:before,.scc-c-chk__label-4506f8eb.scc-is-checked-4506f8eb.scc-c-chk__label--toggle-4506f8eb:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23FFF'%3E%3Ccircle cx='7' cy='7' r='6' fill='currentColor'/%3E%3C/svg%3E\")}.scc-c-chk__input-4506f8eb:checked~.scc-c-chk__label-4506f8eb.scc-c-chk__label--toggle-4506f8eb:before,.scc-c-chk__label-4506f8eb.scc-is-checked-4506f8eb.scc-c-chk__label--toggle-4506f8eb:before{background-position:90%}.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb.scc-is-active-4506f8eb:not(.scc-is-disabled-4506f8eb).scc-c-chk__label--toggle-4506f8eb:before,.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb:not(.scc-is-disabled-4506f8eb):active.scc-c-chk__label--toggle-4506f8eb:before{background-color:#68737d}.scc-c-chk__input-4506f8eb:enabled:checked~.scc-c-chk__label-4506f8eb.scc-is-active-4506f8eb:not(.scc-is-disabled-4506f8eb).scc-c-chk__label--toggle-4506f8eb:before,.scc-c-chk__input-4506f8eb:enabled:checked~.scc-c-chk__label-4506f8eb:not(.scc-is-disabled-4506f8eb):active.scc-c-chk__label--toggle-4506f8eb:before,.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb.scc-is-checked-4506f8eb.scc-is-active-4506f8eb:not(.scc-is-disabled-4506f8eb).scc-c-chk__label--toggle-4506f8eb:before,.scc-c-chk__input-4506f8eb:enabled~.scc-c-chk__label-4506f8eb.scc-is-checked-4506f8eb:not(.scc-is-disabled-4506f8eb):active.scc-c-chk__label--toggle-4506f8eb:before{background-color:#144a75}.scc-c-chk__input-4506f8eb[disabled]~.scc-c-chk__label-4506f8eb.scc-c-chk__label--toggle-4506f8eb:before,.scc-c-chk__label-4506f8eb.scc-is-disabled-4506f8eb.scc-c-chk__label--toggle-4506f8eb:before{background-color:#e9ebed}.scc-c-chk__label--toggle-4506f8eb.scc-is-hidden-4506f8eb{padding-left:40px;vertical-align:top}.scc-is-rtl-4506f8eb.scc-c-chk__hint--toggle-4506f8eb,.scc-is-rtl-4506f8eb.scc-c-chk__label--toggle-4506f8eb,.scc-is-rtl-4506f8eb.scc-c-chk__message--toggle-4506f8eb{padding-right:48px;padding-left:0}.scc-is-rtl-4506f8eb.scc-c-chk__message--toggle-4506f8eb{background-position:calc(100% - 26px)}.scc-is-rtl-4506f8eb.scc-c-chk__label--toggle-4506f8eb.scc-is-hidden-4506f8eb{padding-right:40px}.scc-is-rtl-4506f8eb.scc-c-chk__label--toggle-4506f8eb:before{background-position:90%}.scc-c-chk__input-4506f8eb:checked~.scc-c-chk__label-4506f8eb.scc-is-rtl-4506f8eb.scc-c-chk__label--toggle-4506f8eb:before,.scc-c-chk__label-4506f8eb.scc-is-checked-4506f8eb.scc-is-rtl-4506f8eb.scc-c-chk__label--toggle-4506f8eb:before{background-position:10%}.scc-c-range-4506f8eb{margin:0;border:0;padding:0}.scc-c-range__input-4506f8eb{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0;outline:0;background-color:inherit;background-size:0;cursor:pointer;padding:0;width:100%;vertical-align:middle}.scc-c-range__input-4506f8eb::-moz-range-track{-moz-appearance:none;appearance:none;margin:10.5px 0;border-radius:5px;border-color:transparent;background-color:#e9ebed;background-image:linear-gradient(#1f73b7,#1f73b7);background-repeat:repeat-y;background-size:0;width:99.8%;height:5px;color:transparent;box-sizing:border-box}.scc-c-range__input-4506f8eb::-ms-track{appearance:none;margin:10.5px 0;border-radius:5px;border-color:transparent;background-color:#e9ebed;background-image:linear-gradient(#1f73b7,#1f73b7);background-repeat:repeat-y;background-size:0;width:99.8%;height:5px;color:transparent;box-sizing:border-box}.scc-c-range__input-4506f8eb::-webkit-slider-runnable-track{-webkit-appearance:none;appearance:none;margin:10.5px 0;border-radius:5px;border-color:transparent;background-color:#e9ebed;background-image:-webkit-gradient(linear,left top,left bottom,from(#1f73b7),to(#1f73b7));background-image:linear-gradient(#1f73b7,#1f73b7);background-repeat:repeat-y;background-size:0;width:99.8%;height:5px;color:transparent;-webkit-box-sizing:border-box;box-sizing:border-box}.scc-c-range__input-4506f8eb::-moz-range-thumb{-moz-appearance:none;appearance:none;margin:-7.5px 0;border:3px solid #1f73b7;border-radius:100%;box-shadow:0 4px 8px 0 rgba(47,57,65,.24);background-color:#1f73b7;width:20px;height:20px;box-sizing:border-box}.scc-c-range__input-4506f8eb::-ms-thumb{appearance:none;margin:-7.5px 0;border:3px solid #1f73b7;border-radius:100%;box-shadow:0 4px 8px 0 rgba(47,57,65,.24);background-color:#1f73b7;width:20px;height:20px;box-sizing:border-box}.scc-c-range__input-4506f8eb::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;margin:-7.5px 0;border:3px solid #1f73b7;border-radius:100%;-webkit-box-shadow:0 4px 8px 0 rgba(47,57,65,.24);box-shadow:0 4px 8px 0 rgba(47,57,65,.24);background-color:#1f73b7;width:20px;height:20px;-webkit-box-sizing:border-box;box-sizing:border-box}.scc-c-range__input-4506f8eb::-moz-range-progress{border-top-left-radius:5px;border-bottom-left-radius:5px;background-color:#1f73b7;height:5px}.scc-c-range__input-4506f8eb::-ms-fill-lower{border-top-left-radius:5px;border-bottom-left-radius:5px;background-color:#1f73b7;height:5px}.scc-c-range__input-4506f8eb::-moz-focus-outer{border:0}.scc-c-range__input-4506f8eb::-ms-tooltip{display:none}.scc-c-range__input-4506f8eb::-webkit-slider-container,.scc-c-range__input-4506f8eb::-webkit-slider-runnable-track{background-size:inherit}.scc-c-range-4506f8eb.scc-is-rtl-4506f8eb,.scc-c-range__hint-4506f8eb.scc-is-rtl-4506f8eb,.scc-c-range__input-4506f8eb.scc-is-rtl-4506f8eb,.scc-c-range__label-4506f8eb.scc-is-rtl-4506f8eb,.scc-c-range__message-4506f8eb.scc-is-rtl-4506f8eb{direction:rtl}.scc-c-range__input-4506f8eb.scc-is-rtl-4506f8eb::-moz-range-track{background-position:100% 100%}.scc-c-range__input-4506f8eb.scc-is-rtl-4506f8eb::-ms-track{background-position:100% 100%}.scc-c-range__input-4506f8eb.scc-is-rtl-4506f8eb::-webkit-slider-runnable-track{background-position:100% 100%}.scc-c-range__input-4506f8eb.scc-is-rtl-4506f8eb::-moz-range-progress{border-top-right-radius:5px;border-bottom-right-radius:5px}.scc-c-range__input-4506f8eb.scc-is-rtl-4506f8eb::-ms-fill-lower{border-top-right-radius:5px;border-bottom-right-radius:5px}.scc-c-range--inline-4506f8eb{display:inline-block}.scc-c-range--inline-4506f8eb .scc-c-range__input-4506f8eb{width:auto}.scc-c-range__input-4506f8eb.scc-is-disabled-4506f8eb,.scc-c-range__input-4506f8eb[disabled]{cursor:default}.scc-c-range__input-4506f8eb.scc-is-focused-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled])::-moz-range-thumb{box-shadow:0 0 0 3px rgba(31,115,183,.35)}.scc-c-range__input-4506f8eb.scc-is-focused-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled])::-ms-thumb{box-shadow:0 0 0 3px rgba(31,115,183,.35)}.scc-c-range__input-4506f8eb.scc-is-focused-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled])::-webkit-slider-thumb{-webkit-box-shadow:0 0 0 3px rgba(31,115,183,.35);box-shadow:0 0 0 3px rgba(31,115,183,.35)}.scc-c-range__input-4506f8eb.scc-is-active-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled])::-moz-range-thumb,.scc-c-range__input-4506f8eb:active:not(.scc-is-disabled-4506f8eb):not([disabled])::-moz-range-thumb{background-color:#144a75}.scc-c-range__input-4506f8eb.scc-is-active-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled])::-ms-thumb,.scc-c-range__input-4506f8eb:active:not(.scc-is-disabled-4506f8eb):not([disabled])::-ms-thumb{background-color:#144a75}.scc-c-range__input-4506f8eb.scc-is-active-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled])::-webkit-slider-thumb,.scc-c-range__input-4506f8eb:active:not(.scc-is-disabled-4506f8eb):not([disabled])::-webkit-slider-thumb{background-color:#144a75}.scc-c-range__input-4506f8eb.scc-is-disabled-4506f8eb::-moz-range-track,.scc-c-range__input-4506f8eb[disabled]::-moz-range-track{background-color:#e9ebed;background-image:linear-gradient(#d8dcde,#d8dcde)}.scc-c-range__input-4506f8eb.scc-is-disabled-4506f8eb::-ms-track,.scc-c-range__input-4506f8eb[disabled]::-ms-track{background-color:#e9ebed;background-image:linear-gradient(#d8dcde,#d8dcde)}.scc-c-range__input-4506f8eb.scc-is-disabled-4506f8eb::-webkit-slider-runnable-track,.scc-c-range__input-4506f8eb[disabled]::-webkit-slider-runnable-track{background-color:#e9ebed;background-image:-webkit-gradient(linear,left top,left bottom,from(#d8dcde),to(#d8dcde));background-image:linear-gradient(#d8dcde,#d8dcde)}.scc-c-range__input-4506f8eb.scc-is-disabled-4506f8eb::-moz-range-thumb,.scc-c-range__input-4506f8eb[disabled]::-moz-range-thumb{border-color:#d8dcde;box-shadow:none;background-color:#d8dcde}.scc-c-range__input-4506f8eb.scc-is-disabled-4506f8eb::-ms-thumb,.scc-c-range__input-4506f8eb[disabled]::-ms-thumb{border-color:#d8dcde;box-shadow:none;background-color:#d8dcde}.scc-c-range__input-4506f8eb.scc-is-disabled-4506f8eb::-webkit-slider-thumb,.scc-c-range__input-4506f8eb[disabled]::-webkit-slider-thumb{border-color:#d8dcde;-webkit-box-shadow:none;box-shadow:none;background-color:#d8dcde}.scc-c-range__input-4506f8eb.scc-is-disabled-4506f8eb::-moz-range-progress,.scc-c-range__input-4506f8eb[disabled]::-moz-range-progress{background-color:#d8dcde}.scc-c-range__input-4506f8eb.scc-is-disabled-4506f8eb::-ms-fill-lower,.scc-c-range__input-4506f8eb[disabled]::-ms-fill-lower{background-color:#d8dcde}.scc-c-range__slider-4506f8eb{display:block;position:relative;z-index:0;cursor:pointer;height:26px}.scc-c-range__slider__track-4506f8eb{position:absolute;top:50%;margin-top:-2.5px;border-radius:5px;background-color:#e9ebed;background-origin:content-box;background-image:-webkit-gradient(linear,left top,left bottom,from(#1f73b7),to(#1f73b7));background-image:linear-gradient(#1f73b7,#1f73b7);background-repeat:repeat-y;padding:0 10px;width:100%}.scc-c-range__slider__track__rail-4506f8eb{position:relative;margin:0 10px 0 -10px;height:5px}.scc-c-range__slider__track__rail__thumb-4506f8eb{-webkit-appearance:none;-moz-appearance:none;appearance:none;position:absolute;top:50%;z-index:1;margin-top:-10px;border:3px solid #1f73b7;border-radius:100%;-webkit-box-shadow:0 4px 8px 0 rgba(47,57,65,.24);box-shadow:0 4px 8px 0 rgba(47,57,65,.24);background-color:#1f73b7;cursor:inherit;width:20px;height:20px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:0}.scc-c-range__slider__track__rail__thumb-4506f8eb::-moz-range-track{-moz-appearance:none;appearance:none}.scc-c-range__slider__track__rail__thumb-4506f8eb::-ms-track{appearance:none}.scc-c-range__slider__track__rail__thumb-4506f8eb::-webkit-slider-runnable-track{-webkit-appearance:none;appearance:none}.scc-c-range__slider__track__rail__thumb-4506f8eb::-moz-range-thumb{-moz-appearance:none;appearance:none}.scc-c-range__slider__track__rail__thumb-4506f8eb::-ms-thumb{appearance:none}.scc-c-range__slider__track__rail__thumb-4506f8eb::-webkit-slider-thumb{-webkit-appearance:none;appearance:none}.scc-c-range__slider__track__rail__thumb-4506f8eb::-ms-tooltip{display:none}.scc-c-range__slider__track__rail__thumb-4506f8eb:first-of-type{left:0}.scc-c-range__slider__track__rail__thumb-4506f8eb:last-of-type{left:100%}.scc-c-range__slider__track__rail__thumb-4506f8eb:focus{outline:0}.scc-c-range__slider__track__rail__thumb-4506f8eb.scc-is-focused-4506f8eb{-webkit-box-shadow:0 0 0 3px rgba(31,115,183,.35);box-shadow:0 0 0 3px rgba(31,115,183,.35)}.scc-c-range__slider-4506f8eb.scc-is-active-4506f8eb .scc-c-range__slider__track__rail__thumb-4506f8eb:first-of-type,.scc-c-range__slider-4506f8eb:not(.scc-is-disabled-4506f8eb) .scc-c-range__slider__track__rail__thumb-4506f8eb:active{background-color:#144a75}.scc-c-range__slider__track__rail__thumb-4506f8eb.scc-is-focused-4506f8eb:active{-webkit-box-shadow:none;box-shadow:none}.scc-c-range__slider-4506f8eb.scc-is-disabled-4506f8eb .scc-c-range__slider-4506f8eb{cursor:default}.scc-c-range__slider-4506f8eb.scc-is-disabled-4506f8eb .scc-c-range__slider__track-4506f8eb{background-color:#e9ebed;background-image:-webkit-gradient(linear,left top,left bottom,from(#d8dcde),to(#d8dcde));background-image:linear-gradient(#d8dcde,#d8dcde)}.scc-c-range__slider-4506f8eb.scc-is-disabled-4506f8eb .scc-c-range__slider__track__rail__thumb-4506f8eb{border-color:#d8dcde;-webkit-box-shadow:none;box-shadow:none;background-color:#d8dcde}.scc-c-range--inline-4506f8eb .scc-c-range__slider-4506f8eb{display:inline-block;vertical-align:middle;inline-size:129px}.scc-c-range__slider-4506f8eb.scc-is-rtl-4506f8eb .scc-c-range__slider__track__rail-4506f8eb{margin:0 -10px 0 10px}.scc-c-range__label-4506f8eb{vertical-align:middle;line-height:2.14286;color:#2f3941;font-size:14px;font-weight:600}.scc-c-range__label--regular-4506f8eb{font-weight:400}.scc-c-range__label--sm-4506f8eb{line-height:2}.scc-c-range__hint-4506f8eb{line-height:1.42857;color:#68737d;font-size:14px}.scc-c-range__message-4506f8eb{display:inline-block;vertical-align:middle;line-height:1.33333;color:#49545c;font-size:12px}.scc-c-range__message--error-4506f8eb,.scc-c-range__message--success-4506f8eb,.scc-c-range__message--warning-4506f8eb{background-repeat:no-repeat;background-position:0 0;padding-left:20px}.scc-c-range__message--error-4506f8eb{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23D93F4C'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm-.75 3.75c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.5zM7 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'/%3E%3C/svg%3E\");color:#cc3340}.scc-c-range__message--success-4506f8eb{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23228F67'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm3.09 5.363l-3.3 4.2a.75.75 0 0 1-.545.286H6.2a.748.748 0 0 1-.53-.22L3.97 7.93a.75.75 0 1 1 1.06-1.06l1.103 1.102L8.91 4.437a.75.75 0 0 1 1.18.926z'/%3E%3C/svg%3E\");color:#038153}.scc-c-range__message--warning-4506f8eb{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23F5A133'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm-.75 3.75c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.5zM7 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'/%3E%3C/svg%3E\");color:#ad5e18}.scc-is-rtl-4506f8eb.scc-c-range__message--error-4506f8eb,.scc-is-rtl-4506f8eb.scc-c-range__message--success-4506f8eb,.scc-is-rtl-4506f8eb.scc-c-range__message--warning-4506f8eb{background-position:100% 0;padding-right:20px;padding-left:0}.scc-c-range__hint-4506f8eb+.scc-c-range__input-4506f8eb,.scc-c-range__hint-4506f8eb+.scc-c-range__slider-4506f8eb,.scc-c-range__input-4506f8eb+.scc-c-range__hint-4506f8eb,.scc-c-range__slider-4506f8eb+.scc-c-range__hint-4506f8eb{margin-top:8px}.scc-c-range__hint--sm-4506f8eb+.scc-c-range__input--sm-4506f8eb,.scc-c-range__hint--sm-4506f8eb+.scc-c-range__slider--sm-4506f8eb,.scc-c-range__input--sm-4506f8eb+.scc-c-range__hint--sm-4506f8eb,.scc-c-range__slider--sm-4506f8eb+.scc-c-range__hint--sm-4506f8eb{margin-top:4px}.scc-c-range__label-4506f8eb+.scc-c-range__hint-4506f8eb{margin-top:-4px}.scc-c-range__input-4506f8eb+.scc-c-range__message-4506f8eb,.scc-c-range__slider-4506f8eb+.scc-c-range__message-4506f8eb{margin-top:8px}.scc-c-range-4506f8eb .scc-c-range__hint-4506f8eb{display:block}.scc-c-range--inline-4506f8eb .scc-c-range__input-4506f8eb+.scc-c-range__message-4506f8eb,.scc-c-range--inline-4506f8eb .scc-c-range__slider-4506f8eb+.scc-c-range__message-4506f8eb{margin-top:0}.scc-c-txt-4506f8eb{margin:0;border:0;padding:0}.scc-c-txt__input-4506f8eb{-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-transition:border-color .25s ease-in-out,background-color .25s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;transition:border-color .25s ease-in-out,background-color .25s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;transition:border-color .25s ease-in-out,box-shadow .1s ease-in-out,background-color .25s ease-in-out,color .25s ease-in-out;transition:border-color .25s ease-in-out,box-shadow .1s ease-in-out,background-color .25s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;outline:0;border:1px solid #d8dcde;border-radius:4px;background-color:#fff;padding:.71429em 1.14286em;width:100%;min-height:40px;-webkit-box-sizing:border-box;box-sizing:border-box;vertical-align:middle;line-height:1.28571;color:#2f3941;font-family:inherit;font-size:14px}@media screen\\0{.scc-c-txt__input-4506f8eb{font-family:sans-serif}}.scc-c-txt__input-4506f8eb::-ms-browse{border-radius:2px;font-size:12px}.scc-c-txt__input-4506f8eb::-ms-clear,.scc-c-txt__input-4506f8eb::-ms-reveal{display:none}.scc-c-txt__input-4506f8eb::-webkit-clear-button,.scc-c-txt__input-4506f8eb::-webkit-inner-spin-button,.scc-c-txt__input-4506f8eb::-webkit-search-cancel-button,.scc-c-txt__input-4506f8eb::-webkit-search-results-button{display:none}.scc-c-txt__input-4506f8eb::-webkit-datetime-edit{line-height:1}.scc-c-txt__input-4506f8eb::-webkit-input-placeholder{opacity:1;color:#c2c8cc}.scc-c-txt__input-4506f8eb:-ms-input-placeholder,.scc-c-txt__input-4506f8eb::-ms-input-placeholder{opacity:1;color:#c2c8cc}.scc-c-txt__input-4506f8eb::placeholder{opacity:1;color:#c2c8cc}.scc-c-txt__input-4506f8eb:invalid{-webkit-box-shadow:none;box-shadow:none}.scc-c-txt__input-4506f8eb[type=date],.scc-c-txt__input-4506f8eb[type=datetime-local],.scc-c-txt__input-4506f8eb[type=file],.scc-c-txt__input-4506f8eb[type=month],.scc-c-txt__input-4506f8eb[type=time],.scc-c-txt__input-4506f8eb[type=week]{max-height:40px}.scc-c-txt__input-4506f8eb[type=file]{line-height:1}.scc-c-txt__input-4506f8eb[type=file]::-ms-value{display:none}@media screen and (min--moz-device-pixel-ratio:0){.scc-c-txt__input-4506f8eb[type=number]{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}}.scc-c-txt-4506f8eb.scc-is-rtl-4506f8eb,.scc-c-txt__hint-4506f8eb.scc-is-rtl-4506f8eb,.scc-c-txt__input-4506f8eb.scc-is-rtl-4506f8eb,.scc-c-txt__label-4506f8eb.scc-is-rtl-4506f8eb,.scc-c-txt__message-4506f8eb.scc-is-rtl-4506f8eb{direction:rtl}.scc-c-txt__input-4506f8eb.scc-is-rtl-4506f8eb::-webkit-datetime-edit{direction:rtl}.scc-c-txt--inline-4506f8eb{display:inline-block}.scc-c-txt--inline-4506f8eb .scc-c-txt__input-4506f8eb{width:auto}@supports (-ms-ime-align:auto){.scc-c-txt__input-4506f8eb[type=color]{padding:1px 3px}.scc-c-txt--sm__input-4506f8eb[type=color]{padding:0 2px}}.scc-c-txt__input-4506f8eb::-moz-color-swatch{margin-top:-5px;margin-left:-11px;border:none;border-radius:2px;width:calc(100% + 22px);height:28px}.scc-c-txt__input-4506f8eb::-webkit-color-swatch{margin:-5px -11px;border:none;border-radius:2px}.scc-c-txt__input--sm-4506f8eb::-webkit-color-swatch{margin:-3px -9px}.scc-c-txt__input--sm-4506f8eb::-moz-color-swatch{margin-top:-3px;margin-left:-9px;width:calc(100% + 18px);height:24px}.scc-c-txt__input-4506f8eb::-webkit-color-swatch-wrapper{padding:0}.scc-c-txt__input--area-4506f8eb{resize:none;overflow:auto}.scc-c-txt__input--area-4506f8eb.scc-is-resizable-4506f8eb{resize:vertical}.scc-c-txt__input--select-4506f8eb{-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;padding-right:3.42857em;text-align:left}.scc-c-txt__input--select-4506f8eb:not(select):before{position:absolute;top:0;right:0;cursor:pointer;width:48px;height:40px;content:\"\"}.scc-c-txt__input--select-4506f8eb:not(select):before,select.scc-c-txt__input--select-4506f8eb{-webkit-transition:background-image .25s ease-in-out,border-color .25s ease-in-out,background-color .25s ease-in-out,color .25s ease-in-out,-webkit-transform .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;transition:background-image .25s ease-in-out,border-color .25s ease-in-out,background-color .25s ease-in-out,color .25s ease-in-out,-webkit-transform .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;transition:background-image .25s ease-in-out,transform .25s ease-in-out,border-color .25s ease-in-out,box-shadow .1s ease-in-out,background-color .25s ease-in-out,color .25s ease-in-out;transition:background-image .25s ease-in-out,transform .25s ease-in-out,border-color .25s ease-in-out,box-shadow .1s ease-in-out,background-color .25s ease-in-out,color .25s ease-in-out,-webkit-transform .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%2368737D'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M4 6l3 3 3-3'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right 1.21429em center}select.scc-c-txt__input--select-4506f8eb::-ms-expand{display:none}select.scc-c-txt__input--select-4506f8eb::-ms-value{background-color:transparent;color:inherit}select.scc-c-txt__input--select-4506f8eb:-moz-focusring{-webkit-transition:none;transition:none;text-shadow:0 0 0 #2f3941;color:transparent}.scc-c-txt__input--select-4506f8eb::-webkit-calendar-picker-indicator{background-color:transparent;padding:0;color:transparent;position:absolute;top:0;right:0;cursor:pointer;width:48px;height:40px;content:\"\"}.scc-c-txt__input--select-4506f8eb.scc-is-focused-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]):not(select):before,.scc-c-txt__input--select-4506f8eb.scc-is-hovered-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]):not(select):before,.scc-c-txt__input--select-4506f8eb:focus:not(.scc-is-disabled-4506f8eb):not([disabled]):not(select):before,.scc-c-txt__input--select-4506f8eb:hover:not(.scc-is-disabled-4506f8eb):not([disabled]):not(select):before,select.scc-c-txt__input--select-4506f8eb.scc-is-focused-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]),select.scc-c-txt__input--select-4506f8eb.scc-is-hovered-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]),select.scc-c-txt__input--select-4506f8eb:focus:not(.scc-is-disabled-4506f8eb):not([disabled]),select.scc-c-txt__input--select-4506f8eb:hover:not(.scc-is-disabled-4506f8eb):not([disabled]){background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%2349545C'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M4 6l3 3 3-3'/%3E%3C/svg%3E\")}.scc-c-txt__input--select-4506f8eb.scc-is-open-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]):not(select):before{-webkit-transform:rotate(180deg) translateY(-1px);transform:rotate(180deg) translateY(-1px)}.scc-c-txt__input--select-4506f8eb.scc-is-disabled-4506f8eb:not(select):before,.scc-c-txt__input--select-4506f8eb[disabled]:not(select):before,select.scc-c-txt__input--select-4506f8eb[disabled]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23C2C8CC'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M4 6l3 3 3-3'/%3E%3C/svg%3E\")}.scc-is-rtl-4506f8eb.scc-c-txt__input--select-4506f8eb{padding-right:1.14286em;padding-left:3.42857em;text-align:right}.scc-is-rtl-4506f8eb.scc-c-txt__input--select-4506f8eb:not(select):before{right:auto;left:0}.scc-is-rtl-4506f8eb.scc-c-txt__input--select-4506f8eb::-webkit-calendar-picker-indicator{right:auto;left:0}.scc-is-rtl-4506f8eb.scc-c-txt__input--select-4506f8eb:not(select):before,select.scc-is-rtl-4506f8eb.scc-c-txt__input--select-4506f8eb{background-position:left 1.21429em center}.scc-is-rtl-4506f8eb.scc-c-txt__input--select-4506f8eb.scc-is-open-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]):not(select):before{-webkit-transform:rotate(-180deg) translateY(-1px);transform:rotate(-180deg) translateY(-1px)}.scc-c-txt__input--tag-4506f8eb .scc-c-label-4506f8eb,.scc-c-txt__input--tag-4506f8eb .scc-c-tag-4506f8eb{margin:2px}.scc-c-txt__input-4506f8eb.scc-c-txt__input--tag-4506f8eb{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:2px 8px}.scc-c-txt__input--tag-4506f8eb.scc-c-txt__input--sm-4506f8eb{padding-top:3px;padding-bottom:3px}.scc-c-txt__input--tag-4506f8eb.scc-c-txt__input--select-4506f8eb{padding-right:3.42857em}.scc-is-rtl-4506f8eb.scc-c-txt__input-4506f8eb.scc-c-txt__input--tag-4506f8eb.scc-c-txt__input--select-4506f8eb{padding-right:8px;padding-left:3.42857em}.scc-c-txt__input-4506f8eb.scc-is-hovered-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]),.scc-c-txt__input-4506f8eb:hover:not(.scc-is-disabled-4506f8eb):not([disabled]){border-color:#5293c7}.scc-c-txt__input-4506f8eb:focus{outline:0}.scc-c-txt__input-4506f8eb.scc-is-focused-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]),.scc-c-txt__input-4506f8eb:focus:not(.scc-is-disabled-4506f8eb):not([disabled]){border-color:#1f73b7;-webkit-box-shadow:0 0 0 3px rgba(31,115,183,.35);box-shadow:0 0 0 3px rgba(31,115,183,.35)}.scc-c-txt__input-4506f8eb.scc-is-disabled-4506f8eb,.scc-c-txt__input-4506f8eb[disabled]{border-color:#e9ebed;-webkit-box-shadow:none;box-shadow:none;background-color:#f8f9f9;cursor:default;color:#c2c8cc}.scc-c-txt__input-4506f8eb.scc-is-disabled-4506f8eb::-webkit-input-placeholder,.scc-c-txt__input-4506f8eb[disabled]::-webkit-input-placeholder{color:#c2c8cc}.scc-c-txt__input-4506f8eb.scc-is-disabled-4506f8eb:-ms-input-placeholder,.scc-c-txt__input-4506f8eb.scc-is-disabled-4506f8eb::-ms-input-placeholder,.scc-c-txt__input-4506f8eb[disabled]:-ms-input-placeholder,.scc-c-txt__input-4506f8eb[disabled]::-ms-input-placeholder{color:#c2c8cc}.scc-c-txt__input-4506f8eb.scc-is-disabled-4506f8eb::placeholder,.scc-c-txt__input-4506f8eb[disabled]::placeholder{color:#c2c8cc}.scc-c-txt__input-4506f8eb.scc-c-txt__input--error-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]){border-color:#e35b66}.scc-c-txt__input--error-4506f8eb.scc-is-focused-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]),.scc-c-txt__input--error-4506f8eb:focus:not(.scc-is-disabled-4506f8eb):not([disabled]){-webkit-box-shadow:0 0 0 3px rgba(204,51,64,.35);box-shadow:0 0 0 3px rgba(204,51,64,.35)}.scc-c-txt__input-4506f8eb.scc-c-txt__input--success-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]){border-color:#5eae91}.scc-c-txt__input--success-4506f8eb.scc-is-focused-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]),.scc-c-txt__input--success-4506f8eb:focus:not(.scc-is-disabled-4506f8eb):not([disabled]){-webkit-box-shadow:0 0 0 3px rgba(3,129,83,.35);box-shadow:0 0 0 3px rgba(3,129,83,.35)}.scc-c-txt__input-4506f8eb.scc-c-txt__input--warning-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]){border-color:#ffb648}.scc-c-txt__input--warning-4506f8eb.scc-is-focused-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]),.scc-c-txt__input--warning-4506f8eb:focus:not(.scc-is-disabled-4506f8eb):not([disabled]){-webkit-box-shadow:0 0 0 3px rgba(237,150,28,.35);box-shadow:0 0 0 3px rgba(237,150,28,.35)}.scc-c-txt__input--sm-4506f8eb{padding:.42857em .85714em;min-height:32px}.scc-c-txt__input--sm-4506f8eb[type=date],.scc-c-txt__input--sm-4506f8eb[type=datetime-local],.scc-c-txt__input--sm-4506f8eb[type=file],.scc-c-txt__input--sm-4506f8eb[type=month],.scc-c-txt__input--sm-4506f8eb[type=time],.scc-c-txt__input--sm-4506f8eb[type=week]{max-height:32px}.scc-c-txt__input--sm-4506f8eb::-ms-browse{font-size:11px}.scc-c-txt__input--sm-4506f8eb.scc-c-txt__input--media-4506f8eb{padding-right:0;padding-left:0}.scc-c-txt__input--sm-4506f8eb.scc-c-txt__input--select-4506f8eb{padding-right:2.85714em}.scc-c-txt__input--sm-4506f8eb.scc-c-txt__input--select-4506f8eb:not(select):before{width:40px}.scc-c-txt__input--sm-4506f8eb.scc-c-txt__input--select-4506f8eb:not(select):before,select.scc-c-txt__input--sm-4506f8eb.scc-c-txt__input--select-4506f8eb{background-position:right .92857em center;height:32px}.scc-is-rtl-4506f8eb.scc-c-txt__input--sm-4506f8eb.scc-c-txt__input--select-4506f8eb{padding-right:.85714em;padding-left:2.85714em}.scc-is-rtl-4506f8eb.scc-c-txt__input--sm-4506f8eb.scc-c-txt__input--select-4506f8eb:not(select):before,select.scc-is-rtl-4506f8eb.scc-c-txt__input--sm-4506f8eb.scc-c-txt__input--select-4506f8eb{background-position:left .92857em center}.scc-c-txt__input--sm-4506f8eb .scc-c-txt__input--media__figure-4506f8eb:first-of-type,.scc-is-rtl-4506f8eb.scc-c-txt__input--sm-4506f8eb .scc-c-txt__input--media__figure-4506f8eb:last-of-type{margin:auto .64285em auto .85714em}.scc-c-txt__input--sm-4506f8eb .scc-c-txt__input--media__figure-4506f8eb:last-of-type,.scc-is-rtl-4506f8eb.scc-c-txt__input--sm-4506f8eb .scc-c-txt__input--media__figure-4506f8eb:first-of-type{margin:auto .85714em auto .64285em}.scc-c-txt__input-4506f8eb.scc-c-txt__input--bare-4506f8eb{border:none;border-radius:0;background-color:transparent;padding:0;min-height:1em}.scc-c-txt__input-4506f8eb.scc-is-focused-4506f8eb:not(.scc-is-disabled-4506f8eb):not([disabled]).scc-c-txt__input--bare-4506f8eb,.scc-c-txt__input-4506f8eb:focus:not(.scc-is-disabled-4506f8eb):not([disabled]).scc-c-txt__input--bare-4506f8eb{-webkit-box-shadow:none;box-shadow:none}.scc-c-txt__input-4506f8eb.scc-is-disabled-4506f8eb.scc-c-txt__input--bare-4506f8eb,.scc-c-txt__input-4506f8eb[disabled].scc-c-txt__input--bare-4506f8eb{background-color:transparent}.scc-c-txt__input--media-4506f8eb{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;padding-right:0;padding-left:0}.scc-c-txt__input--media__body-4506f8eb{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.scc-c-txt__input--media__figure-4506f8eb{margin:auto;max-height:1em;color:#c2c8cc}.scc-c-txt__input--media__figure-4506f8eb svg{width:1em;height:1em}.scc-c-txt__input--media__figure-4506f8eb:first-of-type,.scc-is-rtl-4506f8eb .scc-c-txt__input--media__figure-4506f8eb:last-of-type{margin-right:.85715em;margin-left:1.14286em}.scc-c-txt__input--media__figure-4506f8eb:last-of-type,.scc-is-rtl-4506f8eb .scc-c-txt__input--media__figure-4506f8eb:first-of-type{margin-right:1.14286em;margin-left:.85715em}.scc-c-txt__label-4506f8eb{vertical-align:middle;line-height:2.14286;color:#2f3941;font-size:14px;font-weight:600}.scc-c-txt__label--regular-4506f8eb{font-weight:400}.scc-c-txt__label--sm-4506f8eb{line-height:2}.scc-c-txt__hint-4506f8eb{line-height:1.42857;color:#68737d;font-size:14px}.scc-c-txt__message-4506f8eb{display:inline-block;vertical-align:middle;line-height:1.33333;color:#49545c;font-size:12px}.scc-c-txt__message--error-4506f8eb,.scc-c-txt__message--success-4506f8eb,.scc-c-txt__message--warning-4506f8eb{background-repeat:no-repeat;background-position:0 0;padding-left:20px}.scc-c-txt__message--error-4506f8eb{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23D93F4C'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm-.75 3.75c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.5zM7 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'/%3E%3C/svg%3E\");color:#cc3340}.scc-c-txt__message--success-4506f8eb{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23228F67'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm3.09 5.363l-3.3 4.2a.75.75 0 0 1-.545.286H6.2a.748.748 0 0 1-.53-.22L3.97 7.93a.75.75 0 1 1 1.06-1.06l1.103 1.102L8.91 4.437a.75.75 0 0 1 1.18.926z'/%3E%3C/svg%3E\");color:#038153}.scc-c-txt__message--warning-4506f8eb{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23F5A133'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm-.75 3.75c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.5zM7 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'/%3E%3C/svg%3E\");color:#ad5e18}.scc-is-rtl-4506f8eb.scc-c-txt__message--error-4506f8eb,.scc-is-rtl-4506f8eb.scc-c-txt__message--success-4506f8eb,.scc-is-rtl-4506f8eb.scc-c-txt__message--warning-4506f8eb{background-position:100% 0;padding-right:20px;padding-left:0}.scc-c-txt__hint-4506f8eb+.scc-c-txt__input-4506f8eb,.scc-c-txt__input-4506f8eb+.scc-c-txt__hint-4506f8eb{margin-top:8px}.scc-c-txt__hint--sm-4506f8eb+.scc-c-txt__input--sm-4506f8eb,.scc-c-txt__input--sm-4506f8eb+.scc-c-txt__hint--sm-4506f8eb{margin-top:4px}.scc-c-txt__label-4506f8eb+.scc-c-txt__hint-4506f8eb{margin-top:-4px}.scc-c-txt__input-4506f8eb+.scc-c-txt__message-4506f8eb{margin-top:8px}.scc-c-txt-4506f8eb .scc-c-txt__hint-4506f8eb{display:block}.scc-c-txt--inline-4506f8eb .scc-c-txt__input-4506f8eb+.scc-c-txt__message-4506f8eb{margin-top:0}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"c-chk":"scc-c-chk-4506f8eb","c-chk__input":"scc-c-chk__input-4506f8eb","c-chk__label":"scc-c-chk__label-4506f8eb","c-chk__label--regular":"scc-c-chk__label--regular-4506f8eb","c-chk__hint":"scc-c-chk__hint-4506f8eb","c-chk__message":"scc-c-chk__message-4506f8eb","c-chk__message--error":"scc-c-chk__message--error-4506f8eb","c-chk__message--success":"scc-c-chk__message--success-4506f8eb","c-chk__message--warning":"scc-c-chk__message--warning-4506f8eb","is-hidden":"scc-is-hidden-4506f8eb","is-rtl":"scc-is-rtl-4506f8eb","is-checked":"scc-is-checked-4506f8eb","c-chk__label--radio":"scc-c-chk__label--radio-4506f8eb","c-chk__label--toggle":"scc-c-chk__label--toggle-4506f8eb","is-indeterminate":"scc-is-indeterminate-4506f8eb","is-disabled":"scc-is-disabled-4506f8eb","is-hovered":"scc-is-hovered-4506f8eb","is-focused":"scc-is-focused-4506f8eb","is-active":"scc-is-active-4506f8eb","c-chk__hint--toggle":"scc-c-chk__hint--toggle-4506f8eb","c-chk__message--toggle":"scc-c-chk__message--toggle-4506f8eb","c-range":"scc-c-range-4506f8eb","c-range__input":"scc-c-range__input-4506f8eb","c-range__hint":"scc-c-range__hint-4506f8eb","c-range__label":"scc-c-range__label-4506f8eb","c-range__message":"scc-c-range__message-4506f8eb","c-range--inline":"scc-c-range--inline-4506f8eb","c-range__slider":"scc-c-range__slider-4506f8eb","c-range__slider__track":"scc-c-range__slider__track-4506f8eb","c-range__slider__track__rail":"scc-c-range__slider__track__rail-4506f8eb","c-range__slider__track__rail__thumb":"scc-c-range__slider__track__rail__thumb-4506f8eb","c-range__label--regular":"scc-c-range__label--regular-4506f8eb","c-range__label--sm":"scc-c-range__label--sm-4506f8eb","c-range__message--error":"scc-c-range__message--error-4506f8eb","c-range__message--success":"scc-c-range__message--success-4506f8eb","c-range__message--warning":"scc-c-range__message--warning-4506f8eb","c-range__hint--sm":"scc-c-range__hint--sm-4506f8eb","c-range__input--sm":"scc-c-range__input--sm-4506f8eb","c-range__slider--sm":"scc-c-range__slider--sm-4506f8eb","c-txt":"scc-c-txt-4506f8eb","c-txt__input":"scc-c-txt__input-4506f8eb","c-txt__hint":"scc-c-txt__hint-4506f8eb","c-txt__label":"scc-c-txt__label-4506f8eb","c-txt__message":"scc-c-txt__message-4506f8eb","c-txt--inline":"scc-c-txt--inline-4506f8eb","c-txt--sm__input":"scc-c-txt--sm__input-4506f8eb","c-txt__input--sm":"scc-c-txt__input--sm-4506f8eb","c-txt__input--area":"scc-c-txt__input--area-4506f8eb","is-resizable":"scc-is-resizable-4506f8eb","c-txt__input--select":"scc-c-txt__input--select-4506f8eb","is-open":"scc-is-open-4506f8eb","c-txt__input--tag":"scc-c-txt__input--tag-4506f8eb","c-label":"scc-c-label-4506f8eb","c-tag":"scc-c-tag-4506f8eb","c-txt__input--error":"scc-c-txt__input--error-4506f8eb","c-txt__input--success":"scc-c-txt__input--success-4506f8eb","c-txt__input--warning":"scc-c-txt__input--warning-4506f8eb","c-txt__input--media":"scc-c-txt__input--media-4506f8eb","c-txt__input--media__figure":"scc-c-txt__input--media__figure-4506f8eb","c-txt__input--bare":"scc-c-txt__input--bare-4506f8eb","c-txt__input--media__body":"scc-c-txt__input--media__body-4506f8eb","c-txt__label--regular":"scc-c-txt__label--regular-4506f8eb","c-txt__label--sm":"scc-c-txt__label--sm-4506f8eb","c-txt__message--error":"scc-c-txt__message--error-4506f8eb","c-txt__message--success":"scc-c-txt__message--success-4506f8eb","c-txt__message--warning":"scc-c-txt__message--warning-4506f8eb","c-txt__hint--sm":"scc-c-txt__hint--sm-4506f8eb"}


/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _Core = __webpack_require__(599);

var _Core2 = _interopRequireDefault(_Core);

var _styles = __webpack_require__(601);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function (_ThemedComponent) {
  (0, _inherits3.default)(Button, _ThemedComponent);

  function Button(props, context) {
    (0, _classCallCheck3.default)(this, Button);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Button",
      styles: _styles2.default
    }));

    _this.onBlur = function (e) {
      var onBlur = _this.props.onBlur;


      _this.setState({
        focused: false,
        active: false
      });
      onBlur && onBlur(e);
    };

    _this.onKeyboardFocus = function (e) {
      _this.setState({ focused: true });
    };

    _this.onSubmitKeyPressed = function (e) {
      _this.setState({ active: true });
    };

    _this.onKeyUp = function (e) {
      var onKeyUp = _this.props.onKeyUp;


      _this.setState({ active: false });
      onKeyUp && onKeyUp(e);
    };

    _this.state = {
      focused: false,
      active: false
    };
    return _this;
  }

  Button.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        className = _props.className,
        children = _props.children,
        danger = _props.danger,
        disabled = _props.disabled,
        stretched = _props.stretched,
        pill = _props.pill,
        size = _props.size,
        type = _props.type,
        other = (0, _objectWithoutProperties3.default)(_props, ["className", "children", "danger", "disabled", "stretched", "pill", "size", "type"]);
    var _state = this.state,
        focused = _state.focused,
        active = _state.active;
    var theme = this.theme;


    var typeStyle = theme["type_" + type];
    return _react2.default.createElement(
      _Core2.default,
      (0, _extends3.default)({}, other, {
        disabled: disabled,
        onBlur: this.onBlur,
        onKeyUp: this.onKeyUp,
        onKeyboardFocus: this.onKeyboardFocus,
        onSubmitKeyPressed: this.onSubmitKeyPressed,
        className: (0, _classnames2.default)(theme["size_" + size], (_classNames = {}, _classNames[typeStyle] = typeStyle, _classNames[theme.focused] = focused, _classNames[theme.pill] = pill, _classNames[theme.stretched] = stretched, _classNames[theme.disabled] = disabled, _classNames[theme.active] = active, _classNames[theme.danger] = danger, _classNames), className)
      }),
      children
    );
  };

  return Button;
}(_ThemedComponent3.default);

Button.Core = _Core2.default;
Button.propTypes = {
  autoFocus: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  danger: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  pill: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(["small", "medium", "large"]),
  stretched: _propTypes2.default.bool,
  tabIndex: _propTypes2.default.number,
  testId: _propTypes2.default.string,
  /** Must be wrapped by a <a href="#tooltipprovider">TooltipProvider</a> */
  title: _propTypes2.default.string,
  /** <a href="#view">See View</a> for positioning options */
  tooltipPositioning: function tooltipPositioning() {},
  type: _propTypes2.default.oneOf(["default", "primary", "basic", "anchor"])
};
Button.defaultProps = {
  tabIndex: 0,
  type: "default",
  size: "small"
};
exports.default = Button;

/***/ }),
/* 133 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 134 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(186);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserSegmentsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPermissionsUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_context__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_context__);

var getUserSegmentsUrl = function getUserSegmentsUrl() {
  return "/knowledge/user_segments?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_context__["getCurrentBrandId"])());
};
var getPermissionsUrl = function getPermissionsUrl() {
  return "/knowledge/permissions?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_context__["getCurrentBrandId"])());
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)
__webpack_require__(638)

appendStyles({
  css: ".ssc-pagination-3b291e1a:focus{outline:0}.ssc-no_animation-3b291e1a{-webkit-transition:none;transition:none}.ssc-is_hidden-3b291e1a[aria-hidden=true]{display:inherit}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"pagination":"ssc-pagination-3b291e1a scc-c-pagination-dfde14de","page":"ssc-page-3b291e1a scc-c-pagination__page-dfde14de","no_animation":"ssc-no_animation-3b291e1a","page_previous":"ssc-page_previous-3b291e1a scc-c-pagination__page--previous-dfde14de","page_next":"ssc-page_next-3b291e1a scc-c-pagination__page--next-dfde14de","page_gap":"ssc-page_gap-3b291e1a scc-c-pagination__page--gap-dfde14de","is_current":"ssc-is_current-3b291e1a scc-is-current-dfde14de","is_focused":"ssc-is_focused-3b291e1a scc-is-focused-dfde14de","is_hovered":"ssc-is_hovered-3b291e1a scc-is-hovered-dfde14de","is_hidden":"ssc-is_hidden-3b291e1a scc-is-hidden-dfde14de","is_rtl":"ssc-is_rtl-3b291e1a scc-is-rtl-dfde14de"}


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DUPLICATE_USER_SEGMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DUPLICATE_USER_SEGMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DUPLICATE_USER_SEGMENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DELETE_USER_SEGMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DELETE_USER_SEGMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DELETE_USER_SEGMENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SAVE_USER_SEGMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SAVE_USER_SEGMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SAVE_USER_SEGMENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CREATE_USER_SEGMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CREATE_USER_SEGMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CREATE_USER_SEGMENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FETCH_USER_SEGMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FETCH_USER_SEGMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_USER_SEGMENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FETCH_USER_SEGMENT_ORGANIZATIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FETCH_USER_SEGMENT_ORGANIZATIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_USER_SEGMENT_ORGANIZATIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_USER_SEGMENT_GROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_USER_SEGMENT_GROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_USER_SEGMENT_GROUPS_FAILURE; });
/* unused harmony export FETCH_USER_SEGMENT_USERS_REQUEST */
/* unused harmony export FETCH_USER_SEGMENT_USERS_SUCCESS */
/* unused harmony export FETCH_USER_SEGMENT_USERS_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHANGE_USER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHANGE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return REMOVE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_ORGANIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_ORGANIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return REMOVE_ORGANIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return REMOVE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return RESET_USER_SEGMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return RESET_USER_SEGMENT_ATTRIBUTES; });
var DUPLICATE_USER_SEGMENT_REQUEST = "DUPLICATE_USER_SEGMENT_REQUEST";
var DUPLICATE_USER_SEGMENT_SUCCESS = "DUPLICATE_USER_SEGMENT_SUCCESS";
var DUPLICATE_USER_SEGMENT_FAILURE = "DUPLICATE_USER_SEGMENT_FAILURE";
var DELETE_USER_SEGMENT_REQUEST = "DELETE_USER_SEGMENT_REQUEST";
var DELETE_USER_SEGMENT_SUCCESS = "DELETE_USER_SEGMENT_SUCCESS";
var DELETE_USER_SEGMENT_FAILURE = "DELETE_USER_SEGMENT_FAILURE";
var SAVE_USER_SEGMENT_REQUEST = "SAVE_USER_SEGMENT_REQUEST";
var SAVE_USER_SEGMENT_SUCCESS = "SAVE_USER_SEGMENT_SUCCESS";
var SAVE_USER_SEGMENT_FAILURE = "SAVE_USER_SEGMENT_FAILURE";
var CREATE_USER_SEGMENT_REQUEST = "CREATE_USER_SEGMENT_REQUEST";
var CREATE_USER_SEGMENT_SUCCESS = "CREATE_USER_SEGMENT_SUCCESS";
var CREATE_USER_SEGMENT_FAILURE = "CREATE_USER_SEGMENT_FAILURE";
var FETCH_USER_SEGMENT_REQUEST = "FETCH_USER_SEGMENT_REQUEST";
var FETCH_USER_SEGMENT_SUCCESS = "FETCH_USER_SEGMENT_SUCCESS";
var FETCH_USER_SEGMENT_FAILURE = "FETCH_USER_SEGMENT_FAILURE";
var FETCH_USER_SEGMENT_ORGANIZATIONS_REQUEST = "FETCH_USER_SEGMENT_ORGANIZATIONS_REQUEST";
var FETCH_USER_SEGMENT_ORGANIZATIONS_SUCCESS = "FETCH_USER_SEGMENT_ORGANIZATIONS_SUCCESS";
var FETCH_USER_SEGMENT_ORGANIZATIONS_FAILURE = "FETCH_USER_SEGMENT_ORGANIZATIONS_FAILURE";
var FETCH_USER_SEGMENT_GROUPS_REQUEST = "FETCH_USER_SEGMENT_GROUPS_REQUEST";
var FETCH_USER_SEGMENT_GROUPS_SUCCESS = "FETCH_USER_SEGMENT_GROUPS_SUCCESS";
var FETCH_USER_SEGMENT_GROUPS_FAILURE = "FETCH_USER_SEGMENT_GROUPS_FAILURE";
var FETCH_USER_SEGMENT_USERS_REQUEST = "FETCH_USER_SEGMENT_USERS_REQUEST";
var FETCH_USER_SEGMENT_USERS_SUCCESS = "FETCH_USER_SEGMENT_USERS_SUCCESS";
var FETCH_USER_SEGMENT_USERS_FAILURE = "FETCH_USER_SEGMENT_USERS_FAILURE";
var FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
var FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
var FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";
var CHANGE_NAME = "CHANGE_NAME";
var CHANGE_USER_TYPE = "CHANGE_USER_TYPE";
var CHANGE_TAG = "CHANGE_TAG";
var ADD_TAG = "ADD_TAG";
var REMOVE_TAG = "REMOVE_TAG";
var CHANGE_ORGANIZATION = "CHANGE_ORGANIZATION";
var ADD_ORGANIZATION = "ADD_ORGANIZATION";
var REMOVE_ORGANIZATION = "REMOVE_ORGANIZATION";
var CHANGE_GROUP = "CHANGE_GROUP";
var ADD_GROUP = "ADD_GROUP";
var REMOVE_GROUP = "REMOVE_GROUP";
var RESET_USER_SEGMENT = "RESET_USER_SEGMENT";
var RESET_USER_SEGMENT_ATTRIBUTES = "RESET_USER_SEGMENT_ATTRIBUTES";

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _uuid = __webpack_require__(82);

var _uuid2 = _interopRequireDefault(_uuid);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _Core = __webpack_require__(784);

var _Core2 = _interopRequireDefault(_Core);

var _styles = __webpack_require__(785);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextInput = function (_ThemedComponent) {
  (0, _inherits3.default)(TextInput, _ThemedComponent);

  function TextInput(props, context) {
    (0, _classCallCheck3.default)(this, TextInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "TextInput",
      styles: _styles2.default
    }));

    _this.getId = function () {
      return _this.props.id || _this.generatedId;
    };

    _this.renderLabel = function () {
      var label = _this.props.label;
      var theme = _this.theme;


      if (!label) {
        return null;
      }

      return _react2.default.createElement(
        "label",
        { className: theme.label, htmlFor: _this.getId() },
        label
      );
    };

    _this.generatedId = _uuid2.default.v4();
    return _this;
  }

  TextInput.prototype.render = function render() {
    var _classNames,
        _classNames2,
        _this2 = this;

    var _props = this.props,
        className = _props.className,
        dir = _props.dir,
        disabled = _props.disabled,
        hint = _props.hint,
        size = _props.size,
        title = _props.title,
        tooltipPositioning = _props.tooltipPositioning,
        type = _props.type,
        validation = _props.validation,
        validationText = _props.validationText,
        valueType = _props.valueType,
        other = (0, _objectWithoutProperties3.default)(_props, ["className", "dir", "disabled", "hint", "size", "title", "tooltipPositioning", "type", "validation", "validationText", "valueType"]);
    var theme = this.theme;


    return _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(theme.txt, (_classNames = {}, _classNames[theme.disabled] = disabled, _classNames[theme.rtl] = dir === "rtl", _classNames), className),
        title: title,
        tooltipPositioning: tooltipPositioning
      },
      this.renderLabel(),
      hint && _react2.default.createElement(
        "small",
        { className: theme.hint },
        hint
      ),
      _react2.default.createElement(_Core2.default, (0, _extends3.default)({}, other, {
        dir: dir,
        disabled: disabled,
        valueType: valueType,
        id: this.getId(),
        className: (0, _classnames2.default)(theme.input, theme["size_" + size], validation && theme["input_" + validation], (_classNames2 = {}, _classNames2[theme.style_bare] = type === "bare", _classNames2)),
        ref: function ref(_ref) {
          if (_ref && _ref.input) {
            _this2.input = _ref.input;
          }
        }
      })),
      validation && validationText && _react2.default.createElement(
        "small",
        {
          className: (0, _classnames2.default)(theme.message, validation && theme["message_" + validation])
        },
        validationText
      )
    );
  };

  return TextInput;
}(_ThemedComponent3.default);

TextInput.Core = _Core2.default;
TextInput.propTypes = {
  autoComplete: _propTypes2.default.oneOf(["on", "off"]),
  autoFocus: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  isFocused: _propTypes2.default.bool,
  defaultValue: _propTypes2.default.string,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  disabled: _propTypes2.default.bool.isRequired,
  hint: _propTypes2.default.node,
  label: _propTypes2.default.node,
  maxLength: _propTypes2.default.number,
  name: _propTypes2.default.string,
  onArrowDown: _propTypes2.default.func,
  onArrowLeft: _propTypes2.default.func,
  onArrowRight: _propTypes2.default.func,
  onArrowUp: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onEnter: _propTypes2.default.func,
  onEscape: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onPaste: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(["small", "medium"]),
  tabIndex: _propTypes2.default.number,
  testId: _propTypes2.default.string,
  /** Must be wrapped by a <a href="#tooltipprovider">TooltipProvider</a> */
  title: _propTypes2.default.string,
  /** <a href="#view">See View</a> for positioning options */
  tooltipPositioning: function tooltipPositioning() {},
  type: _propTypes2.default.oneOf(["default", "bare"]),
  validation: _propTypes2.default.oneOf(["error", "warning", "success"]),
  validationText: _propTypes2.default.string,
  value: _propTypes2.default.string,
  /** Supports all valid [Input types](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input) */
  valueType: _propTypes2.default.string
};
TextInput.defaultProps = {
  autoComplete: "off",
  disabled: false,
  type: "default",
  valueType: "text",
  size: "medium",
  dir: "ltr"
};
exports.default = TextInput;

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(563);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(93);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 185 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(189)('keys')
  , uid    = __webpack_require__(133);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(68)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 191 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(92)
  , dPs         = __webpack_require__(571)
  , enumBugKeys = __webpack_require__(190)
  , IE_PROTO    = __webpack_require__(188)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(255)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(572).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(69).f
  , has = __webpack_require__(79)
  , TAG = __webpack_require__(50)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(50);

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(68)
  , core           = __webpack_require__(42)
  , LIBRARY        = __webpack_require__(192)
  , wksExt         = __webpack_require__(195)
  , defineProperty = __webpack_require__(69).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)
__webpack_require__(606)

appendStyles({
  css: ".ssc-list-eb0c3da:focus{outline:0}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"tabs":"ssc-tabs-eb0c3da scc-c-tab-3b6f1d0a","list":"ssc-list-eb0c3da scc-c-tab__list-3b6f1d0a","label":"ssc-label-eb0c3da scc-c-tab__list__item-3b6f1d0a","panel":"ssc-panel-eb0c3da scc-c-tab__panel-3b6f1d0a","selected":"ssc-selected-eb0c3da scc-is-selected-3b6f1d0a","focused":"ssc-focused-eb0c3da scc-is-focused-3b6f1d0a","vertical":"ssc-vertical-eb0c3da scc-c-tab--block-3b6f1d0a","disabled":"ssc-disabled-eb0c3da scc-is-disabled-3b6f1d0a","rtl":"ssc-rtl-eb0c3da scc-is-rtl-3b6f1d0a"}


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendesk_self_service_components_lib_Callouts__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendesk_self_service_components_lib_Callouts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__zendesk_self_service_components_lib_Callouts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__zendesk_self_service_components_lib_Callout__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__zendesk_self_service_components_lib_Callout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__zendesk_self_service_components_lib_Callout__);







function Notifications(_ref) {
  var notifications = _ref.notifications;
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_4__zendesk_self_service_components_lib_Callouts___default.a, {
    floating: true
  }, void 0, notifications.map(function (notification) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5__zendesk_self_service_components_lib_Callout___default.a, {
      type: notification.type,
      testId: "notification-".concat(notification.type)
    }, notification.id, notification.message);
  }));
}

Notifications.propTypes = {
  notifications: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string.isRequired,
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].oneOf(["error", "success"]).isRequired,
    message: __WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string.isRequired
  })).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state, ownProps) {
  return {
    notifications: state.notifications.notifications
  };
})(Notifications));

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: "/*!\n * Copyright Zendesk, Inc.\n *\n * Use of this source code is governed under the Apache License, Version 2.0\n * found at http://www.apache.org/licenses/LICENSE-2.0.\n */.scc-c-menu-526a8b12{display:inline-block;position:absolute;margin:0;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #d8dcde;border-radius:4px;-webkit-box-shadow:0 20px 30px 0 rgba(4,68,77,.15);box-shadow:0 20px 30px 0 rgba(4,68,77,.15);background-color:#fff;cursor:default;padding:8px 0;min-width:180px;text-align:left;white-space:normal;font-size:14px;font-weight:400}.scc-c-menu-526a8b12.scc-is-open-526a8b12{-webkit-animation:.2s cubic-bezier(.15,.85,.35,1.2);animation:.2s cubic-bezier(.15,.85,.35,1.2)}.scc-c-menu-526a8b12.scc-is-open-526a8b12:after,.scc-c-menu-526a8b12.scc-is-open-526a8b12:before{-webkit-animation:.3s ease-in-out;animation:.3s ease-in-out}.scc-c-menu--down-526a8b12.scc-is-open-526a8b12{-webkit-animation-name:scc-zd-menu--down-open-526a8b12;animation-name:scc-zd-menu--down-open-526a8b12}.scc-c-menu--down-526a8b12.scc-is-open-526a8b12:after,.scc-c-menu--down-526a8b12.scc-is-open-526a8b12:before{-webkit-animation-name:scc-zd-menu--down-open-arrow-526a8b12;animation-name:scc-zd-menu--down-open-arrow-526a8b12}.scc-c-menu--left-526a8b12.scc-is-open-526a8b12{-webkit-animation-name:scc-zd-menu--left-open-526a8b12;animation-name:scc-zd-menu--left-open-526a8b12}.scc-c-menu--left-526a8b12.scc-is-open-526a8b12:after,.scc-c-menu--left-526a8b12.scc-is-open-526a8b12:before{-webkit-animation-name:scc-zd-menu--left-open-arrow-526a8b12;animation-name:scc-zd-menu--left-open-arrow-526a8b12}.scc-c-menu--right-526a8b12.scc-is-open-526a8b12{-webkit-animation-name:scc-zd-menu--right-open-526a8b12;animation-name:scc-zd-menu--right-open-526a8b12}.scc-c-menu--right-526a8b12.scc-is-open-526a8b12:after,.scc-c-menu--right-526a8b12.scc-is-open-526a8b12:before{-webkit-animation-name:scc-zd-menu--right-open-arrow-526a8b12;animation-name:scc-zd-menu--right-open-arrow-526a8b12}.scc-c-menu--up-526a8b12.scc-is-open-526a8b12{-webkit-animation-name:scc-zd-menu--up-open-526a8b12;animation-name:scc-zd-menu--up-open-526a8b12}.scc-c-menu--up-526a8b12.scc-is-open-526a8b12:after,.scc-c-menu--up-526a8b12.scc-is-open-526a8b12:before{-webkit-animation-name:scc-zd-menu--up-open-arrow-526a8b12;animation-name:scc-zd-menu--up-open-arrow-526a8b12}.scc-c-menu-526a8b12.scc-is-rtl-526a8b12{direction:rtl;text-align:right}.scc-c-menu__item-526a8b12{display:block;position:relative;-webkit-transition:-webkit-box-shadow .1s ease-in-out;transition:-webkit-box-shadow .1s ease-in-out;transition:box-shadow .1s ease-in-out;transition:box-shadow .1s ease-in-out,-webkit-box-shadow .1s ease-in-out;z-index:0;cursor:pointer;padding:10px 24px;text-decoration:none;line-height:1.42857;word-wrap:break-word;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.scc-c-menu__item-526a8b12:before{position:absolute;top:0;left:0;-webkit-transition:opacity .1s ease-in-out;transition:opacity .1s ease-in-out;opacity:0;background:no-repeat 60%/10px url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%231F73B7'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 7.92L5.08 12 13 1.92'/%3E%3C/svg%3E\");width:24px;height:40px;content:\"\"}.scc-c-menu--sm-526a8b12 .scc-c-menu__item-526a8b12{padding:6px 20px}.scc-c-menu--sm-526a8b12 .scc-c-menu__item-526a8b12:before{background-size:9px;width:20px;height:32px}.scc-c-menu__item-526a8b12:not(.scc-c-menu__item--add-526a8b12){color:#2f3941}.scc-c-menu__item-526a8b12.scc-c-menu__item--add-526a8b12{color:#1f73b7}.scc-c-menu__item-526a8b12.scc-c-menu__item--header-526a8b12{cursor:default}.scc-c-menu__item-526a8b12.scc-c-menu__item--header-526a8b12,.scc-c-menu__item-526a8b12.scc-c-menu__item--previous-526a8b12{font-weight:600}.scc-c-menu__item-526a8b12 .scc-c-menu__item--header__icon-526a8b12{position:absolute;top:13px;left:5px;width:14px;height:14px}.scc-c-menu--sm-526a8b12 .scc-c-menu__item-526a8b12 .scc-c-menu__item--header__icon-526a8b12{top:9px;left:3px}.scc-c-menu-526a8b12.scc-is-rtl-526a8b12 .scc-c-menu__item--header__icon-526a8b12{right:5px;left:auto}.scc-c-menu--sm-526a8b12.scc-is-rtl-526a8b12 .scc-c-menu__item--header__icon-526a8b12{right:3px;left:auto}.scc-c-menu__item-526a8b12.scc-c-menu__item--previous-526a8b12{text-align:center}.scc-c-menu__item-526a8b12.scc-c-menu__item--add-526a8b12:before,.scc-c-menu__item-526a8b12.scc-c-menu__item--next-526a8b12:before,.scc-c-menu__item-526a8b12.scc-c-menu__item--previous-526a8b12:before,.scc-c-menu__item-526a8b12.scc-is-checked-526a8b12:before,.scc-c-menu__item-526a8b12[aria-checked=true]:before{opacity:1}.scc-c-menu__item-526a8b12.scc-c-menu__item--add-526a8b12:before,.scc-c-menu__item-526a8b12.scc-c-menu__item--next-526a8b12:before,.scc-c-menu__item-526a8b12.scc-c-menu__item--previous-526a8b12:before{background-position:50%;background-size:14px}.scc-c-menu__item-526a8b12.scc-c-menu__item--add-526a8b12:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%231F73B7'%3E%3Cpath stroke='currentColor' stroke-linecap='round' d='M7 11V3M3 7h8'/%3E%3C/svg%3E\")}.scc-c-menu__item-526a8b12.scc-c-menu__item--next-526a8b12:before{right:0;left:auto;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%2368737D'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 11l4-4-4-4'/%3E%3C/svg%3E\")}.scc-c-menu__item-526a8b12.scc-c-menu__item--previous-526a8b12:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%231F73B7'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9 11L5 7l4-4'/%3E%3C/svg%3E\")}.scc-c-menu-526a8b12.scc-is-rtl-526a8b12 .scc-c-menu__item-526a8b12:before{right:0;left:auto;background-position:40%}.scc-c-menu-526a8b12.scc-is-rtl-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--add-526a8b12:before,.scc-c-menu-526a8b12.scc-is-rtl-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--next-526a8b12:before,.scc-c-menu-526a8b12.scc-is-rtl-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--previous-526a8b12:before{background-position:50%}.scc-c-menu-526a8b12.scc-is-rtl-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--next-526a8b12:before{right:auto;left:0}.scc-c-menu-526a8b12.scc-is-rtl-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--next-526a8b12:before,.scc-c-menu-526a8b12.scc-is-rtl-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--previous-526a8b12:before{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.scc-c-menu__item__meta-526a8b12{display:block;line-height:1.33333;color:#68737d;font-size:12px}.scc-c-menu__item--media-526a8b12:before{height:54px}.scc-c-menu__item--media-526a8b12:after{display:table;clear:both;content:\"\"}.scc-c-menu__item--media__figure-526a8b12{float:left;margin-top:1px;margin-right:8px;width:32px;height:32px}.scc-c-menu__item--media__body-526a8b12{display:block;overflow:hidden}.scc-c-menu--sm-526a8b12 .scc-c-menu__item--media-526a8b12:before{height:36px}.scc-c-menu--sm-526a8b12 .scc-c-menu__item--media__body-526a8b12{margin-top:2px}.scc-c-menu--sm-526a8b12 .scc-c-menu__item--media__body-526a8b12 .scc-c-menu__item__meta-526a8b12{display:none}.scc-c-menu--sm-526a8b12 .scc-c-menu__item--media__figure-526a8b12{margin-top:0;margin-right:4px;width:24px;height:24px}.scc-c-menu-526a8b12.scc-is-rtl-526a8b12 .scc-c-menu__item--media__figure-526a8b12{float:right;margin-right:0;margin-left:8px}.scc-c-menu--sm-526a8b12.scc-is-rtl-526a8b12 .scc-c-menu__item--media__figure-526a8b12{margin-left:4px}.scc-c-menu__item-526a8b12.scc-is-focused-526a8b12,.scc-c-menu__item-526a8b12.scc-is-hovered-526a8b12,.scc-c-menu__item-526a8b12:not(.scc-c-menu__item--header-526a8b12):focus,.scc-c-menu__item-526a8b12:not(.scc-c-menu__item--header-526a8b12):hover{background-color:#edf7ff;text-decoration:none}.scc-c-menu__item-526a8b12.scc-is-focused-526a8b12,.scc-c-menu__item-526a8b12:not(.scc-c-menu__item--header-526a8b12):focus{outline:0;-webkit-box-shadow:inset 0 3px 0 rgba(31,115,183,.35),inset 0 -3px 0 rgba(31,115,183,.35);box-shadow:inset 0 3px 0 rgba(31,115,183,.35),inset 0 -3px 0 rgba(31,115,183,.35)}.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-is-active-526a8b12.scc-is-focused-526a8b12,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-is-active-526a8b12:not(.scc-c-menu__item--header-526a8b12):focus,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12:active.scc-is-focused-526a8b12,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12:active:not(.scc-c-menu__item--header-526a8b12):focus{-webkit-box-shadow:none;box-shadow:none}.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-is-disabled-526a8b12,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[aria-disabled=true],.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[disabled]{cursor:default;color:#c2c8cc}.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-is-disabled-526a8b12.scc-is-focused-526a8b12,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-is-disabled-526a8b12.scc-is-hovered-526a8b12,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-is-disabled-526a8b12:not(.scc-c-menu__item--header-526a8b12):focus,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-is-disabled-526a8b12:not(.scc-c-menu__item--header-526a8b12):hover,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[aria-disabled=true].scc-is-focused-526a8b12,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[aria-disabled=true].scc-is-hovered-526a8b12,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[aria-disabled=true]:not(.scc-c-menu__item--header-526a8b12):focus,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[aria-disabled=true]:not(.scc-c-menu__item--header-526a8b12):hover,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[disabled].scc-is-focused-526a8b12,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[disabled].scc-is-hovered-526a8b12,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[disabled]:not(.scc-c-menu__item--header-526a8b12):focus,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[disabled]:not(.scc-c-menu__item--header-526a8b12):hover{background-color:inherit}.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-is-disabled-526a8b12.scc-is-focused-526a8b12,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-is-disabled-526a8b12:not(.scc-c-menu__item--header-526a8b12):focus,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[aria-disabled=true].scc-is-focused-526a8b12,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[aria-disabled=true]:not(.scc-c-menu__item--header-526a8b12):focus,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[disabled].scc-is-focused-526a8b12,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[disabled]:not(.scc-c-menu__item--header-526a8b12):focus{-webkit-box-shadow:none;box-shadow:none}.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-is-checked-526a8b12.scc-is-disabled-526a8b12:before,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-is-checked-526a8b12[aria-disabled=true]:before,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-is-checked-526a8b12[disabled]:before,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[aria-checked=true].scc-is-disabled-526a8b12:before,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[aria-checked=true][aria-disabled=true]:before,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12[aria-checked=true][disabled]:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23C2C8CC'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 7.92L5.08 12 13 1.92'/%3E%3C/svg%3E\")}.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--add-526a8b12.scc-is-disabled-526a8b12:before,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--add-526a8b12[aria-disabled=true]:before,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--add-526a8b12[disabled]:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23C2C8CC'%3E%3Cpath stroke='currentColor' stroke-linecap='round' d='M7 11V3M3 7h8'/%3E%3C/svg%3E\")}.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--next-526a8b12.scc-is-disabled-526a8b12:before,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--next-526a8b12[aria-disabled=true]:before,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--next-526a8b12[disabled]:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23C2C8CC'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 11l4-4-4-4'/%3E%3C/svg%3E\")}.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--previous-526a8b12.scc-is-disabled-526a8b12:before,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--previous-526a8b12[aria-disabled=true]:before,.scc-c-menu-526a8b12 .scc-c-menu__item-526a8b12.scc-c-menu__item--previous-526a8b12[disabled]:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23C2C8CC'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9 11L5 7l4-4'/%3E%3C/svg%3E\")}.scc-c-menu__item-526a8b12.scc-is-expanded-526a8b12{z-index:1}.scc-c-menu-526a8b12.scc-is-hidden-526a8b12,.scc-c-menu-526a8b12[aria-hidden=true]{display:inline-block;-webkit-transition:opacity .2s ease-in-out,visibility .2s linear 0s;transition:opacity .2s ease-in-out,visibility .2s linear 0s;visibility:hidden;opacity:0}.scc-c-menu-526a8b12.scc-is-hidden-526a8b12:after,.scc-c-menu-526a8b12.scc-is-hidden-526a8b12:before,.scc-c-menu-526a8b12[aria-hidden=true]:after,.scc-c-menu-526a8b12[aria-hidden=true]:before{display:none}.scc-c-menu__separator-526a8b12{display:block;margin:4px 0;border-bottom:1px solid #e9ebed}@-webkit-keyframes scc-zd-menu--up-open-526a8b12{0%{margin-bottom:-20px}to{margin-bottom:0}}@keyframes scc-zd-menu--up-open-526a8b12{0%{margin-bottom:-20px}to{margin-bottom:0}}@-webkit-keyframes scc-zd-menu--up-open-arrow-526a8b12{0%,66%{bottom:2px}}@keyframes scc-zd-menu--up-open-arrow-526a8b12{0%,66%{bottom:2px}}@-webkit-keyframes scc-zd-menu--right-open-526a8b12{0%{margin-left:-20px}to{margin-left:0}}@keyframes scc-zd-menu--right-open-526a8b12{0%{margin-left:-20px}to{margin-left:0}}@-webkit-keyframes scc-zd-menu--right-open-arrow-526a8b12{0%,66%{left:2px}}@keyframes scc-zd-menu--right-open-arrow-526a8b12{0%,66%{left:2px}}@-webkit-keyframes scc-zd-menu--down-open-526a8b12{0%{margin-top:-20px}to{margin-top:0}}@keyframes scc-zd-menu--down-open-526a8b12{0%{margin-top:-20px}to{margin-top:0}}@-webkit-keyframes scc-zd-menu--down-open-arrow-526a8b12{0%,66%{top:2px}}@keyframes scc-zd-menu--down-open-arrow-526a8b12{0%,66%{top:2px}}@-webkit-keyframes scc-zd-menu--left-open-526a8b12{0%{margin-right:-20px}to{margin-right:0}}@keyframes scc-zd-menu--left-open-526a8b12{0%{margin-right:-20px}to{margin-right:0}}@-webkit-keyframes scc-zd-menu--left-open-arrow-526a8b12{0%,66%{right:2px}}@keyframes scc-zd-menu--left-open-arrow-526a8b12{0%,66%{right:2px}}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"c-menu":"scc-c-menu-526a8b12","is-open":"scc-is-open-526a8b12","c-menu--down":"scc-c-menu--down-526a8b12","zd-menu--down-open":"scc-zd-menu--down-open-526a8b12","zd-menu--down-open-arrow":"scc-zd-menu--down-open-arrow-526a8b12","c-menu--left":"scc-c-menu--left-526a8b12","zd-menu--left-open":"scc-zd-menu--left-open-526a8b12","zd-menu--left-open-arrow":"scc-zd-menu--left-open-arrow-526a8b12","c-menu--right":"scc-c-menu--right-526a8b12","zd-menu--right-open":"scc-zd-menu--right-open-526a8b12","zd-menu--right-open-arrow":"scc-zd-menu--right-open-arrow-526a8b12","c-menu--up":"scc-c-menu--up-526a8b12","zd-menu--up-open":"scc-zd-menu--up-open-526a8b12","zd-menu--up-open-arrow":"scc-zd-menu--up-open-arrow-526a8b12","is-rtl":"scc-is-rtl-526a8b12","c-menu__item":"scc-c-menu__item-526a8b12","c-menu--sm":"scc-c-menu--sm-526a8b12","c-menu__item--add":"scc-c-menu__item--add-526a8b12","c-menu__item--header":"scc-c-menu__item--header-526a8b12","c-menu__item--previous":"scc-c-menu__item--previous-526a8b12","c-menu__item--header__icon":"scc-c-menu__item--header__icon-526a8b12","c-menu__item--next":"scc-c-menu__item--next-526a8b12","is-checked":"scc-is-checked-526a8b12","c-menu__item__meta":"scc-c-menu__item__meta-526a8b12","c-menu__item--media":"scc-c-menu__item--media-526a8b12","c-menu__item--media__figure":"scc-c-menu__item--media__figure-526a8b12","c-menu__item--media__body":"scc-c-menu__item--media__body-526a8b12","is-focused":"scc-is-focused-526a8b12","is-hovered":"scc-is-hovered-526a8b12","is-active":"scc-is-active-526a8b12","is-disabled":"scc-is-disabled-526a8b12","is-expanded":"scc-is-expanded-526a8b12","is-hidden":"scc-is-hidden-526a8b12","c-menu__separator":"scc-c-menu__separator-526a8b12"}


/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_utils_lib_ErrorHandler__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_utils_lib_ErrorHandler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_utils_lib_ErrorHandler__);

var errorHandler = new __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_utils_lib_ErrorHandler___default.a();

var notifyError = function notifyError(component, error) {
  errorHandler.notify({
    error: error,
    context: {
      version: "no version provided",
      component: "user-segments:".concat(component),
      details: error.details
    }
  });
  console.error(component, error);
};

/* harmony default export */ __webpack_exports__["a"] = (notifyError);

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(561), __esModule: true };

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(78) && !__webpack_require__(94)(function(){
  return Object.defineProperty(__webpack_require__(255)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(93)
  , document = __webpack_require__(68).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(79)
  , toIObject    = __webpack_require__(80)
  , arrayIndexOf = __webpack_require__(565)(false)
  , IE_PROTO     = __webpack_require__(188)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(185);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(187)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(567);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(578);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(569)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(261)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(192)
  , $export        = __webpack_require__(62)
  , redefine       = __webpack_require__(262)
  , hide           = __webpack_require__(91)
  , has            = __webpack_require__(79)
  , Iterators      = __webpack_require__(106)
  , $iterCreate    = __webpack_require__(570)
  , setToStringTag = __webpack_require__(194)
  , getPrototypeOf = __webpack_require__(573)
  , ITERATOR       = __webpack_require__(50)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(91);

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(256)
  , hiddenKeys = __webpack_require__(190).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(134)
  , createDesc     = __webpack_require__(105)
  , toIObject      = __webpack_require__(80)
  , toPrimitive    = __webpack_require__(184)
  , has            = __webpack_require__(79)
  , IE8_DOM_DEFINE = __webpack_require__(254)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(78) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(596), __esModule: true };

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(608);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;


__webpack_require__(631)

exports.default = {"default":"ssc-default-f116de5e scc-c-callout-57e1d465","success":"ssc-success-f116de5e scc-c-callout-57e1d465 scc-c-callout--success-57e1d465","warning":"ssc-warning-f116de5e scc-c-callout-57e1d465 scc-c-callout--warning-57e1d465","error":"ssc-error-f116de5e scc-c-callout-57e1d465 scc-c-callout--error-57e1d465","remove":"ssc-remove-f116de5e scc-c-callout__close-57e1d465","title":"ssc-title-f116de5e scc-c-callout__title-57e1d465","rtl":"ssc-rtl-f116de5e scc-is-rtl-57e1d465","paragraph":"ssc-paragraph-f116de5e scc-c-callout__paragraph-57e1d465","floating":"ssc-floating-f116de5e scc-c-callout--dialog-57e1d465"}


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isInteger = __webpack_require__(633);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _ReactSingleSelectionModel = __webpack_require__(107);

var _ReactSingleSelectionModel2 = _interopRequireDefault(_ReactSingleSelectionModel);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _Page = __webpack_require__(637);

var _Page2 = _interopRequireDefault(_Page);

var _Gap = __webpack_require__(639);

var _Gap2 = _interopRequireDefault(_Gap);

var _PageIncrement = __webpack_require__(640);

var _PageIncrement2 = _interopRequireDefault(_PageIncrement);

var _styles = __webpack_require__(137);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pagination = function (_ThemedComponent) {
  (0, _inherits3.default)(Pagination, _ThemedComponent);

  function Pagination(props, context) {
    (0, _classCallCheck3.default)(this, Pagination);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Pagination",
      styles: _styles2.default
    }));

    _initialiseProps.call(_this);

    _this.mouseInitiated = false;
    _this.state = {
      pages: [],
      currentSelectedPage: undefined
    };

    _this.selectionModel = new _ReactSingleSelectionModel2.default({
      rtl: props.dir === "rtl",
      vertical: false
    });
    _this.selectionModel.onSelectionChanged = _this.onSelectionChanged;
    _this.selectionModel.onValueChosen = _this.onValueChosen;
    _this.selectionModel.onHome = _this.onHomePressed;
    _this.selectionModel.onEnd = _this.onEndPressed;
    return _this;
  }

  /**
   * When the user presses Home we should select the first page, not the page incrementer.
   */


  /**
   * When the user presses End we should select the last page, not the page incrementer.
   */


  Pagination.prototype.componentWillMount = function componentWillMount() {
    this.setSelectableItems(this.props);
  };

  Pagination.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.selectionModel.rtl = nextProps.dir === "rtl";
    this.setSelectableItems(nextProps);
  };

  Pagination.prototype.render = function render() {
    var _classNames,
        _this2 = this;

    var theme = this.theme;
    var _props = this.props,
        dir = _props.dir,
        tabIndex = _props.tabIndex,
        testId = _props.testId,
        className = _props.className;
    var _state = this.state,
        pages = _state.pages,
        currentSelectedPage = _state.currentSelectedPage;


    return _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(theme.pagination, (_classNames = {}, _classNames[theme.is_rtl] = dir === "rtl", _classNames), className),
        role: "navigation",
        "aria-label": "Pagination",
        testId: testId,
        onFocus: function onFocus() {
          if (!_this2.selectionModel.hasSelection() && !_this2.mouseInitiated) {
            // We should focus the current page on initial focus.
            _this2.selectionModel.reactivate(currentSelectedPage);
          }

          _this2.mouseInitiated = false;
        },
        onMouseDown: function onMouseDown() {
          // Necessary to not focus on first page when initially focused with mouse.
          _this2.mouseInitiated = true;

          setTimeout(function () {
            _this2.mouseInitiated = false;
          }, 0);
        },
        onBlur: function onBlur() {
          _this2.selectionModel.clear();
        },
        onKeyDown: this.selectionModel.handleKeyDown,
        tabIndex: tabIndex
      },
      pages
    );
  };

  return Pagination;
}(_ThemedComponent3.default);

Pagination.propTypes = {
  /**
   * The index (**integer**) of the current page that is selected.
   */
  currentPage: function currentPage(_ref) {
    var _currentPage = _ref.currentPage,
        total = _ref.total;

    if (!(0, _isInteger2.default)(_currentPage)) {
      throw new Error("The current page must be a whole number (integer).");
    } else if (_currentPage >= total) {
      throw new Error("The current page must be less than the total number of pages.");
    }
  },
  /**
   * The total number (**integer**) of pages available.
   */
  total: function total(_ref2) {
    var _total = _ref2.total;

    if (!(0, _isInteger2.default)(_total)) {
      throw new Error("The total must be a whole number (integer).");
    } else if (_total < 1) {
      throw new Error("The total must be greater than 0.");
    }
  },
  /**
   * Callback that is triggered when a page is selected. Passes the current selected page index.
   */
  onPageSelected: _propTypes2.default.func,
  /**
   * The number (**integer**) of pages to pad your currently selected page.
   */
  pagePadding: function pagePadding(_ref3) {
    var _pagePadding = _ref3.pagePadding;

    if (typeof _pagePadding === "undefined") {
      return null;
    } else if (!(0, _isInteger2.default)(_pagePadding)) {
      throw new Error("Page padding must be a whole number (integer).");
    } else if (_pagePadding < 1) {
      throw new Error("Page padding must be greater than 0.");
    }
  },
  /**
   * Used to allow localization of the aria-label for page elements, is English by default.  Is passed the "currentPage" as a parameter.
   */
  pageLabelFormatter: _propTypes2.default.func,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  tabIndex: _propTypes2.default.number,
  testId: _propTypes2.default.string,
  className: _propTypes2.default.string
};
Pagination.defaultProps = {
  dir: "ltr",
  tabIndex: 0,
  pagePadding: 2
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onSelectionChanged = function () {
    _this3.setState({ pages: _this3.selectionModel.items });
  };

  this.onValueChosen = function (selectedPage) {
    if (selectedPage === "previous") {
      _this3.assignCurrentPage(_this3.props.currentPage - 1);

      // We must clear the previous buttons selection since it is now disabled.
      if (_this3.props.currentPage === 1) {
        _this3.selectionModel.clear();
      }
    } else if (selectedPage === "next") {
      _this3.assignCurrentPage(_this3.props.currentPage + 1);

      // We must clear the next buttons selection since it is now disabled.
      if (_this3.props.currentPage === _this3.props.total - 2) {
        _this3.selectionModel.clear();
      }
    } else {
      _this3.assignCurrentPage(selectedPage);
    }
  };

  this.onHomePressed = function (event) {
    var selectedItem = _this3.selectionModel.model.items[0];

    if (selectedItem.key === "previous") {
      selectedItem = _this3.selectionModel.model.items[1];
    }

    _this3.selectionModel.model.select(selectedItem);
    event.preventDefault();
    event.stopPropagation();
  };

  this.onEndPressed = function (event) {
    var selectedItem = _this3.selectionModel.model.items[_this3.selectionModel.model.items.length - 1];
    if (selectedItem.key === "next") {
      selectedItem = _this3.selectionModel.model.items[_this3.selectionModel.model.items.length - 2];
    }

    _this3.selectionModel.model.select(selectedItem);
    event.preventDefault();
    event.stopPropagation();
  };

  this.assignCurrentPage = function (currentPage) {
    _this3.props.onPageSelected(currentPage);
  };

  this.pageAriaLabelFormatter = function (currentPage) {
    var pageLabelFormatter = _this3.props.pageLabelFormatter;


    if (pageLabelFormatter) {
      return pageLabelFormatter(currentPage);
    }

    return "Page " + currentPage;
  };

  this.createPage = function (pageIndex, currentPage, isAnimated) {
    return _react2.default.createElement(
      _Page2.default,
      {
        isCurrent: pageIndex === currentPage,
        isAnimated: isAnimated,
        key: pageIndex,
        ariaLabel: _this3.pageAriaLabelFormatter(pageIndex + 1),
        onSelection: function onSelection() {
          // We should remove the focus state when the page is selected.
          _this3.selectionModel.clear();
          _this3.assignCurrentPage(pageIndex);
        },
        value: pageIndex
      },
      pageIndex + 1
    );
  };

  this.setSelectableItems = function (props) {
    var total = props.total,
        pagePadding = props.pagePadding,
        currentPage = props.currentPage;

    var currentSelectedPage = void 0;

    var pages = [_react2.default.createElement(_PageIncrement2.default, {
      key: "previous",
      value: "previous",
      description: "Previous Page",
      disabled: currentPage === 0,
      onSelection: function onSelection() {
        // We should remove the focus state when current page is incremented.
        _this3.selectionModel.clear();
        _this3.assignCurrentPage(currentPage - 1);
      }
    })];

    for (var x = 0; x < total; x++) {
      if (x === currentPage) {
        currentSelectedPage = _this3.createPage(x, currentPage, true);
        pages.push(currentSelectedPage);
        continue;
      }

      // Always display the first and last page
      if (x === 0 || x === total - 1) {
        pages.push(_this3.createPage(x, currentPage, true));
        continue;
      }

      // Display pages used for padding around the current page
      if (x >= currentPage - pagePadding && x <= currentPage + pagePadding) {
        pages.push(_this3.createPage(x, currentPage, false));
        continue;
      }

      // Handle case where front gap should not be displayed
      if (currentPage <= pagePadding + 2 && x <= pagePadding * 2 + 2) {
        pages.push(_this3.createPage(x, currentPage, true));
        continue;
      }

      // Handle case where back gap should not be displayed
      if (currentPage >= total - pagePadding - 3 && x >= total - pagePadding * 2 - 4) {
        pages.push(_this3.createPage(x, currentPage, true));
        continue;
      }

      if (x < currentPage) {
        pages.push(_react2.default.createElement(_Gap2.default, { key: x }));

        if (currentPage >= total - pagePadding - 2) {
          x = total - pagePadding * 2 - 4;
        } else {
          x = currentPage - pagePadding - 1;
        }
      } else {
        pages.push(_react2.default.createElement(_Gap2.default, { key: x }));
        x = total - 2;
      }
    }

    pages.push(_react2.default.createElement(_PageIncrement2.default, {
      key: "next",
      value: "next",
      description: "Next Page",
      disabled: currentPage === total - 1,
      onSelection: function onSelection() {
        // We should remove the focus state when current page is incremented.
        _this3.selectionModel.clear();
        _this3.assignCurrentPage(currentPage + 1);
      }
    }));

    _this3.selectionModel.items = pages;
    _this3.setState({
      pages: _this3.selectionModel.items,
      currentSelectedPage: currentSelectedPage
    });
  };
};

exports.default = Pagination;

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_STAFF_USER_SEGMENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_STAFF_USER_SEGMENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_STAFF_USER_SEGMENTS_FAILURE; });
var FETCH_STAFF_USER_SEGMENTS_REQUEST = "FETCH_STAFF_USER_SEGMENTS_REQUEST";
var FETCH_STAFF_USER_SEGMENTS_SUCCESS = "FETCH_STAFF_USER_SEGMENTS_SUCCESS";
var FETCH_STAFF_USER_SEGMENTS_FAILURE = "FETCH_STAFF_USER_SEGMENTS_FAILURE";

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_SIGNED_IN_USER_SEGMENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_SIGNED_IN_USER_SEGMENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_SIGNED_IN_USER_SEGMENTS_FAILURE; });
var FETCH_SIGNED_IN_USER_SEGMENTS_REQUEST = "FETCH_SIGNED_IN_USER_SEGMENTS_REQUEST";
var FETCH_SIGNED_IN_USER_SEGMENTS_SUCCESS = "FETCH_SIGNED_IN_USER_SEGMENTS_SUCCESS";
var FETCH_SIGNED_IN_USER_SEGMENTS_FAILURE = "FETCH_SIGNED_IN_USER_SEGMENTS_FAILURE";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Ellipsis = __webpack_require__(647);

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Ellipsis).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _from = __webpack_require__(649);

var _from2 = _interopRequireDefault(_from);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = __webpack_require__(44);

var _uuid = __webpack_require__(82);

var _uuid2 = _interopRequireDefault(_uuid);

var _Portal = __webpack_require__(658);

var _Portal2 = _interopRequireDefault(_Portal);

var _FocusJail = __webpack_require__(659);

var _FocusJail2 = _interopRequireDefault(_FocusJail);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _getBestRelativePlacement = __webpack_require__(276);

var _getBestRelativePlacement2 = _interopRequireDefault(_getBestRelativePlacement);

var _styles = __webpack_require__(665);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var positions = ["bottom", "bottom_stretch", "bottom_left", "bottom_right", "left", "left_top", "left_bottom", "right", "right_top", "right_bottom", "top", "top_stretch", "top_left", "top_right"];

var rtlMapping = {
  bottom_right: "bottom_left",
  bottom_left: "bottom_right",
  left: "right",
  left_top: "right_top",
  left_bottom: "right_bottom",
  right: "left",
  right_top: "left_top",
  right_bottom: "left_bottom",
  top_left: "top_right",
  top_right: "top_left"
};

var getDocuments = function getDocuments() {
  var iframes = document.querySelectorAll("iframe");

  return (0, _from2.default)(iframes).reduce(function (documents, iframe) {
    try {
      if (iframe.contentDocument) {
        return documents.concat(iframe.contentDocument);
      }
    } catch (e) {}
    return documents;
  }, [document]);
};

var RelativePositionedPopup = function (_Component) {
  (0, _inherits3.default)(RelativePositionedPopup, _Component);

  function RelativePositionedPopup(props, context) {
    (0, _classCallCheck3.default)(this, RelativePositionedPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));

    _this.updatePlacement = function () {
      var hidden = _this.props.hidden;


      if (!hidden) {
        // Necessary to allow resize of content on change
        var originalWidth = _this.popupElement.style.width;
        _this.popupElement.style.width = "auto";

        _this.anchorRect = _this.anchorElement.firstChild.getBoundingClientRect();
        _this.popupRect = _this.popupElement.firstChild.getBoundingClientRect();

        _this.popupElement.style.width = originalWidth;

        var placement = _this.getBestRelativePlacement();
        _this.setState({
          placement: placement
        });
      }
    };

    _this.clickOutsideHandler = function (e) {
      var _this$props = _this.props,
          hidden = _this$props.hidden,
          onClickOutside = _this$props.onClickOutside;


      var isLeftClick = e.which === 1;
      if (onClickOutside && !hidden && isLeftClick) {
        var target = e.target || document.elementFromPoint(e.pageX || e.clientX, e.pageY || e.clientY);

        var elementIds = (0, _from2.default)(_this.popupElement.querySelectorAll("[aria-owns]")).map(function (element) {
          return element.getAttribute("aria-owns");
        });

        var insidePopup = _this.popupElement && _this.popupElement.contains(target) || elementIds.some(function (id) {
          var element = document.getElementById(id);
          return element && element.contains(target);
        });

        if (!insidePopup) {
          setTimeout(function () {
            onClickOutside();
          }, 0);
        }
      }
    };

    _this.getPositions = function () {
      var _this$props2 = _this.props,
          dir = _this$props2.dir,
          positioning = _this$props2.positioning;


      var positions = Array.isArray(positioning) ? positioning : [positioning];

      return dir === "rtl" ? positions.map(function (position) {
        return rtlMapping[position] || position;
      }) : positions;
    };

    _this.getAnchorMargins = function () {
      var _this$props3 = _this.props,
          marginBottom = _this$props3.marginBottom,
          marginLeft = _this$props3.marginLeft,
          marginRight = _this$props3.marginRight,
          marginTop = _this$props3.marginTop;


      return {
        bottom: marginBottom,
        left: marginLeft,
        right: marginRight,
        top: marginTop
      };
    };

    _this.getBestRelativePlacement = function () {
      var viewport = {
        width: window.innerWidth,
        height: window.innerHeight
      };

      var anchorRect = {
        top: _this.anchorRect.top,
        left: _this.anchorRect.left,
        width: _this.anchorRect.width,
        height: _this.anchorRect.height,
        margins: _this.getAnchorMargins()
      };

      var centerPoint = _this.props.centerPoint;


      var target = {
        top: _this.popupRect.top,
        left: _this.popupRect.left,
        width: _this.popupRect.width,
        height: _this.popupRect.height
      };

      var bestPlacement = (0, _getBestRelativePlacement2.default)({
        positions: _this.getPositions(),
        anchor: anchorRect,
        centerPoint: centerPoint,
        target: target,
        viewport: viewport
      });

      return bestPlacement;
    };

    _this.onTab = function (e) {
      _this.tabJail && _this.tabJail.onTab(e);
    };

    _this.popupId = _uuid2.default.v4();
    return _this;
  }

  RelativePositionedPopup.prototype.componentWillMount = function componentWillMount() {
    setTimeout(this.updatePlacement, 0);
  };

  RelativePositionedPopup.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    window.addEventListener("resize", this.updatePlacement);
    window.addEventListener("scroll", this.updatePlacement, true);

    getDocuments().forEach(function (doc) {
      doc.addEventListener("click", _this2.clickOutsideHandler, true);
    });
  };

  RelativePositionedPopup.prototype.componentWillUnmount = function componentWillUnmount() {
    var _this3 = this;

    window.removeEventListener("resize", this.updatePlacement);
    window.removeEventListener("scroll", this.updatePlacement, true);

    getDocuments().forEach(function (doc) {
      doc.removeEventListener("click", _this3.clickOutsideHandler, true);
    });
  };

  RelativePositionedPopup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this4 = this;

    var _props = this.props,
        hidden = _props.hidden,
        trapFocus = _props.trapFocus;


    if (hidden && !nextProps.hidden) {
      this.tabJail = trapFocus && new _FocusJail2.default(this.popupElement);
      this.setState({ opening: true });
      setTimeout(function () {
        _this4.setState({ opening: false });
        _this4.updatePlacement();
      }, 0);
    } else if (!hidden && nextProps.hidden) {
      this.setState({ placement: null });
    } else {
      setTimeout(function () {
        _this4.updatePlacement();
      }, 0);
    }
  };

  RelativePositionedPopup.prototype.render = function render() {
    var _classNames,
        _classNames2,
        _this5 = this,
        _classNames3;

    var _props2 = this.props,
        anchor = _props2.anchor,
        children = _props2.children,
        dir = _props2.dir,
        hidden = _props2.hidden,
        testId = _props2.testId,
        stretched = _props2.stretched,
        zIndex = _props2.zIndex;

    var _ref = this.state || {},
        opening = _ref.opening,
        placement = _ref.placement;

    var popupStyle = placement ? {
      visibility: "visible",
      top: placement.rect.top + "px",
      left: placement.rect.left + "px",
      height: placement.rect.height + "px",
      width: placement.rect.width + "px",
      zIndex: zIndex
    } : { visibility: "hidden" };

    var position = placement ? placement.position : this.getPositions()[0];

    return _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(_styles2.default.container, (_classNames = {}, _classNames[_styles2.default.stretched] = stretched, _classNames)),
        dir: dir,
        testId: testId
      },
      _react2.default.createElement(
        _View2.default,
        {
          "aria-haspopup": !hidden,
          "aria-owns": this.popupId,
          className: (0, _classnames2.default)(_styles2.default.trigger, (_classNames2 = {}, _classNames2[_styles2.default.stretched] = stretched, _classNames2)),
          ref: function ref(_ref2) {
            _this5.anchorElement = _this5.anchorElement || (0, _reactDom.findDOMNode)(_ref2);
          }
        },
        anchor
      ),
      _react2.default.createElement(
        _Portal2.default,
        null,
        _react2.default.createElement(
          _View2.default,
          {
            className: (0, _classnames2.default)(_styles2.default.popup, (_classNames3 = {}, _classNames3[_styles2.default.opening] = opening, _classNames3[_styles2.default.stretched] = stretched, _classNames3)),
            dir: dir,
            hidden: hidden,
            id: this.popupId,
            onTab: this.onTab,
            style: popupStyle,
            ref: function ref(_ref3) {
              _this5.popupElement = _this5.popupElement || (0, _reactDom.findDOMNode)(_ref3);
            },
            testId: testId && testId + "-popup"
          },
          hidden ? null : typeof children === "function" ? children(position) : children
        )
      )
    );
  };

  return RelativePositionedPopup;
}(_react.Component);

RelativePositionedPopup.propTypes = {
  anchor: _propTypes2.default.node.isRequired,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]).isRequired,
  hidden: _propTypes2.default.bool,
  marginBottom: _propTypes2.default.number,
  marginLeft: _propTypes2.default.number,
  marginRight: _propTypes2.default.number,
  marginTop: _propTypes2.default.number,
  centerPoint: _propTypes2.default.number,
  positioning: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(positions), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(positions))]).isRequired,
  testId: _propTypes2.default.string,
  trapFocus: _propTypes2.default.bool,
  stretched: _propTypes2.default.bool,
  onClickOutside: _propTypes2.default.func,
  zIndex: _propTypes2.default.number
};
RelativePositionedPopup.defaultProps = {
  dir: "ltr",
  hidden: true,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  marginTop: 0,
  trapFocus: false,
  zIndex: 500
};
exports.default = RelativePositionedPopup;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _positionRelative = __webpack_require__(661);

var _positionRelative2 = _interopRequireDefault(_positionRelative);

var _isInsideViewport = __webpack_require__(662);

var _isInsideViewport2 = _interopRequireDefault(_isInsideViewport);

var _distance = __webpack_require__(663);

var _distance2 = _interopRequireDefault(_distance);

var _keepInViewport = __webpack_require__(664);

var _keepInViewport2 = _interopRequireDefault(_keepInViewport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBestRelativePlacement = function getBestRelativePlacement(_ref) {
  var anchor = _ref.anchor,
      centerPoint = _ref.centerPoint,
      positions = _ref.positions,
      target = _ref.target,
      viewport = _ref.viewport;

  var possiblePlacements = positions.map(function (position) {
    return {
      rect: (0, _positionRelative2.default)({
        anchor: anchor,
        centerPoint: centerPoint,
        position: position,
        target: target
      }),
      position: position
    };
  });

  var placementWithinViewport = possiblePlacements.find(function (placement) {
    return (0, _isInsideViewport2.default)({
      target: placement.rect,
      viewport: viewport
    });
  });

  if (placementWithinViewport) {
    return placementWithinViewport;
  }

  var bestPlacement = possiblePlacements.map(function (placement) {
    return (0, _extends3.default)({
      distance: (0, _distance2.default)(placement.rect, (0, _keepInViewport2.default)({
        target: placement.rect,
        viewport: viewport
      }))
    }, placement);
  }).sort(function (a, b) {
    return a.distance - b.distance;
  })[0];

  var anchorIsInsideViewport = (0, _isInsideViewport2.default)({
    target: anchor,
    viewport: viewport
  });

  if (anchorIsInsideViewport) {
    return {
      rect: (0, _keepInViewport2.default)({
        target: bestPlacement.rect,
        viewport: viewport
      }),
      position: bestPlacement.position
    };
  } else {
    return {
      rect: bestPlacement.rect,
      position: bestPlacement.position
    };
  }
};

exports.default = getBestRelativePlacement;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: "/*!\n * Copyright Zendesk, Inc.\n *\n * Use of this source code is governed under the Apache License, Version 2.0\n * found at http://www.apache.org/licenses/LICENSE-2.0.\n */.scc-c-arrow-be7b392f{position:relative}.scc-c-arrow-be7b392f:before{border-width:inherit;border-style:inherit;border-color:transparent;background-clip:content-box}.scc-c-arrow-be7b392f:after{z-index:-1;border:inherit;-webkit-box-shadow:inherit;box-shadow:inherit}.scc-c-arrow-be7b392f:after,.scc-c-arrow-be7b392f:before{position:absolute;-webkit-transform:rotate(45deg);transform:rotate(45deg);background-color:inherit;-webkit-box-sizing:inherit;box-sizing:inherit;width:.85714em;height:.85714em;content:\"\"}.scc-c-arrow--t-be7b392f:before,.scc-c-arrow--tl-be7b392f:before,.scc-c-arrow--tr-be7b392f:before{border-bottom-right-radius:100%;-webkit-clip-path:polygon(100% 0,100% 1px,1px 100%,0 100%,0 0);clip-path:polygon(100% 0,100% 1px,1px 100%,0 100%,0 0)}.scc-c-arrow--t-be7b392f:after,.scc-c-arrow--t-be7b392f:before{top:-.42857em;left:50%;margin-left:-.42857em}.scc-c-arrow--tl-be7b392f:after,.scc-c-arrow--tl-be7b392f:before{top:-.42857em;left:.85714em}.scc-c-arrow--tr-be7b392f:after,.scc-c-arrow--tr-be7b392f:before{top:-.42857em;right:.85714em}.scc-c-arrow--r-be7b392f:before,.scc-c-arrow--rb-be7b392f:before,.scc-c-arrow--rt-be7b392f:before{border-bottom-left-radius:100%;-webkit-clip-path:polygon(100% 0,100% 100%,calc(100% - 1px) 100%,0 1px,0 0);clip-path:polygon(100% 0,100% 100%,calc(100% - 1px) 100%,0 1px,0 0)}.scc-c-arrow--rt-be7b392f:after,.scc-c-arrow--rt-be7b392f:before{top:.85714em;right:-.42857em}.scc-c-arrow--r-be7b392f:after,.scc-c-arrow--r-be7b392f:before{top:50%;right:-.42857em;margin-top:-.42857em}.scc-c-arrow--rb-be7b392f:after,.scc-c-arrow--rb-be7b392f:before{right:-.42857em;bottom:.85714em}.scc-c-arrow--l-be7b392f:before,.scc-c-arrow--lb-be7b392f:before,.scc-c-arrow--lt-be7b392f:before{border-top-right-radius:100%;-webkit-clip-path:polygon(0 100%,100% 100%,100% calc(100% - 1px),1px 0,0 0);clip-path:polygon(0 100%,100% 100%,100% calc(100% - 1px),1px 0,0 0)}.scc-c-arrow--lt-be7b392f:after,.scc-c-arrow--lt-be7b392f:before{top:.85714em;left:-.42857em}.scc-c-arrow--l-be7b392f:after,.scc-c-arrow--l-be7b392f:before{top:50%;left:-.42857em;margin-top:-.42857em}.scc-c-arrow--lb-be7b392f:after,.scc-c-arrow--lb-be7b392f:before{bottom:.85714em;left:-.42857em}.scc-c-arrow--b-be7b392f:before,.scc-c-arrow--bl-be7b392f:before,.scc-c-arrow--br-be7b392f:before{border-top-left-radius:100%;-webkit-clip-path:polygon(100% 0,calc(100% - 1px) 0,0 calc(100% - 1px),0 100%,100% 100%);clip-path:polygon(100% 0,calc(100% - 1px) 0,0 calc(100% - 1px),0 100%,100% 100%)}.scc-c-arrow--b-be7b392f:after,.scc-c-arrow--b-be7b392f:before{bottom:-.42857em;left:50%;margin-left:-.42857em}.scc-c-arrow--bl-be7b392f:after,.scc-c-arrow--bl-be7b392f:before{bottom:-.42857em;left:.85714em}.scc-c-arrow--br-be7b392f:after,.scc-c-arrow--br-be7b392f:before{right:.85714em;bottom:-.42857em}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"c-arrow":"scc-c-arrow-be7b392f","c-arrow--t":"scc-c-arrow--t-be7b392f","c-arrow--tl":"scc-c-arrow--tl-be7b392f","c-arrow--tr":"scc-c-arrow--tr-be7b392f","c-arrow--r":"scc-c-arrow--r-be7b392f","c-arrow--rb":"scc-c-arrow--rb-be7b392f","c-arrow--rt":"scc-c-arrow--rt-be7b392f","c-arrow--l":"scc-c-arrow--l-be7b392f","c-arrow--lb":"scc-c-arrow--lb-be7b392f","c-arrow--lt":"scc-c-arrow--lt-be7b392f","c-arrow--b":"scc-c-arrow--b-be7b392f","c-arrow--bl":"scc-c-arrow--bl-be7b392f","c-arrow--br":"scc-c-arrow--br-be7b392f"}


/***/ }),
/* 278 */,
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_ERROR_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SHOW_SUCCESS_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REMOVE_NOTIFICATION; });
var SHOW_ERROR_NOTIFICATION = "SHOW_ERROR_NOTIFICATION";
var SHOW_SUCCESS_NOTIFICATION = "SHOW_SUCCESS_NOTIFICATION";
var REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";

/***/ }),
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: ".ssc-valueContainer-a5285e9{display:block;padding:10px;cursor:pointer;border-radius:4px;word-wrap:break-word;word-wrap:break-word}.ssc-valueContainer-a5285e9:hover{background:#f8f9f9}.ssc-valueContainer-a5285e9:hover .ssc-icon-a5285e9{opacity:1}.ssc-icon-a5285e9{opacity:.5;margin:0 8px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;vertical-align:baseline}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"valueContainer":"ssc-valueContainer-a5285e9","icon":"ssc-icon-a5285e9"}


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutocompleteList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_Button__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_loaders__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_loaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_loaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AutocompleteItem__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__index_css__);

















var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_loaders__["Spinner"], {});

var AutocompleteList =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(AutocompleteList, _Component);

  function AutocompleteList(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, AutocompleteList);

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(AutocompleteList).call(this, props));
    _this.state = {
      showNew: false
    };
    _this.onAddNew = _this.onAddNew.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onRemoveNew = _this.onRemoveNew.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onShowNew = _this.onShowNew.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(AutocompleteList, [{
    key: "onAddNew",
    value: function onAddNew(newItem) {
      var onAddNew = this.props.onAddNew;
      this.setState({
        showNew: false
      });
      onAddNew(newItem);
    }
  }, {
    key: "onRemoveNew",
    value: function onRemoveNew() {
      this.setState({
        showNew: false
      });
    }
  }, {
    key: "onShowNew",
    value: function onShowNew() {
      this.setState({
        showNew: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var showNew = this.state.showNew;
      var _this$props = this.props,
          items = _this$props.items,
          type = _this$props.type,
          conjunction = _this$props.conjunction,
          newText = _this$props.newText,
          isLoading = _this$props.isLoading,
          title = _this$props.title,
          description = _this$props.description,
          error = _this$props.error;

      if (isLoading) {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.itemWrapper
        }, void 0, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("h3", {
          className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.itemHeader
        }, void 0, title), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("p", {
          className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.itemDescription,
          dangerouslySetInnerHTML: {
            __html: description
          }
        }), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.list
        }, void 0, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.loader
        }, void 0, _ref)));
      }

      var newItem = [items.length > 0 && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("span", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.conjunction
      }, "newConj", conjunction), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__components_AutocompleteItem__["a" /* default */], {
        newItem: true,
        type: type,
        onNewAdd: this.onAddNew,
        onNewRemove: this.onRemoveNew
      }, "newItem")];

      var newButton = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_Button___default.a, {
        testId: "add-new-".concat(type),
        type: "anchor",
        className: __WEBPACK_IMPORTED_MODULE_14_classnames___default()(__WEBPACK_IMPORTED_MODULE_15__index_css___default.a.conjunction, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.onlyNewButton, items.length === 0)),
        onClick: this.onShowNew
      }, void 0, newText);

      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.itemWrapper
      }, void 0, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("h3", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.itemHeader
      }, void 0, title), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("p", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.itemDescription,
        dangerouslySetInnerHTML: {
          __html: description
        }
      }), error ? __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.error
      }, void 0, error) : __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.list
      }, void 0, items.reduce(function (acc, item) {
        var id = item.id || item;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(acc).concat([acc.length !== 0 && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("span", {
          className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.conjunction
        }, "".concat(conjunction, "-").concat(id), conjunction), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__components_AutocompleteItem__["a" /* default */], {
          type: type,
          item: item
        }, id)]);
      }, []), showNew ? newItem : newButton));
    }
  }]);

  return AutocompleteList;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);


AutocompleteList.defaultProps = {
  items: [],
  isLoading: false
};
AutocompleteList.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].array,
  type: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].oneOf(["tags", "groups", "organizations"]),
  conjunction: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string,
  newText: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string,
  onAddNew: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  isLoading: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
  error: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string,
  title: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string,
  description: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)
__webpack_require__(199)

appendStyles({
  css: ".ssc-list-1185ab47:focus{outline:0}.ssc-item-1185ab47:first-child{margin-top:0;margin-top:initial}.ssc-item-1185ab47:last-child{margin-bottom:0;margin-bottom:initial}.ssc-item-1185ab47:hover:not(.ssc-selected-1185ab47){background:0 0}.ssc-disabled-1185ab47{pointer-events:none}.ssc-selected-1185ab47{background-color:#f8f8f8}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"list":"ssc-list-1185ab47","item":"ssc-item-1185ab47 scc-c-menu__item-526a8b12","selected":"ssc-selected-1185ab47","disabled":"ssc-disabled-1185ab47 scc-is-disabled-526a8b12","size_small":"ssc-size_small-1185ab47 scc-c-menu--sm-526a8b12"}


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)
__webpack_require__(113)

appendStyles({
  css: ".ssc-stretched-d4e0c943{-webkit-box-flex:1;-ms-flex:1;flex:1;width:100%}.ssc-message-d4e0c943{margin-top:8px}.ssc-input-d4e0c943{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ssc-hint-d4e0c943{margin-bottom:8px}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"stretched":"ssc-stretched-d4e0c943","txt":"ssc-txt-d4e0c943 scc-c-txt-4506f8eb","message":"ssc-message-d4e0c943 scc-c-txt__message-4506f8eb","input":"ssc-input-d4e0c943 scc-c-txt__input-4506f8eb scc-c-txt__input--select-4506f8eb","is_focused":"ssc-is_focused-d4e0c943 scc-is-focused-4506f8eb","label":"ssc-label-d4e0c943 scc-c-txt__label-4506f8eb","hint":"ssc-hint-d4e0c943 scc-c-txt__hint-4506f8eb","size_small":"ssc-size_small-d4e0c943 scc-c-txt__input--sm-4506f8eb","input_error":"ssc-input_error-d4e0c943 scc-c-txt__input--error-4506f8eb","input_warning":"ssc-input_warning-d4e0c943 scc-c-txt__input--warning-4506f8eb","input_success":"ssc-input_success-d4e0c943 scc-c-txt__input--success-4506f8eb","message_error":"ssc-message_error-d4e0c943 scc-c-txt__message--error-4506f8eb","message_warning":"ssc-message_warning-d4e0c943 scc-c-txt__message--warning-4506f8eb","message_success":"ssc-message_success-d4e0c943 scc-c-txt__message--success-4506f8eb","rtl":"ssc-rtl-d4e0c943 scc-is-rtl-4506f8eb","open":"ssc-open-d4e0c943 scc-is-open-4506f8eb","disabled":"ssc-disabled-d4e0c943 scc-is-disabled-4506f8eb"}


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_INITIAL_GROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_INITIAL_GROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_INITIAL_GROUPS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_AUTOCOMPLETE_GROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_AUTOCOMPLETE_GROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_AUTOCOMPLETE_GROUPS_FAILURE; });
var FETCH_INITIAL_GROUPS_REQUEST = "FETCH_INITIAL_GROUPS_REQUEST";
var FETCH_INITIAL_GROUPS_SUCCESS = "FETCH_INITIAL_GROUPS_SUCCESS";
var FETCH_INITIAL_GROUPS_FAILURE = "FETCH_INITIAL_GROUPS_FAILURE";
var FETCH_AUTOCOMPLETE_GROUPS_REQUEST = "FETCH_AUTOCOMPLETE_GROUPS_REQUEST";
var FETCH_AUTOCOMPLETE_GROUPS_SUCCESS = "FETCH_AUTOCOMPLETE_GROUPS_SUCCESS";
var FETCH_AUTOCOMPLETE_GROUPS_FAILURE = "FETCH_AUTOCOMPLETE_GROUPS_FAILURE";

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_INITIAL_ORGANIZATIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_INITIAL_ORGANIZATIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_INITIAL_ORGANIZATIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_AUTOCOMPLETE_ORGANIZATIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_AUTOCOMPLETE_ORGANIZATIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_AUTOCOMPLETE_ORGANIZATIONS_FAILURE; });
var FETCH_INITIAL_ORGANIZATIONS_REQUEST = "FETCH_INITIAL_ORGANIZATIONS_REQUEST";
var FETCH_INITIAL_ORGANIZATIONS_SUCCESS = "FETCH_INITIAL_ORGANIZATIONS_SUCCESS";
var FETCH_INITIAL_ORGANIZATIONS_FAILURE = "FETCH_INITIAL_ORGANIZATIONS_FAILURE";
var FETCH_AUTOCOMPLETE_ORGANIZATIONS_REQUEST = "FETCH_AUTOCOMPLETE_ORGANIZATIONS_REQUEST";
var FETCH_AUTOCOMPLETE_ORGANIZATIONS_SUCCESS = "FETCH_AUTOCOMPLETE_ORGANIZATIONS_SUCCESS";
var FETCH_AUTOCOMPLETE_ORGANIZATIONS_FAILURE = "FETCH_AUTOCOMPLETE_ORGANIZATIONS_FAILURE";

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_INITIAL_TAGS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_INITIAL_TAGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_INITIAL_TAGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_AUTOCOMPLETE_TAGS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_AUTOCOMPLETE_TAGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_AUTOCOMPLETE_TAGS_FAILURE; });
var FETCH_INITIAL_TAGS_REQUEST = "FETCH_INITIAL_TAGS_REQUEST";
var FETCH_INITIAL_TAGS_SUCCESS = "FETCH_INITIAL_TAGS_SUCCESS";
var FETCH_INITIAL_TAGS_FAILURE = "FETCH_INITIAL_TAGS_FAILURE";
var FETCH_AUTOCOMPLETE_TAGS_REQUEST = "FETCH_AUTOCOMPLETE_TAGS_REQUEST";
var FETCH_AUTOCOMPLETE_TAGS_SUCCESS = "FETCH_AUTOCOMPLETE_TAGS_SUCCESS";
var FETCH_AUTOCOMPLETE_TAGS_FAILURE = "FETCH_AUTOCOMPLETE_TAGS_FAILURE";

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_self_service_components_lib_Avatar__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_self_service_components_lib_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_self_service_components_lib_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Pagination__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_self_service_components_lib_Ellipsis__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_self_service_components_lib_Ellipsis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__zendesk_self_service_components_lib_Ellipsis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_loaders__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_loaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_loaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions_userSegment__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);























var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_loaders__["Spinner"], {});

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {});

var UserList =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(UserList, _Component);

  function UserList(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, UserList);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(UserList).call(this, props));
    _this.state = {
      // The pagination state is kept in the component, because parameters by which
      // users are filtered (tags, orgs, groups) can be changed without it being reflected in
      // the URL, making the page parameter there useless (it won't produce the same result)
      page: 1
    };
    _this.onPageSelected = _this.onPageSelected.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(UserList, [{
    key: "onPageSelected",
    value: function onPageSelected(page) {
      var nextPageNumber = page + 1;
      var fetchUsers = this.props.fetchUsers;
      this.setState({
        page: nextPageNumber
      });
      fetchUsers(nextPageNumber);
    }
  }, {
    key: "renderRows",
    value: function renderRows() {
      var _this$props = this.props,
          users = _this$props.users,
          isFetching = _this$props.isFetching,
          userType = _this$props.userType;

      if (isFetching) {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("tr", {
          className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row"]
        }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("td", {
          colSpan: 4,
          className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row__cell"], __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.cell)
        }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.loader,
          "data-test-id": "user-list-loader"
        }, void 0, _ref)));
      }

      if (users.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("tr", {
          className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row"]
        }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("td", {
          colSpan: 3,
          className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row__cell"], __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.cell),
          "data-test-id": "user-list-empty"
        }, void 0, __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.noUsers")));
      }

      return users.map(function (user) {
        var userTypeSpecificProperty = userType === __WEBPACK_IMPORTED_MODULE_20__constants__["e" /* STAFF */] ? user.groups : user.organizations;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("tr", {
          className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row"],
          "data-test-id": "user-row"
        }, user.id, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("td", {
          className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row__cell"], __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.cell),
          "data-test-id": "user-name"
        }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("a", {
          "data-test-id": "user-profile-in-support-link",
          target: "_blank",
          href: "/agent/users/".concat(user.id),
          title: __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.profileInSupport", {
            name: user.name
          })
        }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__zendesk_self_service_components_lib_Avatar___default.a, {
          className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.avatar,
          size: "medium",
          alt: user.name,
          src: user.photo.content_url
        }, "avatar"), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("span", {
          className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.name
        }, void 0, user.name))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("td", {
          className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row__cell"], __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.cell),
          "data-test-id": "user-email"
        }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__zendesk_self_service_components_lib_Ellipsis___default.a, {}, void 0, user.email)), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("td", {
          className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row__cell"], __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.cell),
          "data-test-id": "user-tags"
        }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__zendesk_self_service_components_lib_Ellipsis___default.a, {}, void 0, user.tags.join(", "))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("td", {
          className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row__cell"], __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.cell),
          "data-test-id": "user-groups-orgs"
        }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__zendesk_self_service_components_lib_Ellipsis___default.a, {}, void 0, userTypeSpecificProperty.map(function (_ref2) {
          var name = _ref2.name;
          return name;
        }).join(", "))));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var page = this.state.page;
      var _this$props2 = this.props,
          isFetching = _this$props2.isFetching,
          isAdmin = _this$props2.isAdmin,
          pageCount = _this$props2.pageCount,
          userCount = _this$props2.userCount,
          userType = _this$props2.userType; // Non-admins shouldn't see user list

      if (!isAdmin) {
        return _ref3;
      }

      var pagination = pageCount > 1 && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Pagination___default.a, {
        total: pageCount,
        currentPage: page - 1,
        onPageSelected: this.onPageSelected
      });

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h2", {
        className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.title
      }, void 0, isFetching ? __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.matchingUsers") : __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.matchingUsersWithCount", {
        count: userCount
      })), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("p", {
        className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.description,
        dangerouslySetInnerHTML: {
          __html: __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.matchingUsersDescription", {
            addUserUrl: "/agent/users/new"
          })
        }
      }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("table", {
        className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table"], __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.table)
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("thead", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("tr", {
        className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row"], __WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row--header"])
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("th", {
        className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row__cell"], __WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row__cell--truncate"])
      }, void 0, __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.users")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("th", {
        className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row__cell"]
      }, void 0, __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.email")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("th", {
        className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row__cell"]
      }, void 0, __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.tags")), userType === __WEBPACK_IMPORTED_MODULE_20__constants__["e" /* STAFF */] ? __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("th", {
        className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row__cell"]
      }, void 0, __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.groups")) : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("th", {
        className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a["c-table__row__cell"]
      }, void 0, __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.organizations")))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("tbody", {}, void 0, this.renderRows())), pagination);
    }
  }]);

  return UserList;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);
UserList.defaultProps = {
  users: [],
  isFetching: false
};
UserList.propTypes = {
  users: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].array,
  isFetching: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool,
  isAdmin: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool,
  fetchUsers: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  userCount: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number,
  pageCount: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number,
  userType: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].oneOf([__WEBPACK_IMPORTED_MODULE_20__constants__["e" /* STAFF */], __WEBPACK_IMPORTED_MODULE_20__constants__["d" /* SIGNED_IN_USERS */]])
};

var mapStateToProps = function mapStateToProps(_ref4, ownProps) {
  var userSegment = _ref4.userSegment;
  return {
    users: userSegment.users,
    userType: userSegment.userType,
    userCount: userSegment.userCount,
    pageCount: userSegment.userPageCount,
    isAdmin: Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["hasEntitlement"])("admin"),
    isFetching: userSegment.isFetching || userSegment.isFetchingUsers || userSegment.isFetchingOrganizations || userSegment.isFetchingGroups
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_11_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, __WEBPACK_IMPORTED_MODULE_19__actions_userSegment__), dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(UserList));

/***/ }),
/* 304 */,
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(306);
module.exports = __webpack_require__(307);


/***/ }),
/* 306 */,
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_polyfill__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_whatwg_fetch__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendeskgarden_react_tags_dist_styles_css__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendeskgarden_react_tags_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__zendeskgarden_react_tags_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_thunk__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_connected_react_router__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_redux_lib_middleware_logMiddleware__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_redux_lib_middleware_logMiddleware___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_redux_lib_middleware_logMiddleware__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_notifyError__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_utils_lib_PageNavigator_getQuery__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_utils_lib_PageNavigator_getQuery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_utils_lib_PageNavigator_getQuery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_utils_lib_PageNavigator_setQuery__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_utils_lib_PageNavigator_setQuery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_utils_lib_PageNavigator_setQuery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_history_createBrowserHistory__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_analytics__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_connect__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_connect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_connect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_App__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__reducers__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context__);






















var history = __WEBPACK_IMPORTED_MODULE_15_history_createBrowserHistory___default()();
var middleware = [Object(__WEBPACK_IMPORTED_MODULE_10_connected_react_router__["routerMiddleware"])(history), __WEBPACK_IMPORTED_MODULE_8_redux_thunk___default.a, __WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_redux_lib_middleware_logMiddleware___default()(__WEBPACK_IMPORTED_MODULE_12__utils_notifyError__["a" /* default */])];

if (false) {
  var _require = require("redux-logger"),
      createLogger = _require.createLogger;

  var logger = createLogger({
    collapsed: true
  });
  middleware.push(logger);
}

var enhancer = __WEBPACK_IMPORTED_MODULE_9_redux__["a" /* applyMiddleware */].apply(void 0, middleware);
var store = Object(__WEBPACK_IMPORTED_MODULE_9_redux__["d" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_20__reducers__["a" /* default */])(history), undefined, enhancer);

var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_redux__["Provider"], {
  store: store
}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_connected_react_router__["ConnectedRouter"], {
  history: history
}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_19__components_App__["a" /* default */], {})));

function renderApp(context) {
  __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default.a.load(context.token.user.locale, function () {
    document.title = __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.name");
    Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["render"])(_ref, document.getElementById("container"));
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_analytics___default.a.setup();
      __WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_connect___default.a.setup();
    }, 1000);
  });
}

var query = __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_utils_lib_PageNavigator_getQuery___default()(); // Make sure a brand with a help center is selected.
// If brand_id in the query is not valid or is not set
// pick the agent brand or a first suitable brand

Object(__WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context__["loadContext"])({
  brandId: query.brand_id
}).then(function (context) {
  if (!(Object(__WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context__["hasEntitlement"])("admin") || Object(__WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context__["hasEntitlement"])("manager")) || !Object(__WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context__["hasFeature"])("user_segments")) {
    window.location.replace("/knowledge/lists");
    return;
  }

  var hasBrandId = "brand_id" in query;

  if (!hasBrandId) {
    __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_utils_lib_PageNavigator_setQuery___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, query, {
      brand_id: context.default_brand.id
    }));
  }

  renderApp(context);
});

/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export App */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserSegments__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserSegment__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NewUserSegment__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(139);












var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["d" /* Switch */], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["c" /* Route */], {
  exact: true,
  path: "/knowledge/user_segments",
  component: __WEBPACK_IMPORTED_MODULE_7__UserSegments__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["c" /* Route */], {
  exact: true,
  path: "/knowledge/user_segments/new",
  component: __WEBPACK_IMPORTED_MODULE_9__NewUserSegment__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["c" /* Route */], {
  exact: true,
  path: "/knowledge/user_segments/:type(staff|signedIn)/:page?",
  component: __WEBPACK_IMPORTED_MODULE_7__UserSegments__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["c" /* Route */], {
  exact: true,
  path: "/knowledge/user_segments/:id",
  component: __WEBPACK_IMPORTED_MODULE_8__UserSegment__["a" /* default */]
}));

var App =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(App, _Component);

  function App() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, App);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(App).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(App, [{
    key: "render",
    value: function render() {
      return _ref;
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["e" /* withRouter */])(App));

/***/ }),
/* 550 */,
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserSegments */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Button__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_self_service_components_lib_Tabs__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_self_service_components_lib_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__zendesk_self_service_components_lib_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_context__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ErrorBoundary__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Notifications__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_urls__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_List__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_userSegment__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__index_css__);
























var STAFF_TYPE = "staff";
var SIGNED_IN_TYPE = "signedIn";

var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_19__Notifications__["a" /* default */], {});

var UserSegments =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(UserSegments, _Component);

  function UserSegments() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, UserSegments);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(UserSegments).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(UserSegments, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          page = _this$props.page,
          showSidebar = _this$props.showSidebar,
          addUserSegment = _this$props.addUserSegment,
          filterUserSegments = _this$props.filterUserSegments;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a, {
        brandId: Object(__WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_context__["getCurrentBrandId"])(),
        dir: __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default.a.dir,
        topNav: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("a", {
          href: Object(__WEBPACK_IMPORTED_MODULE_20__utils_urls__["b" /* getUserSegmentsUrl */])()
        }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-user-segments.userPermissions"))), _ref, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-user-segments.name")))
      }, void 0, showSidebar && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["Sidebar"], {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["Sidebar"].Item, {
        active: true,
        testId: "sidebar-user-segments-link"
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-user-segments.name")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["Sidebar"].LinkItem, {
        href: Object(__WEBPACK_IMPORTED_MODULE_20__utils_urls__["a" /* getPermissionsUrl */])(),
        testId: "sidebar-permission-groups-link"
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-user-segments.managementPermissions"))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["ContentView"], {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(showSidebar ? __WEBPACK_IMPORTED_MODULE_23__index_css___default.a.twoColumn : __WEBPACK_IMPORTED_MODULE_23__index_css___default.a.singleColumn)
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18__ErrorBoundary__["a" /* default */], {}, void 0, _ref2, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_23__index_css___default.a.header
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_23__index_css___default.a.headerContent
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h1", {
        className: __WEBPACK_IMPORTED_MODULE_23__index_css___default.a.title
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-user-segments.list.title")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("p", {
        className: __WEBPACK_IMPORTED_MODULE_23__index_css___default.a.subtitle,
        dangerouslySetInnerHTML: {
          __html: __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-user-segments.list.description", {
            learnMoreUrl: __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-user-segments.list.descriptionLearnMoreUrl")
          })
        }
      })), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Button___default.a, {
        type: "primary",
        onClick: addUserSegment,
        testId: "add-new"
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-user-segments.list.addNew"))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__zendesk_self_service_components_lib_Tabs___default.a, {
        active: type,
        onChange: filterUserSegments
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__zendesk_self_service_components_lib_Tabs___default.a.Panel, {
        label: __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-user-segments.list.tabStaff"),
        id: STAFF_TYPE,
        testId: "tab-staff"
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_21__components_List__["a" /* default */], {
        type: STAFF_TYPE,
        page: page
      }, STAFF_TYPE)), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__zendesk_self_service_components_lib_Tabs___default.a.Panel, {
        label: __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-user-segments.list.tabSignedInUsers"),
        id: SIGNED_IN_TYPE,
        testId: "tab-signed-in-users"
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_21__components_List__["a" /* default */], {
        type: SIGNED_IN_TYPE,
        page: page
      }, SIGNED_IN_TYPE)))))));
    }
  }]);

  return UserSegments;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);
UserSegments.propTypes = {
  addUserSegment: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].func,
  filterUserSegments: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].func,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].oneOf([STAFF_TYPE, SIGNED_IN_TYPE]).isRequired,
  page: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].number,
  showSidebar: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].bool.isRequired
};
UserSegments.defaultProps = {
  type: STAFF_TYPE,
  page: 1,
  showSidebar: false
};

var mapStateToProps = function mapStateToProps(_ref3, _ref4) {
  var staffUserSegments = _ref3.staffUserSegments;
  var match = _ref4.match;
  var page = parseInt(match.params.page, 10);
  return {
    showSidebar: Object(__WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_context__["hasFeature"])("guide_permission_groups") && Object(__WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_context__["hasFeature"])("permission_groups"),
    type: match.params.type,
    page: isNaN(page) ? 1 : page
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_10_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, __WEBPACK_IMPORTED_MODULE_22__actions_userSegment__), dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(UserSegments));

/***/ }),
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(562);
module.exports = __webpack_require__(42).Object.assign;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(62);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(564)});

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(95)
  , gOPS     = __webpack_require__(191)
  , pIE      = __webpack_require__(134)
  , toObject = __webpack_require__(135)
  , IObject  = __webpack_require__(257)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(94)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(80)
  , toLength  = __webpack_require__(258)
  , toIndex   = __webpack_require__(566);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(187)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(568), __esModule: true };

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(260);
__webpack_require__(574);
module.exports = __webpack_require__(195).f('iterator');

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(187)
  , defined   = __webpack_require__(186);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(193)
  , descriptor     = __webpack_require__(105)
  , setToStringTag = __webpack_require__(194)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(91)(IteratorPrototype, __webpack_require__(50)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(69)
  , anObject = __webpack_require__(92)
  , getKeys  = __webpack_require__(95);

module.exports = __webpack_require__(78) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(68).document && document.documentElement;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(79)
  , toObject    = __webpack_require__(135)
  , IE_PROTO    = __webpack_require__(188)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(575);
var global        = __webpack_require__(68)
  , hide          = __webpack_require__(91)
  , Iterators     = __webpack_require__(106)
  , TO_STRING_TAG = __webpack_require__(50)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(576)
  , step             = __webpack_require__(577)
  , Iterators        = __webpack_require__(106)
  , toIObject        = __webpack_require__(80);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(261)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(579), __esModule: true };

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(580);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
module.exports = __webpack_require__(42).Symbol;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(68)
  , has            = __webpack_require__(79)
  , DESCRIPTORS    = __webpack_require__(78)
  , $export        = __webpack_require__(62)
  , redefine       = __webpack_require__(262)
  , META           = __webpack_require__(581).KEY
  , $fails         = __webpack_require__(94)
  , shared         = __webpack_require__(189)
  , setToStringTag = __webpack_require__(194)
  , uid            = __webpack_require__(133)
  , wks            = __webpack_require__(50)
  , wksExt         = __webpack_require__(195)
  , wksDefine      = __webpack_require__(196)
  , keyOf          = __webpack_require__(582)
  , enumKeys       = __webpack_require__(583)
  , isArray        = __webpack_require__(584)
  , anObject       = __webpack_require__(92)
  , toIObject      = __webpack_require__(80)
  , toPrimitive    = __webpack_require__(184)
  , createDesc     = __webpack_require__(105)
  , _create        = __webpack_require__(193)
  , gOPNExt        = __webpack_require__(585)
  , $GOPD          = __webpack_require__(264)
  , $DP            = __webpack_require__(69)
  , $keys          = __webpack_require__(95)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(263).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(134).f  = $propertyIsEnumerable;
  __webpack_require__(191).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(192)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(91)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(133)('meta')
  , isObject = __webpack_require__(93)
  , has      = __webpack_require__(79)
  , setDesc  = __webpack_require__(69).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(94)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(95)
  , toIObject = __webpack_require__(80);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(95)
  , gOPS    = __webpack_require__(191)
  , pIE     = __webpack_require__(134);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(185);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(80)
  , gOPN      = __webpack_require__(263).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 586 */
/***/ (function(module, exports) {



/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(196)('asyncIterator');

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(196)('observable');

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(590), __esModule: true };

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(591);
module.exports = __webpack_require__(42).Object.setPrototypeOf;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(62);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(592).set});

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(93)
  , anObject = __webpack_require__(92);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(183)(Function.call, __webpack_require__(264).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(594), __esModule: true };

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(595);
var $Object = __webpack_require__(42).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(62)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(193)});

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(597);
module.exports = __webpack_require__(42).Object.keys;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(135)
  , $keys    = __webpack_require__(95);

__webpack_require__(598)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(62)
  , core    = __webpack_require__(42)
  , fails   = __webpack_require__(94);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Core = function (_Component) {
  (0, _inherits3.default)(Core, _Component);

  function Core(props, context) {
    (0, _classCallCheck3.default)(this, Core);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));

    _this.onSubmitKeyPressed = function (e) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onSubmitKeyPressed = _this$props.onSubmitKeyPressed;

      onClick && onClick(e);
      onSubmitKeyPressed && onSubmitKeyPressed(e);
      e.preventDefault();
    };

    _this.onMouseDown = function (e) {
      var disabled = _this.props.disabled;


      if (disabled) {
        e.stopPropagation();
        e.preventDefault();
      } else {
        _this.keyboard = false;
      }
    };

    _this.onClick = function (e) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          onClick = _this$props2.onClick;


      if (disabled) {
        e.stopPropagation();
        e.preventDefault();
      } else {
        onClick && onClick(e);
      }
    };

    _this.onFocus = function (e) {
      var _this$props3 = _this.props,
          onFocus = _this$props3.onFocus,
          onKeyboardFocus = _this$props3.onKeyboardFocus;


      onFocus && onFocus(e);
      _this.keyboard && onKeyboardFocus && onKeyboardFocus(e);

      _this.keyboard = true;
    };

    _this.keyboard = true;
    return _this;
  }

  Core.prototype.render = function render() {
    var _props = this.props,
        autoFocus = _props.autoFocus,
        className = _props.className,
        children = _props.children,
        disabled = _props.disabled,
        onBlur = _props.onBlur,
        onKeyDown = _props.onKeyDown,
        onKeyUp = _props.onKeyUp,
        tabIndex = _props.tabIndex,
        testId = _props.testId,
        title = _props.title,
        tooltipPositioning = _props.tooltipPositioning,
        onKeyboardFocus = _props.onKeyboardFocus,
        onSubmitKeyPressed = _props.onSubmitKeyPressed,
        other = (0, _objectWithoutProperties3.default)(_props, ["autoFocus", "className", "children", "disabled", "onBlur", "onKeyDown", "onKeyUp", "tabIndex", "testId", "title", "tooltipPositioning", "onKeyboardFocus", "onSubmitKeyPressed"]);


    return _react2.default.createElement(
      _View2.default,
      (0, _extends3.default)({}, other, {
        autoFocus: autoFocus,
        className: className,
        testId: testId,
        disabled: disabled,
        onBlur: onBlur,
        onClick: this.onClick,
        onEnter: this.onSubmitKeyPressed,
        onFocus: this.onFocus,
        onMouseDown: this.onMouseDown,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onSpace: this.onSubmitKeyPressed,
        tabIndex: disabled ? null : tabIndex,
        role: "button",
        title: title,
        tooltipPositioning: tooltipPositioning
      }),
      children
    );
  };

  return Core;
}(_react.Component);

Core.propTypes = {
  autoFocus: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  onKeyboardFocus: _propTypes2.default.func,
  onSubmitKeyPressed: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number,
  testId: _propTypes2.default.string,
  title: _propTypes2.default.string,
  /** <a href="#view">See View</a> */
  tooltipPositioning: function tooltipPositioning() {},
  children: _propTypes2.default.node
};
Core.defaultProps = {
  tabIndex: 0
};
exports.default = Core;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: ".ssc-view-3cf51d67[aria-hidden=true]{display:none}.ssc-inline-3cf51d67{display:inline-block}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"view":"ssc-view-3cf51d67","inline":"ssc-inline-3cf51d67"}


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)
__webpack_require__(602)

appendStyles({
  css: ".ssc-stretched-250c62b7{-webkit-box-flex:1;-ms-flex:1;flex:1}.ssc-group-250c62b7:focus{outline:0}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"active":"ssc-active-250c62b7 scc-is-active-4151b641","selected":"ssc-selected-250c62b7 scc-is-selected-4151b641","focused":"ssc-focused-250c62b7 scc-is-focused-4151b641","danger":"ssc-danger-250c62b7 scc-c-btn--danger-4151b641","rtl":"ssc-rtl-250c62b7 scc-is-rtl-4151b641","type_default":"ssc-type_default-250c62b7 scc-c-btn-4151b641","type_primary":"ssc-type_primary-250c62b7 scc-c-btn-4151b641 scc-c-btn--primary-4151b641","type_basic":"ssc-type_basic-250c62b7 scc-c-btn-4151b641 scc-c-btn--basic-4151b641","type_anchor":"ssc-type_anchor-250c62b7 scc-c-btn-4151b641 scc-c-btn--anchor-4151b641","pill":"ssc-pill-250c62b7 scc-c-btn--pill-4151b641","size_small":"ssc-size_small-250c62b7 scc-c-btn--sm-4151b641","size_large":"ssc-size_large-250c62b7 scc-c-btn--lg-4151b641","stretched":"ssc-stretched-250c62b7 scc-c-btn--full-4151b641","disabled":"ssc-disabled-250c62b7 scc-is-disabled-4151b641","group":"ssc-group-250c62b7 scc-l-btn-group-4151b641"}


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: "/*!\n * Copyright Zendesk, Inc.\n *\n * Use of this source code is governed under the Apache License, Version 2.0\n * found at http://www.apache.org/licenses/LICENSE-2.0.\n */.scc-c-btn-4151b641{display:inline-block;-webkit-transition:border-color .25s ease-in-out,background-color .25s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;transition:border-color .25s ease-in-out,background-color .25s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;transition:border-color .25s ease-in-out,box-shadow .1s ease-in-out,background-color .25s ease-in-out,color .25s ease-in-out;transition:border-color .25s ease-in-out,box-shadow .1s ease-in-out,background-color .25s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;margin:0;border:1px solid #5293c7;border-radius:4px;background-color:transparent;cursor:pointer;padding:0 1.92857em;min-width:8.57143em;overflow:visible;vertical-align:middle;text-align:center;text-decoration:none;line-height:38px;white-space:nowrap;color:#1f73b7;font-family:inherit;font-size:14px;font-weight:400;-webkit-font-smoothing:subpixel-antialiased;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none}.scc-c-btn-4151b641::-moz-focus-inner{border:0;padding:0}.scc-c-btn--pill-4151b641{border-radius:100px}.scc-c-btn--sm-4151b641{padding:0 2.25em;min-width:8.33333em;line-height:30px;font-size:12px}.scc-c-btn--lg-4151b641{padding:0 1.92857em;min-width:10em;line-height:46px;font-size:14px}.scc-c-btn--full-4151b641{width:100%;overflow:hidden;text-overflow:ellipsis}.scc-c-btn-4151b641.scc-c-btn--danger-4151b641{border-color:#e35b66;color:#cc3340}.scc-c-btn--basic-4151b641.scc-c-btn--basic-4151b641{border-color:transparent;background-color:transparent}.scc-l-btn-group-4151b641{position:relative;z-index:0;white-space:nowrap}.scc-l-btn-group-4151b641 .scc-c-btn-4151b641{position:relative;margin-left:-1px;border-radius:0}.scc-l-btn-group-4151b641 .scc-c-btn-4151b641.scc-is-active-4151b641.scc-is-active-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn-4151b641.scc-is-hovered-4151b641.scc-is-hovered-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn-4151b641:active:active,.scc-l-btn-group-4151b641 .scc-c-btn-4151b641:hover:hover{z-index:1}.scc-l-btn-group-4151b641 .scc-c-btn-4151b641.scc-is-focused-4151b641{-webkit-box-shadow:inset 0 0 0 3px rgba(31,115,183,.35);box-shadow:inset 0 0 0 3px rgba(31,115,183,.35)}.scc-l-btn-group-4151b641 .scc-c-btn-4151b641.scc-is-disabled-4151b641.scc-is-disabled-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn-4151b641:disabled:disabled{z-index:-1}.scc-l-btn-group-4151b641 .scc-c-btn-4151b641.scc-c-btn--primary-4151b641.scc-is-focused-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn-4151b641.scc-is-selected-4151b641.scc-is-focused-4151b641{-webkit-box-shadow:inset 0 0 0 3px hsla(0,0%,100%,.35);box-shadow:inset 0 0 0 3px hsla(0,0%,100%,.35)}.scc-l-btn-group-4151b641 .scc-c-btn--primary-4151b641.scc-c-btn--primary-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn--primary-4151b641.scc-is-active-4151b641.scc-is-active-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn--primary-4151b641.scc-is-hovered-4151b641.scc-is-hovered-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn--primary-4151b641:active:active,.scc-l-btn-group-4151b641 .scc-c-btn--primary-4151b641:hover:hover,.scc-l-btn-group-4151b641 .scc-c-btn-4151b641.scc-is-disabled-4151b641.scc-is-disabled-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn-4151b641:disabled:disabled{border-right-color:#f8f9f9;border-left-color:#f8f9f9}.scc-l-btn-group-4151b641 .scc-c-btn-4151b641.scc-c-btn--primary-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn-4151b641.scc-is-disabled-4151b641.scc-is-disabled-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn-4151b641.scc-is-selected-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn-4151b641:disabled:disabled{border-top-width:0;border-bottom-width:0;line-height:40px}.scc-l-btn-group-4151b641 .scc-c-btn--sm-4151b641.scc-c-btn-4151b641.scc-c-btn--primary-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn--sm-4151b641.scc-c-btn-4151b641.scc-is-selected-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn--sm-4151b641.scc-is-disabled-4151b641.scc-is-disabled-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn--sm-4151b641:disabled:disabled{line-height:32px}.scc-l-btn-group-4151b641 .scc-c-btn--lg-4151b641.scc-c-btn-4151b641.scc-c-btn--primary-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn--lg-4151b641.scc-c-btn-4151b641.scc-is-selected-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn--lg-4151b641.scc-is-disabled-4151b641.scc-is-disabled-4151b641,.scc-l-btn-group-4151b641 .scc-c-btn--lg-4151b641:disabled:disabled{line-height:48px}.scc-l-btn-group-4151b641.scc-is-rtl-4151b641{direction:rtl}.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn-4151b641{margin-right:-1px;margin-left:0;border-radius:0}.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn-4151b641:last-of-type,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn-4151b641:first-of-type{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn-4151b641:first-of-type,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn-4151b641:last-of-type{margin-right:0;border-top-right-radius:4px;border-bottom-right-radius:4px}.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn--pill-4151b641:last-of-type,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn--pill-4151b641:first-of-type{border-top-left-radius:100px;border-bottom-left-radius:100px}.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn--pill-4151b641:last-of-type .scc-c-btn__icon-4151b641,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn--pill-4151b641:first-of-type .scc-c-btn__icon-4151b641{margin-right:-2px}.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn--pill-4151b641:first-of-type,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn--pill-4151b641:last-of-type{border-top-right-radius:100px;border-bottom-right-radius:100px}.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn--pill-4151b641:first-of-type .scc-c-btn__icon-4151b641,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn--pill-4151b641:last-of-type .scc-c-btn__icon-4151b641{margin-left:-2px}.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn-4151b641.scc-c-btn--primary-4151b641:last-of-type,.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn-4151b641.scc-is-disabled-4151b641.scc-is-disabled-4151b641:last-of-type,.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn-4151b641.scc-is-selected-4151b641:last-of-type,.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn-4151b641:disabled:disabled:last-of-type,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn-4151b641.scc-c-btn--primary-4151b641:first-of-type,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn-4151b641.scc-is-disabled-4151b641.scc-is-disabled-4151b641:first-of-type,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn-4151b641.scc-is-selected-4151b641:first-of-type,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn-4151b641:disabled:disabled:first-of-type{border-left-color:transparent}.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn-4151b641.scc-c-btn--primary-4151b641:first-of-type,.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn-4151b641.scc-is-disabled-4151b641.scc-is-disabled-4151b641:first-of-type,.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn-4151b641.scc-is-selected-4151b641:first-of-type,.scc-l-btn-group-4151b641.scc-is-rtl-4151b641 .scc-c-btn-4151b641:disabled:disabled:first-of-type,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn-4151b641.scc-c-btn--primary-4151b641:last-of-type,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn-4151b641.scc-is-disabled-4151b641.scc-is-disabled-4151b641:last-of-type,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn-4151b641.scc-is-selected-4151b641:last-of-type,.scc-l-btn-group-4151b641:not(.scc-is-rtl-4151b641) .scc-c-btn-4151b641:disabled:disabled:last-of-type{border-right-color:transparent}.scc-c-btn-4151b641.scc-is-hovered-4151b641.scc-is-hovered-4151b641,.scc-c-btn-4151b641:hover:hover{border-color:transparent;background-color:#5293c7;text-decoration:none;color:#fff}.scc-c-btn-4151b641.scc-c-btn--danger-4151b641.scc-is-hovered-4151b641.scc-is-hovered-4151b641,.scc-c-btn-4151b641.scc-c-btn--danger-4151b641:hover:hover{background-color:#e35b66}.scc-c-btn-4151b641:focus{outline:0;text-decoration:none}.scc-c-btn-4151b641.scc-is-focused-4151b641{-webkit-box-shadow:0 0 0 3px rgba(31,115,183,.35);box-shadow:0 0 0 3px rgba(31,115,183,.35)}.scc-c-btn-4151b641.scc-c-btn--danger-4151b641.scc-is-focused-4151b641{-webkit-box-shadow:0 0 0 3px rgba(204,51,64,.35);box-shadow:0 0 0 3px rgba(204,51,64,.35)}.scc-c-btn-4151b641.scc-is-active-4151b641.scc-is-active-4151b641,.scc-c-btn-4151b641:active:active{-webkit-transition:border-color .1s ease-in-out,background-color .1s ease-in-out,color .1s ease-in-out;transition:border-color .1s ease-in-out,background-color .1s ease-in-out,color .1s ease-in-out;border-color:transparent;background-color:#144a75;text-decoration:none;color:#fff}.scc-c-btn-4151b641.scc-c-btn--danger-4151b641.scc-is-active-4151b641.scc-is-active-4151b641,.scc-c-btn-4151b641.scc-c-btn--danger-4151b641:active:active{background-color:#8c232c}.scc-c-btn-4151b641.scc-is-focused-4151b641.scc-is-active-4151b641.scc-is-active-4151b641,.scc-c-btn-4151b641.scc-is-focused-4151b641:active:active,.scc-c-btn-4151b641.scc-is-hovered-4151b641.scc-is-hovered-4151b641.scc-is-active-4151b641.scc-is-active-4151b641,.scc-c-btn-4151b641.scc-is-hovered-4151b641.scc-is-hovered-4151b641:active:active,.scc-c-btn-4151b641:hover:hover.scc-is-active-4151b641.scc-is-active-4151b641,.scc-c-btn-4151b641:hover:hover:active:active{-webkit-box-shadow:none;box-shadow:none}.scc-c-btn-4151b641.scc-is-disabled-4151b641.scc-is-disabled-4151b641,.scc-c-btn-4151b641:disabled:disabled{border-color:transparent;-webkit-box-shadow:none;box-shadow:none;background-color:#e9ebed;cursor:default;color:#c2c8cc}.scc-c-btn--anchor-4151b641{display:inline;border:none;border-radius:0;background-color:transparent;cursor:pointer;padding:0;min-width:0;vertical-align:baseline;text-decoration:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;line-height:normal;white-space:normal;color:#1f73b7;font-size:inherit;font-weight:inherit}.scc-c-btn--anchor-4151b641.scc-c-btn--anchor-4151b641.scc-is-hovered-4151b641.scc-is-hovered-4151b641,.scc-c-btn--anchor-4151b641.scc-c-btn--anchor-4151b641:hover:hover{background-color:transparent;text-decoration:underline;color:#1f73b7}.scc-c-btn-4151b641.scc-c-btn--anchor-4151b641.scc-c-btn--danger-4151b641,.scc-c-btn-4151b641.scc-c-btn--anchor-4151b641.scc-c-btn--danger-4151b641.scc-is-hovered-4151b641.scc-is-hovered-4151b641,.scc-c-btn-4151b641.scc-c-btn--anchor-4151b641.scc-c-btn--danger-4151b641:hover:hover{color:#cc3340}.scc-c-btn--anchor-4151b641.scc-c-btn--anchor-4151b641.scc-is-focused-4151b641{-webkit-box-shadow:none;box-shadow:none;text-decoration:underline}.scc-c-btn--anchor-4151b641.scc-c-btn--anchor-4151b641.scc-is-active-4151b641.scc-is-active-4151b641,.scc-c-btn--anchor-4151b641.scc-c-btn--anchor-4151b641:active:active{background-color:transparent;text-decoration:underline;color:#1f73b7}.scc-c-btn-4151b641.scc-c-btn--anchor-4151b641.scc-c-btn--danger-4151b641.scc-is-active-4151b641.scc-is-active-4151b641,.scc-c-btn-4151b641.scc-c-btn--anchor-4151b641.scc-c-btn--danger-4151b641:active:active{color:#cc3340}.scc-c-btn--anchor-4151b641.scc-c-btn--anchor-4151b641.scc-is-disabled-4151b641.scc-is-disabled-4151b641,.scc-c-btn--anchor-4151b641.scc-c-btn--anchor-4151b641:disabled:disabled{background-color:transparent;text-decoration:none;color:#87929d}.scc-c-btn-4151b641.scc-c-btn--primary-4151b641,.scc-c-btn-4151b641.scc-is-selected-4151b641{border-color:transparent;background-color:#1f73b7;color:#fff}.scc-c-btn-4151b641.scc-c-btn--danger-4151b641.scc-c-btn--primary-4151b641,.scc-c-btn-4151b641.scc-c-btn--danger-4151b641.scc-is-selected-4151b641{background-color:#cc3340}.scc-c-btn--icon-4151b641{padding:0;width:40px;min-width:0;height:40px}.scc-c-btn--icon-4151b641.scc-c-btn--sm-4151b641{width:32px;height:32px}.scc-c-btn--icon-4151b641.scc-c-btn--lg-4151b641{width:48px;height:48px}.scc-c-btn__icon-4151b641{-webkit-transition:-webkit-transform .25s ease-in-out;transition:-webkit-transform .25s ease-in-out;transition:transform .25s ease-in-out;transition:transform .25s ease-in-out,-webkit-transform .25s ease-in-out;margin-top:-2px;width:18px;height:18px;vertical-align:middle}.scc-c-btn--sm-4151b641 .scc-c-btn__icon-4151b641{width:14px;height:14px}.scc-c-btn--lg-4151b641 .scc-c-btn__icon-4151b641{width:24px;height:24px}.scc-c-btn__icon-4151b641.scc-is-rotated-4151b641{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.scc-is-rtl-4151b641 .scc-c-btn__icon-4151b641.scc-is-rotated-4151b641{-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}.scc-c-btn--muted-4151b641{border-color:#87929d;background-color:transparent;color:#87929d}.scc-c-btn-4151b641.scc-c-btn--muted-4151b641.scc-is-focused-4151b641{outline:0;-webkit-box-shadow:none;box-shadow:none;background-color:rgba(135,146,157,.15);color:#2f3941}.scc-c-btn-4151b641.scc-c-btn--muted-4151b641.scc-is-active-4151b641.scc-is-active-4151b641,.scc-c-btn-4151b641.scc-c-btn--muted-4151b641.scc-is-hovered-4151b641.scc-is-hovered-4151b641,.scc-c-btn-4151b641.scc-c-btn--muted-4151b641:active:active,.scc-c-btn-4151b641.scc-c-btn--muted-4151b641:hover:hover{border-color:#87929d;background-color:transparent;color:#2f3941}.scc-c-btn-4151b641.scc-c-btn--muted-4151b641.scc-is-disabled-4151b641.scc-is-disabled-4151b641,.scc-c-btn-4151b641.scc-c-btn--muted-4151b641:disabled:disabled{border-color:transparent;background-color:#e9ebed;color:#c2c8cc}.scc-c-btn--muted-4151b641.scc-c-btn--basic-4151b641{border:none}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"c-btn":"scc-c-btn-4151b641","c-btn--pill":"scc-c-btn--pill-4151b641","c-btn--sm":"scc-c-btn--sm-4151b641","c-btn--lg":"scc-c-btn--lg-4151b641","c-btn--full":"scc-c-btn--full-4151b641","c-btn--danger":"scc-c-btn--danger-4151b641","c-btn--basic":"scc-c-btn--basic-4151b641","l-btn-group":"scc-l-btn-group-4151b641","is-active":"scc-is-active-4151b641","is-hovered":"scc-is-hovered-4151b641","is-focused":"scc-is-focused-4151b641","is-disabled":"scc-is-disabled-4151b641","c-btn--primary":"scc-c-btn--primary-4151b641","is-selected":"scc-is-selected-4151b641","is-rtl":"scc-is-rtl-4151b641","c-btn__icon":"scc-c-btn__icon-4151b641","c-btn--anchor":"scc-c-btn--anchor-4151b641","c-btn--icon":"scc-c-btn--icon-4151b641","is-rotated":"scc-is-rotated-4151b641","c-btn--muted":"scc-c-btn--muted-4151b641"}


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _PanelConfig = __webpack_require__(604);

var _PanelConfig2 = _interopRequireDefault(_PanelConfig);

var _Label = __webpack_require__(605);

var _Label2 = _interopRequireDefault(_Label);

var _Panel = __webpack_require__(607);

var _Panel2 = _interopRequireDefault(_Panel);

var _ReactSingleSelectionModel = __webpack_require__(107);

var _ReactSingleSelectionModel2 = _interopRequireDefault(_ReactSingleSelectionModel);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _styles = __webpack_require__(197);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tabs = function (_ThemedComponent) {
  (0, _inherits3.default)(Tabs, _ThemedComponent);

  function Tabs(props, context) {
    (0, _classCallCheck3.default)(this, Tabs);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Tabs",
      styles: _styles2.default
    }));

    _this.onSelectionChanged = function () {
      var labels = _this.selectionModel.items;
      _this.setState({ labels: labels });
    };

    _this.updatePanel = function (_ref) {
      var children = _ref.children,
          active = _ref.active;

      var panelConfigs = [];

      _react.Children.forEach(children, function (child) {
        if (child && child.type === _PanelConfig2.default) {
          panelConfigs.push(child.props);
        }
      });

      var activePanelConfig = panelConfigs.find(function (_ref2) {
        var id = _ref2.id;
        return active === id;
      }) || panelConfigs[0];

      var activePanelContent = activePanelConfig.children;

      var panel = _react2.default.createElement(
        _Panel2.default,
        { id: activePanelConfig.id },
        typeof activePanelContent === "function" ? activePanelContent(activePanelConfig.id) : activePanelContent
      );

      _this.setState({ panel: panel });
    };

    _this.componentWillReceiveProps = function (nextProps) {
      _this.selectionModel.rtl = nextProps.dir === "rtl";
      _this.selectionModel.vertical = nextProps.vertical;
      _this.setSelectableItems(nextProps);
      _this.updatePanel(nextProps);
    };

    _this.selectionModel = new _ReactSingleSelectionModel2.default({
      rtl: props.dir === "rtl",
      vertical: props.vertical
    });
    _this.selectionModel.onSelectionChanged = _this.onSelectionChanged;
    _this.selectionModel.onValueChosen = props.onChange;
    _this.keyboard = true;
    _this.state = {};
    return _this;
  }

  Tabs.prototype.setSelectableItems = function setSelectableItems(_ref3) {
    var children = _ref3.children,
        dir = _ref3.dir,
        active = _ref3.active,
        vertical = _ref3.vertical;

    var labels = [];

    _react.Children.forEach(children, function (child) {
      if (child && child.type === _PanelConfig2.default) {
        var _child$props = child.props,
            disabled = _child$props.disabled,
            id = _child$props.id,
            label = _child$props.label,
            title = _child$props.title,
            tooltipPositioning = _child$props.tooltipPositioning,
            testId = _child$props.testId;

        labels.push(_react2.default.createElement(
          _Label2.default,
          {
            active: id === active,
            disabled: disabled,
            id: id,
            key: id,
            title: title,
            tooltipPositioning: tooltipPositioning,
            value: id,
            testId: testId
          },
          label
        ));
      } else {
        labels.push(child);
      }
    });

    this.selectionModel.items = labels;
    this.setState({ labels: this.selectionModel.items });
  };

  Tabs.prototype.componentWillMount = function componentWillMount() {
    this.setSelectableItems(this.props);
    this.updatePanel(this.props);
  };

  Tabs.prototype.render = function render() {
    var _classNames,
        _this2 = this;

    var _props = this.props,
        dir = _props.dir,
        tabIndex = _props.tabIndex,
        testId = _props.testId,
        vertical = _props.vertical,
        className = _props.className;
    var _state = this.state,
        labels = _state.labels,
        panel = _state.panel;
    var theme = this.theme;


    var props = {};
    if (testId) {
      props["data-test-id"] = testId;
    }

    if (dir === "rtl") {
      props.dir = dir;
    }

    return _react2.default.createElement(
      "nav",
      (0, _extends3.default)({
        className: (0, _classnames2.default)(theme.tabs, (_classNames = {}, _classNames[theme.vertical] = vertical, _classNames[theme.rtl] = dir === "rtl", _classNames), className)
      }, props),
      _react2.default.createElement(
        "ul",
        {
          className: theme.list,
          onFocus: function onFocus() {
            if (!_this2.selectionModel.hasSelection() && _this2.keyboard) {
              _this2.selectionModel.reactivate();
            }
            _this2.keyboard = true;
          },
          onMouseDown: function onMouseDown() {
            _this2.keyboard = false;
            setTimeout(function () {
              _this2.keyboard = true;
            }, 0);
          },
          onBlur: this.selectionModel.clear,
          onKeyDown: this.selectionModel.handleKeyDown,
          role: "tablist",
          tabIndex: tabIndex
        },
        labels
      ),
      panel
    );
  };

  return Tabs;
}(_ThemedComponent3.default);

Tabs.Panel = _PanelConfig2.default;
Tabs.propTypes = {
  active: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  onChange: _propTypes2.default.func,
  vertical: _propTypes2.default.bool.isRequired,
  tabIndex: _propTypes2.default.number,
  testId: _propTypes2.default.string
};
Tabs.defaultProps = {
  dir: "ltr",
  tabIndex: 0,
  vertical: false
};
exports.default = Tabs;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PanelConfig = function (_Component) {
  (0, _inherits3.default)(PanelConfig, _Component);

  function PanelConfig() {
    (0, _classCallCheck3.default)(this, PanelConfig);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  PanelConfig.prototype.render = function render() {
    return null;
  };

  return PanelConfig;
}(_react.Component);

PanelConfig.propTypes = {
  /* eslint-disable react/no-unused-prop-types */
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  disabled: _propTypes2.default.bool,
  id: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.node.isRequired,
  title: _propTypes2.default.string,
  /** <a href="#view">See View</a> */
  tooltipPositioning: function tooltipPositioning() {}
};
exports.default = PanelConfig;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Selectable = __webpack_require__(51);

var _Selectable2 = _interopRequireDefault(_Selectable);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _styles = __webpack_require__(197);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function (_ThemedComponent) {
  (0, _inherits3.default)(Label, _ThemedComponent);

  function Label(props, context) {
    (0, _classCallCheck3.default)(this, Label);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Tabs",
      styles: _styles2.default
    }));
  }

  Label.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        active = _props.active,
        children = _props.children,
        disabled = _props.disabled,
        onClick = _props.onClick,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        selected = _props.selected,
        selectedByMouse = _props.selectedByMouse,
        title = _props.title,
        testId = _props.testId,
        tooltipPositioning = _props.tooltipPositioning;
    var theme = this.theme;


    return _react2.default.createElement(
      "li",
      {
        "aria-activedescendant": selected,
        "aria-disabled": disabled,
        "aria-selected": active,
        className: (0, _classnames2.default)(theme.label, (_classNames = {}, _classNames[theme.disabled] = disabled, _classNames[theme.selected] = active, _classNames[theme.focused] = !selectedByMouse && selected, _classNames)),
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        role: "tab"
      },
      _react2.default.createElement(
        _View2.default,
        {
          title: title,
          tooltipPositioning: tooltipPositioning,
          testId: testId
        },
        children
      )
    );
  };

  return Label;
}(_ThemedComponent3.default);

Label.propTypes = {
  active: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  selected: _propTypes2.default.bool,
  selectedByMouse: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  testId: _propTypes2.default.string,
  /** <a href="#view">See View</a> */
  tooltipPositioning: function tooltipPositioning() {}
};
exports.default = (0, _Selectable2.default)(Label, {
  selectEvent: "onClick"
});

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: "/*!\n * Copyright Zendesk, Inc.\n *\n * Use of this source code is governed under the Apache License, Version 2.0\n * found at http://www.apache.org/licenses/LICENSE-2.0.\n */.scc-c-tab-3b6f1d0a{display:block;overflow:hidden}.scc-c-tab-3b6f1d0a.scc-is-rtl-3b6f1d0a{direction:rtl}.scc-c-tab__list-3b6f1d0a{display:block;margin-top:0;margin-bottom:20px;border-bottom:1px solid #d8dcde;padding:0;line-height:20px;white-space:nowrap;color:#68737d;font-size:14px}.scc-c-tab__list__item-3b6f1d0a{display:inline-block;position:relative;-webkit-transition:color .25s ease-in-out;transition:color .25s ease-in-out;border-width:3px;border-bottom-style:solid;border-bottom-color:transparent;cursor:pointer;overflow:hidden;vertical-align:top;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-align:center;text-overflow:ellipsis}.scc-c-tab__list__item-3b6f1d0a,.scc-c-tab__list__item-3b6f1d0a a{padding:10px 28px 6px;text-decoration:none;color:inherit}.scc-c-tab__list__item-3b6f1d0a a{display:block;margin:-10px -28px -6px}.scc-c-tab__panel-3b6f1d0a{display:block}.scc-c-tab--block-3b6f1d0a{display:table}.scc-c-tab--block-3b6f1d0a .scc-c-tab__list-3b6f1d0a{display:table-cell;margin-bottom:0;border-bottom:none;vertical-align:top}.scc-c-tab--block-3b6f1d0a .scc-c-tab__list__item-3b6f1d0a{display:block;margin-bottom:20px;border-bottom-style:none;border-left-style:solid;border-left-color:transparent;padding:4px 8px;text-align:left}.scc-c-tab--block-3b6f1d0a .scc-c-tab__list__item-3b6f1d0a a{margin:-4px -8px;padding:4px 8px}.scc-c-tab--block-3b6f1d0a .scc-c-tab__list__item-3b6f1d0a.scc-is-last-3b6f1d0a,.scc-c-tab--block-3b6f1d0a .scc-c-tab__list__item-3b6f1d0a:last-of-type{margin-bottom:0}.scc-c-tab--block-3b6f1d0a .scc-c-tab__list__item-3b6f1d0a.scc-is-focused-3b6f1d0a:before,.scc-c-tab--block-3b6f1d0a .scc-c-tab__list__item-3b6f1d0a:focus:before{top:4px;right:4px;left:4px}.scc-c-tab--block-3b6f1d0a.scc-is-rtl-3b6f1d0a .scc-c-tab__list__item-3b6f1d0a{margin-left:0;border-left:0;border-right-style:solid;border-right-color:transparent;text-align:right}.scc-c-tab--block-3b6f1d0a .scc-c-tab__panel-3b6f1d0a{margin-left:32px;vertical-align:top}.scc-c-tab--block-3b6f1d0a.scc-is-rtl-3b6f1d0a .scc-c-tab__panel-3b6f1d0a{margin-right:32px}.scc-c-tab__list__item-3b6f1d0a.scc-is-hovered-3b6f1d0a,.scc-c-tab__list__item-3b6f1d0a:hover{color:#1f73b7}.scc-c-tab__list__item-3b6f1d0a a:hover{text-decoration:none}.scc-c-tab__list__item-3b6f1d0a a:focus,.scc-c-tab__list__item-3b6f1d0a:focus{outline:0;text-decoration:none}.scc-c-tab__list__item-3b6f1d0a.scc-is-focused-3b6f1d0a,.scc-c-tab__list__item-3b6f1d0a:focus{color:#1f73b7}.scc-c-tab__list__item-3b6f1d0a:before{-webkit-transition:-webkit-box-shadow .1s ease-in-out;transition:-webkit-box-shadow .1s ease-in-out;transition:box-shadow .1s ease-in-out;transition:box-shadow .1s ease-in-out,-webkit-box-shadow .1s ease-in-out;content:\"\"}.scc-c-tab__list__item-3b6f1d0a.scc-is-focused-3b6f1d0a:before,.scc-c-tab__list__item-3b6f1d0a:focus:before{position:absolute;top:10px;right:24px;left:24px;border-radius:4px;-webkit-box-shadow:inset 0 0 0 2px rgba(31,115,183,.35);box-shadow:inset 0 0 0 2px rgba(31,115,183,.35);height:20px;pointer-events:none}.scc-c-tab__list__item-3b6f1d0a.scc-c-tab__list__item-3b6f1d0a.scc-is-active-3b6f1d0a,.scc-c-tab__list__item-3b6f1d0a.scc-c-tab__list__item-3b6f1d0a:active{border-color:currentColor;color:#1f73b7}.scc-c-tab__list__item-3b6f1d0a.scc-c-tab__list__item-3b6f1d0a.scc-is-active-3b6f1d0a:before,.scc-c-tab__list__item-3b6f1d0a.scc-c-tab__list__item-3b6f1d0a:active:before{-webkit-box-shadow:none;box-shadow:none}.scc-c-tab__list__item-3b6f1d0a.scc-c-tab__list__item-3b6f1d0a.scc-is-selected-3b6f1d0a{border-color:currentColor;color:#1f73b7}.scc-c-tab__list__item-3b6f1d0a.scc-c-tab__list__item-3b6f1d0a.scc-is-disabled-3b6f1d0a,.scc-c-tab__list__item-3b6f1d0a.scc-c-tab__list__item-3b6f1d0a[aria-disabled=true],.scc-c-tab__list__item-3b6f1d0a.scc-c-tab__list__item-3b6f1d0a[disabled]{border-color:transparent;cursor:default;color:#c2c8cc}.scc-c-tab__list__item-3b6f1d0a.scc-c-tab__list__item-3b6f1d0a.scc-is-disabled-3b6f1d0a a,.scc-c-tab__list__item-3b6f1d0a.scc-c-tab__list__item-3b6f1d0a[aria-disabled=true] a,.scc-c-tab__list__item-3b6f1d0a.scc-c-tab__list__item-3b6f1d0a[disabled] a{cursor:inherit}.scc-c-tab__panel-3b6f1d0a.scc-is-hidden-3b6f1d0a,.scc-c-tab__panel-3b6f1d0a[aria-hidden=true]{display:none}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"c-tab":"scc-c-tab-3b6f1d0a","is-rtl":"scc-is-rtl-3b6f1d0a","c-tab__list":"scc-c-tab__list-3b6f1d0a","c-tab__list__item":"scc-c-tab__list__item-3b6f1d0a","c-tab__panel":"scc-c-tab__panel-3b6f1d0a","c-tab--block":"scc-c-tab--block-3b6f1d0a","is-last":"scc-is-last-3b6f1d0a","is-focused":"scc-is-focused-3b6f1d0a","is-hovered":"scc-is-hovered-3b6f1d0a","is-active":"scc-is-active-3b6f1d0a","is-selected":"scc-is-selected-3b6f1d0a","is-disabled":"scc-is-disabled-3b6f1d0a","is-hidden":"scc-is-hidden-3b6f1d0a"}


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _styles = __webpack_require__(197);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Panel = function (_ThemedComponent) {
  (0, _inherits3.default)(Panel, _ThemedComponent);

  function Panel(props, context) {
    (0, _classCallCheck3.default)(this, Panel);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Tabs",
      styles: _styles2.default
    }));
  }

  Panel.prototype.render = function render() {
    var children = this.props.children;
    var theme = this.theme;


    return _react2.default.createElement(
      _View2.default,
      { className: theme.panel, role: "tabpanel" },
      children
    );
  };

  return Panel;
}(_ThemedComponent3.default);

Panel.propTypes = {
  children: _propTypes2.default.node,
  id: _propTypes2.default.string.isRequired
};
exports.default = Panel;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(609), __esModule: true };

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(610);
var $Object = __webpack_require__(42).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(62);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(78), 'Object', {defineProperty: __webpack_require__(69).f});

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(266);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleSelectionModel = function () {
  function SingleSelectionModel() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$wrapping = _ref.wrapping,
        wrapping = _ref$wrapping === undefined ? "items" : _ref$wrapping;

    (0, _classCallCheck3.default)(this, SingleSelectionModel);

    this.selection = null;
    this.items = [];
    this.wrapping = wrapping;
  }

  SingleSelectionModel.prototype.fireSelectionChanged = function fireSelectionChanged(newSelection, previousSelection) {
    if (this.onSelectionChanged) {
      if (typeof newSelection === "undefined") {
        newSelection = null;
      }

      if (typeof previousSelection === "undefined") {
        previousSelection = null;
      }

      this.onSelectionChanged(newSelection, previousSelection);
    }
  };

  SingleSelectionModel.prototype.select = function select(item) {
    var selection = this.selection;
    this.selection = item;
    if (this.selectedIndex === -1) {
      this.selection = null;
    }

    this.fireSelectionChanged(this.selection, selection);
  };

  SingleSelectionModel.prototype.selectNext = function selectNext() {
    if (this.items.length > 0) {
      var newIndex = this.selectedIndex + 1;
      if (this.items.length <= newIndex) {
        switch (this.wrapping) {
          case "clear":
            newIndex = -1;
            break;
          case "items":
            newIndex = newIndex % this.items.length;
            break;
          case "off":
            newIndex = this.items.length - 1;
            break;
        }
      }

      this.select(this.items[newIndex] || null);
      return true;
    } else {
      return false;
    }
  };

  SingleSelectionModel.prototype.selectPrevious = function selectPrevious() {
    if (this.items.length > 0) {
      var newIndex = void 0;
      if (this.selectedIndex === -1) {
        newIndex = this.items.length - 1;
      } else {
        newIndex = this.selectedIndex - 1;
        if (newIndex < 0) {
          switch (this.wrapping) {
            case "clear":
              newIndex = -1;
              break;
            case "items":
              newIndex = this.items.length - 1;
              break;
            case "off":
              newIndex = 0;
              break;
          }
        }
      }

      this.select(this.items[newIndex] || null);
      return true;
    } else {
      return false;
    }
  };

  SingleSelectionModel.prototype.selectFirst = function selectFirst() {
    if (this.items.length > 0) {
      this.select(this.items[0] || null);
      return true;
    } else {
      return false;
    }
  };

  SingleSelectionModel.prototype.selectLast = function selectLast() {
    if (this.items.length > 0) {
      this.select(this.items[this.items.length - 1] || null);
      return true;
    } else {
      return false;
    }
  };

  SingleSelectionModel.prototype.clear = function clear() {
    this.clearedSelection = this.selection;
    this.select(null);
  };

  SingleSelectionModel.prototype.reactivate = function reactivate(defaultSelection) {
    if (typeof defaultSelection !== "undefined") {
      this.select(defaultSelection);
      this.clearedSelection = null;
      return true;
    }

    if (this.items.indexOf(this.clearedSelection) === -1) {
      return this.selectFirst();
    }

    this.select(this.clearedSelection);
    this.clearedSelection = null;
    return true;
  };

  SingleSelectionModel.prototype.hasSelection = function hasSelection() {
    return this.selection !== null;
  };

  (0, _createClass3.default)(SingleSelectionModel, [{
    key: "selectedIndex",
    get: function get() {
      return this.items.indexOf(this.selection);
    }
  }]);
  return SingleSelectionModel;
}();

exports.default = SingleSelectionModel;

/***/ }),
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_resilient__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_resilient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_resilient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ErrorScreen__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_notifyError__ = __webpack_require__(250);







var reportError = function reportError(error) {
  return Object(__WEBPACK_IMPORTED_MODULE_5__utils_notifyError__["a" /* default */])("ErrorBoundary", error);
};

var ErrorBoundary = function ErrorBoundary(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_3_react_resilient___default.a, {
    FallbackComponent: __WEBPACK_IMPORTED_MODULE_4__ErrorScreen__["a" /* default */],
    onError: reportError
  }, void 0, children);
};

ErrorBoundary.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ }),
/* 624 */,
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_self_service_components_lib_View__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_self_service_components_lib_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__zendesk_self_service_components_lib_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_css__);











var ErrorScreen =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ErrorScreen, _PureComponent);

  function ErrorScreen() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ErrorScreen);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ErrorScreen).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ErrorScreen, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__zendesk_self_service_components_lib_View___default.a, {
        className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.container
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__zendesk_self_service_components_lib_View___default.a, {
        className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.title
      }, void 0, __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools___default()("knowledge-user-segments.fatalApplicationLoadErrorTitle")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__zendesk_self_service_components_lib_View___default.a, {
        className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.body
      }, void 0, __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools___default()("knowledge-user-segments.fatalApplicationLoadErrorBody")));
    }
  }]);

  return ErrorScreen;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);



/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_-src-components-ErrorScreen-index---container---GxfwM","title":"_-src-components-ErrorScreen-index---title---1FwCw"};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(628);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Callouts = function (_Component) {
  (0, _inherits3.default)(Callouts, _Component);

  function Callouts(props, context) {
    (0, _classCallCheck3.default)(this, Callouts);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context, {
      namespace: "Callout"
    }));

    _this.state = {};
    return _this;
  }

  Callouts.prototype.getChildContext = function getChildContext() {
    return { floating: this.props.floating };
  };

  Callouts.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        testId = _props.testId,
        floating = _props.floating,
        dir = _props.dir,
        children = _props.children,
        className = _props.className,
        zIndex = _props.zIndex;


    var props = {};
    if (testId) {
      props["data-test-id"] = testId;
    }

    return _react2.default.createElement(
      "div",
      (0, _extends3.default)({
        className: (0, _classnames2.default)(_styles2.default.callouts, (_classNames = {}, _classNames[_styles2.default.floating] = floating, _classNames[_styles2.default.rtl] = dir === "rtl", _classNames), className),
        style: { zIndex: zIndex }
      }, props),
      children
    );
  };

  return Callouts;
}(_react.Component);

Callouts.propTypes = {
  children: _propTypes2.default.node.isRequired,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  testId: _propTypes2.default.string,
  floating: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  zIndex: _propTypes2.default.number
};
Callouts.defaultProps = {
  dir: "ltr",
  floating: false,
  zIndex: 700
};
Callouts.childContextTypes = {
  floating: _propTypes2.default.bool
};
exports.default = Callouts;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: ".ssc-floating-fbdc32b0{position:fixed;top:16px;right:16px;width:360px}.ssc-rtl-fbdc32b0.ssc-callouts-fbdc32b0{right:0;left:16px}.ssc-callouts-fbdc32b0>*{margin-bottom:10px}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"floating":"ssc-floating-fbdc32b0","rtl":"ssc-rtl-fbdc32b0","callouts":"ssc-callouts-fbdc32b0"}


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _P = __webpack_require__(630);

var _P2 = _interopRequireDefault(_P);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _styles = __webpack_require__(270);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Callout = function (_ThemedComponent) {
  (0, _inherits3.default)(Callout, _ThemedComponent);

  function Callout(props, context) {
    (0, _classCallCheck3.default)(this, Callout);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Callout",
      styles: _styles2.default
    }));

    _this.renderClose = function (onClose) {
      var theme = _this.theme;
      var tabIndex = _this.props.tabIndex;


      return _react2.default.createElement("button", {
        tabIndex: tabIndex,
        className: theme.remove,
        onClick: onClose,
        "aria-label": "close"
      });
    };

    return _this;
  }

  Callout.prototype.render = function render() {
    var _classNames;

    var theme = this.theme;
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        dir = _props.dir,
        onClose = _props.onClose,
        testId = _props.testId,
        type = _props.type,
        title = _props.title,
        floating = _props.floating;


    return _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(theme[type], (_classNames = {}, _classNames[theme.rtl] = dir === "rtl", _classNames[theme.floating] = floating || this.context.floating, _classNames), className),
        testId: testId
      },
      title && _react2.default.createElement(
        "strong",
        { className: theme.title },
        title
      ),
      children,
      onClose && this.renderClose(onClose)
    );
  };

  return Callout;
}(_ThemedComponent3.default);

Callout.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  onClose: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number,
  testId: _propTypes2.default.string,
  title: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(["default", "success", "warning", "error"]),
  floating: _propTypes2.default.bool
};
Callout.defaultProps = {
  dir: "ltr",
  type: "default",
  tabIndex: 0
};
Callout.contextTypes = (0, _extends3.default)({}, _ThemedComponent3.default.contextTypes, {
  floating: _propTypes2.default.bool
});
Callout.P = _P2.default;
exports.default = Callout;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _styles = __webpack_require__(270);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var P = function (_ThemedComponent) {
  (0, _inherits3.default)(P, _ThemedComponent);

  function P(props, context) {
    (0, _classCallCheck3.default)(this, P);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Callout",
      styles: _styles2.default
    }));
  }

  P.prototype.render = function render() {
    var theme = this.theme;
    var children = this.props.children;


    return _react2.default.createElement(
      "p",
      { className: theme.paragraph },
      children
    );
  };

  return P;
}(_ThemedComponent3.default);

P.propTypes = {
  children: _propTypes2.default.node.isRequired
};
exports.default = P;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: "/*!\n * Copyright Zendesk, Inc.\n *\n * Use of this source code is governed under the Apache License, Version 2.0\n * found at http://www.apache.org/licenses/LICENSE-2.0.\n */.scc-c-callout-57e1d465{position:relative;border:1px solid #d8dcde;border-radius:4px;background-color:#fff;padding:20px 40px;line-height:1.42857;color:#68737d;font-size:14px}.scc-c-callout__title-57e1d465{display:block;margin:0;color:#2f3941;font-weight:600}.scc-c-callout__paragraph-57e1d465{margin:10px 0 0}.scc-c-callout-57e1d465.scc-is-rtl-57e1d465{direction:rtl}.scc-c-callout__close-57e1d465{display:block;position:absolute;top:4px;right:4px;-webkit-transition:background-color .1s ease-in-out;transition:background-color .1s ease-in-out;border:none;border-radius:50%;background-color:transparent;cursor:pointer;width:28px;height:28px;overflow:hidden;text-decoration:none;font-size:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.scc-c-callout__close-57e1d465:after,.scc-c-callout__close-57e1d465:before{display:block;position:absolute;top:0;right:0;bottom:0;left:0;-webkit-transition:opacity .25s ease-in-out;transition:opacity .25s ease-in-out;background-repeat:no-repeat;background-position:50%;background-size:18px;content:\"\"}.scc-c-callout__close-57e1d465:before{opacity:1;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%2387929D'%3E%3Cpath stroke='currentColor' stroke-linecap='round' d='M4 10l6-6M4 4l6 6'/%3E%3C/svg%3E\")}.scc-c-callout__close-57e1d465:after{opacity:0;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%232F3941'%3E%3Cpath stroke='currentColor' stroke-linecap='round' d='M4 10l6-6M4 4l6 6'/%3E%3C/svg%3E\")}.scc-c-callout__close-57e1d465.scc-is-focused-57e1d465:before,.scc-c-callout__close-57e1d465.scc-is-hovered-57e1d465:before,.scc-c-callout__close-57e1d465:focus:before,.scc-c-callout__close-57e1d465:hover:before{opacity:0}.scc-c-callout__close-57e1d465.scc-is-focused-57e1d465:after,.scc-c-callout__close-57e1d465.scc-is-hovered-57e1d465:after,.scc-c-callout__close-57e1d465:focus:after,.scc-c-callout__close-57e1d465:hover:after{opacity:1}.scc-c-callout__close-57e1d465.scc-is-focused-57e1d465,.scc-c-callout__close-57e1d465:focus{outline:0;background-color:hsla(209,9%,45%,.15)}.scc-c-callout-57e1d465.scc-is-rtl-57e1d465 .scc-c-callout__close-57e1d465{right:auto;left:4px}.scc-c-callout--error-57e1d465:not(.scc-c-callout--dialog-57e1d465) .scc-c-callout__close-57e1d465:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23D93F4C'%3E%3Cpath stroke='currentColor' stroke-linecap='round' d='M4 10l6-6M4 4l6 6'/%3E%3C/svg%3E\")}.scc-c-callout--error-57e1d465:not(.scc-c-callout--dialog-57e1d465) .scc-c-callout__close-57e1d465:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23681219'%3E%3Cpath stroke='currentColor' stroke-linecap='round' d='M4 10l6-6M4 4l6 6'/%3E%3C/svg%3E\")}.scc-c-callout--success-57e1d465:not(.scc-c-callout--dialog-57e1d465) .scc-c-callout__close-57e1d465:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23228F67'%3E%3Cpath stroke='currentColor' stroke-linecap='round' d='M4 10l6-6M4 4l6 6'/%3E%3C/svg%3E\")}.scc-c-callout--success-57e1d465:not(.scc-c-callout--dialog-57e1d465) .scc-c-callout__close-57e1d465:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%230B3B29'%3E%3Cpath stroke='currentColor' stroke-linecap='round' d='M4 10l6-6M4 4l6 6'/%3E%3C/svg%3E\")}.scc-c-callout--warning-57e1d465:not(.scc-c-callout--dialog-57e1d465) .scc-c-callout__close-57e1d465:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23ED961C'%3E%3Cpath stroke='currentColor' stroke-linecap='round' d='M4 10l6-6M4 4l6 6'/%3E%3C/svg%3E\")}.scc-c-callout--warning-57e1d465:not(.scc-c-callout--dialog-57e1d465) .scc-c-callout__close-57e1d465:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23703B15'%3E%3Cpath stroke='currentColor' stroke-linecap='round' d='M4 10l6-6M4 4l6 6'/%3E%3C/svg%3E\")}.scc-c-callout--error-57e1d465:not(.scc-c-callout--dialog-57e1d465) .scc-c-callout__close-57e1d465.scc-is-focused-57e1d465,.scc-c-callout--error-57e1d465:not(.scc-c-callout--dialog-57e1d465) .scc-c-callout__close-57e1d465:focus{background-color:rgba(204,51,64,.15)}.scc-c-callout--success-57e1d465:not(.scc-c-callout--dialog-57e1d465) .scc-c-callout__close-57e1d465.scc-is-focused-57e1d465,.scc-c-callout--success-57e1d465:not(.scc-c-callout--dialog-57e1d465) .scc-c-callout__close-57e1d465:focus{background-color:rgba(3,129,83,.15)}.scc-c-callout--warning-57e1d465:not(.scc-c-callout--dialog-57e1d465) .scc-c-callout__close-57e1d465.scc-is-focused-57e1d465,.scc-c-callout--warning-57e1d465:not(.scc-c-callout--dialog-57e1d465) .scc-c-callout__close-57e1d465:focus{background-color:rgba(237,150,28,.15)}.scc-c-callout-57e1d465 .scc-c-callout__close-57e1d465.scc-is-focused-57e1d465:active,.scc-c-callout-57e1d465 .scc-c-callout__close-57e1d465:focus:active{background-color:transparent}.scc-c-callout--recessed-57e1d465{background-color:#f8f9f9}.scc-c-callout--error-57e1d465{border-color:#f5b5ba;background-color:#fff0f1;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23CC3340'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm-.75 3.75c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.5zM7 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'/%3E%3C/svg%3E\");color:#8c232c}.scc-c-callout--success-57e1d465{border-color:#aecfc2;background-color:#edf8f4;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23038153'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm3.09 5.363l-3.3 4.2a.75.75 0 0 1-.545.286H6.2a.748.748 0 0 1-.53-.22L3.97 7.93a.75.75 0 1 1 1.06-1.06l1.103 1.102L8.91 4.437a.75.75 0 0 1 1.18.926z'/%3E%3C/svg%3E\");color:#186146}.scc-c-callout--warning-57e1d465{border-color:#fcdba9;background-color:#fff8ed;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23ED961C'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm-.75 3.75c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.5zM7 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'/%3E%3C/svg%3E\");color:#ad5e18}.scc-c-callout--error-57e1d465,.scc-c-callout--success-57e1d465,.scc-c-callout--warning-57e1d465{background-repeat:no-repeat;background-position:20px 23px;padding-left:50px}.scc-c-callout--dialog-57e1d465{-webkit-box-shadow:0 20px 28px 0 rgba(4,68,77,.15);box-shadow:0 20px 28px 0 rgba(4,68,77,.15)}.scc-c-callout--dialog-57e1d465.scc-c-callout--error-57e1d465,.scc-c-callout--dialog-57e1d465.scc-c-callout--success-57e1d465,.scc-c-callout--dialog-57e1d465.scc-c-callout--warning-57e1d465{border-color:#d8dcde;background-color:#fff;color:#49545c}.scc-c-callout--dialog-57e1d465.scc-c-callout--error-57e1d465{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23D93F4C'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm-.75 3.75c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.5zM7 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'/%3E%3C/svg%3E\")}.scc-c-callout--dialog-57e1d465.scc-c-callout--success-57e1d465{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23228F67'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm3.09 5.363l-3.3 4.2a.75.75 0 0 1-.545.286H6.2a.748.748 0 0 1-.53-.22L3.97 7.93a.75.75 0 1 1 1.06-1.06l1.103 1.102L8.91 4.437a.75.75 0 0 1 1.18.926z'/%3E%3C/svg%3E\")}.scc-c-callout--dialog-57e1d465.scc-c-callout--warning-57e1d465{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%23F5A133'%3E%3Cpath fill='currentColor' d='M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm-.75 3.75c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.5zM7 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'/%3E%3C/svg%3E\")}.scc-c-callout--error-57e1d465 .scc-c-callout__title-57e1d465{color:#681219}.scc-c-callout--success-57e1d465 .scc-c-callout__title-57e1d465{color:#0b3b29}.scc-c-callout--warning-57e1d465 .scc-c-callout__title-57e1d465{color:#703b15}.scc-c-callout--dialog-57e1d465.scc-c-callout--error-57e1d465 .scc-c-callout__title-57e1d465{color:#cc3340}.scc-c-callout--dialog-57e1d465.scc-c-callout--success-57e1d465 .scc-c-callout__title-57e1d465{color:#038153}.scc-c-callout--dialog-57e1d465.scc-c-callout--warning-57e1d465 .scc-c-callout__title-57e1d465{color:#ad5e18}.scc-c-callout--error-57e1d465.scc-is-rtl-57e1d465,.scc-c-callout--success-57e1d465.scc-is-rtl-57e1d465,.scc-c-callout--warning-57e1d465.scc-is-rtl-57e1d465{background-position:calc(100% - 20px) 23px;padding-right:50px;padding-left:40px}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"c-callout":"scc-c-callout-57e1d465","c-callout__title":"scc-c-callout__title-57e1d465","c-callout__paragraph":"scc-c-callout__paragraph-57e1d465","is-rtl":"scc-is-rtl-57e1d465","c-callout__close":"scc-c-callout__close-57e1d465","is-focused":"scc-is-focused-57e1d465","is-hovered":"scc-is-hovered-57e1d465","c-callout--error":"scc-c-callout--error-57e1d465","c-callout--dialog":"scc-c-callout--dialog-57e1d465","c-callout--success":"scc-c-callout--success-57e1d465","c-callout--warning":"scc-c-callout--warning-57e1d465","c-callout--recessed":"scc-c-callout--recessed-57e1d465"}


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export List */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_connected_react_router__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_Pagination__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_Pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_loaders__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_loaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_loaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_context__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_staffUserSegments__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_signedInUserSegments__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__UserSegment__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);





















var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_loaders__["Spinner"], {});

var List =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(List, _Component);

  function List(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, List);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(List).call(this, props));
    _this.onPageSelected = _this.onPageSelected.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(List, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          fetchUserSegments = _this$props.fetchUserSegments,
          page = _this$props.page;
      fetchUserSegments(page);
    }
  }, {
    key: "onPageSelected",
    value: function onPageSelected(page) {
      var _this$props2 = this.props,
          fetchUserSegments = _this$props2.fetchUserSegments,
          type = _this$props2.type,
          pushPage = _this$props2.pushPage;
      var compatiblePageNumber = page + 1;
      fetchUserSegments(compatiblePageNumber);
      pushPage({
        pathname: "/knowledge/user_segments/".concat(type, "/").concat(compatiblePageNumber),
        search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_context__["getCurrentBrandId"])())
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          isFetching = _this$props3.isFetching,
          userSegments = _this$props3.userSegments,
          pageCount = _this$props3.pageCount,
          page = _this$props3.page;

      var pagination = pageCount > 1 && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_Pagination___default.a, {
        total: pageCount,
        currentPage: page - 1,
        onPageSelected: this.onPageSelected
      });

      if (isFetching) {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_19__index_css___default.a.loader
        }, void 0, _ref), pagination);
      }

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, userSegments.map(function (us) {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18__UserSegment__["a" /* default */], {
          userSegment: us
        }, us.id);
      })), pagination);
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);
List.propTypes = {
  userSegments: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].shape({
    id: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string.isRequired,
    built_in: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool.isRequired
  })),
  type: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].oneOf(["staff", "signedIn"]).isRequired,
  isFetching: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool,
  pageCount: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number,
  page: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number,
  fetchUserSegments: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  pushPage: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func
};
List.defaultProps = {
  userSegments: [],
  isFetching: false,
  pageCount: 1,
  page: 1
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var type = _ref2.type,
      page = _ref2.page;
  var typeState = type === "staff" ? state.staffUserSegments : state.signedInUserSegments;
  return {
    type: type,
    userSegments: typeState.list,
    isFetching: typeState.isFetching,
    pageCount: typeState.pageCount,
    page: page
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref3) {
  var type = _ref3.type;
  var actions = type === "staff" ? __WEBPACK_IMPORTED_MODULE_16__actions_staffUserSegments__ : __WEBPACK_IMPORTED_MODULE_17__actions_signedInUserSegments__;
  return Object(__WEBPACK_IMPORTED_MODULE_11_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, actions, {
    pushPage: __WEBPACK_IMPORTED_MODULE_12_connected_react_router__["push"]
  }), dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(List));

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(634), __esModule: true };

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(635);
module.exports = __webpack_require__(42).Number.isInteger;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(62);

$export($export.S, 'Number', {isInteger: __webpack_require__(636)});

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(93)
  , floor    = Math.floor;
module.exports = function isInteger(it){
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Selectable = __webpack_require__(51);

var _Selectable2 = _interopRequireDefault(_Selectable);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _styles = __webpack_require__(137);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = function (_ThemedComponent) {
  (0, _inherits3.default)(Page, _ThemedComponent);

  function Page(props, context) {
    (0, _classCallCheck3.default)(this, Page);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Pagination",
      styles: _styles2.default
    }));
  }

  Page.prototype.render = function render() {
    var _classNames;

    var theme = this.theme;
    var _props = this.props,
        isCurrent = _props.isCurrent,
        isAnimated = _props.isAnimated,
        ariaLabel = _props.ariaLabel,
        onSelection = _props.onSelection,
        selectedByMouse = _props.selectedByMouse,
        selected = _props.selected;


    return _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(theme.page, (_classNames = {}, _classNames[theme.is_current] = isCurrent, _classNames[theme.is_focused] = !selectedByMouse && selected, _classNames[theme.no_animation] = !isAnimated, _classNames)),
        "aria-label": ariaLabel,
        "aria-current": isCurrent,
        onClick: onSelection
      },
      this.props.children
    );
  };

  return Page;
}(_ThemedComponent3.default);

Page.propTypes = {
  /**
   * If the page is currently selected.
   */
  isCurrent: _propTypes2.default.bool,
  /**
   * If the page allows animation.
   */
  isAnimated: _propTypes2.default.bool,
  /**
   * Callback when the page is selected.
   */
  onSelection: _propTypes2.default.func.isRequired,
  /**
   * The label to apply to the page element.
   */
  ariaLabel: _propTypes2.default.string.isRequired
};
Page.defaultProps = {
  isCurrent: false,
  isFocused: false,
  isAnimated: false,
  selected: false
};
exports.default = (0, _Selectable2.default)(Page, {
  selectEvent: "onClick"
});

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: "/*!\n * Copyright Zendesk, Inc.\n *\n * Use of this source code is governed under the Apache License, Version 2.0\n * found at http://www.apache.org/licenses/LICENSE-2.0.\n */.scc-c-pagination-dfde14de{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:0;padding:0;white-space:nowrap}.scc-c-pagination__page-dfde14de{display:inline-block;-webkit-transition:background .25s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;transition:background .25s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;transition:background .25s ease-in-out,box-shadow .1s ease-in-out,color .25s ease-in-out;transition:background .25s ease-in-out,box-shadow .1s ease-in-out,color .25s ease-in-out,-webkit-box-shadow .1s ease-in-out;margin-left:4px;border-radius:4px;cursor:pointer;padding:0 .35714em;min-width:32px;max-width:64px;height:32px;overflow:hidden;text-align:center;text-overflow:ellipsis;line-height:2.28571;color:#68737d;font-size:14px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.scc-c-pagination__page--gap-dfde14de,.scc-c-pagination__page--next-dfde14de,.scc-c-pagination__page--previous-dfde14de{width:32px;color:transparent}.scc-c-pagination__page--gap-dfde14de{position:relative;cursor:default}.scc-c-pagination__page--gap-dfde14de:before{position:absolute;left:0;margin-top:-2px;width:100%;color:#68737d;font-size:16px;content:\"\\2026\"}.scc-c-pagination__page--next-dfde14de,.scc-c-pagination__page--previous-dfde14de{border-radius:50%;background-repeat:no-repeat;background-position:50%}.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page--previous-dfde14de,.scc-c-pagination__page--next-dfde14de{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%2387929D'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 11l4-4-4-4'/%3E%3C/svg%3E\")}.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page--next-dfde14de,.scc-c-pagination__page--previous-dfde14de{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%2387929D'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9 11L5 7l4-4'/%3E%3C/svg%3E\")}.scc-c-pagination__page-dfde14de a{display:block;margin:0 -.35714em;padding:0 .35714em;max-width:64px;overflow:hidden;text-decoration:none;text-overflow:ellipsis;color:inherit}.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de{direction:rtl}.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page-dfde14de:last-of-type,.scc-c-pagination-dfde14de:not(.scc-is-rtl-dfde14de) .scc-c-pagination__page-dfde14de:first-of-type{margin-left:0}.scc-c-pagination__page-dfde14de.scc-is-hovered-dfde14de,.scc-c-pagination__page-dfde14de:hover{background-color:hsla(209,9%,45%,.15);color:#2f3941}.scc-c-pagination__page-dfde14de a:hover{text-decoration:none}.scc-c-pagination__page-dfde14de.scc-is-focused-dfde14de{outline:0;-webkit-box-shadow:inset 0 0 0 3px rgba(31,115,183,.35);box-shadow:inset 0 0 0 3px rgba(31,115,183,.35)}.scc-c-pagination__page-dfde14de a:focus,.scc-c-pagination__page-dfde14de:focus{outline:0;text-decoration:none}.scc-c-pagination__page-dfde14de.scc-is-active-dfde14de,.scc-c-pagination__page-dfde14de:active{-webkit-box-shadow:none;box-shadow:none;background-color:hsla(209,9%,45%,.25)}.scc-c-pagination__page-dfde14de.scc-is-current-dfde14de,.scc-c-pagination__page-dfde14de[aria-current=true]{background-color:hsla(209,9%,45%,.15);color:#2f3941;font-weight:600}.scc-c-pagination__page-dfde14de.scc-is-current-dfde14de,.scc-c-pagination__page-dfde14de.scc-is-current-dfde14de a,.scc-c-pagination__page-dfde14de[aria-current=true],.scc-c-pagination__page-dfde14de[aria-current=true] a{max-width:none}.scc-c-pagination__page-dfde14de.scc-is-hidden-dfde14de,.scc-c-pagination__page-dfde14de[aria-hidden=true]{visibility:hidden}.scc-c-pagination__page--next-dfde14de.scc-is-focused-dfde14de,.scc-c-pagination__page--previous-dfde14de.scc-is-focused-dfde14de{-webkit-box-shadow:none;box-shadow:none;background-color:hsla(209,9%,45%,.15)}.scc-c-pagination__page--gap-dfde14de.scc-is-active-dfde14de,.scc-c-pagination__page--gap-dfde14de.scc-is-hovered-dfde14de,.scc-c-pagination__page--gap-dfde14de:active,.scc-c-pagination__page--gap-dfde14de:hover,.scc-c-pagination__page--next-dfde14de.scc-is-active-dfde14de,.scc-c-pagination__page--next-dfde14de.scc-is-hovered-dfde14de,.scc-c-pagination__page--next-dfde14de:active,.scc-c-pagination__page--next-dfde14de:hover,.scc-c-pagination__page--previous-dfde14de.scc-is-active-dfde14de,.scc-c-pagination__page--previous-dfde14de.scc-is-hovered-dfde14de,.scc-c-pagination__page--previous-dfde14de:active,.scc-c-pagination__page--previous-dfde14de:hover{background-color:transparent;color:transparent}.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page--previous-dfde14de.scc-is-active-dfde14de,.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page--previous-dfde14de.scc-is-focused-dfde14de,.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page--previous-dfde14de.scc-is-hovered-dfde14de,.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page--previous-dfde14de:active,.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page--previous-dfde14de:hover,.scc-c-pagination__page--next-dfde14de.scc-is-active-dfde14de,.scc-c-pagination__page--next-dfde14de.scc-is-focused-dfde14de,.scc-c-pagination__page--next-dfde14de.scc-is-hovered-dfde14de,.scc-c-pagination__page--next-dfde14de:active,.scc-c-pagination__page--next-dfde14de:hover{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%232F3941'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 11l4-4-4-4'/%3E%3C/svg%3E\")}.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page--next-dfde14de.scc-is-active-dfde14de,.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page--next-dfde14de.scc-is-focused-dfde14de,.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page--next-dfde14de.scc-is-hovered-dfde14de,.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page--next-dfde14de:active,.scc-c-pagination-dfde14de.scc-is-rtl-dfde14de .scc-c-pagination__page--next-dfde14de:hover,.scc-c-pagination__page--previous-dfde14de.scc-is-active-dfde14de,.scc-c-pagination__page--previous-dfde14de.scc-is-focused-dfde14de,.scc-c-pagination__page--previous-dfde14de.scc-is-hovered-dfde14de,.scc-c-pagination__page--previous-dfde14de:active,.scc-c-pagination__page--previous-dfde14de:hover{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' color='%232F3941'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9 11L5 7l4-4'/%3E%3C/svg%3E\")}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"c-pagination":"scc-c-pagination-dfde14de","c-pagination__page":"scc-c-pagination__page-dfde14de","c-pagination__page--gap":"scc-c-pagination__page--gap-dfde14de","c-pagination__page--next":"scc-c-pagination__page--next-dfde14de","c-pagination__page--previous":"scc-c-pagination__page--previous-dfde14de","is-rtl":"scc-is-rtl-dfde14de","is-hovered":"scc-is-hovered-dfde14de","is-focused":"scc-is-focused-dfde14de","is-active":"scc-is-active-dfde14de","is-current":"scc-is-current-dfde14de","is-hidden":"scc-is-hidden-dfde14de"}


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _styles = __webpack_require__(137);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Gap = function (_ThemedComponent) {
  (0, _inherits3.default)(Gap, _ThemedComponent);

  function Gap(props, context) {
    (0, _classCallCheck3.default)(this, Gap);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Pagination",
      styles: _styles2.default
    }));
  }

  Gap.prototype.render = function render() {
    var theme = this.theme;

    return _react2.default.createElement(_View2.default, { className: (0, _classnames2.default)(theme.page, theme.page_gap) });
  };

  return Gap;
}(_ThemedComponent3.default);

exports.default = Gap;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Selectable = __webpack_require__(51);

var _Selectable2 = _interopRequireDefault(_Selectable);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _styles = __webpack_require__(137);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageIncrement = function (_ThemedComponent) {
  (0, _inherits3.default)(PageIncrement, _ThemedComponent);

  function PageIncrement(props, context) {
    (0, _classCallCheck3.default)(this, PageIncrement);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Pagination",
      styles: _styles2.default
    }));
  }

  PageIncrement.prototype.render = function render() {
    var _classNames;

    var theme = this.theme;
    var _props = this.props,
        selectedByMouse = _props.selectedByMouse,
        selected = _props.selected,
        disabled = _props.disabled,
        value = _props.value,
        description = _props.description,
        onSelection = _props.onSelection;


    return _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(theme.page, (_classNames = {}, _classNames[theme.page_previous] = value === "previous", _classNames[theme.page_next] = value === "next", _classNames[theme.is_hidden] = disabled, _classNames[theme.is_focused] = !selectedByMouse && selected, _classNames)),
        "aria-hidden": disabled,
        "aria-disabled": disabled,
        "aria-label": description,
        onClick: onSelection
      },
      description
    );
  };

  return PageIncrement;
}(_ThemedComponent3.default);

PageIncrement.propTypes = {
  value: _propTypes2.default.oneOf(["previous", "next"]).isRequired,
  description: _propTypes2.default.string.isRequired,
  onSelection: _propTypes2.default.func.isRequired
};
exports.default = (0, _Selectable2.default)(PageIncrement, {
  selectEvent: "onClick"
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchUserSegments"] = fetchUserSegments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(52);



var USER_SEGMENTS_URL = "/hc/api/v2/user_segments?multibrand=true&user_type=".concat(__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* STAFF */]);

function fetchUserSegmentsRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["b" /* FETCH_STAFF_USER_SEGMENTS_REQUEST */]
  };
}

function fetchUserSegmentsSuccess(userSegments, page, pageCount) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* FETCH_STAFF_USER_SEGMENTS_SUCCESS */],
    userSegments: userSegments,
    page: page,
    pageCount: pageCount
  };
}

function fetchUserSegmentsFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["a" /* FETCH_STAFF_USER_SEGMENTS_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchUserSegments(page) {
  return function (dispatch, getState) {
    dispatch(fetchUserSegmentsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])("".concat(USER_SEGMENTS_URL, "&page=").concat(page)).then(function (_ref) {
      var user_segments = _ref.user_segments,
          page = _ref.page,
          page_count = _ref.page_count;
      return dispatch(fetchUserSegmentsSuccess(user_segments, page, page_count));
    }).catch(function (err) {
      dispatch(fetchUserSegmentsFailure(err));
      throw err;
    });
  };
}

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchUserSegments"] = fetchUserSegments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(52);



var USER_SEGMENTS_URL = "/hc/api/v2/user_segments?multibrand=true&user_type=".concat(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* SIGNED_IN_USERS */]);

function fetchUserSegmentsRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["b" /* FETCH_SIGNED_IN_USER_SEGMENTS_REQUEST */]
  };
}

function fetchUserSegmentsSuccess(userSegments, page, pageCount) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* FETCH_SIGNED_IN_USER_SEGMENTS_SUCCESS */],
    userSegments: userSegments,
    page: page,
    pageCount: pageCount
  };
}

function fetchUserSegmentsFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["a" /* FETCH_SIGNED_IN_USER_SEGMENTS_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchUserSegments(page) {
  return function (dispatch, getState) {
    dispatch(fetchUserSegmentsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])("".concat(USER_SEGMENTS_URL, "&page=").concat(page)).then(function (_ref) {
      var user_segments = _ref.user_segments,
          page = _ref.page,
          page_count = _ref.page_count;
      return dispatch(fetchUserSegmentsSuccess(user_segments, page, page_count));
    }).catch(function (err) {
      dispatch(fetchUserSegmentsFailure(err));
      throw err;
    });
  };
}

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserSegment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_View__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_self_service_components_lib_Ellipsis__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_self_service_components_lib_Ellipsis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_self_service_components_lib_Ellipsis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Menu__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_tags__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_userSegment__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);

















var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("g", {
  fill: "currentColor"
}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("circle", {
  cx: "7",
  cy: "13",
  r: "2"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("circle", {
  cx: "13",
  cy: "13",
  r: "2"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("circle", {
  cx: "19",
  cy: "13",
  r: "2"
}));

var EllipsisIcon = function EllipsisIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("svg", props, _ref2);
};

EllipsisIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  viewBox: "0 0 26 26"
};







var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(EllipsisIcon, {});

var UserSegment =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default()(UserSegment, _Component);

  function UserSegment(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck___default()(this, UserSegment);

    _this = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_getPrototypeOf___default()(UserSegment).call(this, props));
    _this.state = {
      isMenuOpen: false
    };
    _this.onMenuOpen = _this.onMenuOpen.bind(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onMenuClose = _this.onMenuClose.bind(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onEdit = _this.onEdit.bind(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onDuplicate = _this.onDuplicate.bind(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onDelete = _this.onDelete.bind(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass___default()(UserSegment, [{
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.setState({
        isMenuOpen: true
      });
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.setState({
        isMenuOpen: false
      });
    }
  }, {
    key: "onEdit",
    value: function onEdit(value, e) {
      e && e.stopPropagation();
      var _this$props = this.props,
          id = _this$props.userSegment.id,
          editUserSegment = _this$props.editUserSegment;
      editUserSegment(id);
    }
  }, {
    key: "onDuplicate",
    value: function onDuplicate(value, e) {
      e.stopPropagation();
      var _this$props2 = this.props,
          userSegment = _this$props2.userSegment,
          duplicateUserSegment = _this$props2.duplicateUserSegment;
      var newUserSegment = {
        name: "".concat(userSegment.name, " copy"),
        user_type: userSegment.user_type,
        tags: __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray___default()(userSegment.tags),
        organization_ids: __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray___default()(userSegment.organization_ids),
        group_ids: __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray___default()(userSegment.group_ids)
      };
      duplicateUserSegment(userSegment.id, newUserSegment);
    }
  }, {
    key: "onDelete",
    value: function onDelete(value, e) {
      e.stopPropagation();
      var _this$props3 = this.props,
          id = _this$props3.userSegment.id,
          deleteUserSegment = _this$props3.deleteUserSegment;
      deleteUserSegment(id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$userSegme = this.props.userSegment,
          name = _this$props$userSegme.name,
          builtIn = _this$props$userSegme.built_in,
          id = _this$props$userSegme.id;
      var isMenuOpen = this.state.isMenuOpen;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_View___default.a, {
        tabIndex: 0,
        className: __WEBPACK_IMPORTED_MODULE_17_classnames___default()(__WEBPACK_IMPORTED_MODULE_21__index_css___default.a.userSegment, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.activeUserSegment, isMenuOpen)),
        onEnter: this.onEdit,
        onClick: this.onEdit,
        testId: "user-segment-row"
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_View___default.a, {
        tabIndex: 1,
        className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.header
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_View___default.a, {
        className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.name
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__zendesk_self_service_components_lib_Ellipsis___default.a, {}, void 0, name)), builtIn && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_View___default.a, {
        className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.builtInLabelContainer
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_tags__["Tag"], {
        className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.builtInLabel,
        type: "blue",
        "data-test-id": "built-in-label"
      }, void 0, __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.builtIn"))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Menu___default.a, {
        testId: "user-segment-row-menu",
        dir: __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default.a.dir,
        size: "small",
        onOpen: this.onMenuOpen,
        onClose: this.onMenuClose,
        trigger: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("a", {
          "aria-label": __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.list.userSegment.ariaLabel"),
          onBlur: this.onBlur,
          tabIndex: 0,
          className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.trigger,
          id: id,
          "data-test-id": "user-segment-row-menu-trigger"
        }, void 0, _ref)
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Menu___default.a.Item, {
        onClick: this.onEdit,
        testId: "user-segment-row-edit"
      }, void 0, builtIn ? __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.list.userSegment.view") : __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.list.userSegment.edit")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Menu___default.a.Item, {
        onClick: this.onDuplicate,
        testId: "user-segment-row-duplicate"
      }, void 0, __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.list.userSegment.duplicate")), !builtIn && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_self_service_components_lib_Menu___default.a.Item, {
        onClick: this.onDelete,
        testId: "user-segment-row-delete"
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("span", {
        className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.delete
      }, void 0, __WEBPACK_IMPORTED_MODULE_18__zendesk_client_i18n_tools___default()("knowledge-user-segments.list.userSegment.delete"))))));
    }
  }]);

  return UserSegment;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);
UserSegment.propTypes = {
  userSegment: __WEBPACK_IMPORTED_MODULE_11_prop_types__["PropTypes"].shape({
    id: __WEBPACK_IMPORTED_MODULE_11_prop_types__["PropTypes"].number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_11_prop_types__["PropTypes"].string.isRequired,
    built_in: __WEBPACK_IMPORTED_MODULE_11_prop_types__["PropTypes"].bool.isRequired
  }).isRequired,
  deleteUserSegment: __WEBPACK_IMPORTED_MODULE_11_prop_types__["PropTypes"].func,
  duplicateUserSegment: __WEBPACK_IMPORTED_MODULE_11_prop_types__["PropTypes"].func,
  editUserSegment: __WEBPACK_IMPORTED_MODULE_11_prop_types__["PropTypes"].func
};

var mapStateToProps = function mapStateToProps() {
  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_12_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, __WEBPACK_IMPORTED_MODULE_20__actions_userSegment__), dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(UserSegment));

/***/ }),
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _styles = __webpack_require__(648);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ellipsis = function (_Component) {
  (0, _inherits3.default)(Ellipsis, _Component);

  function Ellipsis(props) {
    (0, _classCallCheck3.default)(this, Ellipsis);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.analyzeOverflow = function () {
      // setTimeout before reading the DOM element's dimensions:
      // In some cases, they may not be ready in the current stack.
      setTimeout(function () {
        if (!_this.refs.main) {
          return null;
        }

        var _this$refs$main$eleme = _this.refs.main.element,
            offsetWidth = _this$refs$main$eleme.offsetWidth,
            scrollWidth = _this$refs$main$eleme.scrollWidth;

        var isOverflowing = offsetWidth < scrollWidth;

        if (isOverflowing !== _this.state.isOverflowing) {
          _this.setState({ isOverflowing: isOverflowing });
        }
      }, 0);
    };

    _this.onWindowResize = function (e) {
      _this.analyzeOverflow();
    };

    _this.state = {};
    return _this;
  }

  Ellipsis.prototype.componentDidMount = function componentDidMount() {
    this.analyzeOverflow();

    window.addEventListener("resize", this.onWindowResize);
  };

  Ellipsis.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("resize", this.onWindowResize);
  };

  Ellipsis.prototype.componentDidUpdate = function componentDidUpdate() {
    this.analyzeOverflow();
  };

  Ellipsis.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        title = _props.title;


    var props = { className: _styles2.default.ellipsis };

    if ("title" in this.props) {
      props.title = title;
    } else if (this.state.isOverflowing) {
      props.title = this.refs.main.element.textContent;
    }

    /*
      <div />
      Prevent Safari quirk that causes native tooltips to show along-side our tooltips:
      http://stackoverflow.com/a/42023502
    */
    return _react2.default.createElement(
      _View2.default,
      (0, _extends3.default)({ ref: "main" }, props),
      _react2.default.createElement("div", null),
      children
    );
  };

  return Ellipsis;
}(_react.Component);

Ellipsis.propTypes = {
  children: _propTypes2.default.node,
  title: _propTypes2.default.string
};
exports.default = Ellipsis;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: ".ssc-ellipsis-3f511e1d{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"ellipsis":"ssc-ellipsis-3f511e1d"}


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(650), __esModule: true };

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(260);
__webpack_require__(651);
module.exports = __webpack_require__(42).Array.from;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(183)
  , $export        = __webpack_require__(62)
  , toObject       = __webpack_require__(135)
  , call           = __webpack_require__(652)
  , isArrayIter    = __webpack_require__(653)
  , toLength       = __webpack_require__(258)
  , createProperty = __webpack_require__(654)
  , getIterFn      = __webpack_require__(655);

$export($export.S + $export.F * !__webpack_require__(657)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(92);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(106)
  , ITERATOR   = __webpack_require__(50)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(69)
  , createDesc      = __webpack_require__(105);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(656)
  , ITERATOR  = __webpack_require__(50)('iterator')
  , Iterators = __webpack_require__(106);
module.exports = __webpack_require__(42).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(185)
  , TAG = __webpack_require__(50)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(50)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _reactDom = __webpack_require__(44);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Heavily inspired by https://github.com/reactjs/react-modal/blob/master/src/components/Modal.js

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

var Portal = function (_Component) {
  (0, _inherits3.default)(Portal, _Component);

  function Portal() {
    (0, _classCallCheck3.default)(this, Portal);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  Portal.prototype.componentWillMount = function componentWillMount() {
    this.node = document.createElement("div");
    document.body.appendChild(this.node);
  };

  Portal.prototype.componentDidMount = function componentDidMount() {
    !isReact16 && createPortal(this, this.props.children, this.node);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    !isReact16 && createPortal(this, newProps.children, this.node);
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.node) return;

    !isReact16 && _reactDom2.default.unmountComponentAtNode(this.node);
    document.body.removeChild(this.node);
  };

  Portal.prototype.render = function render() {
    if (isReact16) {
      return createPortal(this.props.children, this.node);
    } else {
      return null;
    }
  };

  return Portal;
}(_react.Component);

Portal.propTypes = {
  children: _propTypes2.default.node
};
exports.default = Portal;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _tabbable = __webpack_require__(660);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FocusJail = function FocusJail(container) {
  var _this = this;

  (0, _classCallCheck3.default)(this, FocusJail);

  this.onTab = function (e) {
    var elements = (0, _tabbable2.default)(_this.container);

    var isFirstElementClose = elements.length > 0 && elements[0].getAttribute("aria-label") === "close";

    if (isFirstElementClose) {
      var _elements = elements,
          first = _elements[0],
          rest = _elements.slice(1);

      elements = [].concat(rest, [first]);
    }

    var index = elements.indexOf(e.target);

    if (elements.length === 0) {
      setTimeout(function () {
        _this.container.focus();
      }, 0);
      e.stopPropagation();
      e.preventDefault();
    } else if (e.shiftKey) {
      var newIndex = index <= 0 ? elements.length - 1 : index - 1;
      setTimeout(function () {
        elements[newIndex].focus();
      }, 0);
      e.stopPropagation();
      e.preventDefault();
    } else if (!e.shiftKey) {
      var _newIndex = (index + 1) % elements.length;
      setTimeout(function () {
        elements[_newIndex].focus();
      }, 0);
      e.stopPropagation();
      e.preventDefault();
    }
  };

  this.container = container;

  setTimeout(function () {
    if (!_this.container.contains(window.document.activeElement)) {
      _this.container.focus();
    }
  }, 1);
};

exports.default = FocusJail;

/***/ }),
/* 660 */,
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var calculateTargetBasedOnPosition = {
  bottom: function bottom(_ref) {
    var anchor = _ref.anchor,
        target = _ref.target;
    return {
      top: anchor.top + anchor.margins.bottom + anchor.height,
      left: anchor.left + anchor.width / 2 - target.width / 2,
      height: target.height,
      width: target.width
    };
  },
  bottom_left: function bottom_left(_ref2) {
    var anchor = _ref2.anchor,
        centerPoint = _ref2.centerPoint,
        target = _ref2.target;
    return {
      top: anchor.top + anchor.margins.bottom + anchor.height,
      left: typeof centerPoint === "number" ? anchor.left + anchor.width / 2 - target.width + centerPoint : anchor.left + anchor.width - target.width,
      height: target.height,
      width: target.width
    };
  },
  bottom_right: function bottom_right(_ref3) {
    var anchor = _ref3.anchor,
        centerPoint = _ref3.centerPoint,
        target = _ref3.target;
    return {
      top: anchor.top + anchor.margins.bottom + anchor.height,
      left: typeof centerPoint === "number" ? anchor.left + anchor.width / 2 - centerPoint : anchor.left,
      height: target.height,
      width: target.width
    };
  },
  bottom_stretch: function bottom_stretch(_ref4) {
    var anchor = _ref4.anchor,
        target = _ref4.target;
    return {
      top: anchor.top + anchor.margins.bottom + anchor.height,
      left: anchor.left,
      height: target.height,
      width: anchor.width
    };
  },
  left: function left(_ref5) {
    var anchor = _ref5.anchor,
        target = _ref5.target;
    return {
      top: anchor.top + anchor.height / 2 - target.height / 2,
      left: anchor.left - anchor.margins.left - target.width,
      height: target.height,
      width: target.width
    };
  },
  left_top: function left_top(_ref6) {
    var anchor = _ref6.anchor,
        target = _ref6.target;
    return {
      top: anchor.top,
      left: anchor.left - anchor.margins.left - target.width,
      height: target.height,
      width: target.width
    };
  },
  left_bottom: function left_bottom(_ref7) {
    var anchor = _ref7.anchor,
        target = _ref7.target;
    return {
      top: anchor.top + anchor.margins.top + anchor.height - target.height,
      left: anchor.left - anchor.margins.left - target.width,
      height: target.height,
      width: target.width
    };
  },
  right: function right(_ref8) {
    var anchor = _ref8.anchor,
        target = _ref8.target;
    return {
      top: anchor.top + anchor.height / 2 - target.height / 2,
      left: anchor.left + anchor.margins.right + anchor.width,
      height: target.height,
      width: target.width
    };
  },
  right_top: function right_top(_ref9) {
    var anchor = _ref9.anchor,
        target = _ref9.target;
    return {
      top: anchor.top,
      left: anchor.left + anchor.margins.right + anchor.width,
      height: target.height,
      width: target.width
    };
  },
  right_bottom: function right_bottom(_ref10) {
    var anchor = _ref10.anchor,
        target = _ref10.target;
    return {
      top: anchor.top + anchor.margins.top + anchor.height - target.height,
      left: anchor.left + anchor.margins.right + anchor.width,
      height: target.height,
      width: target.width
    };
  },
  top: function top(_ref11) {
    var anchor = _ref11.anchor,
        target = _ref11.target;
    return {
      top: anchor.top - anchor.margins.top - target.height,
      left: anchor.left + anchor.width / 2 - target.width / 2,
      height: target.height,
      width: target.width
    };
  },
  top_left: function top_left(_ref12) {
    var anchor = _ref12.anchor,
        centerPoint = _ref12.centerPoint,
        target = _ref12.target;
    return {
      top: anchor.top - anchor.margins.top - target.height,
      left: typeof centerPoint === "number" ? anchor.left + anchor.width / 2 - target.width + centerPoint : anchor.left + anchor.width - target.width,
      height: target.height,
      width: target.width
    };
  },
  top_right: function top_right(_ref13) {
    var anchor = _ref13.anchor,
        centerPoint = _ref13.centerPoint,
        target = _ref13.target;
    return {
      top: anchor.top - anchor.margins.top - target.height,
      left: typeof centerPoint === "number" ? anchor.left + anchor.width / 2 - centerPoint : anchor.left,
      height: target.height,
      width: target.width
    };
  },
  top_stretch: function top_stretch(_ref14) {
    var anchor = _ref14.anchor,
        target = _ref14.target;
    return {
      top: anchor.top - anchor.margins.top - target.height,
      left: anchor.left,
      height: target.height,
      width: anchor.width
    };
  }
};

var positionRelative = function positionRelative(_ref15) {
  var anchor = _ref15.anchor,
      centerPoint = _ref15.centerPoint,
      position = _ref15.position,
      target = _ref15.target;

  var repositionedTarget = calculateTargetBasedOnPosition[position]({
    anchor: anchor,
    centerPoint: centerPoint,
    target: target
  });

  return {
    top: repositionedTarget.top,
    left: repositionedTarget.left,
    height: repositionedTarget.height,
    width: repositionedTarget.width
  };
};

exports.default = positionRelative;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var isInsideViewport = function isInsideViewport(_ref) {
  var target = _ref.target,
      viewport = _ref.viewport;

  return target.top >= 0 && target.left >= 0 && target.left + target.width <= viewport.width && target.top + target.height <= viewport.height;
};

exports.default = isInsideViewport;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var distance = function distance(p1, p2) {
  return Math.sqrt(Math.pow(p2.left - p1.left, 2) + Math.pow(p2.top - p1.top, 2));
};

exports.default = distance;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var keepInViewport = function keepInViewport(_ref) {
  var target = _ref.target,
      viewport = _ref.viewport;

  var result = {
    top: target.top,
    left: target.left,
    height: target.height,
    width: target.width,
    margins: target.margins
  };

  if (target.top + target.height > viewport.height) {
    result.top = Math.max(viewport.height - target.height, 0);
  }

  if (target.left + target.width > viewport.width) {
    result.left = Math.max(viewport.width - target.width, 0);
  }

  result.left = Math.max(0, result.left);
  result.top = Math.max(0, result.top);

  return result;
};

exports.default = keepInViewport;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: ".ssc-popup-78797151{position:fixed;opacity:1;z-index:500;outline:0;border:none}.ssc-opening-78797151{opacity:0}.ssc-popup-78797151[aria-hidden=true]{display:inherit;visibility:hidden}.ssc-stretched-78797151,.ssc-stretched-78797151.ssc-container-78797151,.ssc-stretched-78797151.ssc-trigger-78797151{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:100%;height:100%}.ssc-container-78797151,.ssc-trigger-78797151{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"popup":"ssc-popup-78797151","opening":"ssc-opening-78797151","stretched":"ssc-stretched-78797151","container":"ssc-container-78797151","trigger":"ssc-trigger-78797151"}


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Inspiration from the jQuery UI keyCode constants
 * https://api.jqueryui.com/jQuery.ui.keyCode/
 */
exports.default = {
  BACKSPACE: 8,
  COMMA: 188,
  DELETE: 46,
  DOWN: 40,
  END: 35,
  ENTER: 13,
  ESCAPE: 27,
  HOME: 36,
  LEFT: 37,
  NUMPAD_ADD: 107,
  NUMPAD_DECIMAL: 110,
  NUMPAD_DIVIDE: 111,
  NUMPAD_ENTER: 108,
  NUMPAD_MULTIPLY: 106,
  NUMPAD_SUBTRACT: 109,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  PERIOD: 190,
  RIGHT: 39,
  SPACE: 32,
  TAB: 9,
  UP: 38
};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _styles = __webpack_require__(53);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrowPositions = {
  bottom: "top",
  bottom_left: "top_right",
  bottom_right: "top_left",
  left: "right",
  right: "left",
  top: "bottom",
  top_left: "bottom_right",
  top_right: "bottom_left"
};

var Container = function (_ThemedComponent) {
  (0, _inherits3.default)(Container, _ThemedComponent);

  function Container(props, context) {
    (0, _classCallCheck3.default)(this, Container);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Menu",
      styles: _styles2.default
    }));
  }

  Container.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        animate = _props.animate,
        arrow = _props.arrow,
        children = _props.children,
        dir = _props.dir,
        fixedWidth = _props.fixedWidth,
        maxHeight = _props.maxHeight,
        position = _props.position,
        size = _props.size,
        onMouseDown = _props.onMouseDown,
        onBlur = _props.onBlur,
        onKeyDown = _props.onKeyDown,
        onEscape = _props.onEscape,
        className = _props.className;


    var style = {};
    var innerStyle = {};
    var hasMaxHeight = typeof maxHeight !== "undefined";

    if (hasMaxHeight) {
      style.maxHeight = typeof maxHeight === "number" ? maxHeight + "px" : maxHeight;

      innerStyle.maxHeight = "calc(" + style.maxHeight + " - 2px)";
    }

    var theme = this.theme;


    return _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(theme.menu, theme["size_" + size], theme["position_" + position], theme[dir], (_classNames = {}, _classNames[theme.animate] = animate, _classNames[theme.fixed_width] = fixedWidth, _classNames[theme.arrow] = arrow, _classNames[theme["arrow_" + arrowPositions[position]]] = arrow, _classNames[theme.scrollable] = hasMaxHeight, _classNames), className),
        role: "menu",
        style: style,
        tabIndex: -1,
        onMouseDown: onMouseDown,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onEscape: onEscape
      },
      _react2.default.createElement(
        _View2.default,
        { className: theme.inner, style: innerStyle },
        children
      )
    );
  };

  return Container;
}(_ThemedComponent3.default);

Container.propTypes = {
  animate: _propTypes2.default.bool,
  arrow: _propTypes2.default.bool,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  fixedWidth: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired,
  maxHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  position: _propTypes2.default.oneOf(["bottom", "bottom_left", "bottom_right", "bottom_stretch", "left", "right", "top", "top_left", "top_right", "top_stretch"]),
  size: _propTypes2.default.oneOf(["small", "medium"]),
  onMouseDown: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onEscape: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  className: _propTypes2.default.string
};
Container.defaultProps = {
  animate: false,
  arrow: false,
  dir: "ltr",
  position: "bottom_right",
  size: "medium"
};
exports.default = Container;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _Selectable = __webpack_require__(51);

var _Selectable2 = _interopRequireDefault(_Selectable);

var _styles = __webpack_require__(53);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkItem = function (_ThemedComponent) {
  (0, _inherits3.default)(LinkItem, _ThemedComponent);

  function LinkItem(props, context) {
    (0, _classCallCheck3.default)(this, LinkItem);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Menu",
      styles: _styles2.default
    }));
  }

  LinkItem.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        children = _props.children,
        disabled = _props.disabled,
        onMouseDown = _props.onMouseDown,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onClick = _props.onClick,
        role = _props.role,
        selected = _props.selected,
        testId = _props.testId,
        href = _props.href,
        target = _props.target,
        className = _props.className,
        selectedByMouse = _props.selectedByMouse;
    var theme = this.theme;


    var accessibilityProps = {
      "aria-activedescendant": selected,
      "aria-disabled": disabled
    };

    return _react2.default.createElement(
      "a",
      (0, _extends3.default)({}, accessibilityProps, {
        className: (0, _classnames2.default)(theme.item, className, (_classNames = {}, _classNames[theme.disabled] = disabled, _classNames[theme.focused] = selected && !selectedByMouse, _classNames[theme.selected] = selected, _classNames)),
        disabled: disabled,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        role: role,
        "data-test-id": testId,
        href: href,
        target: target
      }),
      children
    );
  };

  return LinkItem;
}(_ThemedComponent3.default);

LinkItem.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  onMouseDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  role: _propTypes2.default.string,
  selected: _propTypes2.default.bool,
  testId: _propTypes2.default.string,
  title: _propTypes2.default.string,
  href: _propTypes2.default.string.isRequired,
  selectedByMouse: _propTypes2.default.bool,
  target: _propTypes2.default.oneOf(["_self", "_blank", "_parent", "_top"])
};
LinkItem.defaultProps = {
  disabled: false,
  role: "menuitem",
  target: "_self"
};
exports.default = (0, _Selectable2.default)(LinkItem, {
  action: function action(props, event) {
    var href = props.href,
        target = props.target;

    var openInNewWindow = event.ctrlKey || event.metaKey;

    var newWindow = window.open(href, openInNewWindow ? "_blank" : target);
    if (newWindow) {
      newWindow.opener = null;
    }
  },
  selectEvent: "onClick",
  preventDefault: true
});

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(53);

var _styles2 = _interopRequireDefault(_styles);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Separator = function Separator() {
  return _react2.default.createElement(_View2.default, { className: _styles2.default.separator, role: "separator" });
};

exports.default = Separator;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _Selectable = __webpack_require__(51);

var _Selectable2 = _interopRequireDefault(_Selectable);

var _Item = __webpack_require__(96);

var _styles = __webpack_require__(53);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviousItem = function (_ThemedComponent) {
  (0, _inherits3.default)(PreviousItem, _ThemedComponent);

  function PreviousItem(props, context) {
    (0, _classCallCheck3.default)(this, PreviousItem);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Menu",
      styles: _styles2.default
    }));
  }

  PreviousItem.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ["children", "className"]);
    var theme = this.theme;


    return _react2.default.createElement(
      _Item.Item,
      (0, _extends3.default)({
        className: (0, _classnames2.default)(className, theme.previous_item)
      }, otherProps),
      children
    );
  };

  return PreviousItem;
}(_ThemedComponent3.default);

PreviousItem.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string
};
exports.default = (0, _Selectable2.default)(PreviousItem, {
  action: function action(props, event) {
    var onClick = props.onClick,
        value = props.value;


    onClick && onClick(value, event);
  },
  selectEvent: "onClick",
  preventDefault: true
});

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _Selectable = __webpack_require__(51);

var _Selectable2 = _interopRequireDefault(_Selectable);

var _Item = __webpack_require__(96);

var _styles = __webpack_require__(53);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NextItem = function (_ThemedComponent) {
  (0, _inherits3.default)(NextItem, _ThemedComponent);

  function NextItem(props, context) {
    (0, _classCallCheck3.default)(this, NextItem);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Menu",
      styles: _styles2.default
    }));
  }

  NextItem.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ["children", "className"]);
    var theme = this.theme;


    return _react2.default.createElement(
      _Item.Item,
      (0, _extends3.default)({ className: (0, _classnames2.default)(className, theme.next_item) }, otherProps),
      children
    );
  };

  return NextItem;
}(_ThemedComponent3.default);

NextItem.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string
};
exports.default = (0, _Selectable2.default)(NextItem, {
  action: function action(props, event) {
    var onClick = props.onClick,
        value = props.value;

    onClick && onClick(value, event);
  },
  selectEvent: "onClick",
  preventDefault: true
});

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _Item = __webpack_require__(96);

var _Item2 = _interopRequireDefault(_Item);

var _styles = __webpack_require__(53);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderItem = function (_ThemedComponent) {
  (0, _inherits3.default)(HeaderItem, _ThemedComponent);

  function HeaderItem(props, context) {
    (0, _classCallCheck3.default)(this, HeaderItem);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Menu",
      styles: _styles2.default
    }));
  }

  HeaderItem.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        icon = _props.icon,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ["children", "className", "icon"]);
    var theme = this.theme;


    return _react2.default.createElement(
      _Item2.default,
      (0, _extends3.default)({
        className: (0, _classnames2.default)(theme.header_item, className),
        isCheckable: false
      }, otherProps),
      icon && _react2.default.createElement(
        "div",
        { className: theme.header_icon },
        icon
      ),
      children
    );
  };

  return HeaderItem;
}(_ThemedComponent3.default);

HeaderItem.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  icon: _propTypes2.default.element
};
exports.default = HeaderItem;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _Selectable = __webpack_require__(51);

var _Selectable2 = _interopRequireDefault(_Selectable);

var _Item = __webpack_require__(96);

var _styles = __webpack_require__(53);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddItem = function (_ThemedComponent) {
  (0, _inherits3.default)(AddItem, _ThemedComponent);

  function AddItem(props, context) {
    (0, _classCallCheck3.default)(this, AddItem);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Menu",
      styles: _styles2.default
    }));
  }

  AddItem.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ["children", "className"]);
    var theme = this.theme;


    return _react2.default.createElement(
      _Item.Item,
      (0, _extends3.default)({ className: (0, _classnames2.default)(theme.add_item, className) }, otherProps),
      children
    );
  };

  return AddItem;
}(_ThemedComponent3.default);

AddItem.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string
};
exports.default = (0, _Selectable2.default)(AddItem, {
  action: function action(props, event) {
    var onClick = props.onClick,
        value = props.value;

    onClick && onClick(value, event);
  },
  selectEvent: "onClick",
  preventDefault: true
});

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _Selectable = __webpack_require__(51);

var _Selectable2 = _interopRequireDefault(_Selectable);

var _Item = __webpack_require__(96);

var _styles = __webpack_require__(53);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaItem = function (_ThemedComponent) {
  (0, _inherits3.default)(MediaItem, _ThemedComponent);

  function MediaItem(props, context) {
    (0, _classCallCheck3.default)(this, MediaItem);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Menu",
      styles: _styles2.default
    }));
  }

  MediaItem.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        media = _props.media,
        metaInformation = _props.metaInformation,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ["children", "className", "media", "metaInformation"]);
    var theme = this.theme;


    return _react2.default.createElement(
      _Item.Item,
      (0, _extends3.default)({ className: (0, _classnames2.default)(className, theme.media_item) }, otherProps),
      media && _react2.default.createElement(
        "div",
        { className: theme.media_figure },
        media
      ),
      _react2.default.createElement(
        "div",
        { className: theme.media_body },
        children,
        metaInformation && _react2.default.createElement(
          "div",
          { className: theme.meta },
          metaInformation
        )
      )
    );
  };

  return MediaItem;
}(_ThemedComponent3.default);

MediaItem.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  media: _propTypes2.default.element
};
exports.default = (0, _Selectable2.default)(MediaItem, {
  action: function action(props, event) {
    var onClick = props.onClick,
        value = props.value;

    onClick && onClick(value, event);
  },
  selectEvent: "onClick",
  preventDefault: true
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = showErrorNotification;
/* harmony export (immutable) */ __webpack_exports__["b"] = showSuccessNotification;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(279);


var ERROR_NOTIFICATION_TIME = 5000;
var SUCCESS_NOTIFICATION_TIME = 2500;

function removeNotification(id) {
  return {
    id: id,
    type: __WEBPACK_IMPORTED_MODULE_1__types__["a" /* REMOVE_NOTIFICATION */]
  };
}

function showErrorNotification(message) {
  return function (dispatch) {
    var id = __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default()();
    dispatch({
      id: id,
      message: message,
      type: __WEBPACK_IMPORTED_MODULE_1__types__["b" /* SHOW_ERROR_NOTIFICATION */]
    });
    setTimeout(function () {
      return dispatch(removeNotification(id));
    }, ERROR_NOTIFICATION_TIME);
    return id;
  };
}
function showSuccessNotification(message) {
  return function (dispatch) {
    var id = __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default()();
    dispatch({
      id: id,
      message: message,
      type: __WEBPACK_IMPORTED_MODULE_1__types__["c" /* SHOW_SUCCESS_NOTIFICATION */]
    });
    setTimeout(function () {
      return dispatch(removeNotification(id));
    }, SUCCESS_NOTIFICATION_TIME);
    return id;
  };
}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"userSegment":"_-src-components-UserSegments-components-UserSegment-index---userSegment---2fs6e","activeUserSegment":"_-src-components-UserSegments-components-UserSegment-index---activeUserSegment---3czi4","header":"_-src-components-UserSegments-components-UserSegment-index---header---2blr1","builtInLabel":"_-src-components-UserSegments-components-UserSegment-index---builtInLabel---OVJZe","name":"_-src-components-UserSegments-components-UserSegment-index---name---3f10g","builtInLabelContainer":"_-src-components-UserSegments-components-UserSegment-index---builtInLabelContainer---2-LeQ","userSegmentName":"_-src-components-UserSegments-components-UserSegment-index---userSegmentName---7Asdj","trigger":"_-src-components-UserSegments-components-UserSegment-index---trigger---2qJJB","delete":"_-src-components-UserSegments-components-UserSegment-index---delete---1wGyE"};

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loader":"_-src-components-UserSegments-components-List-index---loader---3sqxt"};

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"_-src-components-UserSegments-index---header---3G_pQ","title":"_-src-components-UserSegments-index---title---2HAgc","headerContent":"_-src-components-UserSegments-index---headerContent---h-h4F","loader":"_-src-components-UserSegments-index---loader---Z9jf-","singleColumn":"_-src-components-UserSegments-index---singleColumn---39jw8","twoColumn":"_-src-components-UserSegments-index---twoColumn---1sqrR"};

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserSegment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_self_service_components_lib_Button__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_self_service_components_lib_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_self_service_components_lib_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_TooltipProvider__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_TooltipProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_TooltipProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_Link__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_loaders__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_loaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_loaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_chrome_lib_Chrome__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_chrome_lib_Chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_chrome_lib_Chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_isEqual__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__constants__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_urls__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions_userSegment__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Notifications__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Title__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__AutocompleteList__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_UserList__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__index_css__);































var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_25__Notifications__["a" /* default */], {});

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_loaders__["Spinner"], {});

var _ref5 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_28__components_UserList__["a" /* default */], {});

var UserSegment =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(UserSegment, _Component);

  function UserSegment(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, UserSegment);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(UserSegment).call(this, props));
    _this.onNameChange = _this.onNameChange.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onSave = _this.onSave.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onBeforeUnload = _this.onBeforeUnload.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(UserSegment, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          fetchUserSegment = _this$props.fetchUserSegment,
          userSegmentId = _this$props.userSegmentId;

      if (userSegmentId) {
        fetchUserSegment(userSegmentId);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("beforeunload", this.onBeforeUnload);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var resetUserSegment = this.props.resetUserSegment;
      resetUserSegment();
      window.removeEventListener("beforeunload", this.onBeforeUnload);
    }
  }, {
    key: "onBeforeUnload",
    value: function onBeforeUnload(e) {
      var hasChanges = this.props.hasChanges;

      if (hasChanges) {
        var message = __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.unsavedLeaveConfirmation");
        e.returnValue = message;
        return message;
      }
    }
  }, {
    key: "onNameChange",
    value: function onNameChange(newName) {
      var changeName = this.props.changeName;
      changeName(newName);
    }
  }, {
    key: "onSave",
    value: function onSave() {
      var _this$props2 = this.props,
          saveUserSegment = _this$props2.saveUserSegment,
          userSegmentId = _this$props2.userSegmentId;
      saveUserSegment(userSegmentId);
    }
  }, {
    key: "renderAppliesToLink",
    value: function renderAppliesToLink() {
      var _this$props3 = this.props,
          hasArticleViewPermissions = _this$props3.hasArticleViewPermissions,
          userSegmentId = _this$props3.userSegmentId;

      if (!hasArticleViewPermissions) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("p", {
        className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.description
      }, void 0, __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default.a.parts("knowledge-user-segments.userSegment.appliesTo", {
        articlesLink: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_Link___default.a, {
          href: "/knowledge/lists?query=is_source%3Atrue+user_segment_id%3A".concat(userSegmentId, "&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context__["getCurrentBrandId"])()),
          target: "_blank"
        }, "applies-to-articles-link", __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.theseArticles"))
      }).map(function (part, i) {
        switch (part.type) {
          case "text":
          case "variable":
            return part.value;

          case "newline":
            return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("br", {}, "newline-".concat(i));
        }
      }));
    }
  }, {
    key: "renderRestrictions",
    value: function renderRestrictions() {
      var _this$props4 = this.props,
          builtIn = _this$props4.builtIn,
          userType = _this$props4.userType,
          addTag = _this$props4.addTag,
          addOrganization = _this$props4.addOrganization,
          addGroup = _this$props4.addGroup,
          isFetchingOrganizations = _this$props4.isFetchingOrganizations,
          isFetchingOrganizationsForbidden = _this$props4.isFetchingOrganizationsForbidden,
          isFetchingGroups = _this$props4.isFetchingGroups,
          tags = _this$props4.tags,
          organizations = _this$props4.organizations,
          groups = _this$props4.groups;

      if (builtIn) {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.userSegmentContent
        }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("p", {
          className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.description
        }, void 0, __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.builtInDescription")), this.renderAppliesToLink());
      }

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.userSegmentContent
      }, void 0, this.renderAppliesToLink(), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h2", {
        className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.resrtrictionsTitle
      }, void 0, __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.matchTheFollowing")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_27__AutocompleteList__["a" /* default */], {
        isLoading: false,
        items: tags,
        type: "tags",
        newText: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.addTag"),
        conjunction: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.conjunctionAnd"),
        onAddNew: addTag,
        title: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.tags"),
        description: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.tagsDescription", {
          learnMoreUrl: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.tagsDescriptionLearnMoreUrl")
        })
      }), userType === __WEBPACK_IMPORTED_MODULE_22__constants__["d" /* SIGNED_IN_USERS */] && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_27__AutocompleteList__["a" /* default */], {
        isLoading: isFetchingOrganizations,
        items: organizations,
        type: "organizations",
        newText: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.addOrganization"),
        conjunction: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.conjunctionOr"),
        onAddNew: addOrganization,
        title: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.organizations"),
        error: isFetchingOrganizationsForbidden ? __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.organizationsForbidden") : null,
        description: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.organizationsDescription", {
          learnMoreUrl: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.organizationsDescriptionLearnMoreUrl")
        })
      }), userType === __WEBPACK_IMPORTED_MODULE_22__constants__["e" /* STAFF */] && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_27__AutocompleteList__["a" /* default */], {
        isLoading: isFetchingGroups,
        items: groups,
        type: "groups",
        newText: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.addGroup"),
        conjunction: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.conjunctionOr"),
        onAddNew: addGroup,
        title: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.groups"),
        description: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.groupsDescription", {
          learnMoreUrl: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.groupsDescriptionLearnMoreUrl")
        })
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          name = _this$props5.name,
          builtIn = _this$props5.builtIn,
          hasChanges = _this$props5.hasChanges,
          userType = _this$props5.userType,
          isLoaded = _this$props5.isLoaded;
      var isNameEmpty = name.length === 0;

      var actionButton = !builtIn && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_self_service_components_lib_Button___default.a, {
        type: "primary",
        size: "medium",
        testId: "save-button",
        disabled: !hasChanges || isNameEmpty,
        onClick: this.onSave
      }, void 0, __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.save"));

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_chrome_lib_Chrome___default.a, {
        brandId: Object(__WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context__["getCurrentBrandId"])(),
        dir: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default.a.dir,
        topNav: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("a", {
          href: Object(__WEBPACK_IMPORTED_MODULE_23__utils_urls__["b" /* getUserSegmentsUrl */])()
        }, void 0, __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userPermissions"))), _ref, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("a", {
          href: Object(__WEBPACK_IMPORTED_MODULE_23__utils_urls__["b" /* getUserSegmentsUrl */])()
        }, void 0, __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.name"))), _ref2, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, name))
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.contentWrapper
      }, void 0, _ref3, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_TooltipProvider___default.a, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.primaryContent
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.contentView
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, !isLoaded ? __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.userSegmentContent
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.loader
      }, void 0, _ref4)) : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.content
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_26__components_Title__["a" /* default */], {
        builtIn: builtIn,
        userType: userType,
        name: name,
        actionButton: actionButton,
        onChange: this.onNameChange
      }), this.renderRestrictions())), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["b" /* Prompt */], {
        when: hasChanges,
        message: __WEBPACK_IMPORTED_MODULE_16__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.unsavedLeaveConfirmation")
      }))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.secondaryContentWrapper
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_17_classnames___default()(__WEBPACK_IMPORTED_MODULE_29__index_css___default.a.contentView, __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.userSegmentContent)
      }, void 0, _ref5)))));
    }
  }]);

  return UserSegment;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);
UserSegment.propTypes = {
  userSegmentId: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string,
  name: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string,
  builtIn: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool,
  hasChanges: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool,
  hasArticleViewPermissions: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool,
  isLoaded: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool.isRequired,
  isFetchingOrganizations: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool,
  isFetchingOrganizationsForbidden: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool,
  isFetchingGroups: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool,
  fetchUserSegment: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  addTag: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  addGroup: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  addOrganization: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  resetUserSegment: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  changeName: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  saveUserSegment: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  userType: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].oneOf([__WEBPACK_IMPORTED_MODULE_22__constants__["e" /* STAFF */], __WEBPACK_IMPORTED_MODULE_22__constants__["d" /* SIGNED_IN_USERS */]]),
  tags: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string),
  organizations: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].shape({
    id: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string.isRequired
  })),
  groups: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].shape({
    id: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string.isRequired
  }))
};
UserSegment.defaultProps = {
  hasChanges: false,
  hasArticleViewPermissions: false,
  name: "",
  builtIn: false,
  isFetchingOrganizations: false,
  isFetchingOrganizationsForbidden: false,
  isFetchingGroups: false,
  isLoaded: false
};

var mapStateToProps = function mapStateToProps(_ref6, ownProps) {
  var userSegment = _ref6.userSegment;
  return {
    userSegmentId: ownProps.match.params.id,
    name: userSegment.name,
    builtIn: userSegment.builtIn,
    userType: userSegment.userType,
    tags: userSegment.tags,
    organizations: userSegment.organizations,
    groups: userSegment.groups,
    users: userSegment.users,
    isLoaded: userSegment.isLoaded,
    isFetchingOrganizations: userSegment.isFetchingOrganizations,
    isFetchingOrganizationsForbidden: userSegment.isFetchingOrganizationsForbidden,
    isFetchingGroups: userSegment.isFetchingGroups,
    hasArticleViewPermissions: Object(__WEBPACK_IMPORTED_MODULE_21__zendesk_knowledge_context__["hasFeature"])("guide_article_view_permissions"),
    hasChanges: !__WEBPACK_IMPORTED_MODULE_20_lodash_isEqual___default()(userSegment.savedTags, userSegment.tags) || !__WEBPACK_IMPORTED_MODULE_20_lodash_isEqual___default()(userSegment.savedOrganizations, userSegment.organizations) || !__WEBPACK_IMPORTED_MODULE_20_lodash_isEqual___default()(userSegment.savedGroups, userSegment.groups) || userSegment.savedName !== userSegment.name
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_19_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, __WEBPACK_IMPORTED_MODULE_24__actions_userSegment__), dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(UserSegment));

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _TooltipProvider = __webpack_require__(681);

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TooltipProvider).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _createTooltipManager = __webpack_require__(682);

var _createTooltipManager2 = _interopRequireDefault(_createTooltipManager);

var _uuid = __webpack_require__(82);

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TooltipProvider = function (_ThemedComponent) {
  (0, _inherits3.default)(TooltipProvider, _ThemedComponent);

  function TooltipProvider(props, context) {
    (0, _classCallCheck3.default)(this, TooltipProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, { namespace: "TooltipProvider" }));

    _this.id = props.id || "tooltips-" + _uuid2.default.v4();
    return _this;
  }

  TooltipProvider.prototype.componentWillMount = function componentWillMount() {
    var container = document.getElementById(this.id);

    if (!container) {
      container = document.createElement("div");
      container.id = this.id;
      document.body.appendChild(container);
    }

    var _props = this.props,
        dir = _props.dir,
        zIndex = _props.zIndex;
    var theme = this.context.rcTheme;


    this.tooltipManager = (0, _createTooltipManager2.default)(container, {
      dir: dir,
      zIndex: zIndex,
      theme: theme
    });
  };

  TooltipProvider.prototype.getChildContext = function getChildContext() {
    return { tooltips: this.tooltipManager };
  };

  TooltipProvider.prototype.render = function render() {
    var children = this.props.children;


    return children;
  };

  return TooltipProvider;
}(_ThemedComponent3.default);

TooltipProvider.propTypes = {
  children: _propTypes2.default.node,
  /** Used to identify the provider and the element that will contain the tooltips. Defaults to a generated UUID */
  id: _propTypes2.default.string,
  dir: _propTypes2.default.oneOf(["rtl", "ltr"]),
  zIndex: _propTypes2.default.number
};
TooltipProvider.defaultProps = {
  dir: "ltr",
  zIndex: 600
};
TooltipProvider.childContextTypes = {
  tooltips: _propTypes2.default.object
};
exports.default = TooltipProvider;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _TooltipContainer = __webpack_require__(683);

var _TooltipContainer2 = _interopRequireDefault(_TooltipContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTooltipManager = function createTooltipManager(renderNode) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var currentTooltipId = 0;

  var show = function show(anchor, content, positions) {
    document.body.addEventListener("scroll", hide);
    window.addEventListener("resize", hide);

    (0, _reactDom.render)(_react2.default.createElement(_TooltipContainer2.default, {
      anchor: anchor,
      content: content,
      dir: options.dir,
      positions: positions,
      zIndex: options.zIndex,
      theme: options.theme
    }), renderNode);

    return ++currentTooltipId;
  };

  var hide = function hide(tooltipId) {
    if (typeof tooltipId !== "number" || tooltipId === currentTooltipId) {
      (0, _reactDom.render)(_react2.default.createElement(_TooltipContainer2.default, null), renderNode);

      document.body.removeEventListener("scroll", hide);
      window.removeEventListener("resize", hide);
    }
  };

  // Initial empty render that creates the container element
  (0, _reactDom.render)(_react2.default.createElement(_TooltipContainer2.default, null), renderNode);

  return { show: show, hide: hide };
};

exports.default = createTooltipManager;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(44);

var _styles = __webpack_require__(684);

var _styles2 = _interopRequireDefault(_styles);

var _ThemeProvider = __webpack_require__(685);

var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);

var _Tooltip = __webpack_require__(686);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _getBestRelativePlacement = __webpack_require__(276);

var _getBestRelativePlacement2 = _interopRequireDefault(_getBestRelativePlacement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rtlPositions = {
  top: "top",
  bottom: "bottom",
  left: "right",
  right: "left"
};

var TooltipContainer = function (_Component) {
  (0, _inherits3.default)(TooltipContainer, _Component);

  function TooltipContainer() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TooltipContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.container = document.createElement("div");
      _this.container.style.transform = "matrix(1, 0, 0, 1, 0, 0)";
      _this.container.style.position = "absolute";
      _this.container.style.visibility = "hidden";
      _this.container.style.top = "0px";
      _this.container.style.left = "0px";
      _this.container.style.width = "100%";
      document.body.appendChild(_this.container);
    }, _this.componentWillReceiveProps = function (_ref) {
      var content = _ref.content,
          size = _ref.size,
          theme = _ref.theme;

      if (!content) {
        _this.setState({ tooltipBounds: null });

        return null;
      }

      // Render an invisible tooltip into the DOM in order to analyze its dimensions,
      // so we know exactly how to place it correctly when we render it.
      (0, _reactDom.render)(_react2.default.createElement(
        _ThemeProvider2.default,
        { theme: theme },
        _react2.default.createElement(
          _Tooltip2.default,
          { size: size },
          content
        )
      ), _this.container, function () {
        var tooltipBounds = _this.container.firstElementChild.getBoundingClientRect();

        _this.setState({ tooltipBounds: tooltipBounds });
      });
    }, _this.render = function () {
      if (!(_this.state && _this.state.tooltipBounds)) {
        return null;
      }

      var tBounds = _this.state.tooltipBounds;
      var _this$props = _this.props,
          content = _this$props.content,
          anchor = _this$props.anchor,
          rawPositions = _this$props.positions,
          dir = _this$props.dir,
          size = _this$props.size,
          zIndex = _this$props.zIndex,
          theme = _this$props.theme;


      var positions = function () {
        return typeof rawPositions === "string" ? [rawPositions] : rawPositions;
      }().map(function (position) {
        return dir === "rtl" ? rtlPositions[position] : position;
      });

      var aBounds = anchor.getBoundingClientRect();

      var _getBestRelativePlace = (0, _getBestRelativePlacement2.default)({
        positions: positions,
        anchor: {
          left: aBounds.left,
          right: aBounds.right,
          top: aBounds.top,
          bottom: aBounds.bottom,
          width: aBounds.width,
          height: aBounds.height,
          margins: { left: 5, top: 5, right: 5, bottom: 5 }
        },
        centerPoint: 0,
        target: {
          width: tBounds.width,
          height: tBounds.height
        },
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight
        }
      }),
          _getBestRelativePlace2 = _getBestRelativePlace.rect,
          left = _getBestRelativePlace2.left,
          top = _getBestRelativePlace2.top,
          position = _getBestRelativePlace.position;

      return _react2.default.createElement(
        _ThemeProvider2.default,
        { theme: theme },
        _react2.default.createElement(
          "div",
          { className: _styles2.default.container, style: { zIndex: zIndex } },
          _react2.default.createElement(
            _Tooltip2.default,
            { left: left, top: top, position: position, size: size },
            content
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  return TooltipContainer;
}(_react.Component);

TooltipContainer.propTypes = {
  positions: _propTypes2.default.oneOfType([_Tooltip2.default.propTypes.position, _propTypes2.default.arrayOf(_Tooltip2.default.propTypes.position)]),
  content: _Tooltip2.default.propTypes.children,
  anchor: _propTypes2.default.object,
  dir: _propTypes2.default.oneOf(["rtl", "ltr"]),
  size: _Tooltip2.default.propTypes.size,
  zIndex: _propTypes2.default.number,
  theme: _propTypes2.default.object
};

TooltipContainer.defaultProps = {
  positions: ["top", "bottom", "left", "right"],
  dir: "ltr",
  zIndex: 600
};

exports.default = TooltipContainer;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: "@-webkit-keyframes ssc-appear-a58354cf{from{opacity:0}to{opacity:1}}@keyframes ssc-appear-a58354cf{from{opacity:0}to{opacity:1}}.ssc-container-a58354cf{position:absolute;-webkit-animation-name:ssc-appear-a58354cf;animation-name:ssc-appear-a58354cf;-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-delay:.4s;animation-delay:.4s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;pointer-events:none;opacity:0}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"container":"ssc-container-a58354cf","appear":"ssc-appear-a58354cf"}


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemeProvider = function (_Component) {
  (0, _inherits3.default)(ThemeProvider, _Component);

  function ThemeProvider() {
    (0, _classCallCheck3.default)(this, ThemeProvider);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        theme = _props.theme,
        resetTheme = _props.resetTheme;

    return { rcTheme: theme, resetTheme: resetTheme };
  };

  ThemeProvider.prototype.render = function render() {
    var children = this.props.children;


    return children;
  };

  return ThemeProvider;
}(_react.Component);

ThemeProvider.propTypes = {
  children: _propTypes2.default.node,
  theme: _propTypes2.default.object,
  resetTheme: _propTypes2.default.bool
};
ThemeProvider.childContextTypes = {
  rcTheme: _propTypes2.default.object,
  resetTheme: _propTypes2.default.bool
};
exports.default = ThemeProvider;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(687);

var _styles2 = _interopRequireDefault(_styles);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mediumTooltipLimit = 50;

var calculateTooltipSize = function calculateTooltipSize(content) {
  return mediumTooltipLimit < content.length ? "medium" : "default";
};

var Tooltip = function (_ThemedComponent) {
  (0, _inherits3.default)(Tooltip, _ThemedComponent);

  function Tooltip(props, context) {
    (0, _classCallCheck3.default)(this, Tooltip);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Tooltip",
      styles: _styles2.default
    }));
  }

  Tooltip.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        left = _props.left,
        top = _props.top,
        children = _props.children,
        position = _props.position,
        inline = _props.inline,
        size = _props.size;
    var theme = this.theme;


    var resolvedSize = size || typeof children === "string" && calculateTooltipSize(children) || "default";

    return _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(theme.container, (_classNames = {}, _classNames[theme.inline] = inline, _classNames)),
        style: { left: left, top: top }
      },
      _react2.default.createElement(
        _View2.default,
        {
          className: (0, _classnames2.default)(theme.tooltip, theme[position], theme["size_" + resolvedSize])
        },
        children
      )
    );
  };

  return Tooltip;
}(_ThemedComponent3.default);

Tooltip.propTypes = {
  children: _propTypes2.default.node,
  inline: _propTypes2.default.bool,
  left: _propTypes2.default.number,
  /** For displaying a plain, independent tooltip  */
  position: _propTypes2.default.oneOf(["top", "bottom", "left", "right"]),
  size: _propTypes2.default.oneOf(["default", "medium", "large"]),
  top: _propTypes2.default.number
};
Tooltip.defaultProps = {
  top: 0,
  left: 0,
  position: "top",
  inline: false
};
exports.default = Tooltip;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)
__webpack_require__(688)
__webpack_require__(277)

appendStyles({
  css: ".ssc-container-7376d642{position:fixed}.ssc-size_medium-7376d642{max-width:270px}.ssc-inline-7376d642{position:absolute}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"container":"ssc-container-7376d642","tooltip":"ssc-tooltip-7376d642 scc-c-tooltip-1a15e320 scc-c-arrow-1a15e320 scc-c-arrow-be7b392f","size_medium":"ssc-size_medium-7376d642 scc-c-tooltip--medium-1a15e320","size_large":"ssc-size_large-7376d642 scc-c-tooltip--large-1a15e320","left":"ssc-left-7376d642 scc-c-arrow--r-be7b392f","bottom":"ssc-bottom-7376d642 scc-c-arrow--t-be7b392f","top":"ssc-top-7376d642 scc-c-arrow--b-be7b392f","right":"ssc-right-7376d642 scc-c-arrow--l-be7b392f","inline":"ssc-inline-7376d642"}


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: "/*!\n * Copyright Zendesk, Inc.\n *\n * Use of this source code is governed under the Apache License, Version 2.0\n * found at http://www.apache.org/licenses/LICENSE-2.0.\n */.scc-c-tooltip-1a15e320{display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:2px;-webkit-box-shadow:0 4px 8px 0 rgba(4,68,77,.15);box-shadow:0 4px 8px 0 rgba(4,68,77,.15);background-color:#03363d;padding:0 1em;line-height:1.66667;white-space:nowrap;color:#fff;font-size:12px;font-weight:400}.scc-c-tooltip-1a15e320.scc-c-arrow-1a15e320:after,.scc-c-tooltip-1a15e320.scc-c-arrow-1a15e320:before{font-size:7px}.scc-c-tooltip--extra-large-1a15e320{border-radius:4px;padding:40px;max-width:460px;word-wrap:break-word;line-height:1.42857;white-space:normal;font-size:14px}.scc-c-tooltip--extra-large-1a15e320.scc-c-arrow-1a15e320:after,.scc-c-tooltip--extra-large-1a15e320.scc-c-arrow-1a15e320:before{font-size:16px}.scc-c-tooltip--large-1a15e320{border-radius:4px;padding:20px;max-width:270px;word-wrap:break-word;line-height:1.42857;white-space:normal;font-size:14px}.scc-c-tooltip--large-1a15e320.scc-c-arrow-1a15e320:after,.scc-c-tooltip--large-1a15e320.scc-c-arrow-1a15e320:before{font-size:12px}.scc-c-tooltip--medium-1a15e320{border-radius:4px;padding:1em;max-width:140px;word-wrap:break-word;line-height:1.33333;white-space:normal}.scc-c-tooltip__paragraph-1a15e320{margin:0}.scc-c-tooltip__title-1a15e320{display:none;margin:0;font-weight:600}.scc-c-tooltip--large-1a15e320 .scc-c-tooltip__paragraph-1a15e320{margin-top:8px}.scc-c-tooltip--extra-large-1a15e320 .scc-c-tooltip__paragraph-1a15e320{margin-top:10px}.scc-c-tooltip--extra-large-1a15e320 .scc-c-tooltip__title-1a15e320,.scc-c-tooltip--large-1a15e320 .scc-c-tooltip__title-1a15e320{display:block}.scc-c-tooltip-1a15e320.scc-is-rtl-1a15e320{direction:rtl}.scc-c-tooltip--light-1a15e320{border:1px solid #d8dcde;-webkit-box-shadow:0 12px 20px 0 rgba(4,68,77,.15);box-shadow:0 12px 20px 0 rgba(4,68,77,.15);background-color:#fff;color:#49545c}.scc-c-tooltip--light-1a15e320.scc-c-arrow-1a15e320:after,.scc-c-tooltip--light-1a15e320.scc-c-arrow-1a15e320:before{font-size:9px}.scc-c-tooltip--light-1a15e320.scc-c-tooltip--large-1a15e320.scc-c-arrow-1a15e320:after,.scc-c-tooltip--light-1a15e320.scc-c-tooltip--large-1a15e320.scc-c-arrow-1a15e320:before{font-size:14px}.scc-c-tooltip--light-1a15e320.scc-c-tooltip--extra-large-1a15e320.scc-c-arrow-1a15e320:after,.scc-c-tooltip--light-1a15e320.scc-c-tooltip--extra-large-1a15e320.scc-c-arrow-1a15e320:before{font-size:18px}.scc-c-tooltip--light-1a15e320 .scc-c-tooltip__title-1a15e320{color:#2f3941}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"c-tooltip":"scc-c-tooltip-1a15e320","c-arrow":"scc-c-arrow-1a15e320","c-tooltip--extra-large":"scc-c-tooltip--extra-large-1a15e320","c-tooltip--large":"scc-c-tooltip--large-1a15e320","c-tooltip--medium":"scc-c-tooltip--medium-1a15e320","c-tooltip__paragraph":"scc-c-tooltip__paragraph-1a15e320","c-tooltip__title":"scc-c-tooltip__title-1a15e320","is-rtl":"scc-is-rtl-1a15e320","c-tooltip--light":"scc-c-tooltip--light-1a15e320"}


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _Text = __webpack_require__(690);

var _Text2 = _interopRequireDefault(_Text);

var _styles = __webpack_require__(693);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function (_ThemedComponent) {
  (0, _inherits3.default)(Link, _ThemedComponent);

  function Link(props, context) {
    (0, _classCallCheck3.default)(this, Link);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Link",
      styles: _styles2.default
    }));
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        disabled = _props.disabled,
        testId = _props.testId,
        other = (0, _objectWithoutProperties3.default)(_props, ["children", "className", "disabled", "testId"]);
    var theme = this.theme;


    return disabled ? _react2.default.createElement(
      _Text2.default,
      {
        className: (0, _classnames2.default)(theme.link, theme.disabled, className),
        testId: testId
      },
      children
    ) : _react2.default.createElement(
      "a",
      (0, _extends3.default)({}, other, {
        className: (0, _classnames2.default)(theme.link, className),
        "data-test-id": testId
      }),
      children
    );
  };

  return Link;
}(_ThemedComponent3.default);

Link.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  testId: _propTypes2.default.string,
  title: _propTypes2.default.string,
  /** <a href="#view">See View</a> */
  tooltipPositioning: function tooltipPositioning() {}
};
exports.default = Link;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Text = __webpack_require__(691);

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Text).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _styles = __webpack_require__(692);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Text = function (_Component) {
  (0, _inherits3.default)(Text, _Component);

  function Text() {
    (0, _classCallCheck3.default)(this, Text);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  Text.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        onClick = _props.onClick,
        tabIndex = _props.tabIndex,
        testId = _props.testId,
        title = _props.title,
        tooltipPositioning = _props.tooltipPositioning,
        others = (0, _objectWithoutProperties3.default)(_props, ["children", "className", "onClick", "tabIndex", "testId", "title", "tooltipPositioning"]);


    return _react2.default.createElement(
      _View2.default,
      (0, _extends3.default)({
        className: (0, _classnames2.default)(className, _styles2.default.container),
        testId: testId,
        onClick: onClick,
        tabIndex: tabIndex,
        title: title,
        tooltipPositioning: tooltipPositioning
      }, others),
      children
    );
  };

  return Text;
}(_react.Component);

Text.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number,
  testId: _propTypes2.default.string,
  /** Hiding advanced content within tooltips may have accessibility impacts */
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  /** One of: 'top', 'right', 'bottom', 'left' or as array (prioritization) */
  tooltipPositioning: function tooltipPositioning() {}
};
exports.default = Text;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: ".ssc-container-fa490c96{display:inline}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"container":"ssc-container-fa490c96"}


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: ".ssc-link-77929ab5{display:inline;text-decoration:none;color:#1f73b7;outline:0}.ssc-link-77929ab5:not(.ssc-disabled-77929ab5):focus{text-decoration:underline;outline:0}.ssc-link-77929ab5:hover{text-decoration:none;color:#1f73b7;outline:0}.ssc-link-77929ab5:active{text-decoration:none;color:#1f73b7;outline:0}.ssc-link-77929ab5.ssc-disabled-77929ab5{color:#ccc}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"link":"ssc-link-77929ab5","disabled":"ssc-disabled-77929ab5"}


/***/ }),
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Title; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_EditableText__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_EditableText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_EditableText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_TextInput__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_View__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_tags__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_urls__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__index_css__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__index_css__);




















var Title =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Title, _Component);

  function Title(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Title);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Title).call(this, props));
    _this.onChange = _this.onChange.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Title, [{
    key: "onChange",
    value: function onChange(value) {
      var onChange = this.props.onChange;

      if (value.length === 0) {
        return false;
      }

      onChange(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          userType = _this$props.userType,
          builtIn = _this$props.builtIn,
          actionButton = _this$props.actionButton;

      if (builtIn) {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.header
        }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.builtInTitleContainer
        }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.back
        }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* NavLink */], {
          to: Object(__WEBPACK_IMPORTED_MODULE_17__utils_urls__["b" /* getUserSegmentsUrl */])(),
          "data-test-id": "back-button"
        }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.back"))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h1", {
          className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.title
        }, void 0, name), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_tags__["Tag"], {
          className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.builtInLabel,
          type: "blue",
          "data-test-id": "built-in-label"
        }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.builtIn")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_tags__["Tag"], {
          className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.builtInLabel,
          type: "blue",
          "data-test-id": "user-type-label"
        }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()(__WEBPACK_IMPORTED_MODULE_16__constants__["g" /* USER_TYPE_NAME */][userType])))));
      }

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.header
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.back
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* NavLink */], {
        to: Object(__WEBPACK_IMPORTED_MODULE_17__utils_urls__["b" /* getUserSegmentsUrl */])(),
        "data-test-id": "back-button"
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.back"))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.titleWrapper
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_EditableText___default.a, {
        dir: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default.a.dir,
        value: name,
        onChange: this.onChange,
        testId: "edit-name",
        valueRenderer: function valueRenderer(_ref) {
          var containerProps = _ref.containerProps,
              value = _ref.value;
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_View___default.a, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, containerProps, {
            title: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.editName"),
            "aria-label": __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.nameFieldAriaLabel")
          }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h1", {
            className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.title
          }, void 0, value), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_EditableText___default.a.Icon, {
            className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.icon
          }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_tags__["Tag"], {
            className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.builtInLabel,
            type: "blue",
            "data-test-id": "user-type-label"
          }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()(__WEBPACK_IMPORTED_MODULE_16__constants__["g" /* USER_TYPE_NAME */][userType])));
        },
        inputRenderer: function inputRenderer(_ref2) {
          var inputProps = _ref2.inputProps,
              value = _ref2.inputProps.value;
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_TextInput___default.a, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, inputProps, {
            testId: "edit-name-input",
            validation: inputProps.value.length === 0 ? "error" : null,
            validationText: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.nameEmptyValidationError")
          }));
        }
      })), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.actionContainer
      }, void 0, actionButton));
    }
  }]);

  return Title;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);


Title.defaultProps = {
  name: "",
  builtIn: false,
  actionButton: null
};
Title.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string,
  userType: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].oneOf([__WEBPACK_IMPORTED_MODULE_16__constants__["e" /* STAFF */], __WEBPACK_IMPORTED_MODULE_16__constants__["d" /* SIGNED_IN_USERS */]]),
  builtIn: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  actionButton: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].node
};

/***/ }),
/* 782 */,
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _View = __webpack_require__(45);

var _View2 = _interopRequireDefault(_View);

var _TextInput = __webpack_require__(146);

var _TextInput2 = _interopRequireDefault(_TextInput);

var _Icon = __webpack_require__(786);

var _Icon2 = _interopRequireDefault(_Icon);

var _styles = __webpack_require__(296);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditableText = function (_ThemedComponent) {
  (0, _inherits3.default)(EditableText, _ThemedComponent);

  function EditableText(props, context) {
    (0, _classCallCheck3.default)(this, EditableText);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "EditableText",
      styles: _styles2.default
    }));

    _this.resetInput = function () {
      _this.setState({ isEditing: false, dirtyValue: null });
    };

    _this.getValue = function () {
      var value = _this.props.value;
      var dirtyValue = _this.state.dirtyValue;


      return typeof dirtyValue === "string" ? dirtyValue : value;
    };

    _this.submitValue = function (e) {
      var onChange = _this.props.onChange;


      if (onChange(_this.getValue()) !== false) {
        _this.resetInput();
      }
    };

    _this.onInputChange = function (dirtyValue) {
      _this.setState({ dirtyValue: dirtyValue });
    };

    _this.onInputEscape = function () {
      var onCancel = _this.props.onCancel;

      onCancel();
      _this.resetInput();
    };

    _this.startEditing = function () {
      _this.setState({ isEditing: true }, function () {
        var _this$inputField = _this.inputField,
            input = _this$inputField.input,
            value = _this$inputField.input.value;

        // Make sure that caret is moved to the end of the text value
        // (Timeout is for IE11)

        input.focus();
        setTimeout(function () {
          input.value = "";
          input.value = value;
        }, 0);
      });
    };

    _this.state = {
      isEditing: false,
      dirtyValue: null
    };
    return _this;
  }

  EditableText.prototype.componentDidMount = function componentDidMount() {
    var autoFocus = this.props.autoFocus;


    if (autoFocus) {
      this.startEditing();
    }
  };

  EditableText.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        autoFocus = _props.autoFocus,
        dir = _props.dir,
        testId = _props.testId,
        value = _props.value,
        valueRenderer = _props.valueRenderer,
        inputRenderer = _props.inputRenderer,
        title = _props.title,
        tooltipPositioning = _props.tooltipPositioning;
    var isEditing = this.state.isEditing;
    var theme = this.theme;


    return isEditing ? inputRenderer({
      inputProps: {
        autoFocus: autoFocus,
        dir: dir,
        className: theme.inputField,
        onBlur: this.submitValue,
        onChange: this.onInputChange,
        onEnter: this.submitValue,
        onEscape: this.onInputEscape,
        ref: function ref(input) {
          _this2.inputField = input;
        },
        testId: testId,
        value: this.getValue()
      }
    }) : valueRenderer({
      containerProps: {
        className: theme.valueContainer,
        dir: dir,
        onClick: this.startEditing,
        onFocus: this.startEditing,
        tabIndex: 0,
        testId: testId,
        title: title,
        tooltipPositioning: tooltipPositioning
      },
      value: value
    });
  };

  return EditableText;
}(_ThemedComponent3.default);

EditableText.propTypes = {
  autoFocus: _propTypes2.default.bool,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  value: _propTypes2.default.string,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  testId: _propTypes2.default.string,
  title: _propTypes2.default.string,
  /** Handler called when user hits ENTER. Tip: If the function returns `false`, submission will be prevented */
  onChange: _propTypes2.default.func,
  /** Handler called when user hits ESC on the input field */
  onCancel: _propTypes2.default.func,
  /** A custom render func for the value render-state of the component */
  valueRenderer: _propTypes2.default.func,
  /** A custom render func for the input render-state of the component */
  inputRenderer: _propTypes2.default.func,
  /** <a href="#view">See View</a> */
  tooltipPositioning: function tooltipPositioning() {}
};
EditableText.defaultProps = {
  dir: "ltr",
  onCancel: function onCancel() {},
  onChange: function onChange() {},
  inputRenderer: function inputRenderer(_ref // eslint-disable-line
  ) {
    var inputProps = _ref.inputProps;
    return _react2.default.createElement(_TextInput2.default, inputProps);
  },
  valueRenderer: function valueRenderer(_ref2 // eslint-disable-line
  ) {
    var containerProps = _ref2.containerProps,
        value = _ref2.value;
    return _react2.default.createElement(
      _View2.default,
      containerProps,
      value,
      _react2.default.createElement(_Icon2.default, null)
    );
  }
};


EditableText.Icon = _Icon2.default;

exports.default = EditableText;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Core = function (_Component) {
  (0, _inherits3.default)(Core, _Component);

  function Core() {
    (0, _classCallCheck3.default)(this, Core);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  Core.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        autoComplete = _props.autoComplete,
        autoFocus = _props.autoFocus,
        className = _props.className,
        defaultValue = _props.defaultValue,
        dir = _props.dir,
        disabled = _props.disabled,
        id = _props.id,
        isFocused = _props.isFocused,
        name = _props.name,
        maxLength = _props.maxLength,
        onArrowDown = _props.onArrowDown,
        onArrowLeft = _props.onArrowLeft,
        onArrowRight = _props.onArrowRight,
        onArrowUp = _props.onArrowUp,
        onClick = _props.onClick,
        onBlur = _props.onBlur,
        _onChange = _props.onChange,
        onDelete = _props.onDelete,
        onEnter = _props.onEnter,
        onEscape = _props.onEscape,
        onFocus = _props.onFocus,
        _onKeyDown = _props.onKeyDown,
        onPaste = _props.onPaste,
        placeholder = _props.placeholder,
        tabIndex = _props.tabIndex,
        testId = _props.testId,
        type = _props.type,
        value = _props.value,
        valueType = _props.valueType,
        innerRef = _props.innerRef;


    var handlers = {
      "8": onDelete,
      "13": onEnter,
      "27": onEscape,
      "37": onArrowLeft,
      "38": onArrowUp,
      "39": onArrowRight,
      "40": onArrowDown
    };

    var props = {
      autoFocus: autoFocus,
      autoComplete: autoComplete,
      className: className,
      "data-test-id": testId,
      defaultValue: typeof value === "undefined" ? defaultValue : undefined,
      dir: dir,
      disabled: disabled,
      id: id,
      name: name,
      maxLength: maxLength,
      onClick: onClick,
      onBlur: onBlur,
      onChange: function onChange(event) {
        _onChange && _onChange(event.target.value, event);
      },

      onFocus: onFocus,
      onKeyDown: function onKeyDown(event) {
        var handler = handlers[event.keyCode];
        handler && handler(event);
        _onKeyDown && _onKeyDown(event);
      },

      onPaste: onPaste,
      placeholder: placeholder,
      tabIndex: tabIndex,
      type: valueType || type,
      value: value
    };

    return _react2.default.createElement("input", (0, _extends3.default)({}, props, {
      ref: function ref(input) {
        _this2.input = input;
        input && isFocused && input.focus();
        innerRef && innerRef(input);
      }
    }));
  };

  return Core;
}(_react.Component);

Core.propTypes = {
  autoComplete: _propTypes2.default.oneOf(["on", "off"]),
  autoFocus: _propTypes2.default.bool,
  isFocused: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  disabled: _propTypes2.default.bool.isRequired,
  id: _propTypes2.default.string,
  name: _propTypes2.default.string,
  maxLength: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  onArrowDown: _propTypes2.default.func,
  onArrowLeft: _propTypes2.default.func,
  onArrowRight: _propTypes2.default.func,
  onArrowUp: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onEnter: _propTypes2.default.func,
  onEscape: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onPaste: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  tabIndex: _propTypes2.default.number,
  testId: _propTypes2.default.string,
  /** Use `valueType` instead */
  type: function type(props, propName, componentName) {
    if (propName in props) {
      return new Error("The TextInput does not accept a type prop use valueType instead");
    }
  },
  /** Supports all valid [Input types](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input) */
  valueType: _propTypes2.default.string,
  value: _propTypes2.default.string,
  innerRef: _propTypes2.default.func
};
Core.defaultProps = {
  autoComplete: "off",
  disabled: false,
  valueType: "text"
};
exports.default = Core;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)
__webpack_require__(113)

appendStyles({
  css: ".ssc-input-b60b6ac2{-webkit-appearance:none;-moz-appearance:none;appearance:none}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"txt":"ssc-txt-b60b6ac2 scc-c-txt-4506f8eb","message":"ssc-message-b60b6ac2 scc-c-txt__message-4506f8eb","input":"ssc-input-b60b6ac2 scc-c-txt__input-4506f8eb","style_bare":"ssc-style_bare-b60b6ac2 scc-c-txt__input--bare-4506f8eb","label":"ssc-label-b60b6ac2 scc-c-txt__label-4506f8eb","hint":"ssc-hint-b60b6ac2 scc-c-txt__hint-4506f8eb","size_small":"ssc-size_small-b60b6ac2 scc-c-txt__input--sm-4506f8eb","input_error":"ssc-input_error-b60b6ac2 scc-c-txt__input--error-4506f8eb","input_warning":"ssc-input_warning-b60b6ac2 scc-c-txt__input--warning-4506f8eb","input_success":"ssc-input_success-b60b6ac2 scc-c-txt__input--success-4506f8eb","message_error":"ssc-message_error-b60b6ac2 scc-c-txt__message--error-4506f8eb","message_warning":"ssc-message_warning-b60b6ac2 scc-c-txt__message--warning-4506f8eb","message_success":"ssc-message_success-b60b6ac2 scc-c-txt__message--success-4506f8eb","disabled":"ssc-disabled-b60b6ac2 scc-is-disabled-4506f8eb","rtl":"ssc-rtl-b60b6ac2 scc-is-rtl-4506f8eb"}


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(296);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({
      xmlns: "http://www.w3.org/2000/svg",
      width: "14",
      height: "14",
      viewBox: "0 0 14 14"
    }, props),
    _react2.default.createElement("path", {
      fill: "currentColor",
      d: "M3.4 12.4L1 13l.6-2.4L9 3.2 10.8 5zM11.153.99l1.838 1.838-1.48 1.484-1.84-1.838z"
    })
  );
};

var EditIcon = function EditIcon(_ref) {
  var className = _ref.className,
      size = _ref.size;
  return _react2.default.createElement(Icon, {
    className: (0, _classnames2.default)(_styles2.default.icon, className),
    width: size,
    height: size
  });
};

EditIcon.propTypes = {
  className: _propTypes2.default.string,
  size: _propTypes2.default.number
};

EditIcon.defaultProps = {
  size: 14
};

exports.default = EditIcon;

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"_-src-components-UserSegment-components-Title-index---header---STRWA","actionContainer":"_-src-components-UserSegment-components-Title-index---actionContainer---1Mqfj","titleWrapper":"_-src-components-UserSegment-components-Title-index---titleWrapper---Vnfr2","title":"_-src-components-UserSegment-components-Title-index---title---3a2Oa","builtInTitleContainer":"_-src-components-UserSegment-components-Title-index---builtInTitleContainer---18AYB","builtInLabel":"_-src-components-UserSegment-components-Title-index---builtInLabel---3caK6","editIcon":"_-src-components-UserSegment-components-Title-index---editIcon---cUwq7","back":"_-src-components-UserSegment-components-Title-index---back---3SLcR","icon":"_-src-components-UserSegment-components-Title-index---icon---as6Ds"};

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AutocompleteItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_SearchSelect__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_SearchSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_SearchSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_loaders__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_loaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_loaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_debounce__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_userSegment__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_groups__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions_organizations__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_tags__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);






















var ITEM_PROPS_MAPPING = {
  groups: {
    getItemId: function getItemId(item) {
      return item.id;
    },
    renderItem: function renderItem(item) {
      return item.name;
    }
  },
  organizations: {
    getItemId: function getItemId(item) {
      return item.id;
    },
    renderItem: function renderItem(item) {
      return item.name;
    }
  },
  tags: {
    getItemId: function getItemId(item) {
      return item;
    },
    renderItem: function renderItem(item) {
      return item;
    }
  }
};
var ACTIONS_MAPPING = {
  groups: __WEBPACK_IMPORTED_MODULE_18__actions_groups__,
  organizations: __WEBPACK_IMPORTED_MODULE_19__actions_organizations__,
  tags: __WEBPACK_IMPORTED_MODULE_20__actions_tags__
};
var USER_SEGMENT_ACTIONS_MAPPING = {
  groups: {
    add: __WEBPACK_IMPORTED_MODULE_17__actions_userSegment__["addGroup"],
    remove: __WEBPACK_IMPORTED_MODULE_17__actions_userSegment__["removeGroup"],
    change: __WEBPACK_IMPORTED_MODULE_17__actions_userSegment__["changeGroup"]
  },
  organizations: {
    add: __WEBPACK_IMPORTED_MODULE_17__actions_userSegment__["addOrganization"],
    remove: __WEBPACK_IMPORTED_MODULE_17__actions_userSegment__["removeOrganization"],
    change: __WEBPACK_IMPORTED_MODULE_17__actions_userSegment__["changeOrganization"]
  },
  tags: {
    add: __WEBPACK_IMPORTED_MODULE_17__actions_userSegment__["addTag"],
    remove: __WEBPACK_IMPORTED_MODULE_17__actions_userSegment__["removeTag"],
    change: __WEBPACK_IMPORTED_MODULE_17__actions_userSegment__["changeTag"]
  }
};

var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_loaders__["Spinner"], {});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_loaders__["Spinner"], {});

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_SearchSelect___default.a.Item, {
  disabled: true
}, "no-results", "No results");

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_SearchSelect___default.a.Separator, {}, "separator");

var AutocompleteItem =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(AutocompleteItem, _Component);

  function AutocompleteItem(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, AutocompleteItem);

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(AutocompleteItem).call(this, props));
    _this.state = {
      query: ""
    };
    _this.fetchAutocomplete = __WEBPACK_IMPORTED_MODULE_16_lodash_debounce___default()(_this.fetchAutocomplete.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this))), 300);
    _this.onSearchTextChanged = _this.onSearchTextChanged.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onChange = _this.onChange.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onRemove = _this.onRemove.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(AutocompleteItem, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          isInitialFetching = _this$props.isInitialFetching,
          isInitialLoaded = _this$props.isInitialLoaded,
          fetchInitial = _this$props.fetchInitial;

      if (!isInitialLoaded && !isInitialFetching) {
        fetchInitial();
      }
    }
  }, {
    key: "onSearchTextChanged",
    value: function onSearchTextChanged(query) {
      this.setState({
        query: query
      });
      this.fetchAutocomplete(query);
    }
  }, {
    key: "fetchAutocomplete",
    value: function fetchAutocomplete(query) {
      var _this$props2 = this.props,
          autocomplete = _this$props2.autocomplete,
          fetchAutocomplete = _this$props2.fetchAutocomplete;
      var autocompleteResult = autocomplete[query];

      if (!autocompleteResult || !autocompleteResult.isLoaded && !autocompleteResult.isLoading) {
        fetchAutocomplete(query);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(selectedItem) {
      var _this$props3 = this.props,
          newItem = _this$props3.newItem,
          item = _this$props3.item,
          change = _this$props3.change,
          onNewAdd = _this$props3.onNewAdd,
          getItemId = _this$props3.getItemId;

      if (!selectedItem) {
        return;
      }

      if (newItem) {
        onNewAdd(selectedItem);
      } else if (getItemId(item) !== getItemId(selectedItem)) {
        change(item, selectedItem);
      }

      this.setState({
        query: ""
      });
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      var _this$props4 = this.props,
          newItem = _this$props4.newItem,
          item = _this$props4.item,
          remove = _this$props4.remove,
          onNewRemove = _this$props4.onNewRemove;

      if (newItem) {
        onNewRemove();
      } else {
        remove(item);
      }
    }
  }, {
    key: "getApplicable",
    value: function getApplicable(items) {
      var _this$props5 = this.props,
          excludedItems = _this$props5.excludedItems,
          getItemId = _this$props5.getItemId;
      var excludedIds = excludedItems.map(getItemId);
      return items.filter(function (item) {
        return !excludedIds.includes(getItemId(item));
      });
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var query = this.state.query;
      var _this$props6 = this.props,
          initialList = _this$props6.initialList,
          isInitialFetching = _this$props6.isInitialFetching,
          autocomplete = _this$props6.autocomplete,
          renderItem = _this$props6.renderItem,
          getItemId = _this$props6.getItemId;
      var isIntial = query.length === 0;
      var results = autocomplete[query];

      if (isIntial && isInitialFetching) {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.loader,
          "data-test-id": "user-segment-tag-list-loader"
        }, void 0, _ref);
      }

      if (!isIntial && (!results || results.isFetching)) {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.loader,
          "data-test-id": "user-segment-tag-list-loader"
        }, void 0, _ref2);
      }

      var itemList = isIntial ? initialList : results.list;
      var items = itemList.length === 0 ? [_ref3] : this.getApplicable(itemList).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_SearchSelect___default.a.Item, {
          value: item
        }, getItemId(item), renderItem(item));
      });
      return [__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_SearchSelect___default.a.Item, {
        onClick: this.onRemove,
        testId: "remove-item"
      }, "remove", __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.remove")), _ref4].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(items));
    }
  }, {
    key: "render",
    value: function render() {
      var query = this.state.query;
      var _this$props7 = this.props,
          item = _this$props7.item,
          type = _this$props7.type,
          renderItem = _this$props7.renderItem;
      var selected = item ? renderItem(item) : __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.selectNew");
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_21__index_css___default.a.groupContainer
      }, void 0, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_SearchSelect___default.a, {
        testId: "user-segment-".concat(type),
        dir: __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default.a.dir,
        maxHeight: "250px",
        selected: selected,
        searchText: query,
        onSearchTextChanged: this.onSearchTextChanged,
        onChange: this.onChange,
        validation: item && item.deleted ? "error" : null,
        placeholder: __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.searchPlaceholder")
      }, void 0, this.renderItems()));
    }
  }]);

  return AutocompleteItem;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);
AutocompleteItem.propTypes = {
  newItem: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
  item: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].any,
  initialList: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].array,
  isInitialFetching: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
  isInitialLoaded: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
  fetchInitial: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  onNewAdd: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  onNewRemove: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  autocomplete: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].object,
  fetchAutocomplete: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  change: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  remove: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  excludedItems: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].array,
  renderItem: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  getItemId: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  type: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string
};
AutocompleteItem.defaultProps = {
  newItem: false,
  item: null,
  initialList: [],
  excludedItems: [],
  isInitialFetching: false,
  isInitialLoaded: false
};

var mapStateToProps = function mapStateToProps(state, _ref5) {
  var type = _ref5.type;
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({
    initialList: state[type].initialList,
    isInitialFetching: state[type].isInitialFetching,
    isInitialLoaded: state[type].isInitialLoaded,
    autocomplete: state[type].autocomplete,
    excludedItems: state.userSegment[type]
  }, ITEM_PROPS_MAPPING[type]);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref6) {
  var type = _ref6.type;
  return Object(__WEBPACK_IMPORTED_MODULE_15_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, ACTIONS_MAPPING[type], USER_SEGMENT_ACTIONS_MAPPING[type]), dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(AutocompleteItem));

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(44);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _uuid = __webpack_require__(82);

var _uuid2 = _interopRequireDefault(_uuid);

var _Popover = __webpack_require__(790);

var _Popover2 = _interopRequireDefault(_Popover);

var _SearchList = __webpack_require__(793);

var _SearchList2 = _interopRequireDefault(_SearchList);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _View = __webpack_require__(45);

var _View2 = _interopRequireDefault(_View);

var _Menu = __webpack_require__(109);

var _Menu2 = _interopRequireDefault(_Menu);

var _styles = __webpack_require__(299);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchSelect = function (_ThemedComponent) {
  (0, _inherits3.default)(SearchSelect, _ThemedComponent);

  function SearchSelect(props, context) {
    (0, _classCallCheck3.default)(this, SearchSelect);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "SearchSelect",
      styles: _styles2.default
    }));

    _this.getId = function () {
      return _this.props.id || _this.generatedId;
    };

    _this.focusAnchor = function () {
      _this.anchorElement && _this.anchorElement.focus();
    };

    _this.renderLabel = function () {
      var label = _this.props.label;
      var theme = _this.theme;


      return label ? _react2.default.createElement(
        "label",
        {
          className: theme.label,
          onClick: _this.focusAnchor,
          htmlFor: _this.getId()
        },
        label
      ) : null;
    };

    _this.generatedId = _uuid2.default.v4();
    _this.state = {
      hidden: true
    };
    return _this;
  }

  SearchSelect.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _props = this.props,
        onOpen = _props.onOpen,
        onClose = _props.onClose;
    var hidden = this.state.hidden;
    var prevHidden = prevState.hidden;


    if (hidden && !prevHidden) {
      onClose && onClose();
    } else if (!hidden && prevHidden) {
      onOpen && onOpen();
    }
  };

  SearchSelect.prototype.render = function render() {
    var _classNames,
        _this2 = this,
        _classNames2;

    var _props2 = this.props,
        children = _props2.children,
        dir = _props2.dir,
        disabled = _props2.disabled,
        hint = _props2.hint,
        maxHeight = _props2.maxHeight,
        _onSearchTextChanged = _props2.onSearchTextChanged,
        _onChange = _props2.onChange,
        onCollapseItem = _props2.onCollapseItem,
        onExpandItem = _props2.onExpandItem,
        placeholder = _props2.placeholder,
        positioning = _props2.positioning,
        searchText = _props2.searchText,
        selected = _props2.selected,
        size = _props2.size,
        stretched = _props2.stretched,
        tabIndex = _props2.tabIndex,
        testId = _props2.testId,
        validation = _props2.validation,
        validationText = _props2.validationText;
    var _state = this.state,
        focused = _state.focused,
        hidden = _state.hidden;
    var theme = this.theme;


    var anchor = _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(theme.input, theme["size_" + size], validation && theme["input_" + validation], (_classNames = {}, _classNames[theme.open] = !hidden, _classNames[theme.stretched] = stretched, _classNames)),
        id: this.getId(),
        onArrowDown: function onArrowDown(e) {
          e.preventDefault();
          _this2.setState({ hidden: false });
        },
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
        },
        onClick: function onClick(e) {
          if (!disabled && _this2.state.hidden) {
            _this2.setState({ hidden: false });
          }
        },
        onEnter: function onEnter() {
          return _this2.setState({ hidden: false });
        },
        onBlur: function onBlur() {
          return _this2.setState({ focused: false });
        },
        onFocus: function onFocus() {
          return _this2.setState({ focused: true });
        },
        onSpace: function onSpace(e) {
          _this2.setState({ hidden: false });
          e.preventDefault();
        },
        ref: function ref(_ref) {
          _this2.anchorElement = (0, _reactDom.findDOMNode)(_ref);
        },
        role: "button",
        tabIndex: disabled ? -1 : tabIndex
      },
      selected
    );

    return _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(theme.txt, (_classNames2 = {}, _classNames2[theme.disabled] = disabled, _classNames2[theme.focused] = focused, _classNames2[theme.rtl] = dir === "rtl", _classNames2[theme.stretched] = stretched, _classNames2)),
        dir: dir
      },
      this.renderLabel(),
      hint && _react2.default.createElement(
        "small",
        { className: theme.hint },
        hint
      ),
      _react2.default.createElement(
        _Popover2.default,
        {
          anchor: anchor,
          dir: dir,
          hidden: hidden,
          onMouseDown: function onMouseDown(event) {
            if (event.target.tagName !== "INPUT") {
              event.preventDefault();
            }
          },
          onOpen: this.onOpen,
          onClose: function onClose() {
            return _this2.setState({ hidden: true });
          },
          positioning: positioning,
          stretched: stretched,
          testId: testId
        },
        _react2.default.createElement(
          _SearchList2.default,
          {
            autoFocus: !hidden,
            placeholder: placeholder,
            maxHeight: maxHeight,
            searchText: searchText,
            onBlur: function onBlur() {
              _this2.setState({ hidden: true });
            },
            onEscape: function onEscape() {
              _this2.anchorElement && _this2.anchorElement.focus();
            },
            onSearchTextChanged: function onSearchTextChanged(value) {
              return _onSearchTextChanged && _onSearchTextChanged(value);
            },
            onChange: function onChange(value, event) {
              event.preventDefault();
              if (!_onChange || _onChange(value, event) !== false) {
                _this2.setState({ hidden: true });
                _this2.anchorElement && _this2.anchorElement.focus();
              }
            },
            onCollapseItem: onCollapseItem,
            onExpandItem: onExpandItem,
            testId: testId,
            wrapping: "clear"
          },
          children
        )
      ),
      validation && validationText && _react2.default.createElement(
        "small",
        {
          className: (0, _classnames2.default)(theme.message, validation && theme["message_" + validation])
        },
        validationText
      )
    );
  };

  return SearchSelect;
}(_ThemedComponent3.default);

SearchSelect.Item = _Menu2.default.Item;
SearchSelect.Separator = _Menu2.default.Separator;
SearchSelect.propTypes = {
  children: _propTypes2.default.node.isRequired,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  disabled: _propTypes2.default.bool,
  hint: _propTypes2.default.node,
  id: _propTypes2.default.string,
  label: _propTypes2.default.string,
  maxHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  onChange: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  onCollapseItem: _propTypes2.default.func,
  onExpandItem: _propTypes2.default.func,
  onOpen: _propTypes2.default.func,
  onSearchTextChanged: _propTypes2.default.func,
  positioning: _Popover2.default.propTypes.positioning,
  placeholder: _propTypes2.default.string,
  searchText: _propTypes2.default.string.isRequired,
  selected: _propTypes2.default.node,
  size: _propTypes2.default.oneOf(["small", "medium"]),
  stretched: _propTypes2.default.bool,
  tabIndex: _propTypes2.default.number,
  testId: _propTypes2.default.string,
  validation: _propTypes2.default.oneOf(["error", "warning", "success"]),
  validationText: _propTypes2.default.string
};
SearchSelect.defaultProps = {
  dir: "ltr",
  disabled: false,
  positioning: "bottom_stretch",
  searchText: "",
  size: "medium",
  stretched: true,
  tabIndex: 0
};
exports.default = SearchSelect;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _View = __webpack_require__(45);

var _View2 = _interopRequireDefault(_View);

var _RelativePositionedPopup = __webpack_require__(791);

var _RelativePositionedPopup2 = _interopRequireDefault(_RelativePositionedPopup);

var _Menu = __webpack_require__(109);

var _Menu2 = _interopRequireDefault(_Menu);

var _styles = __webpack_require__(792);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Popover = function (_ThemedComponent) {
  (0, _inherits3.default)(Popover, _ThemedComponent);

  function Popover(props, context) {
    (0, _classCallCheck3.default)(this, Popover);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Popover",
      styles: _styles2.default
    }));
  }

  Popover.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        arrow = _props.arrow,
        dir = _props.dir,
        centerArrow = _props.centerArrow,
        children = _props.children,
        hidden = _props.hidden,
        marginBottom = _props.marginBottom,
        marginLeft = _props.marginLeft,
        marginRight = _props.marginRight,
        marginTop = _props.marginTop,
        onClose = _props.onClose,
        positioning = _props.positioning,
        anchor = _props.anchor,
        stretched = _props.stretched,
        trapFocus = _props.trapFocus,
        testId = _props.testId,
        other = (0, _objectWithoutProperties3.default)(_props, ["arrow", "dir", "centerArrow", "children", "hidden", "marginBottom", "marginLeft", "marginRight", "marginTop", "onClose", "positioning", "anchor", "stretched", "trapFocus", "testId"]);


    var arrowMargin = arrow ? 3 : 0;

    var centerPoint = centerArrow ? 19 : null;

    var theme = this.theme;


    return _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(theme.container, (_classNames = {}, _classNames[theme.stretched] = stretched, _classNames))
      },
      _react2.default.createElement(
        _RelativePositionedPopup2.default,
        {
          anchor: anchor,
          dir: dir,
          centerPoint: centerPoint,
          hidden: hidden,
          marginTop: marginTop + arrowMargin,
          marginLeft: marginLeft + arrowMargin,
          marginRight: marginRight + arrowMargin,
          marginBottom: marginBottom + arrowMargin,
          onClickOutside: onClose,
          positioning: positioning,
          stretched: stretched,
          testId: testId,
          trapFocus: trapFocus
        },
        function (position) {
          return _react2.default.createElement(
            _Menu2.default.Container,
            (0, _extends3.default)({}, other, {
              animate: !hidden,
              dir: dir,
              arrow: arrow,
              position: position
            }),
            _react2.default.createElement(
              _View2.default,
              { onEscape: onClose },
              children
            )
          );
        }
      )
    );
  };

  return Popover;
}(_ThemedComponent3.default);

Popover.propTypes = {
  anchor: _propTypes2.default.element.isRequired,
  arrow: _propTypes2.default.bool,
  centerArrow: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.node.isRequired,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  fixedWidth: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool.isRequired,
  marginBottom: _propTypes2.default.number,
  marginLeft: _propTypes2.default.number,
  marginRight: _propTypes2.default.number,
  marginTop: _propTypes2.default.number,
  maxHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  onClose: _propTypes2.default.func,
  positioning: _RelativePositionedPopup2.default.propTypes.positioning,
  stretched: _propTypes2.default.bool,
  trapFocus: _propTypes2.default.bool,
  testId: _propTypes2.default.string,
  wide: _propTypes2.default.bool
};
Popover.defaultProps = {
  arrow: false,
  centerArrow: false,
  dir: "ltr",
  hidden: true,
  marginBottom: 2,
  marginLeft: 2,
  marginRight: 2,
  marginTop: 2,
  positioning: ["bottom_right", "top_right"],
  stretched: false,
  trapFocus: false,
  wide: false
};
exports.default = Popover;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _RelativePositionedPopup = __webpack_require__(275);

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RelativePositionedPopup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: ".ssc-container-f6aa342b{position:relative;display:inline-block}.ssc-stretched-f6aa342b{width:100%;height:100%;-ms-flex-preferred-size:auto;flex-basis:auto;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"container":"ssc-container-f6aa342b","stretched":"ssc-stretched-f6aa342b"}


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _List = __webpack_require__(794);

var _List2 = _interopRequireDefault(_List);

var _SearchInput = __webpack_require__(797);

var _SearchInput2 = _interopRequireDefault(_SearchInput);

var _ReactSingleSelectionModel = __webpack_require__(107);

var _ReactSingleSelectionModel2 = _interopRequireDefault(_ReactSingleSelectionModel);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _View = __webpack_require__(45);

var _View2 = _interopRequireDefault(_View);

var _styles = __webpack_require__(801);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchList = function (_ThemedComponent) {
  (0, _inherits3.default)(SearchList, _ThemedComponent);

  function SearchList(props, context) {
    (0, _classCallCheck3.default)(this, SearchList);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "SearchList",
      styles: _styles2.default
    }));

    _this.onSelectionChanged = function () {
      var onSelectionChanged = _this.props.onSelectionChanged;

      var items = _this.selectionModel.items;
      _this.setState({ items: items }, function () {
        onSelectionChanged && onSelectionChanged(_this.selectionModel.selection);
      });
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var children = nextProps.children;

      _this.setSelectableItems(children);
    };

    _this.selectionModel = new _ReactSingleSelectionModel2.default({
      selectOnSpace: false,
      wrapping: props.wrapping
    });
    _this.selectionModel.onSelectionChanged = _this.onSelectionChanged;
    _this.selectionModel.onValueChosen = props.onChange;
    _this.state = {
      items: []
    };
    return _this;
  }

  SearchList.prototype.setSelectableItems = function setSelectableItems(children) {
    this.selectionModel.items = children;
    this.setState({ items: this.selectionModel.items });
  };

  SearchList.prototype.componentWillMount = function componentWillMount() {
    var children = this.props.children;

    this.setSelectableItems(children);
  };

  SearchList.prototype.render = function render() {
    var _this2 = this,
        _classNames;

    var _props = this.props,
        autoFocus = _props.autoFocus,
        maxHeight = _props.maxHeight,
        _onBlur = _props.onBlur,
        onEscape = _props.onEscape,
        onFocus = _props.onFocus,
        onSearchTextChanged = _props.onSearchTextChanged,
        placeholder = _props.placeholder,
        searchText = _props.searchText,
        size = _props.size,
        testId = _props.testId;
    var items = this.state.items;

    var style = {};
    var hasMaxHeight = typeof maxHeight !== "undefined";

    if (hasMaxHeight) {
      style.maxHeight = typeof maxHeight === "number" ? maxHeight + "px" : maxHeight;
    }

    var theme = this.theme;


    return _react2.default.createElement(
      _View2.default,
      { className: (0, _classnames2.default)(theme.container, theme["size_" + size]) },
      _react2.default.createElement(
        _View2.default,
        { className: theme.search },
        _react2.default.createElement(_SearchInput2.default, {
          autoFocus: autoFocus,
          onBlur: function onBlur(e) {
            _this2.selectionModel.clear();
            _onBlur && _onBlur(e);
          },
          onChange: onSearchTextChanged,
          onEscape: onEscape,
          onFocus: onFocus,
          onKeyDown: this.selectionModel.handleKeyDown,
          placeholder: placeholder,
          size: "small",
          testId: testId && testId + "-search",
          value: searchText
        })
      ),
      _react2.default.createElement(
        _View2.default,
        {
          className: (0, _classnames2.default)((_classNames = {}, _classNames[theme.scrollable] = hasMaxHeight, _classNames)),
          testId: testId && testId + "-list",
          style: style
        },
        items
      )
    );
  };

  return SearchList;
}(_ThemedComponent3.default);

SearchList.Item = _List2.default.Item;
SearchList.Separator = _List2.default.Separator;
SearchList.propTypes = {
  autoFocus: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired,
  maxHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  onBlur: _propTypes2.default.func,
  onEscape: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onSearchTextChanged: _propTypes2.default.func,
  onSelectionChanged: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  searchText: _propTypes2.default.string.isRequired,
  size: _propTypes2.default.oneOf(["small", "medium"]),
  testId: _propTypes2.default.string,
  wrapping: _propTypes2.default.oneOf(["off", "clear", "items"])
};
SearchList.defaultProps = {
  dir: "ltr",
  wrapping: "items",
  size: "medium"
};
exports.default = SearchList;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ReactSingleSelectionModel = __webpack_require__(107);

var _ReactSingleSelectionModel2 = _interopRequireDefault(_ReactSingleSelectionModel);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _Menu = __webpack_require__(109);

var _Menu2 = _interopRequireDefault(_Menu);

var _View = __webpack_require__(45);

var _View2 = _interopRequireDefault(_View);

var _Item = __webpack_require__(795);

var _Item2 = _interopRequireDefault(_Item);

var _styles = __webpack_require__(298);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_ThemedComponent) {
  (0, _inherits3.default)(List, _ThemedComponent);

  function List(props, context) {
    (0, _classCallCheck3.default)(this, List);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "List",
      styles: _styles2.default
    }));

    _this.onSelectionChanged = function () {
      var onSelectionChanged = _this.props.onSelectionChanged;

      var items = _this.selectionModel.items;
      _this.setState({ items: items }, function () {
        onSelectionChanged && onSelectionChanged(_this.selectionModel.selection);
      });
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var children = nextProps.children;

      _this.setSelectableItems(children);
    };

    _this.selectionModel = new _ReactSingleSelectionModel2.default();
    _this.selectionModel.onSelectionChanged = _this.onSelectionChanged;
    _this.selectionModel.onValueChosen = props.onChange;
    _this.keyboard = true;
    _this.state = {
      items: []
    };
    return _this;
  }

  List.prototype.setSelectableItems = function setSelectableItems(children) {
    this.selectionModel.items = children;
    this.setState({ items: this.selectionModel.items });
  };

  List.prototype.componentWillMount = function componentWillMount() {
    var children = this.props.children;

    this.setSelectableItems(children);
  };

  List.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        size = _props.size,
        tabIndex = _props.tabIndex,
        testId = _props.testId;
    var items = this.state.items;
    var theme = this.theme;


    return _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(theme.list, theme["size_" + size]),
        onBlur: this.selectionModel.clear,
        onFocus: function onFocus() {
          if (!_this2.selectionModel.hasSelection() && _this2.keyboard) {
            _this2.selectionModel.reactivate();
          }
          _this2.keyboard = true;
        },
        onMouseDown: function onMouseDown() {
          _this2.keyboard = false;
          setTimeout(function () {
            _this2.keyboard = true;
          }, 0);
        },
        onKeyDown: this.selectionModel.handleKeyDown,
        role: "list",
        tabIndex: tabIndex,
        testId: testId
      },
      items
    );
  };

  return List;
}(_ThemedComponent3.default);

List.propTypes = {
  children: _propTypes2.default.node.isRequired,
  onSelectionChanged: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  size: _propTypes2.default.oneOf(["small", "medium"]),
  tabIndex: _propTypes2.default.number.isRequired,
  testId: _propTypes2.default.string
};
List.defaultProps = {
  size: "medium",
  tabIndex: 0
};
List.Item = _Item2.default;
List.Separator = _Menu2.default.Separator;
exports.default = List;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _Selectable = __webpack_require__(796);

var _Selectable2 = _interopRequireDefault(_Selectable);

var _View = __webpack_require__(45);

var _View2 = _interopRequireDefault(_View);

var _styles = __webpack_require__(298);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function (_ThemedComponent) {
  (0, _inherits3.default)(Item, _ThemedComponent);

  function Item(props, context) {
    (0, _classCallCheck3.default)(this, Item);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "List",
      styles: _styles2.default
    }));
  }

  Item.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        children = _props.children,
        disabled = _props.disabled,
        onMouseDown = _props.onMouseDown,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        role = _props.role,
        selected = _props.selected,
        testId = _props.testId;
    var theme = this.theme;


    return _react2.default.createElement(
      _View2.default,
      {
        "aria-activedescendant": selected,
        "aria-disabled": disabled,
        className: (0, _classnames2.default)(theme.item, (_classNames = {}, _classNames[theme.disabled] = disabled, _classNames[theme.selected] = selected, _classNames)),
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        role: role,
        testId: testId
      },
      children
    );
  };

  return Item;
}(_ThemedComponent3.default);

Item.propTypes = {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  onMouseDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  role: _propTypes2.default.string,
  selected: _propTypes2.default.bool,
  testId: _propTypes2.default.string,
  value: _propTypes2.default.any
};
Item.defaultProps = {
  disabled: false,
  role: "listitem"
};
exports.default = (0, _Selectable2.default)(Item, {
  action: function action(props, event) {
    var onClick = props.onClick,
        value = props.value;


    onClick && onClick(value, event);
  }
});

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Selectable = __webpack_require__(51);

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Selectable).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _uuid = __webpack_require__(82);

var _uuid2 = _interopRequireDefault(_uuid);

var _AutoFocus = __webpack_require__(798);

var _AutoFocus2 = _interopRequireDefault(_AutoFocus);

var _TextInput = __webpack_require__(146);

var _TextInput2 = _interopRequireDefault(_TextInput);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _View = __webpack_require__(45);

var _View2 = _interopRequireDefault(_View);

var _styles = __webpack_require__(800);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchIcon = function SearchIcon(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({
      xmlns: "http://www.w3.org/2000/svg",
      width: "14",
      height: "14",
      viewBox: "0 0 14 14"
    }, props),
    _react2.default.createElement(
      "g",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: "1.5"
      },
      _react2.default.createElement("circle", {
        cx: "6",
        cy: "6",
        r: "4",
        fill: "none"
      }),
      _react2.default.createElement("path", {
        d: "M9 9l3 3"
      })
    )
  );
};

var RemoveIcon = function RemoveIcon(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({
      xmlns: "http://www.w3.org/2000/svg",
      width: "14",
      height: "14",
      viewBox: "0 0 14 14"
    }, props),
    _react2.default.createElement("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      d: "M4 10l6-6M4 4l6 6"
    })
  );
};

var SearchInput = function (_ThemedComponent) {
  (0, _inherits3.default)(SearchInput, _ThemedComponent);

  function SearchInput(props, context) {
    (0, _classCallCheck3.default)(this, SearchInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "SearchInput",
      styles: _styles2.default
    }));

    _this.getId = function () {
      return _this.props.id || _this.generatedId;
    };

    _this.renderLabel = function () {
      var label = _this.props.label;
      var theme = _this.theme;


      if (!label) {
        return null;
      }

      return _react2.default.createElement(
        "label",
        { className: theme.label, htmlFor: _this.getId() },
        label
      );
    };

    _this.generatedId = _uuid2.default.v4();
    return _this;
  }

  SearchInput.prototype.render = function render() {
    var _classNames, _classNames2;

    var _props = this.props,
        autoFocus = _props.autoFocus,
        hint = _props.hint,
        disabled = _props.disabled,
        onChange = _props.onChange,
        _props$onClear = _props.onClear,
        onClear = _props$onClear === undefined ? function (event) {
      return onChange && onChange("", event);
    } : _props$onClear,
        size = _props.size,
        value = _props.value,
        other = (0, _objectWithoutProperties3.default)(_props, ["autoFocus", "hint", "disabled", "onChange", "onClear", "size", "value"]);
    var theme = this.theme;


    return _react2.default.createElement(
      _View2.default,
      { className: (0, _classnames2.default)(theme.txt, theme["size_" + size]) },
      this.renderLabel(),
      hint && _react2.default.createElement(
        "small",
        { className: theme.hint },
        hint
      ),
      _react2.default.createElement(
        _View2.default,
        { className: theme.container },
        _react2.default.createElement(
          _AutoFocus2.default,
          { stretched: true, condition: autoFocus },
          _react2.default.createElement(_TextInput2.default.Core, (0, _extends3.default)({}, other, {
            disabled: disabled,
            className: theme.input,
            id: this.getId(),
            onChange: onChange,
            valueType: "search",
            value: value
          }))
        ),
        _react2.default.createElement(
          _View2.default,
          {
            className: (0, _classnames2.default)(theme.search, (_classNames = {}, _classNames[theme.search_hide] = value, _classNames))
          },
          _react2.default.createElement(SearchIcon, null)
        ),
        _react2.default.createElement(
          _View2.default,
          {
            className: (0, _classnames2.default)(theme.clear, (_classNames2 = {}, _classNames2[theme.clear_show] = value, _classNames2[theme.disabled] = disabled, _classNames2)),
            disabled: disabled,
            onMouseDown: function onMouseDown(e) {
              e.preventDefault();
              e.stopPropagation();
              if (!disabled) {
                onClear && onClear(value, e);
              }
            }
          },
          _react2.default.createElement(RemoveIcon, null)
        )
      )
    );
  };

  return SearchInput;
}(_ThemedComponent3.default);

SearchInput.propTypes = {
  autoFocus: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  hint: _propTypes2.default.node,
  name: _propTypes2.default.string,
  onArrowDown: _propTypes2.default.func,
  onArrowLeft: _propTypes2.default.func,
  onArrowRight: _propTypes2.default.func,
  onArrowUp: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onClear: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onEnter: _propTypes2.default.func,
  onEscape: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(["small", "medium"]),
  tabIndex: _propTypes2.default.number,
  testId: _propTypes2.default.string,
  value: _propTypes2.default.string
};
SearchInput.defaultProps = {
  size: "medium",
  autoFocus: false
};
exports.default = SearchInput;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(44);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(29);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _View = __webpack_require__(45);

var _View2 = _interopRequireDefault(_View);

var _styles = __webpack_require__(799);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoFocus = function (_ThemedComponent) {
  (0, _inherits3.default)(AutoFocus, _ThemedComponent);

  function AutoFocus(props, context) {
    (0, _classCallCheck3.default)(this, AutoFocus);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "AutoFocus",
      styles: _styles2.default
    }));

    _this.grabFocus = function () {
      setTimeout(function () {
        _this.domNode && _this.domNode.firstChild.focus();
      }, 0);
    };

    return _this;
  }

  AutoFocus.prototype.componentDidMount = function componentDidMount() {
    var condition = this.props.condition;


    if (condition) {
      this.grabFocus();
    }
  };

  AutoFocus.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!this.props.condition && nextProps.condition) {
      this.grabFocus();
    }
  };

  AutoFocus.prototype.render = function render() {
    var _classNames,
        _this2 = this;

    var _props = this.props,
        children = _props.children,
        className = _props.className,
        stretched = _props.stretched,
        other = (0, _objectWithoutProperties3.default)(_props, ["children", "className", "stretched"]);


    delete other.condition;

    var theme = this.theme;


    return _react2.default.createElement(
      _View2.default,
      (0, _extends3.default)({}, other, {
        className: (0, _classnames2.default)((_classNames = {}, _classNames[theme.stretched] = stretched, _classNames), className),
        ref: function ref(_ref) {
          _this2.domNode = (0, _reactDom.findDOMNode)(_ref);
        }
      }),
      children
    );
  };

  return AutoFocus;
}(_ThemedComponent3.default);

AutoFocus.propTypes = {
  children: _propTypes2.default.element.isRequired,
  className: _propTypes2.default.string,
  condition: _propTypes2.default.bool,
  stretched: _propTypes2.default.bool
};
AutoFocus.defaultProps = {
  condition: true,
  stretched: false
};
exports.default = AutoFocus;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: ".ssc-stretched-f173244c{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;height:100%;-ms-flex-preferred-size:auto;flex-basis:auto;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"stretched":"ssc-stretched-f173244c"}


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)
__webpack_require__(113)

appendStyles({
  css: ".ssc-txt-ac2aa228{width:100%;-ms-flex-preferred-size:auto;flex-basis:auto;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.ssc-container-ac2aa228{position:relative}.ssc-hint-ac2aa228{margin-bottom:8px}.ssc-input-ac2aa228::-webkit-search-cancel-button,.ssc-input-ac2aa228::-webkit-search-decoration,.ssc-input-ac2aa228::-webkit-search-results-button,.ssc-input-ac2aa228::-webkit-search-results-decoration{display:none}.ssc-input-ac2aa228::-ms-clear,.ssc-input-ac2aa228::-ms-reveal{display:none}.ssc-size_small-ac2aa228 .ssc-input-ac2aa228{line-height:20px;height:32px;min-height:32px;padding-top:0;padding-right:32px;padding-bottom:0}[dir=rtl] .ssc-size_small-ac2aa228 .ssc-input-ac2aa228{padding:.7142857143em 1.4285714286em;padding-left:32px}.ssc-size_medium-ac2aa228 .ssc-input-ac2aa228{padding-right:34px}[dir=rtl] .ssc-size_medium-ac2aa228 .ssc-input-ac2aa228{padding:.7142857143em 1.4285714286em;padding-left:34px}.ssc-search-ac2aa228{position:absolute;top:1px;right:12px;display:-webkit-box;display:-ms-flexbox;display:flex;width:24px;height:calc(100% - 2px);-webkit-transition:opacity .2s .3s ease-in-out,right .2s .3s ease-in-out;transition:opacity .2s .3s ease-in-out,right .2s .3s ease-in-out;opacity:.5;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[dir=rtl] .ssc-search-ac2aa228{right:auto;left:12px}.ssc-search_hide-ac2aa228{right:-12px;-webkit-transition:opacity .3s ease-in-out,right .3s ease-in-out;transition:opacity .3s ease-in-out,right .3s ease-in-out;opacity:0}.ssc-clear-ac2aa228{position:absolute;z-index:1;top:0;right:12px;display:-webkit-box;display:-ms-flexbox;display:flex;width:24px;height:100%;cursor:pointer;-webkit-transition:visibility 0s,opacity .4s;transition:visibility 0s,opacity .4s;opacity:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ssc-clear-ac2aa228.ssc-disabled-ac2aa228{cursor:default}[dir=rtl] .ssc-clear-ac2aa228{right:auto;left:12px}.ssc-clear_show-ac2aa228{visibility:visible;-webkit-transition:visibility 0s,opacity .8s;transition:visibility 0s,opacity .8s;opacity:.5}.ssc-size_medium-ac2aa228 .ssc-search-ac2aa228{background-size:18px}.ssc-size_medium-ac2aa228 .ssc-clear-ac2aa228{background-size:20px}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"txt":"ssc-txt-ac2aa228 scc-c-txt-4506f8eb","container":"ssc-container-ac2aa228","input":"ssc-input-ac2aa228 scc-c-txt__input-4506f8eb","label":"ssc-label-ac2aa228 scc-c-txt__label-4506f8eb","hint":"ssc-hint-ac2aa228 scc-c-txt__hint-4506f8eb","size_small":"ssc-size_small-ac2aa228","size_medium":"ssc-size_medium-ac2aa228","search":"ssc-search-ac2aa228","search_hide":"ssc-search_hide-ac2aa228","clear":"ssc-clear-ac2aa228","disabled":"ssc-disabled-ac2aa228","clear_show":"ssc-clear_show-ac2aa228"}


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)
__webpack_require__(199)

appendStyles({
  css: ".ssc-container-d4614240{padding:0}.ssc-search-d4614240{padding:10px;padding-top:3px}.ssc-scrollable-d4614240{overflow-x:hidden;overflow-y:auto}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"container":"ssc-container-d4614240","search":"ssc-search-d4614240","scrollable":"ssc-scrollable-d4614240","size_small":"ssc-size_small-d4614240 scc-c-menu--sm-526a8b12"}


/***/ }),
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchInitial"] = fetchInitial;
/* harmony export (immutable) */ __webpack_exports__["fetchAutocomplete"] = fetchAutocomplete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__);


var GROUPS_URL = "/api/v2/groups.json";
var AUTOCOMPLETE_URL = "/api/v2/groups/autocomplete.json";

function fetchInitialGroupsRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["e" /* FETCH_INITIAL_GROUPS_REQUEST */]
  };
}

function fetchInitialGroupsSuccess(groups) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["f" /* FETCH_INITIAL_GROUPS_SUCCESS */],
    groups: groups
  };
}

function fetchInitialGroupsFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["d" /* FETCH_INITIAL_GROUPS_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchInitial() {
  return function (dispatch) {
    dispatch(fetchInitialGroupsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])(GROUPS_URL).then(function (_ref) {
      var groups = _ref.groups;
      return dispatch(fetchInitialGroupsSuccess(groups));
    }).catch(function (err) {
      dispatch(fetchInitialGroupsFailure(err));
    });
  };
}

function fetchAutocompleteGroupsRequest(query) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["b" /* FETCH_AUTOCOMPLETE_GROUPS_REQUEST */],
    query: query
  };
}

function fetchAutocompleteGroupsSuccess(query, groups) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* FETCH_AUTOCOMPLETE_GROUPS_SUCCESS */],
    query: query,
    groups: groups
  };
}

function fetchAutocompleteGroupsFailure(error, query) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["a" /* FETCH_AUTOCOMPLETE_GROUPS_FAILURE */],
    error: true,
    payload: error,
    query: query
  };
}

function fetchAutocomplete(query) {
  return function (dispatch) {
    dispatch(fetchAutocompleteGroupsRequest(query));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])("".concat(AUTOCOMPLETE_URL, "?name=").concat(query)).then(function (_ref2) {
      var groups = _ref2.groups;
      return dispatch(fetchAutocompleteGroupsSuccess(query, groups));
    }).catch(function (err) {
      dispatch(fetchAutocompleteGroupsFailure(err, query));
    });
  };
}

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchInitial"] = fetchInitial;
/* harmony export (immutable) */ __webpack_exports__["fetchAutocomplete"] = fetchAutocomplete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__);


var ORGANIZATIONS_URL = "/api/v2/organizations.json";
var AUTOCOMPLETE_URL = "/api/v2/organizations/autocomplete.json";

function fetchInitialOrganizationsRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["e" /* FETCH_INITIAL_ORGANIZATIONS_REQUEST */]
  };
}

function fetchInitialOrganizationsSuccess(organizations) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["f" /* FETCH_INITIAL_ORGANIZATIONS_SUCCESS */],
    organizations: organizations
  };
}

function fetchInitialOrganizationsFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["d" /* FETCH_INITIAL_ORGANIZATIONS_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchInitial() {
  return function (dispatch) {
    dispatch(fetchInitialOrganizationsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])(ORGANIZATIONS_URL).then(function (_ref) {
      var organizations = _ref.organizations;
      return dispatch(fetchInitialOrganizationsSuccess(organizations));
    }).catch(function (err) {
      dispatch(fetchInitialOrganizationsFailure(err));
    });
  };
}

function fetchAutocompleteOrganizationsRequest(query) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["b" /* FETCH_AUTOCOMPLETE_ORGANIZATIONS_REQUEST */],
    query: query
  };
}

function fetchAutocompleteOrganizationsSuccess(query, organizations) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* FETCH_AUTOCOMPLETE_ORGANIZATIONS_SUCCESS */],
    query: query,
    organizations: organizations
  };
}

function fetchAutocompleteOrganizationsFailure(error, query) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["a" /* FETCH_AUTOCOMPLETE_ORGANIZATIONS_FAILURE */],
    error: true,
    payload: error,
    query: query
  };
}

function fetchAutocomplete(query) {
  return function (dispatch) {
    dispatch(fetchAutocompleteOrganizationsRequest(query));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])("".concat(AUTOCOMPLETE_URL, "?name=").concat(query)).then(function (_ref2) {
      var organizations = _ref2.organizations;
      return dispatch(fetchAutocompleteOrganizationsSuccess(query, organizations));
    }).catch(function (err) {
      dispatch(fetchAutocompleteOrganizationsFailure(err, query));
    });
  };
}

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchInitial"] = fetchInitial;
/* harmony export (immutable) */ __webpack_exports__["fetchAutocomplete"] = fetchAutocomplete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__);


var TAGS_URL = "/api/v2/tags.json";
var AUTOCOMPLETE_URL = "/api/v2/autocomplete/tags.json";

function fetchInitialTagsRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["e" /* FETCH_INITIAL_TAGS_REQUEST */]
  };
}

function fetchInitialTagsSuccess(tags) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["f" /* FETCH_INITIAL_TAGS_SUCCESS */],
    tags: tags
  };
}

function fetchInitialTagsFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["d" /* FETCH_INITIAL_TAGS_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchInitial() {
  return function (dispatch) {
    dispatch(fetchInitialTagsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])(TAGS_URL).then(function (_ref) {
      var tags = _ref.tags;
      return dispatch(fetchInitialTagsSuccess(tags));
    }).catch(function (err) {
      dispatch(fetchInitialTagsFailure(err));
    });
  };
}

function fetchAutocompleteTagsRequest(query) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["b" /* FETCH_AUTOCOMPLETE_TAGS_REQUEST */],
    query: query
  };
}

function fetchAutocompleteTagsSuccess(query, tags) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* FETCH_AUTOCOMPLETE_TAGS_SUCCESS */],
    query: query,
    tags: tags
  };
}

function fetchAutocompleteTagsFailure(error, query) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["a" /* FETCH_AUTOCOMPLETE_TAGS_FAILURE */],
    error: true,
    payload: error,
    query: query
  };
}

function fetchAutocomplete(query) {
  return function (dispatch) {
    dispatch(fetchAutocompleteTagsRequest(query));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])("".concat(AUTOCOMPLETE_URL, "?name=").concat(query)).then(function (_ref2) {
      var tags = _ref2.tags;
      return dispatch(fetchAutocompleteTagsSuccess(query, tags));
    }).catch(function (err) {
      dispatch(fetchAutocompleteTagsFailure(err, query));
    });
  };
}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"groupContainer":"_-src-components-AutocompleteList-components-AutocompleteItem-index---groupContainer---1oYss","loader":"_-src-components-AutocompleteList-components-AutocompleteItem-index---loader---E5cvh"};

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"conjunction":"_-src-components-AutocompleteList-index---conjunction---1TAEV","list":"_-src-components-AutocompleteList-index---list---1REMR","itemWrapper":"_-src-components-AutocompleteList-index---itemWrapper---7DX72","itemHeader":"_-src-components-AutocompleteList-index---itemHeader---xUvZb","itemDescription":"_-src-components-AutocompleteList-index---itemDescription---svINx","onlyNewButton":"_-src-components-AutocompleteList-index---onlyNewButton---2YsNG","error":"_-src-components-AutocompleteList-index---error---1jK08","loader":"_-src-components-AutocompleteList-index---loader---1g1Zx"};

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(31);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _styles = __webpack_require__(812);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizes = ["small", "medium", "large"];

var Avatar = function (_Component) {
  (0, _inherits3.default)(Avatar, _Component);

  function Avatar() {
    (0, _classCallCheck3.default)(this, Avatar);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  Avatar.prototype.render = function render() {
    var _props = this.props,
        alt = _props.alt,
        className = _props.className,
        onError = _props.onError,
        onLoad = _props.onLoad,
        src = _props.src,
        size = _props.size,
        tabIndex = _props.tabIndex,
        testId = _props.testId,
        type = _props.type,
        title = _props.title,
        tooltipPositioning = _props.tooltipPositioning,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ["alt", "className", "onError", "onLoad", "src", "size", "tabIndex", "testId", "type", "title", "tooltipPositioning"]);


    var classes = [_styles2.default.avatar, _styles2.default["type_" + type]];

    var avatarStyles = {};

    if (sizes.includes(size)) {
      classes.push(_styles2.default["size_" + size]);
    } else {
      avatarStyles.height = size;
      avatarStyles.width = size;
    }

    return _react2.default.createElement(
      _View2.default,
      (0, _extends3.default)({
        className: (0, _classnames2.default)(classes, className),
        style: avatarStyles,
        tabIndex: tabIndex,
        testId: testId,
        title: title,
        tooltipPositioning: tooltipPositioning
      }, otherProps),
      _react2.default.createElement("img", { alt: alt, src: src, onError: onError, onLoad: onLoad })
    );
  };

  return Avatar;
}(_react.Component);

Avatar.propTypes = {
  alt: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onError: _propTypes2.default.func,
  onLoad: _propTypes2.default.func,
  src: _propTypes2.default.string.isRequired,
  size: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(sizes), _propTypes2.default.number, _propTypes2.default.string]).isRequired,
  tabIndex: _propTypes2.default.number,
  testId: _propTypes2.default.string,
  /** Must be wrapped by a <a href="#tooltipprovider">TooltipProvider</a> */
  title: _propTypes2.default.string,
  /** <a href="#view">See View</a> for positioning options */
  tooltipPositioning: function tooltipPositioning() {},
  type: _propTypes2.default.oneOf(["human", "system"]).isRequired
};
Avatar.defaultProps = {
  alt: "",
  size: "medium",
  type: "human"
};
exports.default = Avatar;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;


__webpack_require__(813)

exports.default = {"avatar":"ssc-avatar-79145ce7 scc-c-avatar-37b91cee","size_small":"ssc-size_small-79145ce7 scc-c-avatar--small-37b91cee","size_large":"ssc-size_large-79145ce7 scc-c-avatar--large-37b91cee","type_system":"ssc-type_system-79145ce7 scc-c-avatar--system-37b91cee"}


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(10)


appendStyles({
  css: "/*!\n * Copyright Zendesk, Inc.\n *\n * Use of this source code is governed under the Apache License, Version 2.0\n * found at http://www.apache.org/licenses/LICENSE-2.0.\n */.scc-c-avatar-37b91cee{display:inline-block;-webkit-transition:background-color .3s;transition:background-color .3s;margin:0;border:1px solid transparent;border-radius:50%;width:34px;height:34px;-webkit-box-sizing:border-box;box-sizing:border-box}.scc-c-avatar-37b91cee>img,.scc-c-avatar__img-37b91cee{-webkit-transition:all .3s;transition:all .3s;border:1px solid #d8dcde;border-radius:50%;background-clip:content-box;background-color:#fff;width:100%;height:100%;-webkit-box-sizing:inherit;box-sizing:inherit;vertical-align:bottom}.scc-c-avatar--large-37b91cee{border-width:2px;width:52px;height:52px}.scc-c-avatar--small-37b91cee{width:26px;height:26px}.scc-c-avatar-37b91cee.scc-is-disabled-37b91cee{background-color:#d8dcde}.scc-c-avatar-37b91cee.scc-is-disabled-37b91cee .scc-c-avatar__img-37b91cee,.scc-c-avatar-37b91cee.scc-is-disabled-37b91cee>img{-webkit-transform:translateZ(0);transform:translateZ(0);filter:url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"grayscale\"><feColorMatrix values=\".3333 .3333 .3333 0 0 .3333 .3333 .3333 0 0 .3333 .3333 .3333 0 0 0 0 0 1 0\"/></filter></svg>#grayscale');filter:gray;-webkit-filter:grayscale(100%);border-color:transparent;opacity:.5}.scc-c-avatar--borderless-37b91cee .scc-c-avatar__img-37b91cee,.scc-c-avatar--borderless-37b91cee>img{border-color:transparent}.scc-c-avatar--system-37b91cee{border-radius:4px}.scc-c-avatar--system-37b91cee.scc-c-avatar--large-37b91cee{border-radius:5px}.scc-c-avatar--system-37b91cee .scc-c-avatar__img-37b91cee,.scc-c-avatar--system-37b91cee>img{border-radius:3px}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"c-avatar":"scc-c-avatar-37b91cee","c-avatar__img":"scc-c-avatar__img-37b91cee","c-avatar--large":"scc-c-avatar--large-37b91cee","c-avatar--small":"scc-c-avatar--small-37b91cee","is-disabled":"scc-is-disabled-37b91cee","c-avatar--borderless":"scc-c-avatar--borderless-37b91cee","c-avatar--system":"scc-c-avatar--system-37b91cee"}


/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"c-table":"_-src-components-UserSegment-components-UserList-index---c-table---22Ah2","c-table__caption":"_-src-components-UserSegment-components-UserList-index---c-table__caption---320K8","c-table__row":"_-src-components-UserSegment-components-UserList-index---c-table__row---3Tz_r","c-table__row--group":"_-src-components-UserSegment-components-UserList-index---c-table__row--group---21hJI","c-table__row--header":"_-src-components-UserSegment-components-UserList-index---c-table__row--header---2kzL2","c-table__row--stripe":"_-src-components-UserSegment-components-UserList-index---c-table__row--stripe---2FJA2","c-table__row__cell":"_-src-components-UserSegment-components-UserList-index---c-table__row__cell---1lZlu","c-table__row__cell--min":"_-src-components-UserSegment-components-UserList-index---c-table__row__cell--min---3KrnQ","c-table__row__cell--truncate":"_-src-components-UserSegment-components-UserList-index---c-table__row__cell--truncate---1OR4v","c-table__row__cell--overflow":"_-src-components-UserSegment-components-UserList-index---c-table__row__cell--overflow---2b9Yz","is-hovered":"_-src-components-UserSegment-components-UserList-index---is-hovered---1i97W","is-focused":"_-src-components-UserSegment-components-UserList-index---is-focused---1jj9I","is-selected":"_-src-components-UserSegment-components-UserList-index---is-selected---2-B0F","c-table__row__cell__overflow":"_-src-components-UserSegment-components-UserList-index---c-table__row__cell__overflow---2yxxC","c-table--lg":"_-src-components-UserSegment-components-UserList-index---c-table--lg---p7Xlk","c-table--sm":"_-src-components-UserSegment-components-UserList-index---c-table--sm---kQD5s","is-active":"_-src-components-UserSegment-components-UserList-index---is-active---2QrbL","c-menu":"_-src-components-UserSegment-components-UserList-index---c-menu---2CQhs","c-table__row__cell__sortable":"_-src-components-UserSegment-components-UserList-index---c-table__row__cell__sortable---1RJlv","is-ascending":"_-src-components-UserSegment-components-UserList-index---is-ascending---2vu8G","is-descending":"_-src-components-UserSegment-components-UserList-index---is-descending---tY7ux","is-rtl":"_-src-components-UserSegment-components-UserList-index---is-rtl---3MpIk","avatar":"_-src-components-UserSegment-components-UserList-index---avatar---2QLRw","name":"_-src-components-UserSegment-components-UserList-index---name---f1CT-","cell":"_-src-components-UserSegment-components-UserList-index---cell---NRT8F","table":"_-src-components-UserSegment-components-UserList-index---table---2LGEL","title":"_-src-components-UserSegment-components-UserList-index---title---W8J1i","description":"_-src-components-UserSegment-components-UserList-index---description---3GGGX","loader":"_-src-components-UserSegment-components-UserList-index---loader---3NFUk"};

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentView":"_-src-components-UserSegment-index---contentView---25kop","userSegmentContent":"_-src-components-UserSegment-index---userSegmentContent---RZp_Z","loader":"_-src-components-UserSegment-index---loader---27KQq","content":"_-src-components-UserSegment-index---content---_LV0F","resrtrictionsTitle":"_-src-components-UserSegment-index---resrtrictionsTitle---33N_o","contentWrapper":"_-src-components-UserSegment-index---contentWrapper---23KlS","primaryContent":"_-src-components-UserSegment-index---primaryContent---1IfM9","description":"_-src-components-UserSegment-index---description---2e46g"};

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NewUserSegment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_self_service_components_lib_Button__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_self_service_components_lib_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_self_service_components_lib_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_isEqual__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_context__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_components_lib_Wizard__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_components_lib_Wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_components_lib_Wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_urls__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions_userSegment__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Notifications__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__UserSegment_components_UserList__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_SetupStep__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_SegmentStep__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_ReviewStep__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__index_css__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__index_css__);





























var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_24__components_SetupStep__["a" /* default */], {});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_25__components_SegmentStep__["a" /* default */], {});

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_26__components_ReviewStep__["a" /* default */], {});

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_24__components_SetupStep__["a" /* default */], {});

var _ref5 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref6 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref7 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_22__Notifications__["a" /* default */], {});

var _ref8 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_23__UserSegment_components_UserList__["a" /* default */], {});

var NewUserSegment =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(NewUserSegment, _Component);

  function NewUserSegment(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, NewUserSegment);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(NewUserSegment).call(this, props));
    _this.state = {
      currentStep: __WEBPACK_IMPORTED_MODULE_19__constants__["c" /* CREATE_STEP_SETUP */]
    };
    _this.onNext = _this.onNext.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onCreate = _this.onCreate.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onBack = _this.onBack.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onCancel = _this.onCancel.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onBeforeUnload = _this.onBeforeUnload.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(NewUserSegment, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("beforeunload", this.onBeforeUnload);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var resetUserSegment = this.props.resetUserSegment;
      resetUserSegment();
      window.removeEventListener("beforeunload", this.onBeforeUnload);
    }
  }, {
    key: "onBeforeUnload",
    value: function onBeforeUnload(e) {
      var hasChanges = this.props.hasChanges;

      if (hasChanges) {
        var message = __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.unsavedLeaveConfirmation");
        e.returnValue = message;
        return message;
      }
    }
  }, {
    key: "onBack",
    value: function onBack() {
      var currentStep = this.state.currentStep;
      var resetUserSegmentAttributes = this.props.resetUserSegmentAttributes;
      var nextStep;

      switch (currentStep) {
        case __WEBPACK_IMPORTED_MODULE_19__constants__["b" /* CREATE_STEP_SEGMENT */]:
          nextStep = __WEBPACK_IMPORTED_MODULE_19__constants__["c" /* CREATE_STEP_SETUP */];
          resetUserSegmentAttributes();
          break;

        case __WEBPACK_IMPORTED_MODULE_19__constants__["a" /* CREATE_STEP_REVIEW */]:
          nextStep = __WEBPACK_IMPORTED_MODULE_19__constants__["b" /* CREATE_STEP_SEGMENT */];
          break;

        default:
          nextStep = __WEBPACK_IMPORTED_MODULE_19__constants__["c" /* CREATE_STEP_SETUP */];
          break;
      }

      this.setState({
        currentStep: nextStep
      });
    }
  }, {
    key: "onCancel",
    value: function onCancel() {
      var cancelNewUserSegment = this.props.cancelNewUserSegment;
      cancelNewUserSegment();
    }
  }, {
    key: "onCreate",
    value: function onCreate() {
      var createUserSegment = this.props.createUserSegment;
      createUserSegment();
    }
  }, {
    key: "onNext",
    value: function onNext() {
      var currentStep = this.state.currentStep;
      var nextStep;

      switch (currentStep) {
        case __WEBPACK_IMPORTED_MODULE_19__constants__["c" /* CREATE_STEP_SETUP */]:
          nextStep = __WEBPACK_IMPORTED_MODULE_19__constants__["b" /* CREATE_STEP_SEGMENT */];
          break;

        case __WEBPACK_IMPORTED_MODULE_19__constants__["b" /* CREATE_STEP_SEGMENT */]:
          nextStep = __WEBPACK_IMPORTED_MODULE_19__constants__["a" /* CREATE_STEP_REVIEW */];
          break;

        default:
          nextStep = __WEBPACK_IMPORTED_MODULE_19__constants__["c" /* CREATE_STEP_SETUP */];
          break;
      }

      this.setState({
        currentStep: nextStep
      });
    }
  }, {
    key: "renderStep",
    value: function renderStep() {
      var currentStep = this.state.currentStep;

      switch (currentStep) {
        case __WEBPACK_IMPORTED_MODULE_19__constants__["c" /* CREATE_STEP_SETUP */]:
          return _ref;

        case __WEBPACK_IMPORTED_MODULE_19__constants__["b" /* CREATE_STEP_SEGMENT */]:
          return _ref2;

        case __WEBPACK_IMPORTED_MODULE_19__constants__["a" /* CREATE_STEP_REVIEW */]:
          return _ref3;

        default:
          return _ref4;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          userType = _this$props.userType,
          hasChanges = _this$props.hasChanges;
      var currentStep = this.state.currentStep;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a, {
        dir: __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default.a.dir,
        brandId: Object(__WEBPACK_IMPORTED_MODULE_17__zendesk_knowledge_context__["getCurrentBrandId"])(),
        topNav: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("a", {
          href: Object(__WEBPACK_IMPORTED_MODULE_20__utils_urls__["b" /* getUserSegmentsUrl */])()
        }, void 0, __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.userPermissions"))), _ref5, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("a", {
          href: Object(__WEBPACK_IMPORTED_MODULE_20__utils_urls__["b" /* getUserSegmentsUrl */])()
        }, void 0, __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.name"))), _ref6, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.pageTitle")))
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.wrp
      }, void 0, _ref7, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["b" /* Prompt */], {
        when: hasChanges,
        message: __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.unsavedLeaveConfirmation")
      }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.contentWrapper
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.contentView
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h1", {
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.pageTitle
      }, void 0, __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.pageTitle")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.primaryContent
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.wizardWrapper
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_components_lib_Wizard___default.a, {
        dir: __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default.a.dir
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_components_lib_Wizard___default.a.Step, {
        active: currentStep === __WEBPACK_IMPORTED_MODULE_19__constants__["c" /* CREATE_STEP_SETUP */],
        label: __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.setupStep"),
        completed: [__WEBPACK_IMPORTED_MODULE_19__constants__["a" /* CREATE_STEP_REVIEW */], __WEBPACK_IMPORTED_MODULE_19__constants__["b" /* CREATE_STEP_SEGMENT */]].includes(currentStep)
      }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_components_lib_Wizard___default.a.Step, {
        active: currentStep === __WEBPACK_IMPORTED_MODULE_19__constants__["b" /* CREATE_STEP_SEGMENT */],
        label: __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.segmentStep"),
        completed: currentStep === __WEBPACK_IMPORTED_MODULE_19__constants__["a" /* CREATE_STEP_REVIEW */]
      }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_components_lib_Wizard___default.a.Step, {
        active: currentStep === __WEBPACK_IMPORTED_MODULE_19__constants__["a" /* CREATE_STEP_REVIEW */],
        label: __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.reviewStep"),
        completed: false
      }))), this.renderStep())), currentStep === __WEBPACK_IMPORTED_MODULE_19__constants__["b" /* CREATE_STEP_SEGMENT */] && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.userList
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.contentView
      }, void 0, _ref8))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.footer,
        "data-test-id": "footer-bar"
      }, void 0, currentStep === __WEBPACK_IMPORTED_MODULE_19__constants__["c" /* CREATE_STEP_SETUP */] ? __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_self_service_components_lib_Button___default.a, {
        onClick: this.onCancel,
        testId: "cancel-button"
      }, void 0, __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.cancel")) : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_self_service_components_lib_Button___default.a, {
        onClick: this.onBack,
        testId: "back-button"
      }, void 0, __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.back")), currentStep === __WEBPACK_IMPORTED_MODULE_19__constants__["a" /* CREATE_STEP_REVIEW */] ? __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_self_service_components_lib_Button___default.a, {
        testId: "create-button",
        disabled: name.length === 0,
        type: "primary",
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.nextButton,
        onClick: this.onCreate
      }, void 0, __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.create")) : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_self_service_components_lib_Button___default.a, {
        testId: "next-button-".concat(currentStep),
        disabled: name.length === 0 || !__WEBPACK_IMPORTED_MODULE_19__constants__["f" /* USER_TYPES */].includes(userType),
        type: "primary",
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.nextButton,
        onClick: this.onNext
      }, void 0, __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.next")))));
    }
  }]);

  return NewUserSegment;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);
NewUserSegment.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string,
  userType: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].oneOf(__WEBPACK_IMPORTED_MODULE_19__constants__["f" /* USER_TYPES */]),
  hasChanges: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool,
  resetUserSegment: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  createUserSegment: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  cancelNewUserSegment: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  resetUserSegmentAttributes: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func
};
NewUserSegment.defaultProps = {
  hasChanges: false,
  type: "edit",
  name: "",
  userType: null,
  builtIn: false,
  isFetchingOrganizations: false,
  isFetchingGroups: false
};

var mapStateToProps = function mapStateToProps(_ref9, ownProps) {
  var userSegment = _ref9.userSegment;
  return {
    name: userSegment.name,
    userType: userSegment.userType,
    hasChanges: !__WEBPACK_IMPORTED_MODULE_16_lodash_isEqual___default()(userSegment.savedTags, userSegment.tags) || !__WEBPACK_IMPORTED_MODULE_16_lodash_isEqual___default()(userSegment.savedOrganizations, userSegment.organizations) || !__WEBPACK_IMPORTED_MODULE_16_lodash_isEqual___default()(userSegment.savedGroups, userSegment.groups) || userSegment.savedName !== userSegment.name
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_15_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, __WEBPACK_IMPORTED_MODULE_21__actions_userSegment__), dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(NewUserSegment));

/***/ }),
/* 817 */,
/* 818 */,
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SetupStep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_TextInput__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_Select__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_FormLabel__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_FormLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_FormLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_self_service_components_lib_FormHint__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_self_service_components_lib_FormHint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_self_service_components_lib_FormHint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_userSegment__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__index_css__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__index_css__);



















var SetupStep =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(SetupStep, _Component);

  function SetupStep() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, SetupStep);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(SetupStep).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(SetupStep, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          userType = _this$props.userType,
          changeName = _this$props.changeName,
          changeUserType = _this$props.changeUserType;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.stepBody,
        "data-test-id": "step-body"
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h2", {
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.stepTitle
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.setupTitle")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_self_service_components_lib_TextInput___default.a, {
        testId: "name-field",
        dir: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default.a.dir,
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.formItem,
        label: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.nameLabel"),
        placeholder: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.namePlaceholder"),
        value: name,
        onChange: changeName
      }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.formItem
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_self_service_components_lib_FormLabel___default.a, {}, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.userTypeLabel"))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__zendesk_self_service_components_lib_FormHint___default.a, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("span", {
        dangerouslySetInnerHTML: {
          __html: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.userTypeHint", {
            learnMoreUrl: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.userTypeHintLearnMoreUrl")
          })
        }
      }))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_Select___default.a, {
        testId: "user-type-field",
        dir: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default.a.dir,
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.userTypeSelect,
        selected: userType ? __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()(__WEBPACK_IMPORTED_MODULE_16__constants__["g" /* USER_TYPE_NAME */][userType]) : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("span", {
          className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.userTypePlaceholder
        }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.pleaseSelect")),
        onChange: changeUserType
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_Select___default.a.Item, {
        value: __WEBPACK_IMPORTED_MODULE_16__constants__["d" /* SIGNED_IN_USERS */]
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()(__WEBPACK_IMPORTED_MODULE_16__constants__["g" /* USER_TYPE_NAME */][__WEBPACK_IMPORTED_MODULE_16__constants__["d" /* SIGNED_IN_USERS */]])), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_self_service_components_lib_Select___default.a.Item, {
        value: __WEBPACK_IMPORTED_MODULE_16__constants__["e" /* STAFF */]
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()(__WEBPACK_IMPORTED_MODULE_16__constants__["g" /* USER_TYPE_NAME */][__WEBPACK_IMPORTED_MODULE_16__constants__["e" /* STAFF */]]))))));
    }
  }]);

  return SetupStep;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);
SetupStep.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  userType: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf([__WEBPACK_IMPORTED_MODULE_16__constants__["e" /* STAFF */], __WEBPACK_IMPORTED_MODULE_16__constants__["d" /* SIGNED_IN_USERS */]]),
  changeName: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  changeUserType: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
};

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var userSegment = _ref.userSegment;
  var type = _ref2.type;
  return {
    name: userSegment.name,
    userType: userSegment.userType
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref3) {
  var type = _ref3.type;
  return Object(__WEBPACK_IMPORTED_MODULE_10_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, __WEBPACK_IMPORTED_MODULE_17__actions_userSegment__), dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(SetupStep));

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(44);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _uuid = __webpack_require__(82);

var _uuid2 = _interopRequireDefault(_uuid);

var _Menu = __webpack_require__(109);

var _Menu2 = _interopRequireDefault(_Menu);

var _View = __webpack_require__(17);

var _View2 = _interopRequireDefault(_View);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _styles = __webpack_require__(299);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = function (_ThemedComponent) {
  (0, _inherits3.default)(Select, _ThemedComponent);

  function Select(props, context) {
    (0, _classCallCheck3.default)(this, Select);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "Select",
      styles: _styles2.default
    }));

    _this.getId = function () {
      return _this.props.id || _this.generatedId;
    };

    _this.renderLabel = function () {
      var label = _this.props.label;
      var theme = _this.theme;


      if (!label) {
        return null;
      }

      return _react2.default.createElement(
        "label",
        { className: theme.label, htmlFor: _this.getId() },
        label
      );
    };

    _this.onClick = function (e) {
      var disabled = _this.props.disabled;


      if (disabled) {
        e.stopPropagation();
        e.preventDefault();
      }
    };

    _this.onOpen = function () {
      var onOpen = _this.props.onOpen;

      _this.setState({ open: true });
      onOpen && onOpen();
    };

    _this.onClose = function () {
      var onClose = _this.props.onClose;

      _this.setState({ open: false });
      onClose && onClose();
    };

    _this.generatedId = _uuid2.default.v4();
    _this.state = {
      open: false
    };
    return _this;
  }

  Select.prototype.render = function render() {
    var _classNames,
        _classNames2,
        _this2 = this;

    var _props = this.props,
        children = _props.children,
        className = _props.className,
        inputClassName = _props.inputClassName,
        dir = _props.dir,
        disabled = _props.disabled,
        hint = _props.hint,
        maxHeight = _props.maxHeight,
        onBlur = _props.onBlur,
        onFocus = _props.onFocus,
        onChange = _props.onChange,
        positioning = _props.positioning,
        selected = _props.selected,
        size = _props.size,
        stretched = _props.stretched,
        tabIndex = _props.tabIndex,
        testId = _props.testId,
        title = _props.title,
        tooltipPositioning = _props.tooltipPositioning,
        validation = _props.validation,
        validationText = _props.validationText,
        shouldClose = _props.shouldClose,
        menuClassName = _props.menuClassName;
    var open = this.state.open;
    var theme = this.theme;


    return _react2.default.createElement(
      _View2.default,
      {
        className: (0, _classnames2.default)(theme.txt, (_classNames = {}, _classNames[theme.rtl] = dir === "rtl", _classNames[theme.stretched] = stretched, _classNames[theme.disabled] = disabled, _classNames[theme.is_focused] = open, _classNames), className),
        testId: testId
      },
      this.renderLabel(),
      hint && _react2.default.createElement(
        "small",
        { className: theme.hint },
        hint
      ),
      _react2.default.createElement(
        _Menu2.default,
        {
          dir: dir,
          maxHeight: maxHeight,
          onChange: onChange,
          positioning: positioning,
          enableArrowKeyExpansion: true,
          onOpen: this.onOpen,
          onClose: this.onClose,
          trigger: _react2.default.createElement(
            _View2.default,
            {
              className: (0, _classnames2.default)(theme.input, theme["size_" + size], validation && theme["input_" + validation], (_classNames2 = {}, _classNames2[theme.open] = open, _classNames2), inputClassName),
              dir: dir,
              disabled: disabled,
              onBlur: onBlur,
              onClick: this.onClick,
              onFocus: onFocus,
              role: "button",
              tabIndex: disabled ? null : tabIndex,
              title: title,
              tooltipPositioning: tooltipPositioning,
              ref: function ref(_ref) {
                _this2.triggerNode = _this2.triggerNode || (0, _reactDom.findDOMNode)(_ref);
              }
            },
            selected || _react2.default.createElement(
              "span",
              null,
              "\xA0"
            )
          ),
          testId: testId && testId + "-menu",
          size: size,
          stretched: stretched,
          shouldClose: shouldClose,
          className: menuClassName
        },
        children
      ),
      validation && validationText && _react2.default.createElement(
        "small",
        {
          className: (0, _classnames2.default)(theme.message, validation && theme["message_" + validation])
        },
        validationText
      )
    );
  };

  return Select;
}(_ThemedComponent3.default);

Select.Item = _Menu2.default.Item;
Select.Separator = _Menu2.default.Separator;
Select.LinkItem = _Menu2.default.LinkItem;
Select.PreviousItem = _Menu2.default.PreviousItem;
Select.NextItem = _Menu2.default.NextItem;
Select.HeaderItem = _Menu2.default.HeaderItem;
Select.AddItem = _Menu2.default.AddItem;
Select.MediaItem = _Menu2.default.MediaItem;
Select.propTypes = {
  children: _propTypes2.default.node.isRequired,
  /**
   * This is for use in self-service-components only
   */
  className: _propTypes2.default.string,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  disabled: _propTypes2.default.bool,
  hint: _propTypes2.default.node,
  inputClassName: _propTypes2.default.string,
  label: _propTypes2.default.node,
  maxHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  onBlur: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onOpen: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  positioning: _Menu2.default.propTypes.positioning,
  selected: _propTypes2.default.node,
  stretched: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(["small", "medium"]),
  tabIndex: _propTypes2.default.number,
  testId: _propTypes2.default.string,
  /** Must be wrapped by a <a href="#tooltipprovider">TooltipProvider</a> */
  title: _propTypes2.default.string,
  /** <a href="#view">See View</a> for positioning options */
  tooltipPositioning: function tooltipPositioning() {},
  validation: _propTypes2.default.oneOf(["error", "warning", "success"]),
  validationText: _propTypes2.default.string,
  shouldClose: _propTypes2.default.func,
  menuClassName: _propTypes2.default.func
};
Select.defaultProps = {
  dir: "ltr",
  disabled: false,
  positioning: ["bottom_stretch", "top_stretch"],
  stretched: true,
  size: "medium",
  tabIndex: 0
};
exports.default = Select;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _styles = __webpack_require__(822);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormLabel = function (_ThemedComponent) {
  (0, _inherits3.default)(FormLabel, _ThemedComponent);

  function FormLabel(props, context) {
    (0, _classCallCheck3.default)(this, FormLabel);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "FormLabel",
      styles: _styles2.default
    }));
  }

  FormLabel.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        htmlFor = _props.htmlFor,
        className = _props.className;
    var theme = this.theme;


    return _react2.default.createElement(
      "label",
      { htmlFor: htmlFor, className: (0, _classnames2.default)(theme.label, className) },
      children
    );
  };

  return FormLabel;
}(_ThemedComponent3.default);

FormLabel.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  htmlFor: _propTypes2.default.string
};
exports.default = FormLabel;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;


__webpack_require__(113)

exports.default = {"label":"ssc-label-d73815a1 scc-c-txt__label-4506f8eb"}


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ThemedComponent2 = __webpack_require__(22);

var _ThemedComponent3 = _interopRequireDefault(_ThemedComponent2);

var _styles = __webpack_require__(824);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormHint = function (_ThemedComponent) {
  (0, _inherits3.default)(FormHint, _ThemedComponent);

  function FormHint(props, context) {
    (0, _classCallCheck3.default)(this, FormHint);
    return (0, _possibleConstructorReturn3.default)(this, _ThemedComponent.call(this, props, context, {
      namespace: "FormHint",
      styles: _styles2.default
    }));
  }

  FormHint.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className;
    var theme = this.theme;


    return _react2.default.createElement(
      "small",
      { className: (0, _classnames2.default)(theme.hint, className) },
      children
    );
  };

  return FormHint;
}(_ThemedComponent3.default);

FormHint.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};
exports.default = FormHint;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;


__webpack_require__(113)

exports.default = {"hint":"ssc-hint-ae241507 scc-c-txt__hint-4506f8eb"}


/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stepTitle":"_-src-components-NewUserSegment-components-SetupStep-index---stepTitle---AUi2X","stepBody":"_-src-components-NewUserSegment-components-SetupStep-index---stepBody---13B9e","formItem":"_-src-components-NewUserSegment-components-SetupStep-index---formItem---1JzGQ","userTypePlaceholder":"_-src-components-NewUserSegment-components-SetupStep-index---userTypePlaceholder---25Fv-","userTypeSelect":"_-src-components-NewUserSegment-components-SetupStep-index---userTypeSelect---1k-Ij"};

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SegmentStep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AutocompleteList__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_userSegment__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__index_css__);
















var SegmentStep =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(SegmentStep, _Component);

  function SegmentStep() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, SegmentStep);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(SegmentStep).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(SegmentStep, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var fetchUsers = this.props.fetchUsers;
      fetchUsers();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          userType = _this$props.userType,
          tags = _this$props.tags,
          groups = _this$props.groups,
          organizations = _this$props.organizations,
          addOrganization = _this$props.addOrganization,
          addGroup = _this$props.addGroup,
          addTag = _this$props.addTag;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.stepBody,
        "data-test-id": "step-body"
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h2", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.stepTitle
      }, void 0, userType === __WEBPACK_IMPORTED_MODULE_13__constants__["e" /* STAFF */] ? __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.segmentStaffTitle") : __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.segmentSignedInUsersTitle")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h2", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.resrtrictionsTitle
      }, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.matchTheFollowing")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__AutocompleteList__["a" /* default */], {
        isLoading: false,
        items: tags,
        type: "tags",
        newText: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.addTag"),
        conjunction: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.conjunctionAnd"),
        onAddNew: addTag,
        title: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.tags"),
        description: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.tagsDescription", {
          learnMoreUrl: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.tagsDescriptionLearnMoreUrl")
        })
      }), userType === __WEBPACK_IMPORTED_MODULE_13__constants__["d" /* SIGNED_IN_USERS */] && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__AutocompleteList__["a" /* default */], {
        isLoading: false,
        items: organizations,
        type: "organizations",
        newText: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.addOrganization"),
        conjunction: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.conjunctionOr"),
        onAddNew: addOrganization,
        title: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.organizations"),
        description: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.organizationsDescription", {
          learnMoreUrl: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.organizationsDescriptionLearnMoreUrl")
        })
      }), userType === __WEBPACK_IMPORTED_MODULE_13__constants__["e" /* STAFF */] && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__AutocompleteList__["a" /* default */], {
        isLoading: false,
        items: groups,
        type: "groups",
        newText: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.addGroup"),
        conjunction: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.conjunctionOr"),
        onAddNew: addGroup,
        title: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.groups"),
        description: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.groupsDescription", {
          learnMoreUrl: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.groupsDescriptionLearnMoreUrl")
        })
      })));
    }
  }]);

  return SegmentStep;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);
SegmentStep.propTypes = {
  userType: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf([__WEBPACK_IMPORTED_MODULE_13__constants__["e" /* STAFF */], __WEBPACK_IMPORTED_MODULE_13__constants__["d" /* SIGNED_IN_USERS */]]),
  tags: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string).isRequired,
  groups: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
  })).isRequired,
  organizations: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
  })).isRequired,
  fetchUsers: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  addOrganization: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  addGroup: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  addTag: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
};
SegmentStep.defaultProps = {
  tags: [],
  groups: [],
  organizations: []
};

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var userSegment = _ref.userSegment;
  var type = _ref2.type;
  return {
    userType: userSegment.userType,
    tags: userSegment.tags,
    groups: userSegment.groups,
    organizations: userSegment.organizations
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref3) {
  var type = _ref3.type;
  return Object(__WEBPACK_IMPORTED_MODULE_10_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, __WEBPACK_IMPORTED_MODULE_14__actions_userSegment__), dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(SegmentStep));

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stepTitle":"_-src-components-NewUserSegment-components-SegmentStep-index---stepTitle---q0kc5","resrtrictionsTitle":"_-src-components-NewUserSegment-components-SegmentStep-index---resrtrictionsTitle---1b2SG","stepBody":"_-src-components-NewUserSegment-components-SegmentStep-index---stepBody---20ftS"};

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReviewStep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_context__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_userSegment__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__index_css__);
















var ReviewStep =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ReviewStep, _Component);

  function ReviewStep() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, ReviewStep);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ReviewStep).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ReviewStep, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          userType = _this$props.userType,
          tags = _this$props.tags,
          groups = _this$props.groups,
          organizations = _this$props.organizations,
          userCount = _this$props.userCount,
          isAdmin = _this$props.isAdmin;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.stepBody,
        "data-test-id": "step-body"
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h2", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.stepTitle
      }, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.reviewTitle")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("table", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("tbody", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("tr", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("th", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.propertyTitle
      }, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.nameLabel")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("td", {}, void 0, name)), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("tr", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("th", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.propertyTitle
      }, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.wizard.userTypeLabel")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("td", {}, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()(__WEBPACK_IMPORTED_MODULE_13__constants__["g" /* USER_TYPE_NAME */][userType]))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("tr", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("th", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.propertyTitle
      }, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.tags")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("td", {}, void 0, tags.length > 0 ? tags.join(", ") : "-")), userType === __WEBPACK_IMPORTED_MODULE_13__constants__["e" /* STAFF */] && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("tr", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("th", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.propertyTitle
      }, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.groups")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("td", {}, void 0, groups.length > 0 ? groups.map(function (_ref) {
        var name = _ref.name;
        return name;
      }).join(", ") : "-")), userType === __WEBPACK_IMPORTED_MODULE_13__constants__["d" /* SIGNED_IN_USERS */] && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("tr", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("th", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.propertyTitle
      }, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.organizations")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("td", {}, void 0, organizations.length > 0 ? organizations.map(function (_ref2) {
        var name = _ref2.name;
        return name;
      }).join(", ") : "-")), isAdmin && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("tr", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("th", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.propertyTitle
      }, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-user-segments.userSegment.matchingUsers")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("td", {}, void 0, userCount)))));
    }
  }]);

  return ReviewStep;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);
ReviewStep.propTypes = {
  isAdmin: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  name: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  userType: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf([__WEBPACK_IMPORTED_MODULE_13__constants__["e" /* STAFF */], __WEBPACK_IMPORTED_MODULE_13__constants__["d" /* SIGNED_IN_USERS */]]),
  tags: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string).isRequired,
  groups: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
  })).isRequired,
  organizations: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
  })).isRequired,
  userCount: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number
};
ReviewStep.defaultProps = {
  tags: [],
  groups: [],
  organizations: []
};

var mapStateToProps = function mapStateToProps(_ref3, _ref4) {
  var userSegment = _ref3.userSegment;
  var type = _ref4.type;
  return {
    name: userSegment.name,
    userType: userSegment.userType,
    tags: userSegment.tags,
    organizations: userSegment.organizations,
    groups: userSegment.groups,
    userCount: userSegment.userCount,
    isAdmin: Object(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_context__["hasEntitlement"])("admin")
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref5) {
  var type = _ref5.type;
  return Object(__WEBPACK_IMPORTED_MODULE_10_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, __WEBPACK_IMPORTED_MODULE_14__actions_userSegment__), dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ReviewStep));

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stepTitle":"_-src-components-NewUserSegment-components-ReviewStep-index---stepTitle---GC_Ob","stepBody":"_-src-components-NewUserSegment-components-ReviewStep-index---stepBody---y8o0Q","propertyTitle":"_-src-components-NewUserSegment-components-ReviewStep-index---propertyTitle---2Fnsf"};

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pageTitle":"_-src-components-NewUserSegment-index---pageTitle---2j8TS","contentView":"_-src-components-NewUserSegment-index---contentView---1im7i","content":"_-src-components-NewUserSegment-index---content---1i7_2","resrtrictionsTitle":"_-src-components-NewUserSegment-index---resrtrictionsTitle---3qGqt","contentWrapper":"_-src-components-NewUserSegment-index---contentWrapper---3VToa","stretch":"_-src-components-NewUserSegment-index---stretch---sZBlI","primaryContent":"_-src-components-NewUserSegment-index---primaryContent---3KZ7N","contentWithFooter":"_-src-components-NewUserSegment-index---contentWithFooter---V4Duj","cnt":"_-src-components-NewUserSegment-index---cnt---1XUNk","footer":"_-src-components-NewUserSegment-index---footer---V-MWr","nextButton":"_-src-components-NewUserSegment-index---nextButton---1ZLNK","wrp":"_-src-components-NewUserSegment-index---wrp---34LX8","userList":"_-src-components-NewUserSegment-index---userList---XHZIX","wizardWrapper":"_-src-components-NewUserSegment-index---wizardWrapper---1ztup"};

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__staffUserSegments__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__signedInUserSegments__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__userSegment__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tags__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__organizations__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__groups__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notifications__ = __webpack_require__(838);









/* harmony default export */ __webpack_exports__["a"] = (function (history) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    router: Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["connectRouter"])(history),
    staffUserSegments: __WEBPACK_IMPORTED_MODULE_2__staffUserSegments__["a" /* default */],
    signedInUserSegments: __WEBPACK_IMPORTED_MODULE_3__signedInUserSegments__["a" /* default */],
    userSegment: __WEBPACK_IMPORTED_MODULE_4__userSegment__["a" /* default */],
    tags: __WEBPACK_IMPORTED_MODULE_5__tags__["a" /* default */],
    organizations: __WEBPACK_IMPORTED_MODULE_6__organizations__["a" /* default */],
    groups: __WEBPACK_IMPORTED_MODULE_7__groups__["a" /* default */],
    notifications: __WEBPACK_IMPORTED_MODULE_8__notifications__["a" /* default */]
  });
});

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = staffUserSegments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_staffUserSegments_types__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__ = __webpack_require__(138);



var initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  list: [],
  page: 0,
  pageCount: 0
};
function staffUserSegments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_staffUserSegments_types__["b" /* FETCH_STAFF_USER_SEGMENTS_REQUEST */]:
      {
        return Object.assign({}, state, {
          isFetching: true,
          hasFetchError: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_staffUserSegments_types__["c" /* FETCH_STAFF_USER_SEGMENTS_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          hasFetchError: false,
          isLoaded: true,
          list: action.userSegments,
          page: action.page,
          pageCount: action.pageCount
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_staffUserSegments_types__["a" /* FETCH_STAFF_USER_SEGMENTS_FAILURE */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: false,
          hasFetchError: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["n" /* DELETE_USER_SEGMENT_SUCCESS */]:
      {
        return Object.assign({}, state, {
          list: state.list.filter(function (userSegment) {
            return userSegment.id !== action.userSegmentId;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["q" /* DUPLICATE_USER_SEGMENT_SUCCESS */]:
      {
        var indexOfOriginal = state.list.findIndex(function (userSegment) {
          return userSegment.id === action.originalId;
        });

        if (indexOfOriginal < 0) {
          return state;
        } // Insert after the duplicated item


        var newList = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.list);

        newList.splice(indexOfOriginal + 1, 0, action.userSegment);
        return Object.assign({}, state, {
          list: newList
        });
      }

    default:
      return state;
  }
}

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = signedInUserSegments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_signedInUserSegments_types__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__ = __webpack_require__(138);



var initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  list: [],
  page: 0,
  pageCount: 0
};
function signedInUserSegments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_signedInUserSegments_types__["b" /* FETCH_SIGNED_IN_USER_SEGMENTS_REQUEST */]:
      {
        return Object.assign({}, state, {
          isFetching: true,
          hasFetchError: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_signedInUserSegments_types__["c" /* FETCH_SIGNED_IN_USER_SEGMENTS_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          hasFetchError: false,
          isLoaded: true,
          list: action.userSegments,
          page: action.page,
          pageCount: action.pageCount
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_signedInUserSegments_types__["a" /* FETCH_SIGNED_IN_USER_SEGMENTS_FAILURE */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: false,
          hasFetchError: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["n" /* DELETE_USER_SEGMENT_SUCCESS */]:
      {
        return Object.assign({}, state, {
          list: state.list.filter(function (userSegment) {
            return userSegment.id !== action.userSegmentId;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["q" /* DUPLICATE_USER_SEGMENT_SUCCESS */]:
      {
        var indexOfOriginal = state.list.findIndex(function (userSegment) {
          return userSegment.id === action.originalId;
        });

        if (indexOfOriginal < 0) {
          return state;
        } // Insert after the duplicated item


        var newList = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.list);

        newList.splice(indexOfOriginal + 1, 0, action.userSegment);
        return Object.assign({}, state, {
          list: newList
        });
      }

    default:
      return state;
  }
}

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = userSegment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__ = __webpack_require__(138);



var initialState = {
  isFetching: false,
  isLoaded: false,
  isFetchingOrganizations: false,
  isFetchingOrganizationsForbidden: false,
  isFetchingGroups: false,
  isFetchingUsers: false,
  isLoadedOrganizations: false,
  isLoadedGroups: false,
  isLoadedUsers: false,
  isSaving: false,
  hasFetchError: false,
  name: "",
  savedName: "",
  userType: null,
  tags: [],
  savedTags: [],
  organizations: [],
  savedOrganizations: [],
  groups: [],
  savedGroups: [],
  builtIn: false,
  users: [],
  userCount: 0,
  userPageCount: 0
};
function userSegment() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["B" /* FETCH_USER_SEGMENT_REQUEST */]:
      {
        return Object.assign({}, state, {
          isFetching: true,
          isLoaded: false,
          hasFetchError: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["C" /* FETCH_USER_SEGMENT_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: true,
          name: action.userSegment.name,
          savedName: action.userSegment.name,
          tags: action.userSegment.tags,
          savedTags: action.userSegment.tags,
          builtIn: action.userSegment.built_in,
          userType: action.userSegment.user_type
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["u" /* FETCH_USER_SEGMENT_FAILURE */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: false,
          hasFetchError: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["z" /* FETCH_USER_SEGMENT_ORGANIZATIONS_REQUEST */]:
      {
        return Object.assign({}, state, {
          isFetchingOrganizations: true,
          isLoadedOrganizations: false,
          isFetchingOrganizationsForbidden: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["y" /* FETCH_USER_SEGMENT_ORGANIZATIONS_FAILURE */]:
      {
        return Object.assign({}, state, {
          isFetchingOrganizations: false,
          isLoadedOrganizations: false,
          isFetchingOrganizationsForbidden: action.error.status === 403
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["A" /* FETCH_USER_SEGMENT_ORGANIZATIONS_SUCCESS */]:
      {
        var deletedCount = 0;
        var organizations = action.requestedIds.map(function (id) {
          var organization = action.organizations.find(function (organization) {
            return organization.id === id;
          });
          return organization ? Object.assign({}, organization, {
            deleted: false
          }) : {
            id: id,
            name: "Deleted organization ".concat(++deletedCount),
            deleted: true
          };
        });
        return Object.assign({}, state, {
          organizations: organizations,
          isFetchingOrganizations: false,
          isLoadedOrganizations: true,
          savedOrganizations: organizations
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["w" /* FETCH_USER_SEGMENT_GROUPS_REQUEST */]:
      {
        return Object.assign({}, state, {
          isFetchingGroups: true,
          isLoadedGroups: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["x" /* FETCH_USER_SEGMENT_GROUPS_SUCCESS */]:
      {
        var _deletedCount = 0;
        var groups = action.groups.map(function (group) {
          return group.deleted ? Object.assign({}, group, {
            name: "Deleted group ".concat(++_deletedCount)
          }) : group;
        });
        return Object.assign({}, state, {
          groups: groups,
          isFetchingGroups: false,
          isLoadedGroups: true,
          savedGroups: groups
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["s" /* FETCH_USERS_REQUEST */]:
      {
        return Object.assign({}, state, {
          isFetchingUsers: true,
          isLoadedUsers: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["t" /* FETCH_USERS_SUCCESS */]:
      {
        // Intersect user segment's properties with user's properties
        var usersWithFilteredProperties = action.users.map(function (user) {
          var userOrganizationIds = user.organizations.map(function (_ref) {
            var id = _ref.id;
            return id;
          });
          var userGroupIds = user.groups.map(function (_ref2) {
            var id = _ref2.id;
            return id;
          });
          var tags = state.tags.filter(function (tag) {
            return user.tags.includes(tag);
          });
          var organizations = state.organizations.filter(function (_ref3) {
            var id = _ref3.id;
            return userOrganizationIds.includes(id);
          });
          var groups = state.groups.filter(function (_ref4) {
            var id = _ref4.id;
            return userGroupIds.includes(id);
          });
          return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, user, {
            tags: tags,
            organizations: organizations,
            groups: groups
          });
        });
        return Object.assign({}, state, {
          isFetchingUsers: false,
          isLoadedUsers: true,
          users: usersWithFilteredProperties,
          userCount: action.count,
          userPageCount: action.pageCount
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["e" /* CHANGE_NAME */]:
      {
        return Object.assign({}, state, {
          name: action.name
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["h" /* CHANGE_USER_TYPE */]:
      {
        return Object.assign({}, state, {
          userType: action.userType
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["g" /* CHANGE_TAG */]:
      {
        var tags = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.tags);

        var indexToReplace = tags.findIndex(function (tag) {
          return tag === action.originalTag;
        });

        if (indexToReplace < 0) {
          return state;
        }

        tags.splice(indexToReplace, 1, action.newTag);
        return Object.assign({}, state, {
          tags: tags
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["c" /* ADD_TAG */]:
      {
        return Object.assign({}, state, {
          tags: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.tags).concat([action.tag])
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["F" /* REMOVE_TAG */]:
      {
        return Object.assign({}, state, {
          tags: state.tags.filter(function (tag) {
            return tag !== action.tag;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["f" /* CHANGE_ORGANIZATION */]:
      {
        var _organizations = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.organizations);

        var _indexToReplace = _organizations.findIndex(function (organization) {
          return organization.id === action.originalOrganization.id;
        });

        if (_indexToReplace < 0) {
          return state;
        }

        _organizations.splice(_indexToReplace, 1, action.newOrganization);

        return Object.assign({}, state, {
          organizations: _organizations
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["b" /* ADD_ORGANIZATION */]:
      {
        return Object.assign({}, state, {
          organizations: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.organizations).concat([action.organization])
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["E" /* REMOVE_ORGANIZATION */]:
      {
        return Object.assign({}, state, {
          organizations: state.organizations.filter(function (organization) {
            return organization.id !== action.organization.id;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["d" /* CHANGE_GROUP */]:
      {
        var _groups = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.groups);

        var _indexToReplace2 = _groups.findIndex(function (group) {
          return group.id === action.originalGroup.id;
        });

        if (_indexToReplace2 < 0) {
          return state;
        }

        _groups.splice(_indexToReplace2, 1, action.newGroup);

        return Object.assign({}, state, {
          groups: _groups
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["a" /* ADD_GROUP */]:
      {
        return Object.assign({}, state, {
          groups: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.groups).concat([action.group])
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["D" /* REMOVE_GROUP */]:
      {
        return Object.assign({}, state, {
          groups: state.groups.filter(function (group) {
            return group.id !== action.group.id;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["J" /* SAVE_USER_SEGMENT_REQUEST */]:
      {
        return Object.assign({}, state, {
          isSaving: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["K" /* SAVE_USER_SEGMENT_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isSaving: false,
          savedName: state.name,
          savedTags: state.tags,
          savedGroups: state.groups,
          savedOrganizations: state.organizations
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["j" /* CREATE_USER_SEGMENT_REQUEST */]:
      {
        return Object.assign({}, state, {
          isSaving: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["k" /* CREATE_USER_SEGMENT_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isSaving: false,
          savedName: state.name,
          savedTags: state.tags,
          savedGroups: state.groups,
          savedOrganizations: state.organizations
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["I" /* SAVE_USER_SEGMENT_FAILURE */]:
      {
        return Object.assign({}, state, {
          isSaving: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["G" /* RESET_USER_SEGMENT */]:
      {
        return Object.assign({}, state, {
          isLoaded: false,
          userType: null,
          name: "",
          savedName: "",
          tags: [],
          savedTags: [],
          groups: [],
          savedGroups: [],
          organizations: [],
          savedOrganizations: [],
          users: [],
          userCount: 0,
          userPageCount: 0
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_userSegment_types__["H" /* RESET_USER_SEGMENT_ATTRIBUTES */]:
      {
        return Object.assign({}, state, {
          tags: [],
          savedTags: [],
          groups: [],
          savedGroups: [],
          organizations: [],
          savedOrganizations: []
        });
      }

    default:
      return state;
  }
}

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tags;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_tags_types__ = __webpack_require__(302);


var initialState = {
  isInitialLoaded: false,
  isInitialFetching: false,
  hasFetchError: false,
  initialList: [],
  autocomplete: {}
};
function tags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_tags_types__["e" /* FETCH_INITIAL_TAGS_REQUEST */]:
      {
        return Object.assign({}, state, {
          isInitialFetching: true,
          hasFetchError: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_tags_types__["f" /* FETCH_INITIAL_TAGS_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isInitialFetching: false,
          isInitialLoaded: true,
          initialList: action.tags.map(function (tag) {
            return tag.name;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_tags_types__["d" /* FETCH_INITIAL_TAGS_FAILURE */]:
      {
        return Object.assign({}, state, {
          isInitialFetching: false,
          isInitialLoaded: false,
          hasFetchError: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_tags_types__["b" /* FETCH_AUTOCOMPLETE_TAGS_REQUEST */]:
      {
        var autocomplete = Object.assign({}, state.autocomplete, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, action.query, {
          isFetching: true,
          isLoaded: false,
          list: []
        }));
        return Object.assign({}, state, {
          autocomplete: autocomplete
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_tags_types__["c" /* FETCH_AUTOCOMPLETE_TAGS_SUCCESS */]:
      {
        var queryState = Object.assign({}, state.autocomplete[action.query], {
          isFetching: false,
          isLoaded: true,
          list: action.tags // No need to extract name, representation in the response differs

        });

        var _autocomplete = Object.assign({}, state.autocomplete, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, action.query, queryState));

        return Object.assign({}, state, {
          autocomplete: _autocomplete
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_tags_types__["a" /* FETCH_AUTOCOMPLETE_TAGS_FAILURE */]:
      {
        var _autocomplete2 = Object.assign({}, state.autocomplete, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, action.query, {
          isFetching: false,
          isLoaded: false,
          list: []
        }));

        return Object.assign({}, state, {
          autocomplete: _autocomplete2
        });
      }

    default:
      return state;
  }
}

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = organizations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_organizations_types__ = __webpack_require__(301);


var initialState = {
  isInitialLoaded: false,
  isInitialFetching: false,
  hasFetchError: false,
  initialList: [],
  autocomplete: {}
};
function organizations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_organizations_types__["e" /* FETCH_INITIAL_ORGANIZATIONS_REQUEST */]:
      {
        return Object.assign({}, state, {
          isInitialFetching: true,
          hasFetchError: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_organizations_types__["f" /* FETCH_INITIAL_ORGANIZATIONS_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isInitialFetching: false,
          isInitialLoaded: true,
          initialList: action.organizations
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_organizations_types__["d" /* FETCH_INITIAL_ORGANIZATIONS_FAILURE */]:
      {
        return Object.assign({}, state, {
          isInitialFetching: false,
          isInitialLoaded: false,
          hasFetchError: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_organizations_types__["b" /* FETCH_AUTOCOMPLETE_ORGANIZATIONS_REQUEST */]:
      {
        var autocomplete = Object.assign({}, state.autocomplete, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, action.query, {
          isFetching: true,
          isLoaded: false,
          list: []
        }));
        return Object.assign({}, state, {
          autocomplete: autocomplete
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_organizations_types__["c" /* FETCH_AUTOCOMPLETE_ORGANIZATIONS_SUCCESS */]:
      {
        var queryState = Object.assign({}, state.autocomplete[action.query], {
          isFetching: false,
          isLoaded: true,
          list: action.organizations
        });

        var _autocomplete = Object.assign({}, state.autocomplete, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, action.query, queryState));

        return Object.assign({}, state, {
          autocomplete: _autocomplete
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_organizations_types__["a" /* FETCH_AUTOCOMPLETE_ORGANIZATIONS_FAILURE */]:
      {
        var _autocomplete2 = Object.assign({}, state.autocomplete, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, action.query, {
          isFetching: false,
          isLoaded: false,
          list: []
        }));

        return Object.assign({}, state, {
          autocomplete: _autocomplete2
        });
      }

    default:
      return state;
  }
}

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = groups;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_groups_types__ = __webpack_require__(300);


var initialState = {
  isInitialLoaded: false,
  isInitialFetching: false,
  hasFetchError: false,
  initialList: [],
  autocomplete: {}
};
function groups() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_groups_types__["e" /* FETCH_INITIAL_GROUPS_REQUEST */]:
      {
        return Object.assign({}, state, {
          isInitialFetching: true,
          hasFetchError: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_groups_types__["f" /* FETCH_INITIAL_GROUPS_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isInitialFetching: false,
          isInitialLoaded: true,
          initialList: action.groups
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_groups_types__["d" /* FETCH_INITIAL_GROUPS_FAILURE */]:
      {
        return Object.assign({}, state, {
          isInitialFetching: false,
          isInitialLoaded: false,
          hasFetchError: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_groups_types__["b" /* FETCH_AUTOCOMPLETE_GROUPS_REQUEST */]:
      {
        var autocomplete = Object.assign({}, state.autocomplete, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, action.query, {
          isFetching: true,
          isLoaded: false,
          list: []
        }));
        return Object.assign({}, state, {
          autocomplete: autocomplete
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_groups_types__["c" /* FETCH_AUTOCOMPLETE_GROUPS_SUCCESS */]:
      {
        var queryState = Object.assign({}, state.autocomplete[action.query], {
          isFetching: false,
          isLoaded: true,
          list: action.groups
        });

        var _autocomplete = Object.assign({}, state.autocomplete, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, action.query, queryState));

        return Object.assign({}, state, {
          autocomplete: _autocomplete
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_groups_types__["a" /* FETCH_AUTOCOMPLETE_GROUPS_FAILURE */]:
      {
        var _autocomplete2 = Object.assign({}, state.autocomplete, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, action.query, {
          isFetching: false,
          isLoaded: false,
          list: []
        }));

        return Object.assign({}, state, {
          autocomplete: _autocomplete2
        });
      }

    default:
      return state;
  }
}

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = userSegments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_notifications_types__ = __webpack_require__(279);


var initialState = {
  notifications: []
};
var ERROR = "error";
var SUCCESS = "success";
function userSegments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_notifications_types__["b" /* SHOW_ERROR_NOTIFICATION */]:
      {
        var notification = {
          id: action.id,
          message: action.message,
          type: ERROR
        };
        return Object.assign({}, state, {
          notifications: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.notifications).concat([notification])
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_notifications_types__["c" /* SHOW_SUCCESS_NOTIFICATION */]:
      {
        var _notification = {
          id: action.id,
          message: action.message,
          type: SUCCESS
        };
        return Object.assign({}, state, {
          notifications: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.notifications).concat([_notification])
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_notifications_types__["a" /* REMOVE_NOTIFICATION */]:
      {
        return Object.assign({}, state, {
          notifications: state.notifications.filter(function (notification) {
            return notification.id !== action.id;
          })
        });
      }

    default:
      return state;
  }
}

/***/ })
],[305]);


// WEBPACK FOOTER //
// app-9915adc83787a222d900.v2.js